(function() {
  try {
    var s = typeof window < "u" ? window : typeof global < "u" ? global : typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : {};
    s.SENTRY_RELEASE = { id: "8f1c8334eb1dad3e62e994ecdeea334fad1f1f1b" };
    var r = new s.Error().stack;
    r && (s._sentryDebugIds = s._sentryDebugIds || {}, s._sentryDebugIds[r] = "74ea3af9-75b4-4cb8-8574-25f48f424f97", s._sentryDebugIdIdentifier = "sentry-dbid-74ea3af9-75b4-4cb8-8574-25f48f424f97");
  } catch {
  }
})();
function ts(s, r) {
  for (var m = 0; m < r.length; m++) {
    const o = r[m];
    if (typeof o != "string" && !Array.isArray(o)) {
      for (const g in o)
        if (g !== "default" && !(g in s)) {
          const z = Object.getOwnPropertyDescriptor(o, g);
          z && Object.defineProperty(s, g, z.get ? z : {
            enumerable: !0,
            get: () => o[g]
          });
        }
    }
  }
  return Object.freeze(Object.defineProperty(s, Symbol.toStringTag, { value: "Module" }));
}
function es(s) {
  return s && s.__esModule && Object.prototype.hasOwnProperty.call(s, "default") ? s.default : s;
}
var xo = { exports: {} }, bu = {};
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var gh;
function Yv() {
  if (gh) return bu;
  gh = 1;
  var s = Symbol.for("react.transitional.element"), r = Symbol.for("react.fragment");
  function m(o, g, z) {
    var R = null;
    if (z !== void 0 && (R = "" + z), g.key !== void 0 && (R = "" + g.key), "key" in g) {
      z = {};
      for (var H in g)
        H !== "key" && (z[H] = g[H]);
    } else z = g;
    return g = z.ref, {
      $$typeof: s,
      type: o,
      key: R,
      ref: g !== void 0 ? g : null,
      props: z
    };
  }
  return bu.Fragment = r, bu.jsx = m, bu.jsxs = m, bu;
}
var yh;
function Gv() {
  return yh || (yh = 1, xo.exports = Yv()), xo.exports;
}
var Me = Gv();
const Qv = /* @__PURE__ */ es(Me), Xv = /* @__PURE__ */ ts({
  __proto__: null,
  default: Qv
}, [Me]);
var Ho = { exports: {} }, et = {};
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var vh;
function kv() {
  if (vh) return et;
  vh = 1;
  var s = Symbol.for("react.transitional.element"), r = Symbol.for("react.portal"), m = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), g = Symbol.for("react.profiler"), z = Symbol.for("react.consumer"), R = Symbol.for("react.context"), H = Symbol.for("react.forward_ref"), N = Symbol.for("react.suspense"), O = Symbol.for("react.memo"), Q = Symbol.for("react.lazy"), j = Symbol.for("react.activity"), $ = Symbol.for("react.view_transition"), ft = Symbol.iterator;
  function gt(d) {
    return d === null || typeof d != "object" ? null : (d = ft && d[ft] || d["@@iterator"], typeof d == "function" ? d : null);
  }
  var ct = {
    isMounted: function() {
      return !1;
    },
    enqueueForceUpdate: function() {
    },
    enqueueReplaceState: function() {
    },
    enqueueSetState: function() {
    }
  }, G = Object.assign, wt = {};
  function yt(d, C, q) {
    this.props = d, this.context = C, this.refs = wt, this.updater = q || ct;
  }
  yt.prototype.isReactComponent = {}, yt.prototype.setState = function(d, C) {
    if (typeof d != "object" && typeof d != "function" && d != null)
      throw Error(
        "takes an object of state variables to update or a function which returns an object of state variables."
      );
    this.updater.enqueueSetState(this, d, C, "setState");
  }, yt.prototype.forceUpdate = function(d) {
    this.updater.enqueueForceUpdate(this, d, "forceUpdate");
  };
  function X() {
  }
  X.prototype = yt.prototype;
  function it(d, C, q) {
    this.props = d, this.context = C, this.refs = wt, this.updater = q || ct;
  }
  var _t = it.prototype = new X();
  _t.constructor = it, G(_t, yt.prototype), _t.isPureReactComponent = !0;
  var W = Array.isArray;
  function jt() {
  }
  var I = { H: null, A: null, T: null, S: null }, ot = Object.prototype.hasOwnProperty;
  function Yt(d, C, q) {
    var D = q.ref;
    return {
      $$typeof: s,
      type: d,
      key: C,
      ref: D !== void 0 ? D : null,
      props: q
    };
  }
  function Ht(d, C) {
    return Yt(d.type, C, d.props);
  }
  function Zt(d) {
    return typeof d == "object" && d !== null && d.$$typeof === s;
  }
  function Ae(d) {
    var C = { "=": "=0", ":": "=2" };
    return "$" + d.replace(/[=:]/g, function(q) {
      return C[q];
    });
  }
  var Wt = /\/+/g;
  function Pt(d, C) {
    return typeof d == "object" && d !== null && d.key != null ? Ae("" + d.key) : C.toString(36);
  }
  function B(d) {
    switch (d.status) {
      case "fulfilled":
        return d.value;
      case "rejected":
        throw d.reason;
      default:
        switch (typeof d.status == "string" ? d.then(jt, jt) : (d.status = "pending", d.then(
          function(C) {
            d.status === "pending" && (d.status = "fulfilled", d.value = C);
          },
          function(C) {
            d.status === "pending" && (d.status = "rejected", d.reason = C);
          }
        )), d.status) {
          case "fulfilled":
            return d.value;
          case "rejected":
            throw d.reason;
        }
    }
    throw d;
  }
  function K(d, C, q, D, Y) {
    var U = typeof d;
    (U === "undefined" || U === "boolean") && (d = null);
    var x = !1;
    if (d === null) x = !0;
    else
      switch (U) {
        case "bigint":
        case "string":
        case "number":
          x = !0;
          break;
        case "object":
          switch (d.$$typeof) {
            case s:
            case r:
              x = !0;
              break;
            case Q:
              return x = d._init, K(
                x(d._payload),
                C,
                q,
                D,
                Y
              );
          }
      }
    if (x)
      return Y = Y(d), x = D === "" ? "." + Pt(d, 0) : D, W(Y) ? (q = "", x != null && (q = x.replace(Wt, "$&/") + "/"), K(Y, C, q, "", function(Rt) {
        return Rt;
      })) : Y != null && (Zt(Y) && (Y = Ht(
        Y,
        q + (Y.key == null || d && d.key === Y.key ? "" : ("" + Y.key).replace(
          Wt,
          "$&/"
        ) + "/") + x
      )), C.push(Y)), 1;
    x = 0;
    var nt = D === "" ? "." : D + ":";
    if (W(d))
      for (var st = 0; st < d.length; st++)
        D = d[st], U = nt + Pt(D, st), x += K(
          D,
          C,
          q,
          U,
          Y
        );
    else if (st = gt(d), typeof st == "function")
      for (d = st.call(d), st = 0; !(D = d.next()).done; )
        D = D.value, U = nt + Pt(D, st++), x += K(
          D,
          C,
          q,
          U,
          Y
        );
    else if (U === "object") {
      if (typeof d.then == "function")
        return K(
          B(d),
          C,
          q,
          D,
          Y
        );
      throw C = String(d), Error(
        "Objects are not valid as a React child (found: " + (C === "[object Object]" ? "object with keys {" + Object.keys(d).join(", ") + "}" : C) + "). If you meant to render a collection of children, use an array instead."
      );
    }
    return x;
  }
  function tt(d, C, q) {
    if (d == null) return d;
    var D = [], Y = 0;
    return K(d, D, "", "", function(U) {
      return C.call(q, U, Y++);
    }), D;
  }
  function bt(d) {
    if (d._status === -1) {
      var C = d._result;
      C = C(), C.then(
        function(q) {
          (d._status === 0 || d._status === -1) && (d._status = 1, d._result = q);
        },
        function(q) {
          (d._status === 0 || d._status === -1) && (d._status = 2, d._result = q);
        }
      ), d._status === -1 && (d._status = 0, d._result = C);
    }
    if (d._status === 1) return d._result.default;
    throw d._result;
  }
  var T = typeof reportError == "function" ? reportError : function(d) {
    if (typeof window == "object" && typeof window.ErrorEvent == "function") {
      var C = new window.ErrorEvent("error", {
        bubbles: !0,
        cancelable: !0,
        message: typeof d == "object" && d !== null && typeof d.message == "string" ? String(d.message) : String(d),
        error: d
      });
      if (!window.dispatchEvent(C)) return;
    } else if (typeof process == "object" && typeof process.emit == "function") {
      process.emit("uncaughtException", d);
      return;
    }
    console.error(d);
  };
  function y(d) {
    var C = I.T, q = {};
    q.types = C !== null ? C.types : null, I.T = q;
    try {
      var D = d(), Y = I.S;
      Y !== null && Y(q, D), typeof D == "object" && D !== null && typeof D.then == "function" && D.then(jt, T);
    } catch (U) {
      T(U);
    } finally {
      C !== null && q.types !== null && (C.types = q.types), I.T = C;
    }
  }
  function V(d) {
    var C = I.T;
    if (C !== null) {
      var q = C.types;
      q === null ? C.types = [d] : q.indexOf(d) === -1 && q.push(d);
    } else y(V.bind(null, d));
  }
  var F = {
    map: tt,
    forEach: function(d, C, q) {
      tt(
        d,
        function() {
          C.apply(this, arguments);
        },
        q
      );
    },
    count: function(d) {
      var C = 0;
      return tt(d, function() {
        C++;
      }), C;
    },
    toArray: function(d) {
      return tt(d, function(C) {
        return C;
      }) || [];
    },
    only: function(d) {
      if (!Zt(d))
        throw Error(
          "React.Children.only expected to receive a single React element child."
        );
      return d;
    }
  };
  return et.Activity = j, et.Children = F, et.Component = yt, et.Fragment = m, et.Profiler = g, et.PureComponent = it, et.StrictMode = o, et.Suspense = N, et.ViewTransition = $, et.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = I, et.__COMPILER_RUNTIME = {
    __proto__: null,
    c: function(d) {
      return I.H.useMemoCache(d);
    }
  }, et.addTransitionType = V, et.cache = function(d) {
    return function() {
      return d.apply(null, arguments);
    };
  }, et.cacheSignal = function() {
    return null;
  }, et.cloneElement = function(d, C, q) {
    if (d == null)
      throw Error(
        "The argument must be a React element, but you passed " + d + "."
      );
    var D = G({}, d.props), Y = d.key;
    if (C != null)
      for (U in C.key !== void 0 && (Y = "" + C.key), C)
        !ot.call(C, U) || U === "key" || U === "__self" || U === "__source" || U === "ref" && C.ref === void 0 || (D[U] = C[U]);
    var U = arguments.length - 2;
    if (U === 1) D.children = q;
    else if (1 < U) {
      for (var x = Array(U), nt = 0; nt < U; nt++)
        x[nt] = arguments[nt + 2];
      D.children = x;
    }
    return Yt(d.type, Y, D);
  }, et.createContext = function(d) {
    return d = {
      $$typeof: R,
      _currentValue: d,
      _currentValue2: d,
      _threadCount: 0,
      Provider: null,
      Consumer: null
    }, d.Provider = d, d.Consumer = {
      $$typeof: z,
      _context: d
    }, d;
  }, et.createElement = function(d, C, q) {
    var D, Y = {}, U = null;
    if (C != null)
      for (D in C.key !== void 0 && (U = "" + C.key), C)
        ot.call(C, D) && D !== "key" && D !== "__self" && D !== "__source" && (Y[D] = C[D]);
    var x = arguments.length - 2;
    if (x === 1) Y.children = q;
    else if (1 < x) {
      for (var nt = Array(x), st = 0; st < x; st++)
        nt[st] = arguments[st + 2];
      Y.children = nt;
    }
    if (d && d.defaultProps)
      for (D in x = d.defaultProps, x)
        Y[D] === void 0 && (Y[D] = x[D]);
    return Yt(d, U, Y);
  }, et.createRef = function() {
    return { current: null };
  }, et.forwardRef = function(d) {
    return { $$typeof: H, render: d };
  }, et.isValidElement = Zt, et.lazy = function(d) {
    return {
      $$typeof: Q,
      _payload: { _status: -1, _result: d },
      _init: bt
    };
  }, et.memo = function(d, C) {
    return {
      $$typeof: O,
      type: d,
      compare: C === void 0 ? null : C
    };
  }, et.startTransition = y, et.unstable_useCacheRefresh = function() {
    return I.H.useCacheRefresh();
  }, et.use = function(d) {
    return I.H.use(d);
  }, et.useActionState = function(d, C, q) {
    return I.H.useActionState(d, C, q);
  }, et.useCallback = function(d, C) {
    return I.H.useCallback(d, C);
  }, et.useContext = function(d) {
    return I.H.useContext(d);
  }, et.useDebugValue = function() {
  }, et.useDeferredValue = function(d, C) {
    return I.H.useDeferredValue(d, C);
  }, et.useEffect = function(d, C) {
    return I.H.useEffect(d, C);
  }, et.useEffectEvent = function(d) {
    return I.H.useEffectEvent(d);
  }, et.useId = function() {
    return I.H.useId();
  }, et.useImperativeHandle = function(d, C, q) {
    return I.H.useImperativeHandle(d, C, q);
  }, et.useInsertionEffect = function(d, C) {
    return I.H.useInsertionEffect(d, C);
  }, et.useLayoutEffect = function(d, C) {
    return I.H.useLayoutEffect(d, C);
  }, et.useMemo = function(d, C) {
    return I.H.useMemo(d, C);
  }, et.useOptimistic = function(d, C) {
    return I.H.useOptimistic(d, C);
  }, et.useReducer = function(d, C, q) {
    return I.H.useReducer(d, C, q);
  }, et.useRef = function(d) {
    return I.H.useRef(d);
  }, et.useState = function(d) {
    return I.H.useState(d);
  }, et.useSyncExternalStore = function(d, C, q) {
    return I.H.useSyncExternalStore(
      d,
      C,
      q
    );
  }, et.useTransition = function() {
    return I.H.useTransition();
  }, et.version = "19.3.0-canary-fb2177c1-20251114", et;
}
var ph;
function Ko() {
  return ph || (ph = 1, Ho.exports = kv()), Ho.exports;
}
var At = Ko();
const A = /* @__PURE__ */ es(At), Vv = /* @__PURE__ */ ts({
  __proto__: null,
  default: A
}, [At]);
/**
 * @license lucide-react v0.546.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Zv = (s) => s.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase(), Kv = (s) => s.replace(
  /^([A-Z])|[\s-_]+(\w)/g,
  (r, m, o) => o ? o.toUpperCase() : m.toLowerCase()
), bh = (s) => {
  const r = Kv(s);
  return r.charAt(0).toUpperCase() + r.slice(1);
}, Lh = (...s) => s.filter((r, m, o) => !!r && r.trim() !== "" && o.indexOf(r) === m).join(" ").trim(), Jv = (s) => {
  for (const r in s)
    if (r.startsWith("aria-") || r === "role" || r === "title")
      return !0;
};
/**
 * @license lucide-react v0.546.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
var $v = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};
/**
 * @license lucide-react v0.546.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Fv = At.forwardRef(
  ({
    color: s = "currentColor",
    size: r = 24,
    strokeWidth: m = 2,
    absoluteStrokeWidth: o,
    className: g = "",
    children: z,
    iconNode: R,
    ...H
  }, N) => At.createElement(
    "svg",
    {
      ref: N,
      ...$v,
      width: r,
      height: r,
      stroke: s,
      strokeWidth: o ? Number(m) * 24 / Number(r) : m,
      className: Lh("lucide", g),
      ...!z && !Jv(H) && { "aria-hidden": "true" },
      ...H
    },
    [
      ...R.map(([O, Q]) => At.createElement(O, Q)),
      ...Array.isArray(z) ? z : [z]
    ]
  )
);
/**
 * @license lucide-react v0.546.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const We = (s, r) => {
  const m = At.forwardRef(
    ({ className: o, ...g }, z) => At.createElement(Fv, {
      ref: z,
      iconNode: r,
      className: Lh(
        `lucide-${Zv(bh(s))}`,
        `lucide-${s}`,
        o
      ),
      ...g
    })
  );
  return m.displayName = bh(s), m;
};
/**
 * @license lucide-react v0.546.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Wv = [
  ["path", { d: "M12 7v14", key: "1akyts" }],
  [
    "path",
    {
      d: "M3 18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h5a4 4 0 0 1 4 4 4 4 0 0 1 4-4h5a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-6a3 3 0 0 0-3 3 3 3 0 0 0-3-3z",
      key: "ruj8y"
    }
  ]
], Iv = We("book-open", Wv);
/**
 * @license lucide-react v0.546.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Pv = [
  ["line", { x1: "6", x2: "6", y1: "3", y2: "15", key: "17qcm7" }],
  ["circle", { cx: "18", cy: "6", r: "3", key: "1h7g24" }],
  ["circle", { cx: "6", cy: "18", r: "3", key: "fqmcym" }],
  ["path", { d: "M18 9a9 9 0 0 1-9 9", key: "n2h4wq" }]
], t0 = We("git-branch", Pv);
/**
 * @license lucide-react v0.546.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const e0 = [
  ["line", { x1: "4", x2: "20", y1: "9", y2: "9", key: "4lhtct" }],
  ["line", { x1: "4", x2: "20", y1: "15", y2: "15", key: "vyu0kd" }],
  ["line", { x1: "10", x2: "8", y1: "3", y2: "21", key: "1ggp8o" }],
  ["line", { x1: "16", x2: "14", y1: "3", y2: "21", key: "weycgp" }]
], n0 = We("hash", e0);
/**
 * @license lucide-react v0.546.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const l0 = [
  [
    "path",
    {
      d: "M12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83z",
      key: "zw3jo"
    }
  ],
  [
    "path",
    {
      d: "M2 12a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 12",
      key: "1wduqc"
    }
  ],
  [
    "path",
    {
      d: "M2 17a1 1 0 0 0 .58.91l8.6 3.91a2 2 0 0 0 1.65 0l8.58-3.9A1 1 0 0 0 22 17",
      key: "kqbvx6"
    }
  ]
], a0 = We("layers", l0);
/**
 * @license lucide-react v0.546.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const u0 = [
  ["rect", { width: "7", height: "18", x: "3", y: "3", rx: "1", key: "2obqm" }],
  ["rect", { width: "7", height: "7", x: "14", y: "3", rx: "1", key: "6d4xhi" }],
  ["rect", { width: "7", height: "7", x: "14", y: "14", rx: "1", key: "nxv5o0" }]
], i0 = We("layout-panel-left", u0);
/**
 * @license lucide-react v0.546.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const s0 = [
  [
    "path",
    {
      d: "M15 14c.2-1 .7-1.7 1.5-2.5 1-.9 1.5-2.2 1.5-3.5A6 6 0 0 0 6 8c0 1 .2 2.2 1.5 3.5.7.7 1.3 1.5 1.5 2.5",
      key: "1gvzjb"
    }
  ],
  ["path", { d: "M9 18h6", key: "x1upvd" }],
  ["path", { d: "M10 22h4", key: "ceow96" }]
], c0 = We("lightbulb", s0);
/**
 * @license lucide-react v0.546.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const o0 = [
  ["path", { d: "M13 5h8", key: "a7qcls" }],
  ["path", { d: "M13 12h8", key: "h98zly" }],
  ["path", { d: "M13 19h8", key: "c3s6r1" }],
  ["path", { d: "m3 17 2 2 4-4", key: "1jhpwq" }],
  ["path", { d: "m3 7 2 2 4-4", key: "1obspn" }]
], r0 = We("list-checks", o0);
/**
 * @license lucide-react v0.546.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const f0 = [
  ["rect", { x: "16", y: "16", width: "6", height: "6", rx: "1", key: "4q2zg0" }],
  ["rect", { x: "2", y: "16", width: "6", height: "6", rx: "1", key: "8cvhb9" }],
  ["rect", { x: "9", y: "2", width: "6", height: "6", rx: "1", key: "1egb70" }],
  ["path", { d: "M5 16v-3a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3", key: "1jsf9p" }],
  ["path", { d: "M12 12V8", key: "2874zd" }]
], d0 = We("network", f0);
/**
 * @license lucide-react v0.546.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const m0 = [
  ["path", { d: "m13 13.5 2-2.5-2-2.5", key: "1rvxrh" }],
  ["path", { d: "m21 21-4.3-4.3", key: "1qie3q" }],
  ["path", { d: "M9 8.5 7 11l2 2.5", key: "6ffwbx" }],
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }]
], h0 = We("search-code", m0);
/**
 * @license lucide-react v0.546.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const g0 = [
  ["path", { d: "M16 7h6v6", key: "box55l" }],
  ["path", { d: "m22 7-8.5 8.5-5-5L2 17", key: "1t1m79" }]
], y0 = We("trending-up", g0);
/**
 * @license lucide-react v0.546.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const v0 = [
  ["rect", { width: "8", height: "8", x: "3", y: "3", rx: "2", key: "by2w9f" }],
  ["path", { d: "M7 11v4a2 2 0 0 0 2 2h4", key: "xkn7yn" }],
  ["rect", { width: "8", height: "8", x: "13", y: "13", rx: "2", key: "1cgmvn" }]
], p0 = We("workflow", v0);
/**
 * @license lucide-react v0.546.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const b0 = [
  [
    "path",
    {
      d: "M4 14a1 1 0 0 1-.78-1.63l9.9-10.2a.5.5 0 0 1 .86.46l-1.92 6.02A1 1 0 0 0 13 10h7a1 1 0 0 1 .78 1.63l-9.9 10.2a.5.5 0 0 1-.86-.46l1.92-6.02A1 1 0 0 0 11 14z",
      key: "1xq2db"
    }
  ]
], S0 = We("zap", b0), E0 = Object.assign({
  type: "lesson",
  title: "The Interview Rubric",
  subtitle: "How interviewers evaluate your performance"
}, {
  entry: "courses/how-coding-interviews-are-scored/the-rubric",
  slug: "the-rubric",
  href: "/courses/how-coding-interviews-are-scored/the-rubric",
  script: "/static/courses/how-coding-interviews-are-scored/the-rubric.js",
  import: "#courses/how-coding-interviews-are-scored/the-rubric",
  filename: "courses/how-coding-interviews-are-scored/the-rubric.mdx"
}), T0 = Object.assign({
  type: "lesson",
  title: "Demonstrating Problem Solving",
  subtitle: "Show your thought process effectively"
}, {
  entry: "courses/how-coding-interviews-are-scored/demonstrating-problem-solving",
  slug: "demonstrating-problem-solving",
  href: "/courses/how-coding-interviews-are-scored/demonstrating-problem-solving",
  script: "/static/courses/how-coding-interviews-are-scored/demonstrating-problem-solving.js",
  import: "#courses/how-coding-interviews-are-scored/demonstrating-problem-solving",
  filename: "courses/how-coding-interviews-are-scored/demonstrating-problem-solving.mdx"
}), _0 = Object.assign({
  type: "lesson",
  title: "Writing Interview Code",
  subtitle: "Code quality and best practices"
}, {
  entry: "courses/how-coding-interviews-are-scored/writing-interview-code",
  slug: "writing-interview-code",
  href: "/courses/how-coding-interviews-are-scored/writing-interview-code",
  script: "/static/courses/how-coding-interviews-are-scored/writing-interview-code.js",
  import: "#courses/how-coding-interviews-are-scored/writing-interview-code",
  filename: "courses/how-coding-interviews-are-scored/writing-interview-code.mdx"
}), O0 = Object.assign({
  type: "course",
  title: "How Coding Interviews are Scored",
  subtitle: "Understand the evaluation criteria and what interviewers look for",
  icon: Me.jsx(r0, {
    className: "h-8 w-8 text-green-700"
  }),
  children: [E0, T0, _0]
}, {
  entry: "courses/how-coding-interviews-are-scored",
  slug: "how-coding-interviews-are-scored",
  href: "/courses/how-coding-interviews-are-scored",
  script: "/static/courses/how-coding-interviews-are-scored.js",
  import: "#courses/how-coding-interviews-are-scored",
  filename: "courses/how-coding-interviews-are-scored/_how-coding-interviews-are-scored.mdx"
}), z0 = Object.assign({
  type: "lesson",
  title: "Recognizing When You're Stuck",
  subtitle: "Identify the type of roadblock you're facing"
}, {
  entry: "courses/how-to-get-unstuck/recognizing-patterns",
  slug: "recognizing-patterns",
  href: "/courses/how-to-get-unstuck/recognizing-patterns",
  script: "/static/courses/how-to-get-unstuck/recognizing-patterns.js",
  import: "#courses/how-to-get-unstuck/recognizing-patterns",
  filename: "courses/how-to-get-unstuck/recognizing-patterns.mdx"
}), C0 = Object.assign({
  type: "lesson",
  title: "Strategies for Getting Unstuck",
  subtitle: "Practical techniques to move forward"
}, {
  entry: "courses/how-to-get-unstuck/strategies-for-unstucking",
  slug: "strategies-for-unstucking",
  href: "/courses/how-to-get-unstuck/strategies-for-unstucking",
  script: "/static/courses/how-to-get-unstuck/strategies-for-unstucking.js",
  import: "#courses/how-to-get-unstuck/strategies-for-unstucking",
  filename: "courses/how-to-get-unstuck/strategies-for-unstucking.mdx"
}), M0 = Object.assign({
  type: "lesson",
  title: "Communicating While Stuck",
  subtitle: "How to maintain momentum through dialogue"
}, {
  entry: "courses/how-to-get-unstuck/communication-while-stuck",
  slug: "communication-while-stuck",
  href: "/courses/how-to-get-unstuck/communication-while-stuck",
  script: "/static/courses/how-to-get-unstuck/communication-while-stuck.js",
  import: "#courses/how-to-get-unstuck/communication-while-stuck",
  filename: "courses/how-to-get-unstuck/communication-while-stuck.mdx"
}), A0 = Object.assign({
  type: "course",
  title: "How to Get Unstuck in Coding Interviews",
  subtitle: "Strategies and techniques to move forward when you're stuck",
  icon: Me.jsx(c0, {
    className: "h-8 w-8 text-yellow-600"
  }),
  children: [z0, C0, M0]
}, {
  entry: "courses/how-to-get-unstuck",
  slug: "how-to-get-unstuck",
  href: "/courses/how-to-get-unstuck",
  script: "/static/courses/how-to-get-unstuck.js",
  import: "#courses/how-to-get-unstuck",
  filename: "courses/how-to-get-unstuck/_how-to-get-unstuck.mdx"
}), w0 = Object.assign({
  type: "lesson",
  title: "Effective Study Strategy",
  subtitle: "How to prepare efficiently and effectively"
}, {
  entry: "courses/how-to-study/study-strategy",
  slug: "study-strategy",
  href: "/courses/how-to-study/study-strategy",
  script: "/static/courses/how-to-study/study-strategy.js",
  import: "#courses/how-to-study/study-strategy",
  filename: "courses/how-to-study/study-strategy.mdx"
}), N0 = Object.assign({
  type: "lesson",
  title: "Choosing the Right Problems",
  subtitle: "How to select problems that maximize learning"
}, {
  entry: "courses/how-to-study/problem-selection",
  slug: "problem-selection",
  href: "/courses/how-to-study/problem-selection",
  script: "/static/courses/how-to-study/problem-selection.js",
  import: "#courses/how-to-study/problem-selection",
  filename: "courses/how-to-study/problem-selection.mdx"
}), U0 = Object.assign({
  type: "lesson",
  title: "Mock Interviews and Practice",
  subtitle: "Simulating real interview conditions"
}, {
  entry: "courses/how-to-study/mock-interviews",
  slug: "mock-interviews",
  href: "/courses/how-to-study/mock-interviews",
  script: "/static/courses/how-to-study/mock-interviews.js",
  import: "#courses/how-to-study/mock-interviews",
  filename: "courses/how-to-study/mock-interviews.mdx"
}), D0 = Object.assign({
  type: "course",
  title: "How to Study for Coding Interviews",
  subtitle: "Effective study strategies to prepare for technical interviews",
  icon: Me.jsx(Iv, {
    className: "h-8 w-8 text-blue-600"
  }),
  children: [w0, N0, U0]
}, {
  entry: "courses/how-to-study",
  slug: "how-to-study",
  href: "/courses/how-to-study",
  script: "/static/courses/how-to-study.js",
  import: "#courses/how-to-study",
  filename: "courses/how-to-study/_how-to-study.mdx"
}), R0 = Object.assign({
  type: "collection",
  title: "Beyond the Code",
  subtitle: "A collection of courses related to theory, strategy, and mindset",
  children: [O0, A0, D0]
}, {
  entry: "courses/beyond-the-code",
  slug: "beyond-the-code",
  href: "/courses/beyond-the-code",
  script: "/static/courses/beyond-the-code.js",
  import: "#courses/beyond-the-code",
  filename: "courses/beyond-the-code.mdx"
}), q0 = Object.freeze({
  InvalidProxyUrlErrorMessage: "The proxyUrl passed to Clerk is invalid. The expected value for proxyUrl is an absolute URL or a relative path with a leading '/'. (key={{url}})",
  InvalidPublishableKeyErrorMessage: "The publishableKey passed to Clerk is invalid (key={{key}}, expected format: pk_test_... or pk_live_...). To create a Clerk application with valid keys, in your terminal run:\n\nnpx clerk@latest init\n\n`npx clerk@latest init` creates a Clerk application and writes keys to your .env file. No Clerk account or login required and the command is non-interactive.\n\nIf you have a Clerk application, run `npx clerk@latest env pull` to write the keys (`--instance prod` for production keys). Or copy its Publishable key from https://dashboard.clerk.com/~/api-keys.",
  MissingPublishableKeyErrorMessage: "Missing publishableKey. To set up Clerk for this project, in your terminal run:\n\nnpx clerk@latest init\n\n`npx clerk@latest init` creates a Clerk application and writes keys to your .env file. No Clerk account or login required and the command is non-interactive.\n\nIf you have a Clerk application, run `npx clerk@latest env pull` to write the keys. Or copy them from https://dashboard.clerk.com/~/api-keys. Deploy a production instance by running `npx clerk@latest deploy`, or `npx clerk@latest env pull --instance prod` to use an existing one.",
  MissingSecretKeyErrorMessage: "Missing secretKey. To set up Clerk for this project, in your terminal run:\n\nnpx clerk@latest init\n\n`npx clerk@latest init` creates a Clerk application and writes keys to your .env file. No Clerk account or login required and the command is non-interactive.\n\nIf you have a Clerk application, run `npx clerk@latest env pull` to write the keys. Or copy them from https://dashboard.clerk.com/~/api-keys. Deploy a production instance by running `npx clerk@latest deploy`, or `npx clerk@latest env pull --instance prod` to use an existing one.",
  MissingClerkProvider: "{{source}} can only be used within the <ClerkProvider /> component. Learn more: https://clerk.com/docs/components/clerk-provider"
});
function Yh({ packageName: s, customMessages: r }) {
  let m = s;
  function o(z, R) {
    if (!R) return `${m}: ${z}`;
    let H = z;
    const N = z.matchAll(/{{([a-zA-Z0-9-_]+)}}/g);
    for (const O of N) {
      const Q = (R[O[1]] || "").toString();
      H = H.replace(`{{${O[1]}}}`, Q);
    }
    return `${m}: ${H}`;
  }
  const g = {
    ...q0,
    ...r
  };
  return {
    setPackageName({ packageName: z }) {
      return typeof z == "string" && (m = z), this;
    },
    setMessages({ customMessages: z }) {
      return Object.assign(g, z || {}), this;
    },
    throwInvalidPublishableKeyError(z) {
      throw new Error(o(g.InvalidPublishableKeyErrorMessage, z));
    },
    throwInvalidProxyUrl(z) {
      throw new Error(o(g.InvalidProxyUrlErrorMessage, z));
    },
    throwMissingPublishableKeyError() {
      throw new Error(o(g.MissingPublishableKeyErrorMessage));
    },
    throwMissingSecretKeyError() {
      throw new Error(o(g.MissingSecretKeyErrorMessage));
    },
    throwMissingClerkProviderError(z) {
      throw new Error(o(g.MissingClerkProvider, z));
    },
    throw(z) {
      throw new Error(o(z));
    }
  };
}
const j0 = () => {
  try {
    return !1;
  } catch {
  }
  return !1;
}, x0 = () => {
  try {
    return !1;
  } catch {
  }
  return !1;
}, H0 = () => {
  try {
    return !0;
  } catch {
  }
  return !1;
};
var Sh = Object.prototype.hasOwnProperty;
function Eh(s, r, m) {
  for (m of s.keys())
    if (Eu(m, r)) return m;
}
function Eu(s, r) {
  var m, o, g;
  if (s === r) return !0;
  if (s && r && (m = s.constructor) === r.constructor) {
    if (m === Date) return s.getTime() === r.getTime();
    if (m === RegExp) return s.toString() === r.toString();
    if (m === Array) {
      if ((o = s.length) === r.length)
        for (; o-- && Eu(s[o], r[o]); ) ;
      return o === -1;
    }
    if (m === Set) {
      if (s.size !== r.size)
        return !1;
      for (o of s)
        if (g = o, g && typeof g == "object" && (g = Eh(r, g), !g) || !r.has(g)) return !1;
      return !0;
    }
    if (m === Map) {
      if (s.size !== r.size)
        return !1;
      for (o of s)
        if (g = o[0], g && typeof g == "object" && (g = Eh(r, g), !g) || !Eu(o[1], r.get(g)))
          return !1;
      return !0;
    }
    if (m === ArrayBuffer)
      s = new Uint8Array(s), r = new Uint8Array(r);
    else if (m === DataView) {
      if ((o = s.byteLength) === r.byteLength)
        for (; o-- && s.getInt8(o) === r.getInt8(o); ) ;
      return o === -1;
    }
    if (ArrayBuffer.isView(s)) {
      if ((o = s.byteLength) === r.byteLength)
        for (; o-- && s[o] === r[o]; ) ;
      return o === -1;
    }
    if (!m || typeof s == "object") {
      o = 0;
      for (m in s)
        if (Sh.call(s, m) && ++o && !Sh.call(r, m) || !(m in r) || !Eu(s[m], r[m])) return !1;
      return Object.keys(r).length === o;
    }
  }
  return s !== s && r !== r;
}
function B0(s, r) {
  if (!s) throw typeof r == "string" ? new Error(r) : /* @__PURE__ */ new Error(`${r.displayName} not found`);
}
const pa = (s, r) => {
  const { assertCtxFn: m = B0 } = {}, o = A.createContext(void 0);
  return o.displayName = s, [
    o,
    () => {
      const R = A.useContext(o);
      return m(R, `${s} not found`), R.value;
    },
    () => {
      const R = A.useContext(o);
      return R ? R.value : {};
    }
  ];
}, [L0, Y0] = pa("ClerkInstanceContext");
pa("InitialStateContext");
A.createContext({});
pa("CheckoutContext");
function G0(s) {
  if (!A.useContext(L0)) {
    if (typeof s == "function") {
      s();
      return;
    }
    throw new Error(`${s} can only be used within the <ClerkProvider /> component.

Possible fixes:
1. Ensure that the <ClerkProvider /> is correctly wrapping your application where this component is used.
2. Check for multiple versions of the \`@clerk/shared\` package in your project. Use a tool like \`npm ls @clerk/shared\` to identify multiple versions, and update your dependencies to only rely on one.

Learn more: https://clerk.com/docs/components/clerk-provider`.trim());
  }
}
function Q0(s) {
  const r = function() {
  };
  let m;
  return m = new Proxy(r, {
    get(o, g) {
      if (g !== "then")
        return g === "toString" ? () => `[${s}]` : g === Symbol.toPrimitive ? () => 0 : m;
    },
    apply() {
      return m;
    },
    construct() {
      return m;
    },
    has() {
      return !1;
    },
    set() {
      return !1;
    }
  }), m;
}
Q0("ClerkMockQueryClient");
typeof window < "u" ? A.useLayoutEffect : A.useEffect;
const Th = Eu, X0 = (s) => {
  const r = At.useRef(s);
  return At.useEffect(() => {
    r.current = s;
  }, [s]), r.current;
}, Le = (s, r, m) => {
  const o = !!m, g = At.useRef(m);
  At.useEffect(() => {
    g.current = m;
  }, [m]), At.useEffect(() => {
    if (!o || !s) return () => {
    };
    const z = (...R) => {
      g.current && g.current(...R);
    };
    return s.on(r, z), () => {
      s.off(r, z);
    };
  }, [
    o,
    r,
    s,
    g
  ]);
}, Gh = A.createContext(null);
Gh.displayName = "ElementsContext";
const k0 = (s, r) => {
  if (!s) throw new Error(`Could not find Elements context; You need to wrap the part of your app that ${r} in an <Elements> provider.`);
  return s;
}, Pi = (s) => s !== null && typeof s == "object", V0 = (s, r, m) => Pi(s) ? Object.keys(s).reduce((o, g) => {
  const z = !Pi(r) || !Qh(s[g], r[g]);
  return m.includes(g) ? (z && console.warn(`Unsupported prop change: options.${g} is not a mutable property.`), o) : z ? {
    ...o || {},
    [g]: s[g]
  } : o;
}, null) : null, _h = "[object Object]", Qh = (s, r) => {
  if (!Pi(s) || !Pi(r)) return s === r;
  const m = Array.isArray(s);
  if (m !== Array.isArray(r)) return !1;
  const o = Object.prototype.toString.call(s) === _h;
  if (o !== (Object.prototype.toString.call(r) === _h)) return !1;
  if (!o && !m) return s === r;
  const g = Object.keys(s), z = Object.keys(r);
  if (g.length !== z.length) return !1;
  const R = {};
  for (let j = 0; j < g.length; j += 1) R[g[j]] = !0;
  for (let j = 0; j < z.length; j += 1) R[z[j]] = !0;
  const H = Object.keys(R);
  if (H.length !== g.length) return !1;
  const N = s, O = r, Q = (j) => Qh(N[j], O[j]);
  return H.every(Q);
}, Oh = (s) => k0(A.useContext(Gh), s), Z0 = (s) => s.charAt(0).toUpperCase() + s.slice(1), K0 = (s, r) => {
  const m = `${Z0(s)}Element`, z = r ? (R) => {
    Oh(`mounts <${m}>`);
    const { id: H, className: N } = R;
    return /* @__PURE__ */ A.createElement("div", {
      id: H,
      className: N
    });
  } : ({ id: R, className: H, fallback: N, options: O = {}, onBlur: Q, onFocus: j, onReady: $, onChange: ft, onEscape: gt, onClick: ct, onLoadError: G, onLoaderStart: wt, onNetworksChange: yt, onConfirm: X, onCancel: it, onShippingAddressChange: _t, onShippingRateChange: W }) => {
    const jt = Oh(`mounts <${m}>`), I = "elements" in jt ? jt.elements : null, [ot, Yt] = A.useState(null), Ht = A.useRef(null), Zt = A.useRef(null), [Ae, Wt] = At.useState(!1);
    Le(ot, "blur", Q), Le(ot, "focus", j), Le(ot, "escape", gt), Le(ot, "click", ct), Le(ot, "loaderror", G), Le(ot, "loaderstart", wt), Le(ot, "networkschange", yt), Le(ot, "confirm", X), Le(ot, "cancel", it), Le(ot, "shippingaddresschange", _t), Le(ot, "shippingratechange", W), Le(ot, "change", ft);
    let Pt;
    $ && (Pt = () => {
      Wt(!0), $(ot);
    }), Le(ot, "ready", Pt), A.useLayoutEffect(() => {
      if (Ht.current === null && Zt.current !== null && I) {
        let K = null;
        I && (K = I.create(s, O)), Ht.current = K, Yt(K), K && K.mount(Zt.current);
      }
    }, [I, O]);
    const B = X0(O);
    return A.useEffect(() => {
      if (!Ht.current) return;
      const K = V0(O, B, ["paymentRequest"]);
      K && "update" in Ht.current && Ht.current.update(K);
    }, [O, B]), A.useLayoutEffect(() => () => {
      if (Ht.current && typeof Ht.current.destroy == "function") try {
        Ht.current.destroy(), Ht.current = null;
      } catch {
      }
    }, []), /* @__PURE__ */ A.createElement(A.Fragment, null, !Ae && N, /* @__PURE__ */ A.createElement("div", {
      id: R,
      style: {
        height: Ae ? "unset" : "0px",
        visibility: Ae ? "visible" : "hidden"
      },
      className: H,
      ref: Zt
    }));
  };
  return z.displayName = m, z.__elementType = s, z;
};
K0("payment", typeof window > "u");
pa("PaymentElementContext");
pa("StripeUtilsContext");
const [Vb, , J0] = pa("PortalProvider"), $0 = () => {
  const s = J0();
  return s && "getContainer" in s && s.getContainer ? s.getContainer : () => null;
}, Jo = Yh({ packageName: "@clerk/react" });
function F0(s) {
  Jo.setMessages(s).setPackageName(s);
}
const W0 = Y0, I0 = (s) => {
  G0(() => {
    Jo.throwMissingClerkProviderError({ source: s });
  });
};
var Bo = { exports: {} }, de = {};
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var zh;
function P0() {
  if (zh) return de;
  zh = 1;
  var s = Ko();
  function r(N) {
    var O = "https://react.dev/errors/" + N;
    if (1 < arguments.length) {
      O += "?args[]=" + encodeURIComponent(arguments[1]);
      for (var Q = 2; Q < arguments.length; Q++)
        O += "&args[]=" + encodeURIComponent(arguments[Q]);
    }
    return "Minified React error #" + N + "; visit " + O + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  function m() {
  }
  var o = {
    d: {
      f: m,
      r: function() {
        throw Error(r(522));
      },
      D: m,
      C: m,
      L: m,
      m,
      X: m,
      S: m,
      M: m
    },
    p: 0,
    findDOMNode: null
  }, g = Symbol.for("react.portal");
  function z(N, O, Q) {
    var j = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
    return {
      $$typeof: g,
      key: j == null ? null : "" + j,
      children: N,
      containerInfo: O,
      implementation: Q
    };
  }
  var R = s.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
  function H(N, O) {
    if (N === "font") return "";
    if (typeof O == "string")
      return O === "use-credentials" ? O : "";
  }
  return de.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = o, de.createPortal = function(N, O) {
    var Q = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
    if (!O || O.nodeType !== 1 && O.nodeType !== 9 && O.nodeType !== 11)
      throw Error(r(299));
    return z(N, O, null, Q);
  }, de.flushSync = function(N) {
    var O = R.T, Q = o.p;
    try {
      if (R.T = null, o.p = 2, N) return N();
    } finally {
      R.T = O, o.p = Q, o.d.f();
    }
  }, de.preconnect = function(N, O) {
    typeof N == "string" && (O ? (O = O.crossOrigin, O = typeof O == "string" ? O === "use-credentials" ? O : "" : void 0) : O = null, o.d.C(N, O));
  }, de.prefetchDNS = function(N) {
    typeof N == "string" && o.d.D(N);
  }, de.preinit = function(N, O) {
    if (typeof N == "string" && O && typeof O.as == "string") {
      var Q = O.as, j = H(Q, O.crossOrigin), $ = typeof O.integrity == "string" ? O.integrity : void 0, ft = typeof O.fetchPriority == "string" ? O.fetchPriority : void 0;
      Q === "style" ? o.d.S(
        N,
        typeof O.precedence == "string" ? O.precedence : void 0,
        {
          crossOrigin: j,
          integrity: $,
          fetchPriority: ft
        }
      ) : Q === "script" && o.d.X(N, {
        crossOrigin: j,
        integrity: $,
        fetchPriority: ft,
        nonce: typeof O.nonce == "string" ? O.nonce : void 0
      });
    }
  }, de.preinitModule = function(N, O) {
    if (typeof N == "string")
      if (typeof O == "object" && O !== null) {
        if (O.as == null || O.as === "script") {
          var Q = H(
            O.as,
            O.crossOrigin
          );
          o.d.M(N, {
            crossOrigin: Q,
            integrity: typeof O.integrity == "string" ? O.integrity : void 0,
            nonce: typeof O.nonce == "string" ? O.nonce : void 0
          });
        }
      } else O == null && o.d.M(N);
  }, de.preload = function(N, O) {
    if (typeof N == "string" && typeof O == "object" && O !== null && typeof O.as == "string") {
      var Q = O.as, j = H(Q, O.crossOrigin);
      o.d.L(N, Q, {
        crossOrigin: j,
        integrity: typeof O.integrity == "string" ? O.integrity : void 0,
        nonce: typeof O.nonce == "string" ? O.nonce : void 0,
        type: typeof O.type == "string" ? O.type : void 0,
        fetchPriority: typeof O.fetchPriority == "string" ? O.fetchPriority : void 0,
        referrerPolicy: typeof O.referrerPolicy == "string" ? O.referrerPolicy : void 0,
        imageSrcSet: typeof O.imageSrcSet == "string" ? O.imageSrcSet : void 0,
        imageSizes: typeof O.imageSizes == "string" ? O.imageSizes : void 0,
        media: typeof O.media == "string" ? O.media : void 0
      });
    }
  }, de.preloadModule = function(N, O) {
    if (typeof N == "string")
      if (O) {
        var Q = H(O.as, O.crossOrigin);
        o.d.m(N, {
          as: typeof O.as == "string" && O.as !== "script" ? O.as : void 0,
          crossOrigin: Q,
          integrity: typeof O.integrity == "string" ? O.integrity : void 0
        });
      } else o.d.m(N);
  }, de.requestFormReset = function(N) {
    o.d.r(N);
  }, de.unstable_batchedUpdates = function(N, O) {
    return N(O);
  }, de.useFormState = function(N, O, Q) {
    return R.H.useFormState(N, O, Q);
  }, de.useFormStatus = function() {
    return R.H.useHostTransitionStatus();
  }, de.version = "19.3.0-canary-fb2177c1-20251114", de;
}
var Ch;
function Xh() {
  if (Ch) return Bo.exports;
  Ch = 1;
  function s() {
    if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function"))
      try {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(s);
      } catch (r) {
        console.error(r);
      }
  }
  return s(), Bo.exports = P0(), Bo.exports;
}
var $o = Xh();
const tp = /* @__PURE__ */ es($o), ep = /* @__PURE__ */ ts({
  __proto__: null,
  default: tp
}, [$o]), Se = (s) => {
  j0() && console.error(`Clerk: ${s}`);
}, Mh = (s, ...r) => {
  const m = { ...s };
  for (const o of r) delete m[o];
  return m;
}, np = (s) => `You've passed multiple children components to <${s}/>. You can only pass a single child component or text.`, lp = "<UserProfile.Page /> component needs to be a direct child of `<UserProfile />` or `<UserButton />`.", ap = "<UserProfile.Link /> component needs to be a direct child of `<UserProfile />` or `<UserButton />`.", up = "<OrganizationProfile.Page /> component needs to be a direct child of `<OrganizationProfile />` or `<OrganizationSwitcher />`.", ip = "<OrganizationProfile.Link /> component needs to be a direct child of `<OrganizationProfile />` or `<OrganizationSwitcher />`.", sp = (s) => `<${s} /> can only accept <${s}.Page /> and <${s}.Link /> as its children. Any other provided component will be ignored. Additionally, please ensure that the component is rendered in a client component.`, cp = (s) => `Missing props. <${s}.Page /> component requires the following props: url, label, labelIcon, alongside with children to be rendered inside the page.`, op = (s) => `Missing props. <${s}.Link /> component requires the following props: url, label and labelIcon.`, rp = "<UserButton /> can only accept <UserButton.UserProfilePage />, <UserButton.UserProfileLink /> and <UserButton.MenuItems /> as its children. Any other provided component will be ignored. Additionally, please ensure that the component is rendered in a client component.", fp = "<UserButton.MenuItems /> component can only accept <UserButton.Action /> and <UserButton.Link /> as its children. Any other provided component will be ignored. Additionally, please ensure that the component is rendered in a client component.", dp = "<UserButton.MenuItems /> component needs to be a direct child of `<UserButton />`.", mp = "<UserButton.Action /> component needs to be a direct child of `<UserButton.MenuItems />`.", hp = "<UserButton.Link /> component needs to be a direct child of `<UserButton.MenuItems />`.", gp = "Missing props. <UserButton.Link /> component requires the following props: href, label and labelIcon.", yp = "Missing props. <UserButton.Action /> component requires the following props: label.", _u = (s) => (r) => {
  try {
    return A.Children.only(s);
  } catch {
    const m = A.Children.toArray(s);
    return m.length === 1 && A.isValidElement(m[0]) ? m[0] : Jo.throw(np(r));
  }
}, Ou = (s, r) => (s || (s = r), typeof s == "string" && (s = /* @__PURE__ */ A.createElement("button", null, s)), s), zu = (s) => (...r) => {
  if (s && typeof s == "function") return s(...r);
}, Tu = (s) => {
  const [r, m] = At.useState(/* @__PURE__ */ new Map()), o = At.useRef(r), g = At.useRef(/* @__PURE__ */ new Map()), z = At.useRef(/* @__PURE__ */ new Map());
  o.current = r, g.current = new Map(s.map((H) => [H.id, H.component]));
  const R = new Set(s.map((H) => H.id));
  return z.current.forEach((H, N) => {
    R.has(N) || z.current.delete(N);
  }), s.map((H) => {
    const N = H.id, O = z.current.get(N);
    if (O) return O;
    const Q = () => {
      const $ = o.current.get(N), ft = g.current.get(N);
      return $ ? $o.createPortal(ft, $) : null;
    }, j = {
      id: H.id,
      mount: ($) => m((ft) => new Map(ft).set(N, $)),
      unmount: () => m(($) => {
        const ft = new Map($);
        return ft.set(N, null), ft;
      }),
      portal: Q
    };
    return z.current.set(N, j), j;
  });
}, be = (s, r) => !!s && A.isValidElement(s) && s?.type === r, kh = (s, r) => Kh({
  children: s,
  reorderItemsLabels: [
    "account",
    "security",
    "billing",
    "apiKeys"
  ],
  LinkComponent: Mu,
  PageComponent: Cu,
  MenuItemsComponent: ls,
  componentName: "UserProfile"
}, r), Vh = (s, r) => Kh({
  children: s,
  reorderItemsLabels: [
    "general",
    "members",
    "billing",
    "apiKeys"
  ],
  LinkComponent: us,
  PageComponent: as,
  componentName: "OrganizationProfile"
}, r), Zh = (s) => {
  const r = [], m = [
    us,
    as,
    ls,
    Cu,
    Mu
  ];
  return A.Children.forEach(s, (o) => {
    m.some((g) => be(o, g)) || r.push(o);
  }), r;
}, Kh = (s, r) => {
  const { children: m, LinkComponent: o, PageComponent: g, MenuItemsComponent: z, reorderItemsLabels: R, componentName: H } = s, { allowForAnyChildren: N = !1 } = r || {}, O = [], Q = /* @__PURE__ */ new Map();
  A.Children.forEach(m, (X) => {
    if (!be(X, g) && !be(X, o) && !be(X, z)) {
      X && !N && Se(sp(H));
      return;
    }
    const { props: it } = X, { children: _t, label: W, url: jt, labelIcon: I } = it, ot = X.key;
    if (be(X, g)) if (wh(it, R)) O.push({ label: W });
    else if (Lo(it)) O.push({
      label: W,
      labelIcon: I,
      children: _t,
      url: jt,
      portalId: Ah("page", it, ot, Q)
    });
    else {
      Se(cp(H));
      return;
    }
    if (be(X, o)) if (Yo(it)) O.push({
      label: W,
      labelIcon: I,
      url: jt,
      portalId: Ah("link", it, ot, Q)
    });
    else {
      Se(op(H));
      return;
    }
  });
  const j = [], $ = [], ft = [];
  O.forEach((X, it) => {
    if (Lo(X)) {
      j.push({
        component: X.children,
        id: X.portalId || it
      }), $.push({
        component: X.labelIcon,
        id: X.portalId || it
      });
      return;
    }
    Yo(X) && ft.push({
      component: X.labelIcon,
      id: X.portalId || it
    });
  });
  const gt = Tu(j), ct = Tu($), G = Tu(ft), wt = [], yt = [];
  return O.forEach((X, it) => {
    if (wh(X, R)) {
      wt.push({ label: X.label });
      return;
    }
    if (Lo(X)) {
      const { portal: _t, mount: W, unmount: jt } = gt.find((Ht) => Ht.id === (X.portalId || it)), { portal: I, mount: ot, unmount: Yt } = ct.find((Ht) => Ht.id === (X.portalId || it));
      wt.push({
        label: X.label,
        url: X.url,
        mount: W,
        unmount: jt,
        mountIcon: ot,
        unmountIcon: Yt
      }), yt.push({
        key: `content:${X.portalId || it}`,
        portal: _t
      }), yt.push({
        key: `label:${X.portalId || it}`,
        portal: I
      });
      return;
    }
    if (Yo(X)) {
      const { portal: _t, mount: W, unmount: jt } = G.find((I) => I.id === (X.portalId || it));
      wt.push({
        label: X.label,
        url: X.url,
        mountIcon: W,
        unmountIcon: jt
      }), yt.push({
        key: `label:${X.portalId || it}`,
        portal: _t
      });
      return;
    }
  }), {
    customPages: wt,
    customPagesPortals: yt
  };
}, Ah = (s, r, m, o) => {
  if (m != null) return `${s}:key:${m}`;
  const g = `${s}:${r.label}:${r.url}`, z = o.get(g) ?? 0;
  return o.set(g, z + 1), `${g}:${z}`;
}, wh = (s, r) => {
  const { children: m, label: o, url: g, labelIcon: z } = s;
  return !m && !g && !z && r.some((R) => R === o);
}, Lo = (s) => {
  const { children: r, label: m, url: o, labelIcon: g } = s;
  return !!r && !!o && !!g && !!m;
}, Yo = (s) => {
  const { children: r, label: m, url: o, labelIcon: g } = s;
  return !r && !!o && !!g && !!m;
}, vp = (s, r) => pp({
  children: s,
  reorderItemsLabels: ["manageAccount", "signOut"],
  MenuItemsComponent: ls,
  MenuActionComponent: $h,
  MenuLinkComponent: Fh,
  UserProfileLinkComponent: Mu,
  UserProfilePageComponent: Cu,
  allowForAnyChildren: r?.allowForAnyChildren ?? !1
}), pp = ({ children: s, MenuItemsComponent: r, MenuActionComponent: m, MenuLinkComponent: o, UserProfileLinkComponent: g, UserProfilePageComponent: z, reorderItemsLabels: R, allowForAnyChildren: H = !1 }) => {
  const N = [], O = [], Q = [], j = /* @__PURE__ */ new Map();
  A.Children.forEach(s, (G) => {
    if (!be(G, r) && !be(G, g) && !be(G, z)) {
      G && !H && Se(rp);
      return;
    }
    if (be(G, g) || be(G, z)) return;
    const { props: wt } = G;
    A.Children.forEach(wt.children, (yt) => {
      if (!be(yt, m) && !be(yt, o)) {
        yt && Se(fp);
        return;
      }
      const { props: X } = yt, it = yt.key, { label: _t, labelIcon: W, href: jt, onClick: I, open: ot } = X;
      if (be(yt, m)) if (Nh(X, R)) N.push({ label: _t });
      else if (Qo(X)) {
        const Yt = {
          label: _t,
          labelIcon: W
        };
        if (I !== void 0) N.push({
          ...Yt,
          onClick: I,
          portalId: Go("action", X, it, j)
        });
        else if (ot !== void 0) N.push({
          ...Yt,
          open: ot.startsWith("/") ? ot : `/${ot}`,
          portalId: Go("action", X, it, j)
        });
        else {
          Se("Custom menu item must have either onClick or open property");
          return;
        }
      } else {
        Se(yp);
        return;
      }
      if (be(yt, o)) if (Xo(X)) N.push({
        label: _t,
        labelIcon: W,
        href: jt,
        portalId: Go("link", X, it, j)
      });
      else {
        Se(gp);
        return;
      }
    });
  });
  const $ = [], ft = [];
  N.forEach((G, wt) => {
    Qo(G) && $.push({
      component: G.labelIcon,
      id: G.portalId || wt
    }), Xo(G) && ft.push({
      component: G.labelIcon,
      id: G.portalId || wt
    });
  });
  const gt = Tu($), ct = Tu(ft);
  return N.forEach((G, wt) => {
    if (Nh(G, R) && O.push({ label: G.label }), Qo(G)) {
      const { portal: yt, mount: X, unmount: it } = gt.find((W) => W.id === (G.portalId || wt)), _t = {
        label: G.label,
        mountIcon: X,
        unmountIcon: it
      };
      "onClick" in G ? _t.onClick = G.onClick : "open" in G && (_t.open = G.open), O.push(_t), Q.push({
        key: `icon:${G.portalId || wt}`,
        portal: yt
      });
    }
    if (Xo(G)) {
      const { portal: yt, mount: X, unmount: it } = ct.find((_t) => _t.id === (G.portalId || wt));
      O.push({
        label: G.label,
        href: G.href,
        mountIcon: X,
        unmountIcon: it
      }), Q.push({
        key: `icon:${G.portalId || wt}`,
        portal: yt
      });
    }
  }), {
    customMenuItems: O,
    customMenuItemsPortals: Q
  };
}, Go = (s, r, m, o) => {
  if (m != null) return `${s}:key:${m}`;
  const g = r.href || r.open || "", z = `${s}:${r.label}:${g}`, R = o.get(z) ?? 0;
  return o.set(z, R + 1), `${z}:${R}`;
}, Nh = (s, r) => {
  const { children: m, label: o, onClick: g, labelIcon: z } = s;
  return !m && !g && !z && r.some((R) => R === o);
}, Qo = (s) => {
  const { label: r, labelIcon: m, onClick: o, open: g } = s;
  return !!m && !!r && (typeof o == "function" || typeof g == "string");
}, Xo = (s) => {
  const { label: r, href: m, labelIcon: o } = s;
  return !!m && !!o && !!r;
}, bp = (s) => {
  const r = s?.isReady;
  return (m) => new Promise((o, g) => {
    const { root: z = document?.body, selector: R, timeout: H = 0 } = m;
    if (!z) {
      g(/* @__PURE__ */ new Error("No root element provided"));
      return;
    }
    let N = z;
    if (R && (N = z?.querySelector(R)), r(N, R)) {
      o();
      return;
    }
    const O = new MutationObserver((Q) => {
      for (const j of Q)
        if (!N && R && (N = z?.querySelector(R)), (s.childList && j.type === "childList" || s.attributes && j.type === "attributes") && r(N, R)) {
          O.disconnect(), o();
          return;
        }
    });
    O.observe(z, s), H > 0 && setTimeout(() => {
      O.disconnect(), g(/* @__PURE__ */ new Error(`Timeout waiting for ${R}`));
    }, H);
  });
}, Sp = bp({
  childList: !0,
  subtree: !0,
  isReady: (s, r) => !!s?.childElementCount && s?.matches?.(r) && s.childElementCount > 0
});
function le(s, r) {
  const m = At.useRef(), [o, g] = At.useState("rendering");
  return At.useEffect(() => {
    if (!s) throw new Error("Clerk: no component name provided, unable to detect mount.");
    if (typeof window < "u" && !m.current) {
      const z = `[data-clerk-component="${s}"]`, R = r?.selector;
      m.current = Sp({ selector: R ? z + R : z }).then(() => {
        g("rendered");
      }).catch(() => {
        g("error");
      });
    }
  }, [s, r?.selector]), o;
}
const Ii = (s) => "mount" in s, Uh = (s) => "open" in s, Dh = (s) => s?.map(({ mountIcon: r, unmountIcon: m, ...o }) => o);
var Ft = class extends A.PureComponent {
  constructor(...s) {
    super(...s), this.rootRef = A.createRef();
  }
  componentDidUpdate(s) {
    if (!Ii(s) || !Ii(this.props)) return;
    const r = Mh(s.props || {}, "customPages", "customMenuItems", "children"), m = Mh(this.props.props || {}, "customPages", "customMenuItems", "children"), o = s.props?.customPages?.length !== this.props.props?.customPages?.length, g = s.props?.customMenuItems?.length !== this.props.props?.customMenuItems?.length, z = Dh(s.props?.customMenuItems), R = Dh(this.props.props?.customMenuItems);
    (!Th(r, m) || !Th(z, R) || o || g) && this.rootRef.current && this.props.updateProps({
      node: this.rootRef.current,
      props: this.props.props
    });
  }
  componentDidMount() {
    this.rootRef.current && (Ii(this.props) && this.props.mount(this.rootRef.current, this.props.props), Uh(this.props) && this.props.open(this.props.props));
  }
  componentWillUnmount() {
    this.rootRef.current && (Ii(this.props) && this.props.unmount(this.rootRef.current), Uh(this.props) && this.props.close());
  }
  render() {
    const { hideRootHtmlElement: s = !1 } = this.props, r = {
      ref: this.rootRef,
      ...this.props.rootProps,
      ...this.props.component && { "data-clerk-component": this.props.component }
    };
    return /* @__PURE__ */ A.createElement(A.Fragment, null, !s && /* @__PURE__ */ A.createElement("div", r), this.props.children);
  }
};
const zt = (s, r) => {
  const m = (typeof r == "string" ? r : r?.component) || s.displayName || s.name || "Component";
  s.displayName = m;
  const o = typeof r == "string" ? void 0 : r, g = (z) => {
    I0(m || "withClerk");
    const R = W0(), H = $0();
    return !R.loaded && !o?.renderWhileLoading ? null : /* @__PURE__ */ A.createElement(s, {
      getContainer: H,
      ...z,
      component: m,
      clerk: R
    });
  };
  return g.displayName = `withClerk(${m})`, g;
}, ns = (s) => /* @__PURE__ */ A.createElement(A.Fragment, null, s?.customPagesPortals?.map(({ key: r, portal: m }) => At.createElement(m, { key: r })), s?.customMenuItemsPortals?.map(({ key: r, portal: m }) => At.createElement(m, { key: r })));
zt(({ clerk: s, component: r, fallback: m, ...o }) => {
  const g = le(r) === "rendering" || !s.loaded, z = { ...g && m && { style: { display: "none" } } };
  return /* @__PURE__ */ A.createElement(A.Fragment, null, g && m, s.loaded && /* @__PURE__ */ A.createElement(Ft, {
    component: r,
    mount: s.mountSignIn,
    unmount: s.unmountSignIn,
    updateProps: s.__internal_updateProps,
    props: o,
    rootProps: z
  }));
}, {
  component: "SignIn",
  renderWhileLoading: !0
});
zt(({ clerk: s, component: r, fallback: m, ...o }) => {
  const g = le(r) === "rendering" || !s.loaded, z = { ...g && m && { style: { display: "none" } } };
  return /* @__PURE__ */ A.createElement(A.Fragment, null, g && m, s.loaded && /* @__PURE__ */ A.createElement(Ft, {
    component: r,
    mount: s.mountSignUp,
    unmount: s.unmountSignUp,
    updateProps: s.__internal_updateProps,
    props: o,
    rootProps: z
  }));
}, {
  component: "SignUp",
  renderWhileLoading: !0
});
function Cu({ children: s }) {
  return Se(lp), /* @__PURE__ */ A.createElement(A.Fragment, null, s);
}
function Mu({ children: s }) {
  return Se(ap), /* @__PURE__ */ A.createElement(A.Fragment, null, s);
}
const Ep = zt(({ clerk: s, component: r, fallback: m, ...o }) => {
  const g = le(r) === "rendering" || !s.loaded, z = { ...g && m && { style: { display: "none" } } }, { customPages: R, customPagesPortals: H } = kh(o.children);
  return /* @__PURE__ */ A.createElement(A.Fragment, null, g && m, /* @__PURE__ */ A.createElement(Ft, {
    component: r,
    mount: s.mountUserProfile,
    unmount: s.unmountUserProfile,
    updateProps: s.__internal_updateProps,
    props: {
      ...o,
      customPages: R
    },
    rootProps: z
  }, /* @__PURE__ */ A.createElement(ns, { customPagesPortals: H })));
}, {
  component: "UserProfile",
  renderWhileLoading: !0
});
Object.assign(Ep, {
  Page: Cu,
  Link: Mu
});
const Jh = At.createContext({
  mount: () => {
  },
  unmount: () => {
  },
  updateProps: () => {
  }
}), Tp = zt(({ clerk: s, component: r, fallback: m, ...o }) => {
  const g = le(r) === "rendering" || !s.loaded, z = { ...g && m && { style: { display: "none" } } }, { customPages: R, customPagesPortals: H } = kh(o.children, { allowForAnyChildren: !!o.__experimental_asProvider }), N = {
    ...o.userProfileProps,
    customPages: R
  }, { customMenuItems: O, customMenuItemsPortals: Q } = vp(o.children, { allowForAnyChildren: !!o.__experimental_asProvider }), j = Zh(o.children), $ = {
    mount: s.mountUserButton,
    unmount: s.unmountUserButton,
    updateProps: s.__internal_updateProps,
    props: {
      ...o,
      userProfileProps: N,
      customMenuItems: O
    }
  }, ft = {
    customPagesPortals: H,
    customMenuItemsPortals: Q
  };
  return /* @__PURE__ */ A.createElement(Jh.Provider, { value: $ }, g && m, s.loaded && /* @__PURE__ */ A.createElement(Ft, {
    component: r,
    ...$,
    hideRootHtmlElement: !!o.__experimental_asProvider,
    rootProps: z
  }, o.__experimental_asProvider ? j : null, /* @__PURE__ */ A.createElement(ns, ft)));
}, {
  component: "UserButton",
  renderWhileLoading: !0
});
function ls({ children: s }) {
  return Se(dp), /* @__PURE__ */ A.createElement(A.Fragment, null, s);
}
function $h({ children: s }) {
  return Se(mp), /* @__PURE__ */ A.createElement(A.Fragment, null, s);
}
function Fh({ children: s }) {
  return Se(hp), /* @__PURE__ */ A.createElement(A.Fragment, null, s);
}
function _p(s) {
  const r = At.useContext(Jh), m = {
    ...r,
    props: {
      ...r.props,
      ...s
    }
  };
  return /* @__PURE__ */ A.createElement(Ft, m);
}
Object.assign(Tp, {
  UserProfilePage: Cu,
  UserProfileLink: Mu,
  MenuItems: ls,
  Action: $h,
  Link: Fh,
  __experimental_Outlet: _p
});
function as({ children: s }) {
  return Se(up), /* @__PURE__ */ A.createElement(A.Fragment, null, s);
}
function us({ children: s }) {
  return Se(ip), /* @__PURE__ */ A.createElement(A.Fragment, null, s);
}
const Op = zt(({ clerk: s, component: r, fallback: m, ...o }) => {
  const g = le(r) === "rendering" || !s.loaded, z = { ...g && m && { style: { display: "none" } } }, { customPages: R, customPagesPortals: H } = Vh(o.children);
  return /* @__PURE__ */ A.createElement(A.Fragment, null, g && m, s.loaded && /* @__PURE__ */ A.createElement(Ft, {
    component: r,
    mount: s.mountOrganizationProfile,
    unmount: s.unmountOrganizationProfile,
    updateProps: s.__internal_updateProps,
    props: {
      ...o,
      customPages: R
    },
    rootProps: z
  }, /* @__PURE__ */ A.createElement(ns, { customPagesPortals: H })));
}, {
  component: "OrganizationProfile",
  renderWhileLoading: !0
});
Object.assign(Op, {
  Page: as,
  Link: us
});
zt(({ clerk: s, component: r, fallback: m, ...o }) => {
  const g = le(r) === "rendering" || !s.loaded, z = { ...g && m && { style: { display: "none" } } };
  return /* @__PURE__ */ A.createElement(A.Fragment, null, g && m, s.loaded && /* @__PURE__ */ A.createElement(Ft, {
    component: r,
    mount: s.mountCreateOrganization,
    unmount: s.unmountCreateOrganization,
    updateProps: s.__internal_updateProps,
    props: o,
    rootProps: z
  }));
}, {
  component: "CreateOrganization",
  renderWhileLoading: !0
});
const Wh = At.createContext({
  mount: () => {
  },
  unmount: () => {
  },
  updateProps: () => {
  }
}), zp = zt(({ clerk: s, component: r, fallback: m, ...o }) => {
  const g = le(r) === "rendering" || !s.loaded, z = { ...g && m && { style: { display: "none" } } }, { customPages: R, customPagesPortals: H } = Vh(o.children, { allowForAnyChildren: !!o.__experimental_asProvider }), N = {
    ...o.organizationProfileProps,
    customPages: R
  }, O = Zh(o.children), Q = {
    mount: s.mountOrganizationSwitcher,
    unmount: s.unmountOrganizationSwitcher,
    updateProps: s.__internal_updateProps,
    props: {
      ...o,
      organizationProfileProps: N
    },
    rootProps: z,
    component: r
  };
  return s.__experimental_prefetchOrganizationSwitcher(), /* @__PURE__ */ A.createElement(Wh.Provider, { value: Q }, /* @__PURE__ */ A.createElement(A.Fragment, null, g && m, s.loaded && /* @__PURE__ */ A.createElement(Ft, {
    ...Q,
    hideRootHtmlElement: !!o.__experimental_asProvider
  }, o.__experimental_asProvider ? O : null, /* @__PURE__ */ A.createElement(ns, { customPagesPortals: H }))));
}, {
  component: "OrganizationSwitcher",
  renderWhileLoading: !0
});
function Cp(s) {
  const r = At.useContext(Wh), m = {
    ...r,
    props: {
      ...r.props,
      ...s
    }
  };
  return /* @__PURE__ */ A.createElement(Ft, m);
}
Object.assign(zp, {
  OrganizationProfilePage: as,
  OrganizationProfileLink: us,
  __experimental_Outlet: Cp
});
zt(({ clerk: s, component: r, fallback: m, ...o }) => {
  const g = le(r) === "rendering" || !s.loaded, z = { ...g && m && { style: { display: "none" } } };
  return /* @__PURE__ */ A.createElement(A.Fragment, null, g && m, s.loaded && /* @__PURE__ */ A.createElement(Ft, {
    component: r,
    mount: s.mountOrganizationList,
    unmount: s.unmountOrganizationList,
    updateProps: s.__internal_updateProps,
    props: o,
    rootProps: z
  }));
}, {
  component: "OrganizationList",
  renderWhileLoading: !0
});
zt(({ clerk: s, component: r, fallback: m, ...o }) => {
  const g = le(r) === "rendering" || !s.loaded, z = { ...g && m && { style: { display: "none" } } };
  return /* @__PURE__ */ A.createElement(A.Fragment, null, g && m, s.loaded && /* @__PURE__ */ A.createElement(Ft, {
    component: r,
    open: s.openGoogleOneTap,
    close: s.closeGoogleOneTap,
    updateProps: s.__internal_updateProps,
    props: o,
    rootProps: z
  }));
}, {
  component: "GoogleOneTap",
  renderWhileLoading: !0
});
zt(({ clerk: s, component: r, fallback: m, ...o }) => {
  const g = le(r) === "rendering" || !s.loaded, z = { ...g && m && { style: { display: "none" } } };
  return /* @__PURE__ */ A.createElement(A.Fragment, null, g && m, s.loaded && /* @__PURE__ */ A.createElement(Ft, {
    component: r,
    mount: s.mountWaitlist,
    unmount: s.unmountWaitlist,
    updateProps: s.__internal_updateProps,
    props: o,
    rootProps: z
  }));
}, {
  component: "Waitlist",
  renderWhileLoading: !0
});
zt(({ clerk: s, component: r, fallback: m, ...o }) => {
  const g = le(r, { selector: '[data-component-status="ready"]' }) === "rendering" || !s.loaded, z = { ...g && m && { style: { display: "none" } } };
  return /* @__PURE__ */ A.createElement(A.Fragment, null, g && m, s.loaded && /* @__PURE__ */ A.createElement(Ft, {
    component: r,
    mount: s.mountPricingTable,
    unmount: s.unmountPricingTable,
    updateProps: s.__internal_updateProps,
    props: o,
    rootProps: z
  }));
}, {
  component: "PricingTable",
  renderWhileLoading: !0
});
zt(({ clerk: s, component: r, fallback: m, ...o }) => {
  const g = le(r) === "rendering" || !s.loaded, z = { ...g && m && { style: { display: "none" } } };
  return /* @__PURE__ */ A.createElement(A.Fragment, null, g && m, s.loaded && /* @__PURE__ */ A.createElement(Ft, {
    component: r,
    mount: s.mountAPIKeys,
    unmount: s.unmountAPIKeys,
    updateProps: s.__internal_updateProps,
    props: o,
    rootProps: z
  }));
}, {
  component: "ApiKeys",
  renderWhileLoading: !0
});
zt(({ clerk: s, component: r, fallback: m, ...o }) => {
  const g = le(r) === "rendering" || !s.loaded, z = { ...g && m && { style: { display: "none" } } };
  return /* @__PURE__ */ A.createElement(A.Fragment, null, g && m, s.loaded && /* @__PURE__ */ A.createElement(Ft, {
    component: r,
    mount: s.__internal_mountOAuthConsent,
    unmount: s.__internal_unmountOAuthConsent,
    updateProps: s.__internal_updateProps,
    props: o,
    rootProps: z
  }));
}, {
  component: "OAuthConsent",
  renderWhileLoading: !0
});
zt(({ clerk: s, component: r, fallback: m, ...o }) => {
  const g = le(r) === "rendering" || !s.loaded, z = { ...g && m && { style: { display: "none" } } };
  return /* @__PURE__ */ A.createElement(A.Fragment, null, g && m, s.loaded && /* @__PURE__ */ A.createElement(Ft, {
    component: r,
    mount: s.__internal_mountOAuthDeviceVerification,
    unmount: s.__internal_unmountOAuthDeviceVerification,
    updateProps: (R) => void s.__internal_updateProps(R),
    props: o,
    rootProps: z
  }));
}, {
  component: "OAuthDeviceVerification",
  renderWhileLoading: !0
});
zt(({ clerk: s, component: r, fallback: m, ...o }) => {
  const g = le(r) === "rendering" || !s.loaded, z = { ...g && m && { style: { display: "none" } } };
  return /* @__PURE__ */ A.createElement(A.Fragment, null, g && m, s.loaded && /* @__PURE__ */ A.createElement(Ft, {
    component: r,
    mount: s.mountUserAvatar,
    unmount: s.unmountUserAvatar,
    updateProps: s.__internal_updateProps,
    props: o,
    rootProps: z
  }));
}, {
  component: "UserAvatar",
  renderWhileLoading: !0
});
zt(({ clerk: s, component: r, fallback: m, ...o }) => {
  const g = le(r) === "rendering" || !s.loaded, z = { ...g && m && { style: { display: "none" } } };
  return /* @__PURE__ */ A.createElement(A.Fragment, null, g && m, s.loaded && /* @__PURE__ */ A.createElement(Ft, {
    component: r,
    mount: s.mountTaskChooseOrganization,
    unmount: s.unmountTaskChooseOrganization,
    updateProps: s.__internal_updateProps,
    props: o,
    rootProps: z
  }));
}, {
  component: "TaskChooseOrganization",
  renderWhileLoading: !0
});
zt(({ clerk: s, component: r, fallback: m, ...o }) => {
  const g = le(r) === "rendering" || !s.loaded, z = { ...g && m && { style: { display: "none" } } };
  return /* @__PURE__ */ A.createElement(A.Fragment, null, g && m, s.loaded && /* @__PURE__ */ A.createElement(Ft, {
    component: r,
    mount: s.mountTaskResetPassword,
    unmount: s.unmountTaskResetPassword,
    updateProps: s.__internal_updateProps,
    props: o,
    rootProps: z
  }));
}, {
  component: "TaskResetPassword",
  renderWhileLoading: !0
});
zt(({ clerk: s, component: r, fallback: m, ...o }) => {
  const g = le(r) === "rendering" || !s.loaded, z = { ...g && m && { style: { display: "none" } } };
  return /* @__PURE__ */ A.createElement(A.Fragment, null, g && m, s.loaded && /* @__PURE__ */ A.createElement(Ft, {
    component: r,
    mount: s.mountTaskSetupMFA,
    unmount: s.unmountTaskSetupMFA,
    updateProps: s.__internal_updateProps,
    props: o,
    rootProps: z
  }));
}, {
  component: "TaskSetupMFA",
  renderWhileLoading: !0
});
const Mp = Yh({ packageName: "@clerk/shared" });
function Ap(s) {
  Mp.setPackageName({ packageName: s });
}
const Rh = /* @__PURE__ */ new Set(), is = (s, r, m) => {
  const o = x0() || H0(), g = s;
  Rh.has(g) || o || (Rh.add(g), console.warn(`Clerk - DEPRECATION WARNING: "${s}" is deprecated and will be removed in the next major release.
${r}`));
};
function wp(s) {
  const r = s.match(/^(\d+)\.(\d+)\.(\d+)/);
  if (!r) return null;
  const [, m, o, g] = r;
  return {
    major: parseInt(m, 10),
    minor: parseInt(o, 10),
    patch: parseInt(g, 10)
  };
}
function Np(s, r) {
  const { major: m, minor: o, patch: g } = s;
  return r.some(([z, R, H, N]) => m !== z ? !1 : H === -1 ? o > R || o === R && g >= N : o === H && g >= N);
}
function Up(s, r) {
  const m = wp(s);
  return m ? Np(m, r) : !1;
}
zt(({ clerk: s, ...r }) => {
  const { client: m, session: o } = s, g = (m.signedInSessions?.length ?? 0) > 0;
  return A.useEffect(() => {
    o === null && g ? s.redirectToAfterSignOut() : s.redirectToSignIn(r);
  }, []), null;
}, "RedirectToSignIn");
zt(({ clerk: s, ...r }) => (A.useEffect(() => {
  s.redirectToSignUp(r);
}, []), null), "RedirectToSignUp");
zt(({ clerk: s, ...r }) => (A.useEffect(() => {
  s.redirectToTasks(r);
}, []), null), "RedirectToTasks");
zt(({ clerk: s }) => (A.useEffect(() => {
  is("RedirectToUserProfile", "Use the `redirectToUserProfile()` method instead."), s.redirectToUserProfile();
}, []), null), "RedirectToUserProfile");
zt(({ clerk: s }) => (A.useEffect(() => {
  is("RedirectToOrganizationProfile", "Use the `redirectToOrganizationProfile()` method instead."), s.redirectToOrganizationProfile();
}, []), null), "RedirectToOrganizationProfile");
zt(({ clerk: s }) => (A.useEffect(() => {
  is("RedirectToCreateOrganization", "Use the `redirectToCreateOrganization()` method instead."), s.redirectToCreateOrganization();
}, []), null), "RedirectToCreateOrganization");
zt(({ clerk: s, ...r }) => (A.useEffect(() => {
  s.handleRedirectCallback(r);
}, []), null), "AuthenticateWithRedirectCallback");
typeof globalThis.__BUILD_DISABLE_RHC__ > "u" && (globalThis.__BUILD_DISABLE_RHC__ = !1);
function Dp() {
  try {
    return Up(A.version, [
      [
        18,
        0,
        -1,
        0
      ],
      [
        19,
        0,
        0,
        3
      ],
      [
        19,
        1,
        1,
        4
      ],
      [
        19,
        2,
        2,
        3
      ],
      [
        19,
        3,
        3,
        0
      ]
    ]);
  } catch {
    return !1;
  }
}
Dp();
var ko = { exports: {} }, Su = {}, Vo = { exports: {} }, Zo = {};
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var qh;
function Rp() {
  return qh || (qh = 1, (function(s) {
    function r(B, K) {
      var tt = B.length;
      B.push(K);
      t: for (; 0 < tt; ) {
        var bt = tt - 1 >>> 1, T = B[bt];
        if (0 < g(T, K))
          B[bt] = K, B[tt] = T, tt = bt;
        else break t;
      }
    }
    function m(B) {
      return B.length === 0 ? null : B[0];
    }
    function o(B) {
      if (B.length === 0) return null;
      var K = B[0], tt = B.pop();
      if (tt !== K) {
        B[0] = tt;
        t: for (var bt = 0, T = B.length, y = T >>> 1; bt < y; ) {
          var V = 2 * (bt + 1) - 1, F = B[V], d = V + 1, C = B[d];
          if (0 > g(F, tt))
            d < T && 0 > g(C, F) ? (B[bt] = C, B[d] = tt, bt = d) : (B[bt] = F, B[V] = tt, bt = V);
          else if (d < T && 0 > g(C, tt))
            B[bt] = C, B[d] = tt, bt = d;
          else break t;
        }
      }
      return K;
    }
    function g(B, K) {
      var tt = B.sortIndex - K.sortIndex;
      return tt !== 0 ? tt : B.id - K.id;
    }
    if (s.unstable_now = void 0, typeof performance == "object" && typeof performance.now == "function") {
      var z = performance;
      s.unstable_now = function() {
        return z.now();
      };
    } else {
      var R = Date, H = R.now();
      s.unstable_now = function() {
        return R.now() - H;
      };
    }
    var N = [], O = [], Q = 1, j = null, $ = 3, ft = !1, gt = !1, ct = !1, G = !1, wt = typeof setTimeout == "function" ? setTimeout : null, yt = typeof clearTimeout == "function" ? clearTimeout : null, X = typeof setImmediate < "u" ? setImmediate : null;
    function it(B) {
      for (var K = m(O); K !== null; ) {
        if (K.callback === null) o(O);
        else if (K.startTime <= B)
          o(O), K.sortIndex = K.expirationTime, r(N, K);
        else break;
        K = m(O);
      }
    }
    function _t(B) {
      if (ct = !1, it(B), !gt)
        if (m(N) !== null)
          gt = !0, W || (W = !0, Zt());
        else {
          var K = m(O);
          K !== null && Pt(_t, K.startTime - B);
        }
    }
    var W = !1, jt = -1, I = 5, ot = -1;
    function Yt() {
      return G ? !0 : !(s.unstable_now() - ot < I);
    }
    function Ht() {
      if (G = !1, W) {
        var B = s.unstable_now();
        ot = B;
        var K = !0;
        try {
          t: {
            gt = !1, ct && (ct = !1, yt(jt), jt = -1), ft = !0;
            var tt = $;
            try {
              e: {
                for (it(B), j = m(N); j !== null && !(j.expirationTime > B && Yt()); ) {
                  var bt = j.callback;
                  if (typeof bt == "function") {
                    j.callback = null, $ = j.priorityLevel;
                    var T = bt(
                      j.expirationTime <= B
                    );
                    if (B = s.unstable_now(), typeof T == "function") {
                      j.callback = T, it(B), K = !0;
                      break e;
                    }
                    j === m(N) && o(N), it(B);
                  } else o(N);
                  j = m(N);
                }
                if (j !== null) K = !0;
                else {
                  var y = m(O);
                  y !== null && Pt(
                    _t,
                    y.startTime - B
                  ), K = !1;
                }
              }
              break t;
            } finally {
              j = null, $ = tt, ft = !1;
            }
            K = void 0;
          }
        } finally {
          K ? Zt() : W = !1;
        }
      }
    }
    var Zt;
    if (typeof X == "function")
      Zt = function() {
        X(Ht);
      };
    else if (typeof MessageChannel < "u") {
      var Ae = new MessageChannel(), Wt = Ae.port2;
      Ae.port1.onmessage = Ht, Zt = function() {
        Wt.postMessage(null);
      };
    } else
      Zt = function() {
        wt(Ht, 0);
      };
    function Pt(B, K) {
      jt = wt(function() {
        B(s.unstable_now());
      }, K);
    }
    s.unstable_IdlePriority = 5, s.unstable_ImmediatePriority = 1, s.unstable_LowPriority = 4, s.unstable_NormalPriority = 3, s.unstable_Profiling = null, s.unstable_UserBlockingPriority = 2, s.unstable_cancelCallback = function(B) {
      B.callback = null;
    }, s.unstable_forceFrameRate = function(B) {
      0 > B || 125 < B ? console.error(
        "forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported"
      ) : I = 0 < B ? Math.floor(1e3 / B) : 5;
    }, s.unstable_getCurrentPriorityLevel = function() {
      return $;
    }, s.unstable_next = function(B) {
      switch ($) {
        case 1:
        case 2:
        case 3:
          var K = 3;
          break;
        default:
          K = $;
      }
      var tt = $;
      $ = K;
      try {
        return B();
      } finally {
        $ = tt;
      }
    }, s.unstable_requestPaint = function() {
      G = !0;
    }, s.unstable_runWithPriority = function(B, K) {
      switch (B) {
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          break;
        default:
          B = 3;
      }
      var tt = $;
      $ = B;
      try {
        return K();
      } finally {
        $ = tt;
      }
    }, s.unstable_scheduleCallback = function(B, K, tt) {
      var bt = s.unstable_now();
      switch (typeof tt == "object" && tt !== null ? (tt = tt.delay, tt = typeof tt == "number" && 0 < tt ? bt + tt : bt) : tt = bt, B) {
        case 1:
          var T = -1;
          break;
        case 2:
          T = 250;
          break;
        case 5:
          T = 1073741823;
          break;
        case 4:
          T = 1e4;
          break;
        default:
          T = 5e3;
      }
      return T = tt + T, B = {
        id: Q++,
        callback: K,
        priorityLevel: B,
        startTime: tt,
        expirationTime: T,
        sortIndex: -1
      }, tt > bt ? (B.sortIndex = tt, r(O, B), m(N) === null && B === m(O) && (ct ? (yt(jt), jt = -1) : ct = !0, Pt(_t, tt - bt))) : (B.sortIndex = T, r(N, B), gt || ft || (gt = !0, W || (W = !0, Zt()))), B;
    }, s.unstable_shouldYield = Yt, s.unstable_wrapCallback = function(B) {
      var K = $;
      return function() {
        var tt = $;
        $ = K;
        try {
          return B.apply(this, arguments);
        } finally {
          $ = tt;
        }
      };
    };
  })(Zo)), Zo;
}
var jh;
function qp() {
  return jh || (jh = 1, Vo.exports = Rp()), Vo.exports;
}
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var xh;
function jp() {
  if (xh) return Su;
  xh = 1;
  var s = qp(), r = Ko(), m = Xh();
  function o(t) {
    var e = "https://react.dev/errors/" + t;
    if (1 < arguments.length) {
      e += "?args[]=" + encodeURIComponent(arguments[1]);
      for (var n = 2; n < arguments.length; n++)
        e += "&args[]=" + encodeURIComponent(arguments[n]);
    }
    return "Minified React error #" + t + "; visit " + e + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  function g(t) {
    return !(!t || t.nodeType !== 1 && t.nodeType !== 9 && t.nodeType !== 11);
  }
  function z(t) {
    var e = t, n = t;
    if (t.alternate) for (; e.return; ) e = e.return;
    else {
      t = e;
      do
        e = t, (e.flags & 4098) !== 0 && (n = e.return), t = e.return;
      while (t);
    }
    return e.tag === 3 ? n : null;
  }
  function R(t) {
    if (t.tag === 13) {
      var e = t.memoizedState;
      if (e === null && (t = t.alternate, t !== null && (e = t.memoizedState)), e !== null) return e.dehydrated;
    }
    return null;
  }
  function H(t) {
    if (t.tag === 31) {
      var e = t.memoizedState;
      if (e === null && (t = t.alternate, t !== null && (e = t.memoizedState)), e !== null) return e.dehydrated;
    }
    return null;
  }
  function N(t) {
    if (z(t) !== t)
      throw Error(o(188));
  }
  function O(t) {
    var e = t.alternate;
    if (!e) {
      if (e = z(t), e === null) throw Error(o(188));
      return e !== t ? null : t;
    }
    for (var n = t, l = e; ; ) {
      var a = n.return;
      if (a === null) break;
      var u = a.alternate;
      if (u === null) {
        if (l = a.return, l !== null) {
          n = l;
          continue;
        }
        break;
      }
      if (a.child === u.child) {
        for (u = a.child; u; ) {
          if (u === n) return N(a), t;
          if (u === l) return N(a), e;
          u = u.sibling;
        }
        throw Error(o(188));
      }
      if (n.return !== l.return) n = a, l = u;
      else {
        for (var i = !1, c = a.child; c; ) {
          if (c === n) {
            i = !0, n = a, l = u;
            break;
          }
          if (c === l) {
            i = !0, l = a, n = u;
            break;
          }
          c = c.sibling;
        }
        if (!i) {
          for (c = u.child; c; ) {
            if (c === n) {
              i = !0, n = u, l = a;
              break;
            }
            if (c === l) {
              i = !0, l = u, n = a;
              break;
            }
            c = c.sibling;
          }
          if (!i) throw Error(o(189));
        }
      }
      if (n.alternate !== l) throw Error(o(190));
    }
    if (n.tag !== 3) throw Error(o(188));
    return n.stateNode.current === n ? t : e;
  }
  function Q(t) {
    var e = t.tag;
    if (e === 5 || e === 26 || e === 27 || e === 6) return t;
    for (t = t.child; t !== null; ) {
      if (e = Q(t), e !== null) return e;
      t = t.sibling;
    }
    return null;
  }
  function j(t, e, n, l, a, u) {
    for (; t !== null; ) {
      if (t.tag === 5 && n(t, l, a, u) || (t.tag !== 22 || t.memoizedState === null) && (e || t.tag !== 5) && j(
        t.child,
        e,
        n,
        l,
        a,
        u
      ))
        return !0;
      t = t.sibling;
    }
    return !1;
  }
  function $(t) {
    for (t = t.return; t !== null; ) {
      if (t.tag === 3 || t.tag === 5) return t;
      t = t.return;
    }
    return null;
  }
  function ft(t, e, n) {
    for (var l = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : !1; n !== null; ) {
      if (n === e)
        if (l = !0, n.sibling) n = n.sibling;
        else return !0;
      if (n.tag === 5) {
        if (l) return t[1] = n, !0;
        t[0] = n;
      } else if ((n.tag !== 22 || n.memoizedState === null) && ft(t, e, n.child, l))
        return !0;
      n = n.sibling;
    }
    return !1;
  }
  function gt(t) {
    switch (t.tag) {
      case 5:
        return t.stateNode;
      case 3:
        return t.stateNode.containerInfo;
      default:
        throw Error(o(559));
    }
  }
  var ct = null, G = null;
  function wt(t) {
    return ct = t, !0;
  }
  function yt(t, e, n) {
    return t === n ? !0 : t === e ? (ct = t, !0) : !1;
  }
  function X(t, e, n) {
    return t === n ? (G = t, !1) : t === e ? (G !== null && (ct = t), !0) : !1;
  }
  function it(t) {
    if (t === null) return null;
    do
      t = t === null ? null : t.return;
    while (t && t.tag !== 5 && t.tag !== 27 && t.tag !== 3);
    return t || null;
  }
  function _t(t, e, n) {
    for (var l = 0, a = t; a; a = n(a)) l++;
    a = 0;
    for (var u = e; u; u = n(u)) a++;
    for (; 0 < l - a; ) t = n(t), l--;
    for (; 0 < a - l; ) e = n(e), a--;
    for (; l--; ) {
      if (t === e || e !== null && t === e.alternate)
        return t;
      t = n(t), e = n(e);
    }
    return null;
  }
  var W = Object.assign, jt = Symbol.for("react.element"), I = Symbol.for("react.transitional.element"), ot = Symbol.for("react.portal"), Yt = Symbol.for("react.fragment"), Ht = Symbol.for("react.strict_mode"), Zt = Symbol.for("react.profiler"), Ae = Symbol.for("react.consumer"), Wt = Symbol.for("react.context"), Pt = Symbol.for("react.forward_ref"), B = Symbol.for("react.suspense"), K = Symbol.for("react.suspense_list"), tt = Symbol.for("react.memo"), bt = Symbol.for("react.lazy"), T = Symbol.for("react.activity"), y = Symbol.for("react.legacy_hidden"), V = Symbol.for("react.memo_cache_sentinel"), F = Symbol.for("react.view_transition"), d = Symbol.iterator;
  function C(t) {
    return t === null || typeof t != "object" ? null : (t = d && t[d] || t["@@iterator"], typeof t == "function" ? t : null);
  }
  var q = Symbol.for("react.client.reference");
  function D(t) {
    if (t == null) return null;
    if (typeof t == "function")
      return t.$$typeof === q ? null : t.displayName || t.name || null;
    if (typeof t == "string") return t;
    switch (t) {
      case Yt:
        return "Fragment";
      case Zt:
        return "Profiler";
      case Ht:
        return "StrictMode";
      case B:
        return "Suspense";
      case K:
        return "SuspenseList";
      case T:
        return "Activity";
      case F:
        return "ViewTransition";
    }
    if (typeof t == "object")
      switch (t.$$typeof) {
        case ot:
          return "Portal";
        case Wt:
          return t.displayName || "Context";
        case Ae:
          return (t._context.displayName || "Context") + ".Consumer";
        case Pt:
          var e = t.render;
          return t = t.displayName, t || (t = e.displayName || e.name || "", t = t !== "" ? "ForwardRef(" + t + ")" : "ForwardRef"), t;
        case tt:
          return e = t.displayName || null, e !== null ? e : D(t.type) || "Memo";
        case bt:
          e = t._payload, t = t._init;
          try {
            return D(t(e));
          } catch {
          }
      }
    return null;
  }
  var Y = Array.isArray, U = r.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, x = m.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, nt = {
    pending: !1,
    data: null,
    method: null,
    action: null
  }, st = [], Rt = -1;
  function lt(t) {
    return { current: t };
  }
  function St(t) {
    0 > Rt || (t.current = st[Rt], st[Rt] = null, Rt--);
  }
  function rt(t, e) {
    Rt++, st[Rt] = t.current, t.current = e;
  }
  var Gt = lt(null), me = lt(null), re = lt(null), he = lt(null);
  function Al(t, e) {
    switch (rt(re, e), rt(me, t), rt(Gt, null), e.nodeType) {
      case 9:
      case 11:
        t = (t = e.documentElement) && (t = t.namespaceURI) ? Mm(t) : 0;
        break;
      default:
        if (t = e.tagName, e = e.namespaceURI)
          e = Mm(e), t = Am(e, t);
        else
          switch (t) {
            case "svg":
              t = 1;
              break;
            case "math":
              t = 2;
              break;
            default:
              t = 0;
          }
    }
    St(Gt), rt(Gt, t);
  }
  function Un() {
    St(Gt), St(me), St(re);
  }
  function ba(t) {
    t.memoizedState !== null && rt(he, t);
    var e = Gt.current, n = Am(e, t.type);
    e !== n && (rt(me, t), rt(Gt, n));
  }
  function ll(t) {
    me.current === t && (St(Gt), St(me)), he.current === t && (St(he), gu._currentValue = nt);
  }
  var Sa, Ea;
  function nn(t) {
    if (Sa === void 0)
      try {
        throw Error();
      } catch (n) {
        var e = n.stack.trim().match(/\n( *(at )?)/);
        Sa = e && e[1] || "", Ea = -1 < n.stack.indexOf(`
    at`) ? " (<anonymous>)" : -1 < n.stack.indexOf("@") ? "@unknown:0:0" : "";
      }
    return `
` + Sa + t + Ea;
  }
  var Ta = !1;
  function wl(t, e) {
    if (!t || Ta) return "";
    Ta = !0;
    var n = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
      var l = {
        DetermineComponentFrameRoot: function() {
          try {
            if (e) {
              var M = function() {
                throw Error();
              };
              if (Object.defineProperty(M.prototype, "props", {
                set: function() {
                  throw Error();
                }
              }), typeof Reflect == "object" && Reflect.construct) {
                try {
                  Reflect.construct(M, []);
                } catch (S) {
                  var b = S;
                }
                Reflect.construct(t, [], M);
              } else {
                try {
                  M.call();
                } catch (S) {
                  b = S;
                }
                t.call(M.prototype);
              }
            } else {
              try {
                throw Error();
              } catch (S) {
                b = S;
              }
              (M = t()) && typeof M.catch == "function" && M.catch(function() {
              });
            }
          } catch (S) {
            if (S && b && typeof S.stack == "string")
              return [S.stack, b.stack];
          }
          return [null, null];
        }
      };
      l.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
      var a = Object.getOwnPropertyDescriptor(
        l.DetermineComponentFrameRoot,
        "name"
      );
      a && a.configurable && Object.defineProperty(
        l.DetermineComponentFrameRoot,
        "name",
        { value: "DetermineComponentFrameRoot" }
      );
      var u = l.DetermineComponentFrameRoot(), i = u[0], c = u[1];
      if (i && c) {
        var f = i.split(`
`), v = c.split(`
`);
        for (a = l = 0; l < f.length && !f[l].includes("DetermineComponentFrameRoot"); )
          l++;
        for (; a < v.length && !v[a].includes(
          "DetermineComponentFrameRoot"
        ); )
          a++;
        if (l === f.length || a === v.length)
          for (l = f.length - 1, a = v.length - 1; 1 <= l && 0 <= a && f[l] !== v[a]; )
            a--;
        for (; 1 <= l && 0 <= a; l--, a--)
          if (f[l] !== v[a]) {
            if (l !== 1 || a !== 1)
              do
                if (l--, a--, 0 > a || f[l] !== v[a]) {
                  var _ = `
` + f[l].replace(" at new ", " at ");
                  return t.displayName && _.includes("<anonymous>") && (_ = _.replace("<anonymous>", t.displayName)), _;
                }
              while (1 <= l && 0 <= a);
            break;
          }
      }
    } finally {
      Ta = !1, Error.prepareStackTrace = n;
    }
    return (n = t ? t.displayName || t.name : "") ? nn(n) : "";
  }
  function Au(t, e) {
    switch (t.tag) {
      case 26:
      case 27:
      case 5:
        return nn(t.type);
      case 16:
        return nn("Lazy");
      case 13:
        return t.child !== e && e !== null ? nn("Suspense Fallback") : nn("Suspense");
      case 19:
        return nn("SuspenseList");
      case 0:
      case 15:
        return wl(t.type, !1);
      case 11:
        return wl(t.type.render, !1);
      case 1:
        return wl(t.type, !0);
      case 31:
        return nn("Activity");
      case 30:
        return nn("ViewTransition");
      default:
        return "";
    }
  }
  function Nl(t) {
    try {
      var e = "", n = null;
      do
        e += Au(t, n), n = t, t = t.return;
      while (t);
      return e;
    } catch (l) {
      return `
Error generating stack: ` + l.message + `
` + l.stack;
    }
  }
  var _a = Object.prototype.hasOwnProperty, Oa = s.unstable_scheduleCallback, ss = s.unstable_cancelCallback, eg = s.unstable_shouldYield, ng = s.unstable_requestPaint, we = s.unstable_now, lg = s.unstable_getCurrentPriorityLevel, Fo = s.unstable_ImmediatePriority, Wo = s.unstable_UserBlockingPriority, wu = s.unstable_NormalPriority, ag = s.unstable_LowPriority, Io = s.unstable_IdlePriority, ug = s.log, ig = s.unstable_setDisableYieldValue, za = null, Ne = null;
  function Dn(t) {
    if (typeof ug == "function" && ig(t), Ne && typeof Ne.setStrictMode == "function")
      try {
        Ne.setStrictMode(za, t);
      } catch {
      }
  }
  var Ue = Math.clz32 ? Math.clz32 : og, sg = Math.log, cg = Math.LN2;
  function og(t) {
    return t >>>= 0, t === 0 ? 32 : 31 - (sg(t) / cg | 0) | 0;
  }
  var Nu = 256, Uu = 262144, Du = 4194304;
  function al(t) {
    var e = t & 42;
    if (e !== 0) return e;
    switch (t & -t) {
      case 1:
        return 1;
      case 2:
        return 2;
      case 4:
        return 4;
      case 8:
        return 8;
      case 16:
        return 16;
      case 32:
        return 32;
      case 64:
        return 64;
      case 128:
        return 128;
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
        return t & 261888;
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return t & 3932160;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
        return t & 62914560;
      case 67108864:
        return 67108864;
      case 134217728:
        return 134217728;
      case 268435456:
        return 268435456;
      case 536870912:
        return 536870912;
      case 1073741824:
        return 0;
      default:
        return t;
    }
  }
  function Ru(t, e, n) {
    var l = t.pendingLanes;
    if (l === 0) return 0;
    var a = 0, u = t.suspendedLanes, i = t.pingedLanes;
    t = t.warmLanes;
    var c = l & 134217727;
    return c !== 0 ? (l = c & ~u, l !== 0 ? a = al(l) : (i &= c, i !== 0 ? a = al(i) : n || (n = c & ~t, n !== 0 && (a = al(n))))) : (c = l & ~u, c !== 0 ? a = al(c) : i !== 0 ? a = al(i) : n || (n = l & ~t, n !== 0 && (a = al(n)))), a === 0 ? 0 : e !== 0 && e !== a && (e & u) === 0 && (u = a & -a, n = e & -e, u >= n || u === 32 && (n & 4194048) !== 0) ? e : a;
  }
  function Ca(t, e) {
    return (t.pendingLanes & ~(t.suspendedLanes & ~t.pingedLanes) & e) === 0;
  }
  function rg(t, e) {
    switch (t) {
      case 1:
      case 2:
      case 4:
      case 8:
      case 64:
        return e + 250;
      case 16:
      case 32:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return e + 5e3;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
        return -1;
      case 67108864:
      case 134217728:
      case 268435456:
      case 536870912:
      case 1073741824:
        return -1;
      default:
        return -1;
    }
  }
  function Po() {
    var t = Du;
    return Du <<= 1, (Du & 62914560) === 0 && (Du = 4194304), t;
  }
  function cs(t) {
    for (var e = [], n = 0; 31 > n; n++) e.push(t);
    return e;
  }
  function Ma(t, e) {
    t.pendingLanes |= e, e !== 268435456 && (t.suspendedLanes = 0, t.pingedLanes = 0, t.warmLanes = 0);
  }
  function fg(t, e, n, l, a, u) {
    var i = t.pendingLanes;
    t.pendingLanes = n, t.suspendedLanes = 0, t.pingedLanes = 0, t.warmLanes = 0, t.expiredLanes &= n, t.entangledLanes &= n, t.errorRecoveryDisabledLanes &= n, t.shellSuspendCounter = 0;
    var c = t.entanglements, f = t.expirationTimes, v = t.hiddenUpdates;
    for (n = i & ~n; 0 < n; ) {
      var _ = 31 - Ue(n), M = 1 << _;
      c[_] = 0, f[_] = -1;
      var b = v[_];
      if (b !== null)
        for (v[_] = null, _ = 0; _ < b.length; _++) {
          var S = b[_];
          S !== null && (S.lane &= -536870913);
        }
      n &= ~M;
    }
    l !== 0 && tr(t, l, 0), u !== 0 && a === 0 && t.tag !== 0 && (t.suspendedLanes |= u & ~(i & ~e));
  }
  function tr(t, e, n) {
    t.pendingLanes |= e, t.suspendedLanes &= ~e;
    var l = 31 - Ue(e);
    t.entangledLanes |= e, t.entanglements[l] = t.entanglements[l] | 1073741824 | n & 261930;
  }
  function er(t, e) {
    var n = t.entangledLanes |= e;
    for (t = t.entanglements; n; ) {
      var l = 31 - Ue(n), a = 1 << l;
      a & e | t[l] & e && (t[l] |= e), n &= ~a;
    }
  }
  function nr(t, e) {
    var n = e & -e;
    return n = (n & 42) !== 0 ? 1 : os(n), (n & (t.suspendedLanes | e)) !== 0 ? 0 : n;
  }
  function os(t) {
    switch (t) {
      case 2:
        t = 1;
        break;
      case 8:
        t = 4;
        break;
      case 32:
        t = 16;
        break;
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
        t = 128;
        break;
      case 268435456:
        t = 134217728;
        break;
      default:
        t = 0;
    }
    return t;
  }
  function rs(t) {
    return t &= -t, 2 < t ? 8 < t ? (t & 134217727) !== 0 ? 32 : 268435456 : 8 : 2;
  }
  function lr() {
    var t = x.p;
    return t !== 0 ? t : (t = window.event, t === void 0 ? 32 : ch(t.type));
  }
  function ar(t, e) {
    var n = x.p;
    try {
      return x.p = t, e();
    } finally {
      x.p = n;
    }
  }
  var Rn = Math.random().toString(36).slice(2), ae = "__reactFiber$" + Rn, Ee = "__reactProps$" + Rn, Ul = "__reactContainer$" + Rn, fs = "__reactEvents$" + Rn, dg = "__reactListeners$" + Rn, mg = "__reactHandles$" + Rn, ur = "__reactResources$" + Rn, Aa = "__reactMarker$" + Rn;
  function ds(t) {
    delete t[ae], delete t[Ee], delete t[fs], delete t[dg], delete t[mg];
  }
  function ul(t) {
    var e;
    if (e = t[ae]) return e;
    for (var n = t.parentNode; n; ) {
      if (e = n[Ul] || n[ae]) {
        if (n = e.alternate, e.child !== null || n !== null && n.child !== null)
          for (t = Qm(t); t !== null; ) {
            if (n = t[ae]) return n;
            t = Qm(t);
          }
        return e;
      }
      t = n, n = t.parentNode;
    }
    return null;
  }
  function Dl(t) {
    if (t = t[ae] || t[Ul]) {
      var e = t.tag;
      if (e === 5 || e === 6 || e === 13 || e === 31 || e === 26 || e === 27 || e === 3)
        return t;
    }
    return null;
  }
  function wa(t) {
    var e = t.tag;
    if (e === 5 || e === 26 || e === 27 || e === 6) return t.stateNode;
    throw Error(o(33));
  }
  function Rl(t) {
    var e = t[ur];
    return e || (e = t[ur] = { hoistableStyles: /* @__PURE__ */ new Map(), hoistableScripts: /* @__PURE__ */ new Map() }), e;
  }
  function te(t) {
    t[Aa] = !0;
  }
  var ir = /* @__PURE__ */ new Set(), sr = {};
  function il(t, e) {
    ql(t, e), ql(t + "Capture", e);
  }
  function ql(t, e) {
    for (sr[t] = e, t = 0; t < e.length; t++)
      ir.add(e[t]);
  }
  var hg = RegExp(
    "^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
  ), cr = {}, or = {};
  function gg(t) {
    return _a.call(or, t) ? !0 : _a.call(cr, t) ? !1 : hg.test(t) ? or[t] = !0 : (cr[t] = !0, !1);
  }
  var Et = !1;
  function rr() {
    var t = Et;
    return Et = !1, t;
  }
  function qu(t, e, n) {
    if (gg(e))
      if (n === null) t.removeAttribute(e);
      else {
        switch (typeof n) {
          case "undefined":
          case "function":
          case "symbol":
            t.removeAttribute(e);
            return;
          case "boolean":
            var l = e.toLowerCase().slice(0, 5);
            if (l !== "data-" && l !== "aria-") {
              t.removeAttribute(e);
              return;
            }
        }
        t.setAttribute(e, "" + n);
      }
  }
  function ju(t, e, n) {
    if (n === null) t.removeAttribute(e);
    else {
      switch (typeof n) {
        case "undefined":
        case "function":
        case "symbol":
        case "boolean":
          t.removeAttribute(e);
          return;
      }
      t.setAttribute(e, "" + n);
    }
  }
  function gn(t, e, n, l) {
    if (l === null) t.removeAttribute(n);
    else {
      switch (typeof l) {
        case "undefined":
        case "function":
        case "symbol":
        case "boolean":
          t.removeAttribute(n);
          return;
      }
      t.setAttributeNS(e, n, "" + l);
    }
  }
  function Ye(t) {
    switch (typeof t) {
      case "bigint":
      case "boolean":
      case "number":
      case "string":
      case "undefined":
        return t;
      case "object":
        return t;
      default:
        return "";
    }
  }
  function fr(t) {
    var e = t.type;
    return (t = t.nodeName) && t.toLowerCase() === "input" && (e === "checkbox" || e === "radio");
  }
  function yg(t, e, n) {
    var l = Object.getOwnPropertyDescriptor(
      t.constructor.prototype,
      e
    );
    if (!t.hasOwnProperty(e) && typeof l < "u" && typeof l.get == "function" && typeof l.set == "function") {
      var a = l.get, u = l.set;
      return Object.defineProperty(t, e, {
        configurable: !0,
        get: function() {
          return a.call(this);
        },
        set: function(i) {
          n = "" + i, u.call(this, i);
        }
      }), Object.defineProperty(t, e, {
        enumerable: l.enumerable
      }), {
        getValue: function() {
          return n;
        },
        setValue: function(i) {
          n = "" + i;
        },
        stopTracking: function() {
          t._valueTracker = null, delete t[e];
        }
      };
    }
  }
  function ms(t) {
    if (!t._valueTracker) {
      var e = fr(t) ? "checked" : "value";
      t._valueTracker = yg(
        t,
        e,
        "" + t[e]
      );
    }
  }
  function dr(t) {
    if (!t) return !1;
    var e = t._valueTracker;
    if (!e) return !0;
    var n = e.getValue(), l = "";
    return t && (l = fr(t) ? t.checked ? "true" : "false" : t.value), t = l, t !== n ? (e.setValue(t), !0) : !1;
  }
  function xu(t) {
    if (t = t || (typeof document < "u" ? document : void 0), typeof t > "u") return null;
    try {
      return t.activeElement || t.body;
    } catch {
      return t.body;
    }
  }
  var vg = /[\n"\\]/g;
  function Ge(t) {
    return t.replace(
      vg,
      function(e) {
        return "\\" + e.charCodeAt(0).toString(16) + " ";
      }
    );
  }
  function hs(t, e, n, l, a, u, i, c) {
    t.name = "", i != null && typeof i != "function" && typeof i != "symbol" && typeof i != "boolean" ? t.type = i : t.removeAttribute("type"), e != null ? i === "number" ? (e === 0 && t.value === "" || t.value != e) && (t.value = "" + Ye(e)) : t.value !== "" + Ye(e) && (t.value = "" + Ye(e)) : i !== "submit" && i !== "reset" || t.removeAttribute("value"), e != null ? gs(t, i, Ye(e)) : n != null ? gs(t, i, Ye(n)) : l != null && t.removeAttribute("value"), a == null && u != null && (t.defaultChecked = !!u), a != null && (t.checked = a && typeof a != "function" && typeof a != "symbol"), c != null && typeof c != "function" && typeof c != "symbol" && typeof c != "boolean" ? t.name = "" + Ye(c) : t.removeAttribute("name");
  }
  function mr(t, e, n, l, a, u, i, c) {
    if (u != null && typeof u != "function" && typeof u != "symbol" && typeof u != "boolean" && (t.type = u), e != null || n != null) {
      if (!(u !== "submit" && u !== "reset" || e != null)) {
        ms(t);
        return;
      }
      n = n != null ? "" + Ye(n) : "", e = e != null ? "" + Ye(e) : n, c || e === t.value || (t.value = e), t.defaultValue = e;
    }
    l = l ?? a, l = typeof l != "function" && typeof l != "symbol" && !!l, t.checked = c ? t.checked : !!l, t.defaultChecked = !!l, i != null && typeof i != "function" && typeof i != "symbol" && typeof i != "boolean" && (t.name = i), ms(t);
  }
  function gs(t, e, n) {
    e === "number" && xu(t.ownerDocument) === t || t.defaultValue === "" + n || (t.defaultValue = "" + n);
  }
  function jl(t, e, n, l) {
    if (t = t.options, e) {
      e = {};
      for (var a = 0; a < n.length; a++)
        e["$" + n[a]] = !0;
      for (n = 0; n < t.length; n++)
        a = e.hasOwnProperty("$" + t[n].value), t[n].selected !== a && (t[n].selected = a), a && l && (t[n].defaultSelected = !0);
    } else {
      for (n = "" + Ye(n), e = null, a = 0; a < t.length; a++) {
        if (t[a].value === n) {
          t[a].selected = !0, l && (t[a].defaultSelected = !0);
          return;
        }
        e !== null || t[a].disabled || (e = t[a]);
      }
      e !== null && (e.selected = !0);
    }
  }
  function hr(t, e, n) {
    if (e != null && (e = "" + Ye(e), e !== t.value && (t.value = e), n == null)) {
      t.defaultValue !== e && (t.defaultValue = e);
      return;
    }
    t.defaultValue = n != null ? "" + Ye(n) : "";
  }
  function gr(t, e, n, l) {
    if (e == null) {
      if (l != null) {
        if (n != null) throw Error(o(92));
        if (Y(l)) {
          if (1 < l.length) throw Error(o(93));
          l = l[0];
        }
        n = l;
      }
      n == null && (n = ""), e = n;
    }
    n = Ye(e), t.defaultValue = n, l = t.textContent, l === n && l !== "" && l !== null && (t.value = l), ms(t);
  }
  function xl(t, e) {
    if (e) {
      var n = t.firstChild;
      if (n && n === t.lastChild && n.nodeType === 3) {
        n.nodeValue = e;
        return;
      }
    }
    t.textContent = e;
  }
  var pg = new Set(
    "animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(
      " "
    )
  );
  function yr(t, e, n) {
    var l = e.indexOf("--") === 0;
    n == null || typeof n == "boolean" || n === "" ? l ? t.setProperty(e, "") : e === "float" ? t.cssFloat = "" : t[e] = "" : l ? t.setProperty(e, n) : typeof n != "number" || n === 0 || pg.has(e) ? e === "float" ? t.cssFloat = n : t[e] = ("" + n).trim() : t[e] = n + "px";
  }
  function vr(t, e, n) {
    if (e != null && typeof e != "object")
      throw Error(o(62));
    if (t = t.style, n != null) {
      for (var l in n)
        !n.hasOwnProperty(l) || e != null && e.hasOwnProperty(l) || (l.indexOf("--") === 0 ? t.setProperty(l, "") : l === "float" ? t.cssFloat = "" : t[l] = "", Et = !0);
      for (var a in e)
        l = e[a], e.hasOwnProperty(a) && n[a] !== l && (yr(t, a, l), Et = !0);
    } else
      for (var u in e)
        e.hasOwnProperty(u) && yr(t, u, e[u]);
  }
  function ys(t) {
    if (t.indexOf("-") === -1) return !1;
    switch (t) {
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return !1;
      default:
        return !0;
    }
  }
  var bg = /* @__PURE__ */ new Map([
    ["acceptCharset", "accept-charset"],
    ["htmlFor", "for"],
    ["httpEquiv", "http-equiv"],
    ["crossOrigin", "crossorigin"],
    ["accentHeight", "accent-height"],
    ["alignmentBaseline", "alignment-baseline"],
    ["arabicForm", "arabic-form"],
    ["baselineShift", "baseline-shift"],
    ["capHeight", "cap-height"],
    ["clipPath", "clip-path"],
    ["clipRule", "clip-rule"],
    ["colorInterpolation", "color-interpolation"],
    ["colorInterpolationFilters", "color-interpolation-filters"],
    ["colorProfile", "color-profile"],
    ["colorRendering", "color-rendering"],
    ["dominantBaseline", "dominant-baseline"],
    ["enableBackground", "enable-background"],
    ["fillOpacity", "fill-opacity"],
    ["fillRule", "fill-rule"],
    ["floodColor", "flood-color"],
    ["floodOpacity", "flood-opacity"],
    ["fontFamily", "font-family"],
    ["fontSize", "font-size"],
    ["fontSizeAdjust", "font-size-adjust"],
    ["fontStretch", "font-stretch"],
    ["fontStyle", "font-style"],
    ["fontVariant", "font-variant"],
    ["fontWeight", "font-weight"],
    ["glyphName", "glyph-name"],
    ["glyphOrientationHorizontal", "glyph-orientation-horizontal"],
    ["glyphOrientationVertical", "glyph-orientation-vertical"],
    ["horizAdvX", "horiz-adv-x"],
    ["horizOriginX", "horiz-origin-x"],
    ["imageRendering", "image-rendering"],
    ["letterSpacing", "letter-spacing"],
    ["lightingColor", "lighting-color"],
    ["markerEnd", "marker-end"],
    ["markerMid", "marker-mid"],
    ["markerStart", "marker-start"],
    ["overlinePosition", "overline-position"],
    ["overlineThickness", "overline-thickness"],
    ["paintOrder", "paint-order"],
    ["panose-1", "panose-1"],
    ["pointerEvents", "pointer-events"],
    ["renderingIntent", "rendering-intent"],
    ["shapeRendering", "shape-rendering"],
    ["stopColor", "stop-color"],
    ["stopOpacity", "stop-opacity"],
    ["strikethroughPosition", "strikethrough-position"],
    ["strikethroughThickness", "strikethrough-thickness"],
    ["strokeDasharray", "stroke-dasharray"],
    ["strokeDashoffset", "stroke-dashoffset"],
    ["strokeLinecap", "stroke-linecap"],
    ["strokeLinejoin", "stroke-linejoin"],
    ["strokeMiterlimit", "stroke-miterlimit"],
    ["strokeOpacity", "stroke-opacity"],
    ["strokeWidth", "stroke-width"],
    ["textAnchor", "text-anchor"],
    ["textDecoration", "text-decoration"],
    ["textRendering", "text-rendering"],
    ["transformOrigin", "transform-origin"],
    ["underlinePosition", "underline-position"],
    ["underlineThickness", "underline-thickness"],
    ["unicodeBidi", "unicode-bidi"],
    ["unicodeRange", "unicode-range"],
    ["unitsPerEm", "units-per-em"],
    ["vAlphabetic", "v-alphabetic"],
    ["vHanging", "v-hanging"],
    ["vIdeographic", "v-ideographic"],
    ["vMathematical", "v-mathematical"],
    ["vectorEffect", "vector-effect"],
    ["vertAdvY", "vert-adv-y"],
    ["vertOriginX", "vert-origin-x"],
    ["vertOriginY", "vert-origin-y"],
    ["wordSpacing", "word-spacing"],
    ["writingMode", "writing-mode"],
    ["xmlnsXlink", "xmlns:xlink"],
    ["xHeight", "x-height"]
  ]), Sg = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
  function Hu(t) {
    return Sg.test("" + t) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : t;
  }
  function yn() {
  }
  var vs = null;
  function ps(t) {
    return t = t.target || t.srcElement || window, t.correspondingUseElement && (t = t.correspondingUseElement), t.nodeType === 3 ? t.parentNode : t;
  }
  var Hl = null, Bl = null;
  function pr(t) {
    var e = Dl(t);
    if (e && (t = e.stateNode)) {
      var n = t[Ee] || null;
      t: switch (t = e.stateNode, e.type) {
        case "input":
          if (hs(
            t,
            n.value,
            n.defaultValue,
            n.defaultValue,
            n.checked,
            n.defaultChecked,
            n.type,
            n.name
          ), e = n.name, n.type === "radio" && e != null) {
            for (n = t; n.parentNode; ) n = n.parentNode;
            for (n = n.querySelectorAll(
              'input[name="' + Ge(
                "" + e
              ) + '"][type="radio"]'
            ), e = 0; e < n.length; e++) {
              var l = n[e];
              if (l !== t && l.form === t.form) {
                var a = l[Ee] || null;
                if (!a) throw Error(o(90));
                hs(
                  l,
                  a.value,
                  a.defaultValue,
                  a.defaultValue,
                  a.checked,
                  a.defaultChecked,
                  a.type,
                  a.name
                );
              }
            }
            for (e = 0; e < n.length; e++)
              l = n[e], l.form === t.form && dr(l);
          }
          break t;
        case "textarea":
          hr(t, n.value, n.defaultValue);
          break t;
        case "select":
          e = n.value, e != null && jl(t, !!n.multiple, e, !1);
      }
    }
  }
  var bs = !1;
  function br(t, e, n) {
    if (bs) return t(e, n);
    bs = !0;
    try {
      var l = t(e);
      return l;
    } finally {
      if (bs = !1, (Hl !== null || Bl !== null) && (Ui(), Hl && (e = Hl, t = Bl, Bl = Hl = null, pr(e), t)))
        for (e = 0; e < t.length; e++) pr(t[e]);
    }
  }
  function Na(t, e) {
    var n = t.stateNode;
    if (n === null) return null;
    var l = n[Ee] || null;
    if (l === null) return null;
    n = l[e];
    t: switch (e) {
      case "onClick":
      case "onClickCapture":
      case "onDoubleClick":
      case "onDoubleClickCapture":
      case "onMouseDown":
      case "onMouseDownCapture":
      case "onMouseMove":
      case "onMouseMoveCapture":
      case "onMouseUp":
      case "onMouseUpCapture":
      case "onMouseEnter":
        (l = !l.disabled) || (t = t.type, l = !(t === "button" || t === "input" || t === "select" || t === "textarea")), t = !l;
        break t;
      default:
        t = !1;
    }
    if (t) return null;
    if (n && typeof n != "function")
      throw Error(
        o(231, e, typeof n)
      );
    return n;
  }
  var vn = !(typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u"), Ss = !1;
  if (vn)
    try {
      var Ua = {};
      Object.defineProperty(Ua, "passive", {
        get: function() {
          Ss = !0;
        }
      }), window.addEventListener("test", Ua, Ua), window.removeEventListener("test", Ua, Ua);
    } catch {
      Ss = !1;
    }
  var qn = null, Es = null, Bu = null;
  function Sr() {
    if (Bu) return Bu;
    var t, e = Es, n = e.length, l, a = "value" in qn ? qn.value : qn.textContent, u = a.length;
    for (t = 0; t < n && e[t] === a[t]; t++) ;
    var i = n - t;
    for (l = 1; l <= i && e[n - l] === a[u - l]; l++) ;
    return Bu = a.slice(t, 1 < l ? 1 - l : void 0);
  }
  function Lu(t) {
    var e = t.keyCode;
    return "charCode" in t ? (t = t.charCode, t === 0 && e === 13 && (t = 13)) : t = e, t === 10 && (t = 13), 32 <= t || t === 13 ? t : 0;
  }
  function Yu() {
    return !0;
  }
  function Er() {
    return !1;
  }
  function Te(t) {
    function e(n, l, a, u, i) {
      this._reactName = n, this._targetInst = a, this.type = l, this.nativeEvent = u, this.target = i, this.currentTarget = null;
      for (var c in t)
        t.hasOwnProperty(c) && (n = t[c], this[c] = n ? n(u) : u[c]);
      return this.isDefaultPrevented = (u.defaultPrevented != null ? u.defaultPrevented : u.returnValue === !1) ? Yu : Er, this.isPropagationStopped = Er, this;
    }
    return W(e.prototype, {
      preventDefault: function() {
        this.defaultPrevented = !0;
        var n = this.nativeEvent;
        n && (n.preventDefault ? n.preventDefault() : typeof n.returnValue != "unknown" && (n.returnValue = !1), this.isDefaultPrevented = Yu);
      },
      stopPropagation: function() {
        var n = this.nativeEvent;
        n && (n.stopPropagation ? n.stopPropagation() : typeof n.cancelBubble != "unknown" && (n.cancelBubble = !0), this.isPropagationStopped = Yu);
      },
      persist: function() {
      },
      isPersistent: Yu
    }), e;
  }
  var sl = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(t) {
      return t.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
  }, Gu = Te(sl), Da = W({}, sl, { view: 0, detail: 0 }), Eg = Te(Da), Ts, _s, Ra, Qu = W({}, Da, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: zs,
    button: 0,
    buttons: 0,
    relatedTarget: function(t) {
      return t.relatedTarget === void 0 ? t.fromElement === t.srcElement ? t.toElement : t.fromElement : t.relatedTarget;
    },
    movementX: function(t) {
      return "movementX" in t ? t.movementX : (t !== Ra && (Ra && t.type === "mousemove" ? (Ts = t.screenX - Ra.screenX, _s = t.screenY - Ra.screenY) : _s = Ts = 0, Ra = t), Ts);
    },
    movementY: function(t) {
      return "movementY" in t ? t.movementY : _s;
    }
  }), Tr = Te(Qu), Tg = W({}, Qu, { dataTransfer: 0 }), _g = Te(Tg), Og = W({}, Da, { relatedTarget: 0 }), Os = Te(Og), zg = W({}, sl, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
  }), Cg = Te(zg), Mg = W({}, sl, {
    clipboardData: function(t) {
      return "clipboardData" in t ? t.clipboardData : window.clipboardData;
    }
  }), Ag = Te(Mg), wg = W({}, sl, { data: 0 }), _r = Te(wg), Ng = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
  }, Ug = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
  }, Dg = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
  };
  function Rg(t) {
    var e = this.nativeEvent;
    return e.getModifierState ? e.getModifierState(t) : (t = Dg[t]) ? !!e[t] : !1;
  }
  function zs() {
    return Rg;
  }
  var qg = W({}, Da, {
    key: function(t) {
      if (t.key) {
        var e = Ng[t.key] || t.key;
        if (e !== "Unidentified") return e;
      }
      return t.type === "keypress" ? (t = Lu(t), t === 13 ? "Enter" : String.fromCharCode(t)) : t.type === "keydown" || t.type === "keyup" ? Ug[t.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: zs,
    charCode: function(t) {
      return t.type === "keypress" ? Lu(t) : 0;
    },
    keyCode: function(t) {
      return t.type === "keydown" || t.type === "keyup" ? t.keyCode : 0;
    },
    which: function(t) {
      return t.type === "keypress" ? Lu(t) : t.type === "keydown" || t.type === "keyup" ? t.keyCode : 0;
    }
  }), jg = Te(qg), xg = W({}, Qu, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
  }), Or = Te(xg), Hg = W({}, Da, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: zs
  }), Bg = Te(Hg), Lg = W({}, sl, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
  }), Yg = Te(Lg), Gg = W({}, Qu, {
    deltaX: function(t) {
      return "deltaX" in t ? t.deltaX : "wheelDeltaX" in t ? -t.wheelDeltaX : 0;
    },
    deltaY: function(t) {
      return "deltaY" in t ? t.deltaY : "wheelDeltaY" in t ? -t.wheelDeltaY : "wheelDelta" in t ? -t.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
  }), Qg = Te(Gg), Xg = W({}, sl, {
    newState: 0,
    oldState: 0
  }), kg = Te(Xg), Vg = [9, 13, 27, 32], Cs = vn && "CompositionEvent" in window, qa = null;
  vn && "documentMode" in document && (qa = document.documentMode);
  var Zg = vn && "TextEvent" in window && !qa, zr = vn && (!Cs || qa && 8 < qa && 11 >= qa), Cr = " ", Mr = !1;
  function Ar(t, e) {
    switch (t) {
      case "keyup":
        return Vg.indexOf(e.keyCode) !== -1;
      case "keydown":
        return e.keyCode !== 229;
      case "keypress":
      case "mousedown":
      case "focusout":
        return !0;
      default:
        return !1;
    }
  }
  function wr(t) {
    return t = t.detail, typeof t == "object" && "data" in t ? t.data : null;
  }
  var Ll = !1;
  function Kg(t, e) {
    switch (t) {
      case "compositionend":
        return wr(e);
      case "keypress":
        return e.which !== 32 ? null : (Mr = !0, Cr);
      case "textInput":
        return t = e.data, t === Cr && Mr ? null : t;
      default:
        return null;
    }
  }
  function Jg(t, e) {
    if (Ll)
      return t === "compositionend" || !Cs && Ar(t, e) ? (t = Sr(), Bu = Es = qn = null, Ll = !1, t) : null;
    switch (t) {
      case "paste":
        return null;
      case "keypress":
        if (!(e.ctrlKey || e.altKey || e.metaKey) || e.ctrlKey && e.altKey) {
          if (e.char && 1 < e.char.length)
            return e.char;
          if (e.which) return String.fromCharCode(e.which);
        }
        return null;
      case "compositionend":
        return zr && e.locale !== "ko" ? null : e.data;
      default:
        return null;
    }
  }
  var $g = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
  };
  function Nr(t) {
    var e = t && t.nodeName && t.nodeName.toLowerCase();
    return e === "input" ? !!$g[t.type] : e === "textarea";
  }
  function Ur(t, e, n, l) {
    Hl ? Bl ? Bl.push(l) : Bl = [l] : Hl = l, e = Hi(e, "onChange"), 0 < e.length && (n = new Gu(
      "onChange",
      "change",
      null,
      n,
      l
    ), t.push({ event: n, listeners: e }));
  }
  var ja = null, xa = null;
  function Fg(t) {
    Em(t, 0);
  }
  function Xu(t) {
    var e = wa(t);
    if (dr(e)) return t;
  }
  function Dr(t, e) {
    if (t === "change") return e;
  }
  var Rr = !1;
  if (vn) {
    var Ms;
    if (vn) {
      var As = "oninput" in document;
      if (!As) {
        var qr = document.createElement("div");
        qr.setAttribute("oninput", "return;"), As = typeof qr.oninput == "function";
      }
      Ms = As;
    } else Ms = !1;
    Rr = Ms && (!document.documentMode || 9 < document.documentMode);
  }
  function jr() {
    ja && (ja.detachEvent("onpropertychange", xr), xa = ja = null);
  }
  function xr(t) {
    if (t.propertyName === "value" && Xu(xa)) {
      var e = [];
      Ur(
        e,
        xa,
        t,
        ps(t)
      ), br(Fg, e);
    }
  }
  function Wg(t, e, n) {
    t === "focusin" ? (jr(), ja = e, xa = n, ja.attachEvent("onpropertychange", xr)) : t === "focusout" && jr();
  }
  function Ig(t) {
    if (t === "selectionchange" || t === "keyup" || t === "keydown")
      return Xu(xa);
  }
  function Pg(t, e) {
    if (t === "click") return Xu(e);
  }
  function ty(t, e) {
    if (t === "input" || t === "change")
      return Xu(e);
  }
  function ey(t, e) {
    return t === e && (t !== 0 || 1 / t === 1 / e) || t !== t && e !== e;
  }
  var De = typeof Object.is == "function" ? Object.is : ey;
  function Ha(t, e) {
    if (De(t, e)) return !0;
    if (typeof t != "object" || t === null || typeof e != "object" || e === null)
      return !1;
    var n = Object.keys(t), l = Object.keys(e);
    if (n.length !== l.length) return !1;
    for (l = 0; l < n.length; l++) {
      var a = n[l];
      if (!_a.call(e, a) || !De(t[a], e[a]))
        return !1;
    }
    return !0;
  }
  function Hr(t) {
    for (; t && t.firstChild; ) t = t.firstChild;
    return t;
  }
  function Br(t, e) {
    var n = Hr(t);
    t = 0;
    for (var l; n; ) {
      if (n.nodeType === 3) {
        if (l = t + n.textContent.length, t <= e && l >= e)
          return { node: n, offset: e - t };
        t = l;
      }
      t: {
        for (; n; ) {
          if (n.nextSibling) {
            n = n.nextSibling;
            break t;
          }
          n = n.parentNode;
        }
        n = void 0;
      }
      n = Hr(n);
    }
  }
  function Lr(t, e) {
    return t && e ? t === e ? !0 : t && t.nodeType === 3 ? !1 : e && e.nodeType === 3 ? Lr(t, e.parentNode) : "contains" in t ? t.contains(e) : t.compareDocumentPosition ? !!(t.compareDocumentPosition(e) & 16) : !1 : !1;
  }
  function Yr(t) {
    t = t != null && t.ownerDocument != null && t.ownerDocument.defaultView != null ? t.ownerDocument.defaultView : window;
    for (var e = xu(t.document); e instanceof t.HTMLIFrameElement; ) {
      try {
        var n = typeof e.contentWindow.location.href == "string";
      } catch {
        n = !1;
      }
      if (n) t = e.contentWindow;
      else break;
      e = xu(t.document);
    }
    return e;
  }
  function ws(t) {
    var e = t && t.nodeName && t.nodeName.toLowerCase();
    return e && (e === "input" && (t.type === "text" || t.type === "search" || t.type === "tel" || t.type === "url" || t.type === "password") || e === "textarea" || t.contentEditable === "true");
  }
  var ny = vn && "documentMode" in document && 11 >= document.documentMode, Yl = null, Ns = null, Ba = null, Us = !1;
  function Gr(t, e, n) {
    var l = n.window === n ? n.document : n.nodeType === 9 ? n : n.ownerDocument;
    Us || Yl == null || Yl !== xu(l) || (l = Yl, "selectionStart" in l && ws(l) ? l = { start: l.selectionStart, end: l.selectionEnd } : (l = (l.ownerDocument && l.ownerDocument.defaultView || window).getSelection(), l = {
      anchorNode: l.anchorNode,
      anchorOffset: l.anchorOffset,
      focusNode: l.focusNode,
      focusOffset: l.focusOffset
    }), Ba && Ha(Ba, l) || (Ba = l, l = Hi(Ns, "onSelect"), 0 < l.length && (e = new Gu(
      "onSelect",
      "select",
      null,
      e,
      n
    ), t.push({ event: e, listeners: l }), e.target = Yl)));
  }
  function cl(t, e) {
    var n = {};
    return n[t.toLowerCase()] = e.toLowerCase(), n["Webkit" + t] = "webkit" + e, n["Moz" + t] = "moz" + e, n;
  }
  var Gl = {
    animationend: cl("Animation", "AnimationEnd"),
    animationiteration: cl("Animation", "AnimationIteration"),
    animationstart: cl("Animation", "AnimationStart"),
    transitionrun: cl("Transition", "TransitionRun"),
    transitionstart: cl("Transition", "TransitionStart"),
    transitioncancel: cl("Transition", "TransitionCancel"),
    transitionend: cl("Transition", "TransitionEnd")
  }, Ds = {}, Qr = {};
  vn && (Qr = document.createElement("div").style, "AnimationEvent" in window || (delete Gl.animationend.animation, delete Gl.animationiteration.animation, delete Gl.animationstart.animation), "TransitionEvent" in window || delete Gl.transitionend.transition);
  function ol(t) {
    if (Ds[t]) return Ds[t];
    if (!Gl[t]) return t;
    var e = Gl[t], n;
    for (n in e)
      if (e.hasOwnProperty(n) && n in Qr)
        return Ds[t] = e[n];
    return t;
  }
  var Xr = ol("animationend"), kr = ol("animationiteration"), Vr = ol("animationstart"), ly = ol("transitionrun"), ay = ol("transitionstart"), uy = ol("transitioncancel"), Zr = ol("transitionend"), Kr = /* @__PURE__ */ new Map(), Rs = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(
    " "
  );
  Rs.push("scrollEnd");
  function Ie(t, e) {
    Kr.set(t, e), il(e, [t]);
  }
  var iy = 0;
  function pn(t, e) {
    if (t.name != null && t.name !== "auto") return t.name;
    if (e.autoName !== null) return e.autoName;
    t = en.identifierPrefix;
    var n = iy++;
    return t = "_" + t + "t_" + n.toString(32) + "_", e.autoName = t;
  }
  function Jr(t) {
    if (t == null || typeof t == "string")
      return t;
    var e = null, n = ca;
    if (n !== null)
      for (var l = 0; l < n.length; l++) {
        var a = t[n[l]];
        if (a != null) {
          if (a === "none") return "none";
          e = e == null ? a : e + (" " + a);
        }
      }
    return e ?? t.default;
  }
  function bn(t, e) {
    return t = Jr(t), e = Jr(e), e == null ? t === "auto" ? null : t : e === "auto" ? null : e;
  }
  var ku = typeof reportError == "function" ? reportError : function(t) {
    if (typeof window == "object" && typeof window.ErrorEvent == "function") {
      var e = new window.ErrorEvent("error", {
        bubbles: !0,
        cancelable: !0,
        message: typeof t == "object" && t !== null && typeof t.message == "string" ? String(t.message) : String(t),
        error: t
      });
      if (!window.dispatchEvent(e)) return;
    } else if (typeof process == "object" && typeof process.emit == "function") {
      process.emit("uncaughtException", t);
      return;
    }
    console.error(t);
  }, Qe = [], Ql = 0, qs = 0;
  function Vu() {
    for (var t = Ql, e = qs = Ql = 0; e < t; ) {
      var n = Qe[e];
      Qe[e++] = null;
      var l = Qe[e];
      Qe[e++] = null;
      var a = Qe[e];
      Qe[e++] = null;
      var u = Qe[e];
      if (Qe[e++] = null, l !== null && a !== null) {
        var i = l.pending;
        i === null ? a.next = a : (a.next = i.next, i.next = a), l.pending = a;
      }
      u !== 0 && $r(n, a, u);
    }
  }
  function Zu(t, e, n, l) {
    Qe[Ql++] = t, Qe[Ql++] = e, Qe[Ql++] = n, Qe[Ql++] = l, qs |= l, t.lanes |= l, t = t.alternate, t !== null && (t.lanes |= l);
  }
  function js(t, e, n, l) {
    return Zu(t, e, n, l), Ku(t);
  }
  function rl(t, e) {
    return Zu(t, null, null, e), Ku(t);
  }
  function $r(t, e, n) {
    t.lanes |= n;
    var l = t.alternate;
    l !== null && (l.lanes |= n);
    for (var a = !1, u = t.return; u !== null; )
      u.childLanes |= n, l = u.alternate, l !== null && (l.childLanes |= n), u.tag === 22 && (t = u.stateNode, t === null || t._visibility & 1 || (a = !0)), t = u, u = u.return;
    return t.tag === 3 ? (u = t.stateNode, a && e !== null && (a = 31 - Ue(n), t = u.hiddenUpdates, l = t[a], l === null ? t[a] = [e] : l.push(e), e.lane = n | 536870912), u) : null;
  }
  function Ku(t) {
    if (50 < su)
      throw su = 0, to = null, Error(o(185));
    for (var e = t.return; e !== null; )
      t = e, e = t.return;
    return t.tag === 3 ? t.stateNode : null;
  }
  var Xl = {};
  function sy(t, e, n, l) {
    this.tag = t, this.key = n, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.refCleanup = this.ref = null, this.pendingProps = e, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = l, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null;
  }
  function _e(t, e, n, l) {
    return new sy(t, e, n, l);
  }
  function xs(t) {
    return t = t.prototype, !(!t || !t.isReactComponent);
  }
  function Sn(t, e) {
    var n = t.alternate;
    return n === null ? (n = _e(
      t.tag,
      e,
      t.key,
      t.mode
    ), n.elementType = t.elementType, n.type = t.type, n.stateNode = t.stateNode, n.alternate = t, t.alternate = n) : (n.pendingProps = e, n.type = t.type, n.flags = 0, n.subtreeFlags = 0, n.deletions = null), n.flags = t.flags & 132120576, n.childLanes = t.childLanes, n.lanes = t.lanes, n.child = t.child, n.memoizedProps = t.memoizedProps, n.memoizedState = t.memoizedState, n.updateQueue = t.updateQueue, e = t.dependencies, n.dependencies = e === null ? null : { lanes: e.lanes, firstContext: e.firstContext }, n.sibling = t.sibling, n.index = t.index, n.ref = t.ref, n.refCleanup = t.refCleanup, n;
  }
  function Fr(t, e) {
    t.flags &= 132120578;
    var n = t.alternate;
    return n === null ? (t.childLanes = 0, t.lanes = e, t.child = null, t.subtreeFlags = 0, t.memoizedProps = null, t.memoizedState = null, t.updateQueue = null, t.dependencies = null, t.stateNode = null) : (t.childLanes = n.childLanes, t.lanes = n.lanes, t.child = n.child, t.subtreeFlags = 0, t.deletions = null, t.memoizedProps = n.memoizedProps, t.memoizedState = n.memoizedState, t.updateQueue = n.updateQueue, t.type = n.type, e = n.dependencies, t.dependencies = e === null ? null : {
      lanes: e.lanes,
      firstContext: e.firstContext
    }), t;
  }
  function Ju(t, e, n, l, a, u) {
    var i = 0;
    if (l = t, typeof t == "function") xs(t) && (i = 1);
    else if (typeof t == "string")
      i = Mv(
        t,
        n,
        Gt.current
      ) ? 26 : t === "html" || t === "head" || t === "body" ? 27 : 5;
    else
      t: switch (t) {
        case T:
          return t = _e(31, n, e, a), t.elementType = T, t.lanes = u, t;
        case Yt:
          return fl(n.children, a, u, e);
        case Ht:
          i = 8, a |= 24;
          break;
        case Zt:
          return t = _e(12, n, e, a | 2), t.elementType = Zt, t.lanes = u, t;
        case B:
          return t = _e(13, n, e, a), t.elementType = B, t.lanes = u, t;
        case K:
          return t = _e(19, n, e, a), t.elementType = K, t.lanes = u, t;
        case y:
        case F:
          return t = a | 32, t = _e(30, n, e, t), t.elementType = F, t.lanes = u, t.stateNode = {
            autoName: null,
            paired: null,
            clones: null,
            ref: null
          }, t;
        default:
          if (typeof t == "object" && t !== null)
            switch (t.$$typeof) {
              case Wt:
                i = 10;
                break t;
              case Ae:
                i = 9;
                break t;
              case Pt:
                i = 11;
                break t;
              case tt:
                i = 14;
                break t;
              case bt:
                i = 16, l = null;
                break t;
            }
          i = 29, n = Error(
            o(130, t === null ? "null" : typeof t, "")
          ), l = null;
      }
    return e = _e(i, n, e, a), e.elementType = t, e.type = l, e.lanes = u, e;
  }
  function fl(t, e, n, l) {
    return t = _e(7, t, l, e), t.lanes = n, t;
  }
  function Hs(t, e, n) {
    return t = _e(6, t, null, e), t.lanes = n, t;
  }
  function Wr(t) {
    var e = _e(18, null, null, 0);
    return e.stateNode = t, e;
  }
  function Bs(t, e, n) {
    return e = _e(
      4,
      t.children !== null ? t.children : [],
      t.key,
      e
    ), e.lanes = n, e.stateNode = {
      containerInfo: t.containerInfo,
      pendingChildren: null,
      implementation: t.implementation
    }, e;
  }
  var Ir = /* @__PURE__ */ new WeakMap();
  function Xe(t, e) {
    if (typeof t == "object" && t !== null) {
      var n = Ir.get(t);
      return n !== void 0 ? n : (e = {
        value: t,
        source: e,
        stack: Nl(e)
      }, Ir.set(t, e), e);
    }
    return {
      value: t,
      source: e,
      stack: Nl(e)
    };
  }
  var kl = [], Vl = 0, $u = null, La = 0, ke = [], Ve = 0, jn = null, ln = 1, an = "";
  function En(t, e) {
    kl[Vl++] = La, kl[Vl++] = $u, $u = t, La = e;
  }
  function Pr(t, e, n) {
    ke[Ve++] = ln, ke[Ve++] = an, ke[Ve++] = jn, jn = t;
    var l = ln;
    t = an;
    var a = 32 - Ue(l) - 1;
    l &= ~(1 << a), n += 1;
    var u = 32 - Ue(e) + a;
    if (30 < u) {
      var i = a - a % 5;
      u = (l & (1 << i) - 1).toString(32), l >>= i, a -= i, ln = 1 << 32 - Ue(e) + a | n << a | l, an = u + t;
    } else
      ln = 1 << u | n << a | l, an = t;
  }
  function Fu(t) {
    t.return !== null && (En(t, 1), Pr(t, 1, 0));
  }
  function Ls(t) {
    for (; t === $u; )
      $u = kl[--Vl], kl[Vl] = null, La = kl[--Vl], kl[Vl] = null;
    for (; t === jn; )
      jn = ke[--Ve], ke[Ve] = null, an = ke[--Ve], ke[Ve] = null, ln = ke[--Ve], ke[Ve] = null;
  }
  function tf(t, e) {
    ke[Ve++] = ln, ke[Ve++] = an, ke[Ve++] = jn, ln = e.id, an = e.overflow, jn = t;
  }
  var ue = null, xt = null, dt = !1, xn = null, Ze = !1, Ys = Error(o(519));
  function Hn(t) {
    var e = Error(
      o(
        418,
        1 < arguments.length && arguments[1] !== void 0 && arguments[1] ? "text" : "HTML",
        ""
      )
    );
    throw Ya(Xe(e, t)), Ys;
  }
  function ef(t) {
    var e = t.stateNode, n = t.type, l = t.memoizedProps;
    switch (e[ae] = t, e[Ee] = l, n) {
      case "dialog":
        ht("cancel", e), ht("close", e);
        break;
      case "iframe":
      case "object":
      case "embed":
        ht("load", e);
        break;
      case "video":
      case "audio":
        for (n = 0; n < ou.length; n++)
          ht(ou[n], e);
        break;
      case "source":
        ht("error", e);
        break;
      case "img":
      case "image":
      case "link":
        ht("error", e), ht("load", e);
        break;
      case "details":
        ht("toggle", e);
        break;
      case "input":
        ht("invalid", e), mr(
          e,
          l.value,
          l.defaultValue,
          l.checked,
          l.defaultChecked,
          l.type,
          l.name,
          !0
        );
        break;
      case "select":
        ht("invalid", e);
        break;
      case "textarea":
        ht("invalid", e), gr(e, l.value, l.defaultValue, l.children);
    }
    n = l.children, typeof n != "string" && typeof n != "number" && typeof n != "bigint" || e.textContent === "" + n || l.suppressHydrationWarning === !0 || zm(e.textContent, n) ? (l.popover != null && (ht("beforetoggle", e), ht("toggle", e)), l.onScroll != null && ht("scroll", e), l.onScrollEnd != null && ht("scrollend", e), l.onClick != null && (e.onclick = yn), e = !0) : e = !1, e || Hn(t, !0);
  }
  function nf(t) {
    for (ue = t.return; ue; )
      switch (ue.tag) {
        case 5:
        case 31:
        case 13:
          Ze = !1;
          return;
        case 27:
        case 3:
          Ze = !0;
          return;
        default:
          ue = ue.return;
      }
  }
  function Zl(t) {
    if (t !== ue) return !1;
    if (!dt) return nf(t), dt = !0, !1;
    var e = t.tag, n;
    if ((n = e !== 3 && e !== 27) && ((n = e === 5) && (n = t.type, n = !(n !== "form" && n !== "button") || So(t.type, t.memoizedProps)), n = !n), n && xt && Hn(t), nf(t), e === 13) {
      if (t = t.memoizedState, t = t !== null ? t.dehydrated : null, !t) throw Error(o(317));
      xt = Gm(t);
    } else if (e === 31) {
      if (t = t.memoizedState, t = t !== null ? t.dehydrated : null, !t) throw Error(o(317));
      xt = Gm(t);
    } else
      e === 27 ? (e = xt, Wn(t.type) ? (t = Mo, Mo = null, xt = t) : xt = e) : xt = ue ? $e(t.stateNode.nextSibling) : null;
    return !0;
  }
  function dl() {
    xt = ue = null, dt = !1;
  }
  function Gs() {
    var t = xn;
    return t !== null && (ze === null ? ze = t : ze.push.apply(
      ze,
      t
    ), xn = null), t;
  }
  function Ya(t) {
    xn === null ? xn = [t] : xn.push(t);
  }
  var Qs = lt(null), ml = null, Tn = null;
  function Bn(t, e, n) {
    rt(Qs, e._currentValue), e._currentValue = n;
  }
  function _n(t) {
    t._currentValue = Qs.current, St(Qs);
  }
  function Xs(t, e, n) {
    for (; t !== null; ) {
      var l = t.alternate;
      if ((t.childLanes & e) !== e ? (t.childLanes |= e, l !== null && (l.childLanes |= e)) : l !== null && (l.childLanes & e) !== e && (l.childLanes |= e), t === n) break;
      t = t.return;
    }
  }
  function ks(t, e, n, l) {
    var a = t.child;
    for (a !== null && (a.return = t); a !== null; ) {
      var u = a.dependencies;
      if (u !== null) {
        var i = a.child;
        u = u.firstContext;
        t: for (; u !== null; ) {
          var c = u;
          u = a;
          for (var f = 0; f < e.length; f++)
            if (c.context === e[f]) {
              u.lanes |= n, c = u.alternate, c !== null && (c.lanes |= n), Xs(
                u.return,
                n,
                t
              ), l || (i = null);
              break t;
            }
          u = c.next;
        }
      } else if (a.tag === 18) {
        if (i = a.return, i === null) throw Error(o(341));
        i.lanes |= n, u = i.alternate, u !== null && (u.lanes |= n), Xs(i, n, t), i = null;
      } else i = a.child;
      if (i !== null) i.return = a;
      else
        for (i = a; i !== null; ) {
          if (i === t) {
            i = null;
            break;
          }
          if (a = i.sibling, a !== null) {
            a.return = i.return, i = a;
            break;
          }
          i = i.return;
        }
      a = i;
    }
  }
  function Kl(t, e, n, l) {
    t = null;
    for (var a = e, u = !1; a !== null; ) {
      if (!u) {
        if ((a.flags & 524288) !== 0) u = !0;
        else if ((a.flags & 262144) !== 0) break;
      }
      if (a.tag === 10) {
        var i = a.alternate;
        if (i === null) throw Error(o(387));
        if (i = i.memoizedProps, i !== null) {
          var c = a.type;
          De(a.pendingProps.value, i.value) || (t !== null ? t.push(c) : t = [c]);
        }
      } else if (a === he.current) {
        if (i = a.alternate, i === null) throw Error(o(387));
        i.memoizedState.memoizedState !== a.memoizedState.memoizedState && (t !== null ? t.push(gu) : t = [gu]);
      }
      a = a.return;
    }
    t !== null && ks(
      e,
      t,
      n,
      l
    ), e.flags |= 262144;
  }
  function Wu(t) {
    for (t = t.firstContext; t !== null; ) {
      if (!De(
        t.context._currentValue,
        t.memoizedValue
      ))
        return !0;
      t = t.next;
    }
    return !1;
  }
  function hl(t) {
    ml = t, Tn = null, t = t.dependencies, t !== null && (t.firstContext = null);
  }
  function ie(t) {
    return lf(ml, t);
  }
  function Iu(t, e) {
    return ml === null && hl(t), lf(t, e);
  }
  function lf(t, e) {
    var n = e._currentValue;
    if (e = { context: e, memoizedValue: n, next: null }, Tn === null) {
      if (t === null) throw Error(o(308));
      Tn = e, t.dependencies = { lanes: 0, firstContext: e }, t.flags |= 524288;
    } else Tn = Tn.next = e;
    return n;
  }
  var cy = typeof AbortController < "u" ? AbortController : function() {
    var t = [], e = this.signal = {
      aborted: !1,
      addEventListener: function(n, l) {
        t.push(l);
      }
    };
    this.abort = function() {
      e.aborted = !0, t.forEach(function(n) {
        return n();
      });
    };
  }, oy = s.unstable_scheduleCallback, ry = s.unstable_NormalPriority, Kt = {
    $$typeof: Wt,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
  };
  function Vs() {
    return {
      controller: new cy(),
      data: /* @__PURE__ */ new Map(),
      refCount: 0
    };
  }
  function Ga(t) {
    t.refCount--, t.refCount === 0 && oy(ry, function() {
      t.controller.abort();
    });
  }
  function af(t, e) {
    if ((t.pendingLanes & 4194048) !== 0) {
      var n = t.transitionTypes;
      for (n === null && (n = t.transitionTypes = []), t = 0; t < e.length; t++) {
        var l = e[t];
        n.indexOf(l) === -1 && n.push(l);
      }
    }
  }
  var Qa = null;
  function fy(t) {
    var e = t.transitionTypes;
    return t.transitionTypes = null, e;
  }
  var Xa = null, Zs = 0, gl = 0, Jl = null;
  function dy(t, e) {
    if (Xa === null) {
      var n = Xa = [];
      Zs = 0, gl = ro(), Jl = {
        status: "pending",
        value: void 0,
        then: function(l) {
          n.push(l);
        }
      };
    }
    return Zs++, e.then(uf, uf), e;
  }
  function uf() {
    if (--Zs === 0 && (Qa = null, Xa !== null)) {
      Jl !== null && (Jl.status = "fulfilled");
      var t = Xa;
      Xa = null, gl = 0, Jl = null;
      for (var e = 0; e < t.length; e++) (0, t[e])();
    }
  }
  function my(t, e) {
    var n = [], l = {
      status: "pending",
      value: null,
      reason: null,
      then: function(a) {
        n.push(a);
      }
    };
    return t.then(
      function() {
        l.status = "fulfilled", l.value = e;
        for (var a = 0; a < n.length; a++) (0, n[a])(e);
      },
      function(a) {
        for (l.status = "rejected", l.reason = a, a = 0; a < n.length; a++)
          (0, n[a])(void 0);
      }
    ), l;
  }
  var sf = U.S;
  U.S = function(t, e) {
    if (Pd = we(), typeof e == "object" && e !== null && typeof e.then == "function" && dy(t, e), Qa !== null)
      for (var n = da; n !== null; )
        af(n, Qa), n = n.next;
    if (n = t.types, n !== null) {
      for (var l = da; l !== null; )
        af(l, n), l = l.next;
      if (gl !== 0) {
        l = Qa, l === null && (l = Qa = []);
        for (var a = 0; a < n.length; a++) {
          var u = n[a];
          l.indexOf(u) === -1 && l.push(u);
        }
      }
    }
    sf !== null && sf(t, e);
  };
  var yl = lt(null);
  function Ks() {
    var t = yl.current;
    return t !== null ? t : Dt.pooledCache;
  }
  function Pu(t, e) {
    e === null ? rt(yl, yl.current) : rt(yl, e.pool);
  }
  function cf() {
    var t = Ks();
    return t === null ? null : { parent: Kt._currentValue, pool: t };
  }
  var $l = Error(o(460)), Js = Error(o(474)), ti = Error(o(542)), ei = { then: function() {
  } };
  function of(t) {
    return t = t.status, t === "fulfilled" || t === "rejected";
  }
  function rf(t, e, n) {
    switch (n = t[n], n === void 0 ? t.push(e) : n !== e && (e.then(yn, yn), e = n), e.status) {
      case "fulfilled":
        return e.value;
      case "rejected":
        throw t = e.reason, df(t), t;
      default:
        if (typeof e.status == "string") e.then(yn, yn);
        else {
          if (t = Dt, t !== null && 100 < t.shellSuspendCounter)
            throw Error(o(482));
          t = e, t.status = "pending", t.then(
            function(l) {
              if (e.status === "pending") {
                var a = e;
                a.status = "fulfilled", a.value = l;
              }
            },
            function(l) {
              if (e.status === "pending") {
                var a = e;
                a.status = "rejected", a.reason = l;
              }
            }
          );
        }
        switch (e.status) {
          case "fulfilled":
            return e.value;
          case "rejected":
            throw t = e.reason, df(t), t;
        }
        throw pl = e, $l;
    }
  }
  function vl(t) {
    try {
      var e = t._init;
      return e(t._payload);
    } catch (n) {
      throw n !== null && typeof n == "object" && typeof n.then == "function" ? (pl = n, $l) : n;
    }
  }
  var pl = null;
  function ff() {
    if (pl === null) throw Error(o(459));
    var t = pl;
    return pl = null, t;
  }
  function df(t) {
    if (t === $l || t === ti)
      throw Error(o(483));
  }
  var Fl = null, ka = 0;
  function ni(t) {
    var e = ka;
    return ka += 1, Fl === null && (Fl = []), rf(Fl, t, e);
  }
  function Ln(t, e) {
    e = e.props.ref, t.ref = e !== void 0 ? e : null;
  }
  function li(t, e) {
    throw e.$$typeof === jt ? Error(o(525)) : (t = Object.prototype.toString.call(e), Error(
      o(
        31,
        t === "[object Object]" ? "object with keys {" + Object.keys(e).join(", ") + "}" : t
      )
    ));
  }
  function mf(t) {
    function e(p, h) {
      if (t) {
        var E = p.deletions;
        E === null ? (p.deletions = [h], p.flags |= 16) : E.push(h);
      }
    }
    function n(p, h) {
      if (!t) return null;
      for (; h !== null; )
        e(p, h), h = h.sibling;
      return null;
    }
    function l(p) {
      for (var h = /* @__PURE__ */ new Map(); p !== null; )
        p.key !== null ? h.set(p.key, p) : h.set(p.index, p), p = p.sibling;
      return h;
    }
    function a(p, h) {
      return p = Sn(p, h), p.index = 0, p.sibling = null, p;
    }
    function u(p, h, E) {
      return p.index = E, t ? (E = p.alternate, E !== null ? (E = E.index, E < h ? (p.flags |= 134217730, h) : E) : (p.flags |= 134217730, h)) : (p.flags |= 1048576, h);
    }
    function i(p) {
      return t && p.alternate === null && (p.flags |= 134217730), p;
    }
    function c(p, h, E, w) {
      return h === null || h.tag !== 6 ? (h = Hs(E, p.mode, w), h.return = p, h) : (h = a(h, E), h.return = p, h);
    }
    function f(p, h, E, w) {
      var Z = E.type;
      return Z === Yt ? (p = _(
        p,
        h,
        E.props.children,
        w,
        E.key
      ), Ln(p, E), p) : h !== null && (h.elementType === Z || typeof Z == "object" && Z !== null && Z.$$typeof === bt && vl(Z) === h.type) ? (h = a(h, E.props), Ln(h, E), h.return = p, h) : (h = Ju(
        E.type,
        E.key,
        E.props,
        null,
        p.mode,
        w
      ), Ln(h, E), h.return = p, h);
    }
    function v(p, h, E, w) {
      return h === null || h.tag !== 4 || h.stateNode.containerInfo !== E.containerInfo || h.stateNode.implementation !== E.implementation ? (h = Bs(E, p.mode, w), h.return = p, h) : (h = a(h, E.children || []), h.return = p, h);
    }
    function _(p, h, E, w, Z) {
      return h === null || h.tag !== 7 ? (h = fl(
        E,
        p.mode,
        w,
        Z
      ), h.return = p, h) : (h = a(h, E), h.return = p, h);
    }
    function M(p, h, E) {
      if (typeof h == "string" && h !== "" || typeof h == "number" || typeof h == "bigint")
        return h = Hs(
          "" + h,
          p.mode,
          E
        ), h.return = p, h;
      if (typeof h == "object" && h !== null) {
        switch (h.$$typeof) {
          case I:
            return E = Ju(
              h.type,
              h.key,
              h.props,
              null,
              p.mode,
              E
            ), Ln(E, h), E.return = p, E;
          case ot:
            return h = Bs(
              h,
              p.mode,
              E
            ), h.return = p, h;
          case bt:
            return h = vl(h), M(p, h, E);
        }
        if (Y(h) || C(h))
          return h = fl(
            h,
            p.mode,
            E,
            null
          ), h.return = p, h;
        if (typeof h.then == "function")
          return M(p, ni(h), E);
        if (h.$$typeof === Wt)
          return M(
            p,
            Iu(p, h),
            E
          );
        li(p, h);
      }
      return null;
    }
    function b(p, h, E, w) {
      var Z = h !== null ? h.key : null;
      if (typeof E == "string" && E !== "" || typeof E == "number" || typeof E == "bigint")
        return Z !== null ? null : c(p, h, "" + E, w);
      if (typeof E == "object" && E !== null) {
        switch (E.$$typeof) {
          case I:
            return E.key === Z ? f(p, h, E, w) : null;
          case ot:
            return E.key === Z ? v(p, h, E, w) : null;
          case bt:
            return E = vl(E), b(p, h, E, w);
        }
        if (Y(E) || C(E))
          return Z !== null ? null : _(p, h, E, w, null);
        if (typeof E.then == "function")
          return b(
            p,
            h,
            ni(E),
            w
          );
        if (E.$$typeof === Wt)
          return b(
            p,
            h,
            Iu(p, E),
            w
          );
        li(p, E);
      }
      return null;
    }
    function S(p, h, E, w, Z) {
      if (typeof w == "string" && w !== "" || typeof w == "number" || typeof w == "bigint")
        return p = p.get(E) || null, c(h, p, "" + w, Z);
      if (typeof w == "object" && w !== null) {
        switch (w.$$typeof) {
          case I:
            return p = p.get(
              w.key === null ? E : w.key
            ) || null, f(h, p, w, Z);
          case ot:
            return p = p.get(
              w.key === null ? E : w.key
            ) || null, v(h, p, w, Z);
          case bt:
            return w = vl(w), S(
              p,
              h,
              E,
              w,
              Z
            );
        }
        if (Y(w) || C(w))
          return p = p.get(E) || null, _(h, p, w, Z, null);
        if (typeof w.then == "function")
          return S(
            p,
            h,
            E,
            ni(w),
            Z
          );
        if (w.$$typeof === Wt)
          return S(
            p,
            h,
            E,
            Iu(h, w),
            Z
          );
        li(h, w);
      }
      return null;
    }
    function L(p, h, E, w) {
      for (var Z = null, pt = null, J = h, P = h = 0, ne = null; J !== null && P < E.length; P++) {
        J.index > P ? (ne = J, J = null) : ne = J.sibling;
        var Tt = b(
          p,
          J,
          E[P],
          w
        );
        if (Tt === null) {
          J === null && (J = ne);
          break;
        }
        t && J && Tt.alternate === null && e(p, J), h = u(Tt, h, P), pt === null ? Z = Tt : pt.sibling = Tt, pt = Tt, J = ne;
      }
      if (P === E.length)
        return n(p, J), dt && En(p, P), Z;
      if (J === null) {
        for (; P < E.length; P++)
          J = M(p, E[P], w), J !== null && (h = u(
            J,
            h,
            P
          ), pt === null ? Z = J : pt.sibling = J, pt = J);
        return dt && En(p, P), Z;
      }
      for (J = l(J); P < E.length; P++)
        ne = S(
          J,
          p,
          P,
          E[P],
          w
        ), ne !== null && (t && ne.alternate !== null && J.delete(
          ne.key === null ? P : ne.key
        ), h = u(
          ne,
          h,
          P
        ), pt === null ? Z = ne : pt.sibling = ne, pt = ne);
      return t && J.forEach(function(nl) {
        return e(p, nl);
      }), dt && En(p, P), Z;
    }
    function k(p, h, E, w) {
      if (E == null) throw Error(o(151));
      for (var Z = null, pt = null, J = h, P = h = 0, ne = null, Tt = E.next(); J !== null && !Tt.done; P++, Tt = E.next()) {
        J.index > P ? (ne = J, J = null) : ne = J.sibling;
        var nl = b(p, J, Tt.value, w);
        if (nl === null) {
          J === null && (J = ne);
          break;
        }
        t && J && nl.alternate === null && e(p, J), h = u(nl, h, P), pt === null ? Z = nl : pt.sibling = nl, pt = nl, J = ne;
      }
      if (Tt.done)
        return n(p, J), dt && En(p, P), Z;
      if (J === null) {
        for (; !Tt.done; P++, Tt = E.next())
          Tt = M(p, Tt.value, w), Tt !== null && (h = u(Tt, h, P), pt === null ? Z = Tt : pt.sibling = Tt, pt = Tt);
        return dt && En(p, P), Z;
      }
      for (J = l(J); !Tt.done; P++, Tt = E.next())
        Tt = S(J, p, P, Tt.value, w), Tt !== null && (t && Tt.alternate !== null && J.delete(Tt.key === null ? P : Tt.key), h = u(Tt, h, P), pt === null ? Z = Tt : pt.sibling = Tt, pt = Tt);
      return t && J.forEach(function(Lv) {
        return e(p, Lv);
      }), dt && En(p, P), Z;
    }
    function ut(p, h, E, w) {
      if (typeof E == "object" && E !== null && E.type === Yt && E.key === null && E.props.ref === void 0 && (E = E.props.children), typeof E == "object" && E !== null) {
        switch (E.$$typeof) {
          case I:
            t: {
              for (var Z = E.key; h !== null; ) {
                if (h.key === Z) {
                  if (Z = E.type, Z === Yt) {
                    if (h.tag === 7) {
                      n(
                        p,
                        h.sibling
                      ), w = a(
                        h,
                        E.props.children
                      ), Ln(w, E), w.return = p, p = w;
                      break t;
                    }
                  } else if (h.elementType === Z || typeof Z == "object" && Z !== null && Z.$$typeof === bt && vl(Z) === h.type) {
                    n(
                      p,
                      h.sibling
                    ), w = a(h, E.props), Ln(w, E), w.return = p, p = w;
                    break t;
                  }
                  n(p, h);
                  break;
                } else e(p, h);
                h = h.sibling;
              }
              E.type === Yt ? (w = fl(
                E.props.children,
                p.mode,
                w,
                E.key
              ), Ln(w, E), w.return = p, p = w) : (w = Ju(
                E.type,
                E.key,
                E.props,
                null,
                p.mode,
                w
              ), Ln(w, E), w.return = p, p = w);
            }
            return i(p);
          case ot:
            t: {
              for (Z = E.key; h !== null; ) {
                if (h.key === Z)
                  if (h.tag === 4 && h.stateNode.containerInfo === E.containerInfo && h.stateNode.implementation === E.implementation) {
                    n(
                      p,
                      h.sibling
                    ), w = a(h, E.children || []), w.return = p, p = w;
                    break t;
                  } else {
                    n(p, h);
                    break;
                  }
                else e(p, h);
                h = h.sibling;
              }
              w = Bs(E, p.mode, w), w.return = p, p = w;
            }
            return i(p);
          case bt:
            return E = vl(E), ut(
              p,
              h,
              E,
              w
            );
        }
        if (Y(E))
          return L(
            p,
            h,
            E,
            w
          );
        if (C(E)) {
          if (Z = C(E), typeof Z != "function") throw Error(o(150));
          return E = Z.call(E), k(
            p,
            h,
            E,
            w
          );
        }
        if (typeof E.then == "function")
          return ut(
            p,
            h,
            ni(E),
            w
          );
        if (E.$$typeof === Wt)
          return ut(
            p,
            h,
            Iu(p, E),
            w
          );
        li(p, E);
      }
      return typeof E == "string" && E !== "" || typeof E == "number" || typeof E == "bigint" ? (E = "" + E, h !== null && h.tag === 6 ? (n(p, h.sibling), w = a(h, E), w.return = p, p = w) : (n(p, h), w = Hs(E, p.mode, w), w.return = p, p = w), i(p)) : n(p, h);
    }
    return function(p, h, E, w) {
      try {
        ka = 0;
        var Z = ut(
          p,
          h,
          E,
          w
        );
        return Fl = null, Z;
      } catch (J) {
        if (J === $l || J === ti) throw J;
        var pt = _e(29, J, null, p.mode);
        return pt.lanes = w, pt.return = p, pt;
      } finally {
      }
    };
  }
  var bl = mf(!0), hf = mf(!1), Yn = !1;
  function $s(t) {
    t.updateQueue = {
      baseState: t.memoizedState,
      firstBaseUpdate: null,
      lastBaseUpdate: null,
      shared: { pending: null, lanes: 0, hiddenCallbacks: null },
      callbacks: null
    };
  }
  function Fs(t, e) {
    t = t.updateQueue, e.updateQueue === t && (e.updateQueue = {
      baseState: t.baseState,
      firstBaseUpdate: t.firstBaseUpdate,
      lastBaseUpdate: t.lastBaseUpdate,
      shared: t.shared,
      callbacks: null
    });
  }
  function Gn(t) {
    return { lane: t, tag: 0, payload: null, callback: null, next: null };
  }
  function Qn(t, e, n) {
    var l = t.updateQueue;
    if (l === null) return null;
    if (l = l.shared, (Ot & 2) !== 0) {
      var a = l.pending;
      return a === null ? e.next = e : (e.next = a.next, a.next = e), l.pending = e, e = Ku(t), $r(t, null, n), e;
    }
    return Zu(t, l, e, n), Ku(t);
  }
  function Va(t, e, n) {
    if (e = e.updateQueue, e !== null && (e = e.shared, (n & 4194048) !== 0)) {
      var l = e.lanes;
      l &= t.pendingLanes, n |= l, e.lanes = n, er(t, n);
    }
  }
  function Ws(t, e) {
    var n = t.updateQueue, l = t.alternate;
    if (l !== null && (l = l.updateQueue, n === l)) {
      var a = null, u = null;
      if (n = n.firstBaseUpdate, n !== null) {
        do {
          var i = {
            lane: n.lane,
            tag: n.tag,
            payload: n.payload,
            callback: null,
            next: null
          };
          u === null ? a = u = i : u = u.next = i, n = n.next;
        } while (n !== null);
        u === null ? a = u = e : u = u.next = e;
      } else a = u = e;
      n = {
        baseState: l.baseState,
        firstBaseUpdate: a,
        lastBaseUpdate: u,
        shared: l.shared,
        callbacks: l.callbacks
      }, t.updateQueue = n;
      return;
    }
    t = n.lastBaseUpdate, t === null ? n.firstBaseUpdate = e : t.next = e, n.lastBaseUpdate = e;
  }
  var Is = !1;
  function Za() {
    if (Is) {
      var t = Jl;
      if (t !== null) throw t;
    }
  }
  function Ka(t, e, n, l) {
    Is = !1;
    var a = t.updateQueue;
    Yn = !1;
    var u = a.firstBaseUpdate, i = a.lastBaseUpdate, c = a.shared.pending;
    if (c !== null) {
      a.shared.pending = null;
      var f = c, v = f.next;
      f.next = null, i === null ? u = v : i.next = v, i = f;
      var _ = t.alternate;
      _ !== null && (_ = _.updateQueue, c = _.lastBaseUpdate, c !== i && (c === null ? _.firstBaseUpdate = v : c.next = v, _.lastBaseUpdate = f));
    }
    if (u !== null) {
      var M = a.baseState;
      i = 0, _ = v = f = null, c = u;
      do {
        var b = c.lane & -536870913, S = b !== c.lane;
        if (S ? (vt & b) === b : (l & b) === b) {
          b !== 0 && b === gl && (Is = !0), _ !== null && (_ = _.next = {
            lane: 0,
            tag: c.tag,
            payload: c.payload,
            callback: null,
            next: null
          });
          t: {
            var L = t, k = c;
            b = e;
            var ut = n;
            switch (k.tag) {
              case 1:
                if (L = k.payload, typeof L == "function") {
                  M = L.call(ut, M, b);
                  break t;
                }
                M = L;
                break t;
              case 3:
                L.flags = L.flags & -65537 | 128;
              case 0:
                if (L = k.payload, b = typeof L == "function" ? L.call(ut, M, b) : L, b == null) break t;
                M = W({}, M, b);
                break t;
              case 2:
                Yn = !0;
            }
          }
          b = c.callback, b !== null && (t.flags |= 64, S && (t.flags |= 8192), S = a.callbacks, S === null ? a.callbacks = [b] : S.push(b));
        } else
          S = {
            lane: b,
            tag: c.tag,
            payload: c.payload,
            callback: c.callback,
            next: null
          }, _ === null ? (v = _ = S, f = M) : _ = _.next = S, i |= b;
        if (c = c.next, c === null) {
          if (c = a.shared.pending, c === null)
            break;
          S = c, c = S.next, S.next = null, a.lastBaseUpdate = S, a.shared.pending = null;
        }
      } while (!0);
      _ === null && (f = M), a.baseState = f, a.firstBaseUpdate = v, a.lastBaseUpdate = _, u === null && (a.shared.lanes = 0), Kn |= i, t.lanes = i, t.memoizedState = M;
    }
  }
  function gf(t, e) {
    if (typeof t != "function")
      throw Error(o(191, t));
    t.call(e);
  }
  function yf(t, e) {
    var n = t.callbacks;
    if (n !== null)
      for (t.callbacks = null, t = 0; t < n.length; t++)
        gf(n[t], e);
  }
  var Wl = lt(null), ai = lt(0);
  function vf(t, e) {
    t = wn, rt(ai, t), rt(Wl, e), wn = t | e.baseLanes;
  }
  function Ps() {
    rt(ai, wn), rt(Wl, Wl.current);
  }
  function tc() {
    wn = ai.current, St(Wl), St(ai);
  }
  var se = lt(null), fe = null;
  function Xn(t) {
    var e = t.alternate;
    rt(ce, ce.current & 1), rt(se, t), fe === null && (e === null || Wl.current !== null || e.memoizedState !== null) && (fe = t);
  }
  function ec(t) {
    rt(ce, ce.current), rt(se, t), fe === null && (fe = t);
  }
  function pf(t) {
    t.tag === 22 ? (rt(ce, ce.current), rt(se, t), fe === null && (fe = t)) : kn();
  }
  function kn() {
    rt(ce, ce.current), rt(se, se.current);
  }
  function Re(t) {
    St(se), fe === t && (fe = null), St(ce);
  }
  var ce = lt(0);
  function Ja(t, e) {
    rt(se, se.current), rt(ce, e);
  }
  function nc(t) {
    St(ce), St(se), fe === t && (fe = null);
  }
  function ui(t) {
    for (var e = t; e !== null; ) {
      if (e.tag === 13) {
        var n = e.memoizedState;
        if (n !== null && (n = n.dehydrated, n === null || zo(n) || Co(n)))
          return e;
      } else if (e.tag === 19 && e.memoizedProps.revealOrder !== "independent") {
        if ((e.flags & 128) !== 0) return e;
      } else if (e.child !== null) {
        e.child.return = e, e = e.child;
        continue;
      }
      if (e === t) break;
      for (; e.sibling === null; ) {
        if (e.return === null || e.return === t) return null;
        e = e.return;
      }
      e.sibling.return = e.return, e = e.sibling;
    }
    return null;
  }
  var On = 0, at = null, Nt = null, Jt = null, ii = !1, Il = !1, Sl = !1, si = 0, $a = 0, Pl = null, hy = 0;
  function Qt() {
    throw Error(o(321));
  }
  function lc(t, e) {
    if (e === null) return !1;
    for (var n = 0; n < e.length && n < t.length; n++)
      if (!De(t[n], e[n])) return !1;
    return !0;
  }
  function ac(t, e, n, l, a, u) {
    return On = u, at = e, e.memoizedState = null, e.updateQueue = null, e.lanes = 0, U.H = t === null || t.memoizedState === null ? ed : bc, Sl = !1, u = n(l, a), Sl = !1, Il && (u = Sf(
      e,
      n,
      l,
      a
    )), bf(t), u;
  }
  function bf(t) {
    U.H = Ia;
    var e = Nt !== null && Nt.next !== null;
    if (On = 0, Jt = Nt = at = null, ii = !1, $a = 0, Pl = null, e) throw Error(o(300));
    t === null || $t || (t = t.dependencies, t !== null && Wu(t) && ($t = !0));
  }
  function Sf(t, e, n, l) {
    at = t;
    var a = 0;
    do {
      if (Il && (Pl = null), $a = 0, Il = !1, 25 <= a) throw Error(o(301));
      if (a += 1, Jt = Nt = null, t.updateQueue != null) {
        var u = t.updateQueue;
        u.lastEffect = null, u.events = null, u.stores = null, u.memoCache != null && (u.memoCache.index = 0);
      }
      U.H = nd, u = e(n, l);
    } while (Il);
    return u;
  }
  function gy() {
    var t = U.H, e = t.useState()[0];
    return e = typeof e.then == "function" ? Fa(e) : e, t = t.useState()[0], (Nt !== null ? Nt.memoizedState : null) !== t && (at.flags |= 1024), e;
  }
  function uc() {
    var t = si !== 0;
    return si = 0, t;
  }
  function ic(t, e, n) {
    e.updateQueue = t.updateQueue, e.flags &= -2053, t.lanes &= ~n;
  }
  function sc(t) {
    if (ii) {
      for (t = t.memoizedState; t !== null; ) {
        var e = t.queue;
        e !== null && (e.pending = null), t = t.next;
      }
      ii = !1;
    }
    On = 0, Jt = Nt = at = null, Il = !1, $a = si = 0, Pl = null;
  }
  function ge() {
    var t = {
      memoizedState: null,
      baseState: null,
      baseQueue: null,
      queue: null,
      next: null
    };
    return Jt === null ? at.memoizedState = Jt = t : Jt = Jt.next = t, Jt;
  }
  function Vt() {
    if (Nt === null) {
      var t = at.alternate;
      t = t !== null ? t.memoizedState : null;
    } else t = Nt.next;
    var e = Jt === null ? at.memoizedState : Jt.next;
    if (e !== null)
      Jt = e, Nt = t;
    else {
      if (t === null)
        throw at.alternate === null ? Error(o(467)) : Error(o(310));
      Nt = t, t = {
        memoizedState: Nt.memoizedState,
        baseState: Nt.baseState,
        baseQueue: Nt.baseQueue,
        queue: Nt.queue,
        next: null
      }, Jt === null ? at.memoizedState = Jt = t : Jt = Jt.next = t;
    }
    return Jt;
  }
  function ci() {
    return { lastEffect: null, events: null, stores: null, memoCache: null };
  }
  function Fa(t) {
    var e = $a;
    return $a += 1, Pl === null && (Pl = []), t = rf(Pl, t, e), e = at, (Jt === null ? e.memoizedState : Jt.next) === null && (e = e.alternate, U.H = e === null || e.memoizedState === null ? ed : bc), t;
  }
  function oi(t) {
    if (t !== null && typeof t == "object") {
      if (typeof t.then == "function") return Fa(t);
      if (t.$$typeof === Wt) return ie(t);
    }
    throw Error(o(438, String(t)));
  }
  function cc(t) {
    var e = null, n = at.updateQueue;
    if (n !== null && (e = n.memoCache), e == null) {
      var l = at.alternate;
      l !== null && (l = l.updateQueue, l !== null && (l = l.memoCache, l != null && (e = {
        data: l.data.map(function(a) {
          return a.slice();
        }),
        index: 0
      })));
    }
    if (e == null && (e = { data: [], index: 0 }), n === null && (n = ci(), at.updateQueue = n), n.memoCache = e, n = e.data[e.index], n === void 0)
      for (n = e.data[e.index] = Array(t), l = 0; l < t; l++)
        n[l] = V;
    return e.index++, n;
  }
  function zn(t, e) {
    return typeof e == "function" ? e(t) : e;
  }
  function ri(t) {
    var e = Vt();
    return oc(e, Nt, t);
  }
  function oc(t, e, n) {
    var l = t.queue;
    if (l === null) throw Error(o(311));
    l.lastRenderedReducer = n;
    var a = t.baseQueue, u = l.pending;
    if (u !== null) {
      if (a !== null) {
        var i = a.next;
        a.next = u.next, u.next = i;
      }
      e.baseQueue = a = u, l.pending = null;
    }
    if (u = t.baseState, a === null) t.memoizedState = u;
    else {
      e = a.next;
      var c = i = null, f = null, v = e, _ = !1;
      do {
        var M = v.lane & -536870913;
        if (M !== v.lane ? (vt & M) === M : (On & M) === M) {
          var b = v.revertLane;
          if (b === 0)
            f !== null && (f = f.next = {
              lane: 0,
              revertLane: 0,
              gesture: null,
              action: v.action,
              hasEagerState: v.hasEagerState,
              eagerState: v.eagerState,
              next: null
            }), M === gl && (_ = !0);
          else if ((On & b) === b) {
            v = v.next, b === gl && (_ = !0);
            continue;
          } else
            M = {
              lane: 0,
              revertLane: v.revertLane,
              gesture: null,
              action: v.action,
              hasEagerState: v.hasEagerState,
              eagerState: v.eagerState,
              next: null
            }, f === null ? (c = f = M, i = u) : f = f.next = M, at.lanes |= b, Kn |= b;
          M = v.action, Sl && n(u, M), u = v.hasEagerState ? v.eagerState : n(u, M);
        } else
          b = {
            lane: M,
            revertLane: v.revertLane,
            gesture: v.gesture,
            action: v.action,
            hasEagerState: v.hasEagerState,
            eagerState: v.eagerState,
            next: null
          }, f === null ? (c = f = b, i = u) : f = f.next = b, at.lanes |= M, Kn |= M;
        v = v.next;
      } while (v !== null && v !== e);
      if (f === null ? i = u : f.next = c, !De(u, t.memoizedState) && ($t = !0, _ && (n = Jl, n !== null)))
        throw n;
      t.memoizedState = u, t.baseState = i, t.baseQueue = f, l.lastRenderedState = u;
    }
    return a === null && (l.lanes = 0), [t.memoizedState, l.dispatch];
  }
  function rc(t) {
    var e = Vt(), n = e.queue;
    if (n === null) throw Error(o(311));
    n.lastRenderedReducer = t;
    var l = n.dispatch, a = n.pending, u = e.memoizedState;
    if (a !== null) {
      n.pending = null;
      var i = a = a.next;
      do
        u = t(u, i.action), i = i.next;
      while (i !== a);
      De(u, e.memoizedState) || ($t = !0), e.memoizedState = u, e.baseQueue === null && (e.baseState = u), n.lastRenderedState = u;
    }
    return [u, l];
  }
  function Ef(t, e, n) {
    var l = at, a = Vt(), u = dt;
    if (u) {
      if (n === void 0) throw Error(o(407));
      n = n();
    } else n = e();
    var i = !De(
      (Nt || a).memoizedState,
      n
    );
    if (i && (a.memoizedState = n, $t = !0), a = a.queue, mc(Of.bind(null, l, a, t), [
      t
    ]), a.getSnapshot !== e || i || Jt !== null && Jt.memoizedState.tag & 1) {
      if (l.flags |= 2048, ta(
        9,
        { destroy: void 0 },
        _f.bind(
          null,
          l,
          a,
          n,
          e
        ),
        null
      ), Dt === null) throw Error(o(349));
      u || (On & 127) !== 0 || Tf(l, e, n);
    }
    return n;
  }
  function Tf(t, e, n) {
    t.flags |= 16384, t = { getSnapshot: e, value: n }, e = at.updateQueue, e === null ? (e = ci(), at.updateQueue = e, e.stores = [t]) : (n = e.stores, n === null ? e.stores = [t] : n.push(t));
  }
  function _f(t, e, n, l) {
    e.value = n, e.getSnapshot = l, zf(e) && Cf(t);
  }
  function Of(t, e, n) {
    return n(function() {
      zf(e) && Cf(t);
    });
  }
  function zf(t) {
    var e = t.getSnapshot;
    t = t.value;
    try {
      var n = e();
      return !De(t, n);
    } catch {
      return !0;
    }
  }
  function Cf(t) {
    var e = rl(t, 2);
    e !== null && Ce(e, t, 2);
  }
  function fc(t) {
    var e = ge();
    if (typeof t == "function") {
      var n = t;
      if (t = n(), Sl) {
        Dn(!0);
        try {
          n();
        } finally {
          Dn(!1);
        }
      }
    }
    return e.memoizedState = e.baseState = t, e.queue = {
      pending: null,
      lanes: 0,
      dispatch: null,
      lastRenderedReducer: zn,
      lastRenderedState: t
    }, e;
  }
  function Mf(t, e, n, l) {
    return t.baseState = n, oc(
      t,
      Nt,
      typeof l == "function" ? l : zn
    );
  }
  function yy(t, e, n, l, a) {
    if (mi(t)) throw Error(o(485));
    if (t = e.action, t !== null) {
      var u = {
        payload: a,
        action: t,
        next: null,
        isTransition: !0,
        status: "pending",
        value: null,
        reason: null,
        listeners: [],
        then: function(i) {
          u.listeners.push(i);
        }
      };
      U.T !== null ? n(!0) : u.isTransition = !1, l(u), n = e.pending, n === null ? (u.next = e.pending = u, Af(e, u)) : (u.next = n.next, e.pending = n.next = u);
    }
  }
  function Af(t, e) {
    var n = e.action, l = e.payload, a = t.state;
    if (e.isTransition) {
      var u = U.T, i = {};
      i.types = u !== null ? u.types : null, U.T = i;
      try {
        var c = n(a, l), f = U.S;
        f !== null && f(i, c), wf(t, e, c);
      } catch (v) {
        dc(t, e, v);
      } finally {
        u !== null && i.types !== null && (u.types = i.types), U.T = u;
      }
    } else
      try {
        u = n(a, l), wf(t, e, u);
      } catch (v) {
        dc(t, e, v);
      }
  }
  function wf(t, e, n) {
    n !== null && typeof n == "object" && typeof n.then == "function" ? n.then(
      function(l) {
        Nf(t, e, l);
      },
      function(l) {
        return dc(t, e, l);
      }
    ) : Nf(t, e, n);
  }
  function Nf(t, e, n) {
    e.status = "fulfilled", e.value = n, Uf(e), t.state = n, e = t.pending, e !== null && (n = e.next, n === e ? t.pending = null : (n = n.next, e.next = n, Af(t, n)));
  }
  function dc(t, e, n) {
    var l = t.pending;
    if (t.pending = null, l !== null) {
      l = l.next;
      do
        e.status = "rejected", e.reason = n, Uf(e), e = e.next;
      while (e !== l);
    }
    t.action = null;
  }
  function Uf(t) {
    t = t.listeners;
    for (var e = 0; e < t.length; e++) (0, t[e])();
  }
  function Df(t, e) {
    return e;
  }
  function Rf(t, e) {
    if (dt) {
      var n = Dt.formState;
      if (n !== null) {
        t: {
          var l = at;
          if (dt) {
            if (xt) {
              e: {
                for (var a = xt, u = Ze; a.nodeType !== 8; ) {
                  if (!u) {
                    a = null;
                    break e;
                  }
                  if (a = $e(
                    a.nextSibling
                  ), a === null) {
                    a = null;
                    break e;
                  }
                }
                u = a.data, a = u === "F!" || u === "F" ? a : null;
              }
              if (a) {
                xt = $e(
                  a.nextSibling
                ), l = a.data === "F!";
                break t;
              }
            }
            Hn(l);
          }
          l = !1;
        }
        l && (e = n[0]);
      }
    }
    return n = ge(), n.memoizedState = n.baseState = e, l = {
      pending: null,
      lanes: 0,
      dispatch: null,
      lastRenderedReducer: Df,
      lastRenderedState: e
    }, n.queue = l, n = If.bind(
      null,
      at,
      l
    ), l.dispatch = n, l = fc(!1), u = pc.bind(
      null,
      at,
      !1,
      l.queue
    ), l = ge(), a = {
      state: e,
      dispatch: null,
      action: t,
      pending: null
    }, l.queue = a, n = yy.bind(
      null,
      at,
      a,
      u,
      n
    ), a.dispatch = n, l.memoizedState = t, [e, n, !1];
  }
  function qf(t) {
    var e = Vt();
    return jf(e, Nt, t);
  }
  function jf(t, e, n) {
    if (e = oc(
      t,
      e,
      Df
    )[0], t = ri(zn)[0], typeof e == "object" && e !== null && typeof e.then == "function")
      try {
        var l = Fa(e);
      } catch (i) {
        throw i === $l ? ti : i;
      }
    else l = e;
    e = Vt();
    var a = e.queue, u = a.dispatch;
    return n !== e.memoizedState && (at.flags |= 2048, ta(
      9,
      { destroy: void 0 },
      vy.bind(null, a, n),
      null
    )), [l, u, t];
  }
  function vy(t, e) {
    t.action = e;
  }
  function xf(t) {
    var e = Vt(), n = Nt;
    if (n !== null)
      return jf(e, n, t);
    Vt(), e = e.memoizedState, n = Vt();
    var l = n.queue.dispatch;
    return n.memoizedState = t, [e, l, !1];
  }
  function ta(t, e, n, l) {
    return t = { tag: t, create: n, deps: l, inst: e, next: null }, e = at.updateQueue, e === null && (e = ci(), at.updateQueue = e), n = e.lastEffect, n === null ? e.lastEffect = t.next = t : (l = n.next, n.next = t, t.next = l, e.lastEffect = t), t;
  }
  function Hf() {
    return Vt().memoizedState;
  }
  function fi(t, e, n, l) {
    var a = ge();
    at.flags |= t, a.memoizedState = ta(
      1 | e,
      { destroy: void 0 },
      n,
      l === void 0 ? null : l
    );
  }
  function di(t, e, n, l) {
    var a = Vt();
    l = l === void 0 ? null : l;
    var u = a.memoizedState.inst;
    Nt !== null && l !== null && lc(l, Nt.memoizedState.deps) ? a.memoizedState = ta(e, u, n, l) : (at.flags |= t, a.memoizedState = ta(
      1 | e,
      u,
      n,
      l
    ));
  }
  function Bf(t, e) {
    fi(8390656, 8, t, e);
  }
  function mc(t, e) {
    di(2048, 8, t, e);
  }
  function py(t) {
    at.flags |= 4;
    var e = at.updateQueue;
    if (e === null)
      e = ci(), at.updateQueue = e, e.events = [t];
    else {
      var n = e.events;
      n === null ? e.events = [t] : n.push(t);
    }
  }
  function Lf(t) {
    var e = Vt().memoizedState;
    return py({ ref: e, nextImpl: t }), function() {
      if ((Ot & 2) !== 0) throw Error(o(440));
      return e.impl.apply(void 0, arguments);
    };
  }
  function Yf(t, e) {
    return di(4, 2, t, e);
  }
  function Gf(t, e) {
    return di(4, 4, t, e);
  }
  function Qf(t, e) {
    if (typeof e == "function") {
      t = t();
      var n = e(t);
      return function() {
        typeof n == "function" ? n() : e(null);
      };
    }
    if (e != null)
      return t = t(), e.current = t, function() {
        e.current = null;
      };
  }
  function Xf(t, e, n) {
    n = n != null ? n.concat([t]) : null, di(4, 4, Qf.bind(null, e, t), n);
  }
  function hc() {
  }
  function kf(t, e) {
    var n = Vt();
    e = e === void 0 ? null : e;
    var l = n.memoizedState;
    return e !== null && lc(e, l[1]) ? l[0] : (n.memoizedState = [t, e], t);
  }
  function Vf(t, e) {
    var n = Vt();
    e = e === void 0 ? null : e;
    var l = n.memoizedState;
    if (e !== null && lc(e, l[1]))
      return l[0];
    if (l = t(), Sl) {
      Dn(!0);
      try {
        t();
      } finally {
        Dn(!1);
      }
    }
    return n.memoizedState = [l, e], l;
  }
  function gc(t, e, n) {
    return n === void 0 || (On & 1073741824) !== 0 && (vt & 261930) === 0 ? t.memoizedState = e : (t.memoizedState = n, t = em(), at.lanes |= t, Kn |= t, n);
  }
  function Zf(t, e, n, l) {
    return De(n, e) ? n : Wl.current !== null ? (t = gc(t, n, l), De(t, e) || ($t = !0), t) : (On & 42) === 0 || (On & 1073741824) !== 0 && (vt & 261930) === 0 ? ($t = !0, t.memoizedState = n) : (t = em(), at.lanes |= t, Kn |= t, e);
  }
  function Kf(t, e, n, l, a) {
    var u = x.p;
    x.p = u !== 0 && 8 > u ? u : 8;
    var i = U.T, c = {};
    c.types = i !== null ? i.types : null, U.T = c, pc(t, !1, e, n);
    try {
      var f = a(), v = U.S;
      if (v !== null && v(c, f), f !== null && typeof f == "object" && typeof f.then == "function") {
        var _ = my(
          f,
          l
        );
        Wa(
          t,
          e,
          _,
          He(t)
        );
      } else
        Wa(
          t,
          e,
          l,
          He(t)
        );
    } catch (M) {
      Wa(
        t,
        e,
        { then: function() {
        }, status: "rejected", reason: M },
        He()
      );
    } finally {
      x.p = u, i !== null && c.types !== null && (i.types = c.types), U.T = i;
    }
  }
  function by() {
  }
  function yc(t, e, n, l) {
    if (t.tag !== 5) throw Error(o(476));
    var a = Jf(t).queue;
    Kf(
      t,
      a,
      e,
      nt,
      n === null ? by : function() {
        return $f(t), n(l);
      }
    );
  }
  function Jf(t) {
    var e = t.memoizedState;
    if (e !== null) return e;
    e = {
      memoizedState: nt,
      baseState: nt,
      baseQueue: null,
      queue: {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: zn,
        lastRenderedState: nt
      },
      next: null
    };
    var n = {};
    return e.next = {
      memoizedState: n,
      baseState: n,
      baseQueue: null,
      queue: {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: zn,
        lastRenderedState: n
      },
      next: null
    }, t.memoizedState = e, t = t.alternate, t !== null && (t.memoizedState = e), e;
  }
  function $f(t) {
    var e = Jf(t);
    e.next === null && (e = t.alternate.memoizedState), Wa(
      t,
      e.next.queue,
      {},
      He()
    );
  }
  function vc() {
    return ie(gu);
  }
  function Ff() {
    return Vt().memoizedState;
  }
  function Wf() {
    return Vt().memoizedState;
  }
  function Sy(t) {
    for (var e = t.return; e !== null; ) {
      switch (e.tag) {
        case 24:
        case 3:
          var n = He();
          t = Gn(n);
          var l = Qn(e, t, n);
          l !== null && (Ce(l, e, n), Va(l, e, n)), e = { cache: Vs() }, t.payload = e;
          return;
      }
      e = e.return;
    }
  }
  function Ey(t, e, n) {
    var l = He();
    n = {
      lane: l,
      revertLane: 0,
      gesture: null,
      action: n,
      hasEagerState: !1,
      eagerState: null,
      next: null
    }, mi(t) ? Pf(e, n) : (n = js(t, e, n, l), n !== null && (Ce(n, t, l), td(n, e, l)));
  }
  function If(t, e, n) {
    var l = He();
    Wa(t, e, n, l);
  }
  function Wa(t, e, n, l) {
    var a = {
      lane: l,
      revertLane: 0,
      gesture: null,
      action: n,
      hasEagerState: !1,
      eagerState: null,
      next: null
    };
    if (mi(t)) Pf(e, a);
    else {
      var u = t.alternate;
      if (t.lanes === 0 && (u === null || u.lanes === 0) && (u = e.lastRenderedReducer, u !== null))
        try {
          var i = e.lastRenderedState, c = u(i, n);
          if (a.hasEagerState = !0, a.eagerState = c, De(c, i))
            return Zu(t, e, a, 0), Dt === null && Vu(), !1;
        } catch {
        } finally {
        }
      if (n = js(t, e, a, l), n !== null)
        return Ce(n, t, l), td(n, e, l), !0;
    }
    return !1;
  }
  function pc(t, e, n, l) {
    if (l = {
      lane: 2,
      revertLane: ro(),
      gesture: null,
      action: l,
      hasEagerState: !1,
      eagerState: null,
      next: null
    }, mi(t)) {
      if (e) throw Error(o(479));
    } else
      e = js(
        t,
        n,
        l,
        2
      ), e !== null && Ce(e, t, 2);
  }
  function mi(t) {
    var e = t.alternate;
    return t === at || e !== null && e === at;
  }
  function Pf(t, e) {
    Il = ii = !0;
    var n = t.pending;
    n === null ? e.next = e : (e.next = n.next, n.next = e), t.pending = e;
  }
  function td(t, e, n) {
    if ((n & 4194048) !== 0) {
      var l = e.lanes;
      l &= t.pendingLanes, n |= l, e.lanes = n, er(t, n);
    }
  }
  var Ia = {
    readContext: ie,
    use: oi,
    useCallback: Qt,
    useContext: Qt,
    useEffect: Qt,
    useImperativeHandle: Qt,
    useLayoutEffect: Qt,
    useInsertionEffect: Qt,
    useMemo: Qt,
    useReducer: Qt,
    useRef: Qt,
    useState: Qt,
    useDebugValue: Qt,
    useDeferredValue: Qt,
    useTransition: Qt,
    useSyncExternalStore: Qt,
    useId: Qt,
    useHostTransitionStatus: Qt,
    useFormState: Qt,
    useActionState: Qt,
    useOptimistic: Qt,
    useMemoCache: Qt,
    useCacheRefresh: Qt
  };
  Ia.useEffectEvent = Qt;
  var ed = {
    readContext: ie,
    use: oi,
    useCallback: function(t, e) {
      return ge().memoizedState = [
        t,
        e === void 0 ? null : e
      ], t;
    },
    useContext: ie,
    useEffect: Bf,
    useImperativeHandle: function(t, e, n) {
      n = n != null ? n.concat([t]) : null, fi(
        4194308,
        4,
        Qf.bind(null, e, t),
        n
      );
    },
    useLayoutEffect: function(t, e) {
      return fi(4194308, 4, t, e);
    },
    useInsertionEffect: function(t, e) {
      fi(4, 2, t, e);
    },
    useMemo: function(t, e) {
      var n = ge();
      e = e === void 0 ? null : e;
      var l = t();
      if (Sl) {
        Dn(!0);
        try {
          t();
        } finally {
          Dn(!1);
        }
      }
      return n.memoizedState = [l, e], l;
    },
    useReducer: function(t, e, n) {
      var l = ge();
      if (n !== void 0) {
        var a = n(e);
        if (Sl) {
          Dn(!0);
          try {
            n(e);
          } finally {
            Dn(!1);
          }
        }
      } else a = e;
      return l.memoizedState = l.baseState = a, t = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: t,
        lastRenderedState: a
      }, l.queue = t, t = t.dispatch = Ey.bind(
        null,
        at,
        t
      ), [l.memoizedState, t];
    },
    useRef: function(t) {
      var e = ge();
      return t = { current: t }, e.memoizedState = t;
    },
    useState: function(t) {
      t = fc(t);
      var e = t.queue, n = If.bind(null, at, e);
      return e.dispatch = n, [t.memoizedState, n];
    },
    useDebugValue: hc,
    useDeferredValue: function(t, e) {
      var n = ge();
      return gc(n, t, e);
    },
    useTransition: function() {
      var t = fc(!1);
      return t = Kf.bind(
        null,
        at,
        t.queue,
        !0,
        !1
      ), ge().memoizedState = t, [!1, t];
    },
    useSyncExternalStore: function(t, e, n) {
      var l = at, a = ge();
      if (dt) {
        if (n === void 0)
          throw Error(o(407));
        n = n();
      } else {
        if (n = e(), Dt === null)
          throw Error(o(349));
        (vt & 127) !== 0 || Tf(l, e, n);
      }
      a.memoizedState = n;
      var u = { value: n, getSnapshot: e };
      return a.queue = u, Bf(Of.bind(null, l, u, t), [
        t
      ]), l.flags |= 2048, ta(
        9,
        { destroy: void 0 },
        _f.bind(
          null,
          l,
          u,
          n,
          e
        ),
        null
      ), n;
    },
    useId: function() {
      var t = ge(), e = Dt.identifierPrefix;
      if (dt) {
        var n = an, l = ln;
        n = (l & ~(1 << 32 - Ue(l) - 1)).toString(32) + n, e = "_" + e + "R_" + n, n = si++, 0 < n && (e += "H" + n.toString(32)), e += "_";
      } else
        n = hy++, e = "_" + e + "r_" + n.toString(32) + "_";
      return t.memoizedState = e;
    },
    useHostTransitionStatus: vc,
    useFormState: Rf,
    useActionState: Rf,
    useOptimistic: function(t) {
      var e = ge();
      e.memoizedState = e.baseState = t;
      var n = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: null,
        lastRenderedState: null
      };
      return e.queue = n, e = pc.bind(
        null,
        at,
        !0,
        n
      ), n.dispatch = e, [t, e];
    },
    useMemoCache: cc,
    useCacheRefresh: function() {
      return ge().memoizedState = Sy.bind(
        null,
        at
      );
    },
    useEffectEvent: function(t) {
      var e = ge(), n = { impl: t };
      return e.memoizedState = n, function() {
        if ((Ot & 2) !== 0)
          throw Error(o(440));
        return n.impl.apply(void 0, arguments);
      };
    }
  }, bc = {
    readContext: ie,
    use: oi,
    useCallback: kf,
    useContext: ie,
    useEffect: mc,
    useImperativeHandle: Xf,
    useInsertionEffect: Yf,
    useLayoutEffect: Gf,
    useMemo: Vf,
    useReducer: ri,
    useRef: Hf,
    useState: function() {
      return ri(zn);
    },
    useDebugValue: hc,
    useDeferredValue: function(t, e) {
      var n = Vt();
      return Zf(
        n,
        Nt.memoizedState,
        t,
        e
      );
    },
    useTransition: function() {
      var t = ri(zn)[0], e = Vt().memoizedState;
      return [
        typeof t == "boolean" ? t : Fa(t),
        e
      ];
    },
    useSyncExternalStore: Ef,
    useId: Ff,
    useHostTransitionStatus: vc,
    useFormState: qf,
    useActionState: qf,
    useOptimistic: function(t, e) {
      var n = Vt();
      return Mf(n, Nt, t, e);
    },
    useMemoCache: cc,
    useCacheRefresh: Wf
  };
  bc.useEffectEvent = Lf;
  var nd = {
    readContext: ie,
    use: oi,
    useCallback: kf,
    useContext: ie,
    useEffect: mc,
    useImperativeHandle: Xf,
    useInsertionEffect: Yf,
    useLayoutEffect: Gf,
    useMemo: Vf,
    useReducer: rc,
    useRef: Hf,
    useState: function() {
      return rc(zn);
    },
    useDebugValue: hc,
    useDeferredValue: function(t, e) {
      var n = Vt();
      return Nt === null ? gc(n, t, e) : Zf(
        n,
        Nt.memoizedState,
        t,
        e
      );
    },
    useTransition: function() {
      var t = rc(zn)[0], e = Vt().memoizedState;
      return [
        typeof t == "boolean" ? t : Fa(t),
        e
      ];
    },
    useSyncExternalStore: Ef,
    useId: Ff,
    useHostTransitionStatus: vc,
    useFormState: xf,
    useActionState: xf,
    useOptimistic: function(t, e) {
      var n = Vt();
      return Nt !== null ? Mf(n, Nt, t, e) : (n.baseState = t, [t, n.queue.dispatch]);
    },
    useMemoCache: cc,
    useCacheRefresh: Wf
  };
  nd.useEffectEvent = Lf;
  function Sc(t, e, n, l) {
    e = t.memoizedState, n = n(l, e), n = n == null ? e : W({}, e, n), t.memoizedState = n, t.lanes === 0 && (t.updateQueue.baseState = n);
  }
  var Ec = {
    enqueueSetState: function(t, e, n) {
      t = t._reactInternals;
      var l = He(), a = Gn(l);
      a.payload = e, n != null && (a.callback = n), e = Qn(t, a, l), e !== null && (Ce(e, t, l), Va(e, t, l));
    },
    enqueueReplaceState: function(t, e, n) {
      t = t._reactInternals;
      var l = He(), a = Gn(l);
      a.tag = 1, a.payload = e, n != null && (a.callback = n), e = Qn(t, a, l), e !== null && (Ce(e, t, l), Va(e, t, l));
    },
    enqueueForceUpdate: function(t, e) {
      t = t._reactInternals;
      var n = He(), l = Gn(n);
      l.tag = 2, e != null && (l.callback = e), e = Qn(t, l, n), e !== null && (Ce(e, t, n), Va(e, t, n));
    }
  };
  function ld(t, e, n, l, a, u, i) {
    return t = t.stateNode, typeof t.shouldComponentUpdate == "function" ? t.shouldComponentUpdate(l, u, i) : e.prototype && e.prototype.isPureReactComponent ? !Ha(n, l) || !Ha(a, u) : !0;
  }
  function ad(t, e, n, l) {
    t = e.state, typeof e.componentWillReceiveProps == "function" && e.componentWillReceiveProps(n, l), typeof e.UNSAFE_componentWillReceiveProps == "function" && e.UNSAFE_componentWillReceiveProps(n, l), e.state !== t && Ec.enqueueReplaceState(e, e.state, null);
  }
  function El(t, e) {
    var n = e;
    if ("ref" in e) {
      n = {};
      for (var l in e)
        l !== "ref" && (n[l] = e[l]);
    }
    if (t = t.defaultProps) {
      n === e && (n = W({}, n));
      for (var a in t)
        n[a] === void 0 && (n[a] = t[a]);
    }
    return n;
  }
  function ud(t) {
    ku(t);
  }
  function id(t) {
    console.error(t);
  }
  function sd(t) {
    ku(t);
  }
  function hi(t, e) {
    try {
      var n = t.onUncaughtError;
      n(e.value, { componentStack: e.stack });
    } catch (l) {
      setTimeout(function() {
        throw l;
      });
    }
  }
  function cd(t, e, n) {
    try {
      var l = t.onCaughtError;
      l(n.value, {
        componentStack: n.stack,
        errorBoundary: e.tag === 1 ? e.stateNode : null
      });
    } catch (a) {
      setTimeout(function() {
        throw a;
      });
    }
  }
  function Tc(t, e, n) {
    return n = Gn(n), n.tag = 3, n.payload = { element: null }, n.callback = function() {
      hi(t, e);
    }, n;
  }
  function od(t) {
    return t = Gn(t), t.tag = 3, t;
  }
  function rd(t, e, n, l) {
    var a = n.type.getDerivedStateFromError;
    if (typeof a == "function") {
      var u = l.value;
      t.payload = function() {
        return a(u);
      }, t.callback = function() {
        cd(e, n, l);
      };
    }
    var i = n.stateNode;
    i !== null && typeof i.componentDidCatch == "function" && (t.callback = function() {
      cd(e, n, l), typeof a != "function" && (Jn === null ? Jn = /* @__PURE__ */ new Set([this]) : Jn.add(this));
      var c = l.stack;
      this.componentDidCatch(l.value, {
        componentStack: c !== null ? c : ""
      });
    });
  }
  function Ty(t, e, n, l, a) {
    if (n.flags |= 32768, l !== null && typeof l == "object" && typeof l.then == "function") {
      if (e = n.alternate, e !== null && Kl(
        e,
        n,
        a,
        !0
      ), n = se.current, n !== null) {
        switch (n.tag) {
          case 31:
          case 13:
          case 19:
            return fe === null ? Di() : n.alternate === null && kt === 0 && (kt = 3), n.flags &= -257, n.flags |= 65536, n.lanes = a, l === ei ? n.flags |= 16384 : (e = n.updateQueue, e === null ? n.updateQueue = /* @__PURE__ */ new Set([l]) : e.add(l), so(t, l, a)), !1;
          case 22:
            return n.flags |= 65536, l === ei ? n.flags |= 16384 : (e = n.updateQueue, e === null ? (e = {
              transitions: null,
              markerInstances: null,
              retryQueue: /* @__PURE__ */ new Set([l])
            }, n.updateQueue = e) : (n = e.retryQueue, n === null ? e.retryQueue = /* @__PURE__ */ new Set([l]) : n.add(l)), so(t, l, a)), !1;
        }
        throw Error(o(435, n.tag));
      }
      return so(t, l, a), Di(), !1;
    }
    if (dt)
      return e = se.current, e !== null ? ((e.flags & 65536) === 0 && (e.flags |= 256), e.flags |= 65536, e.lanes = a, l !== Ys && (t = Error(o(422), { cause: l }), Ya(Xe(t, n)))) : (l !== Ys && (e = Error(o(423), {
        cause: l
      }), Ya(
        Xe(e, n)
      )), t = t.current.alternate, t.flags |= 65536, a &= -a, t.lanes |= a, l = Xe(l, n), a = Tc(
        t.stateNode,
        l,
        a
      ), Ws(t, a), kt !== 4 && (kt = 2)), !1;
    var u = Error(o(520), { cause: l });
    if (u = Xe(u, n), uu === null ? uu = [u] : uu.push(u), kt !== 4 && (kt = 2), e === null) return !0;
    l = Xe(l, n), n = e;
    do {
      switch (n.tag) {
        case 3:
          return n.flags |= 65536, t = a & -a, n.lanes |= t, t = Tc(n.stateNode, l, t), Ws(n, t), !1;
        case 1:
          if (e = n.type, u = n.stateNode, (n.flags & 128) === 0 && (typeof e.getDerivedStateFromError == "function" || u !== null && typeof u.componentDidCatch == "function" && (Jn === null || !Jn.has(u))))
            return n.flags |= 65536, a &= -a, n.lanes |= a, a = od(a), rd(
              a,
              t,
              n,
              l
            ), Ws(n, a), !1;
          break;
        case 22:
          if (n.memoizedState !== null)
            return n.flags |= 65536, !1;
      }
      n = n.return;
    } while (n !== null);
    return !1;
  }
  var _c = Error(o(461)), $t = !1;
  function It(t, e, n, l) {
    e.child = t === null ? hf(e, null, n, l) : bl(
      e,
      t.child,
      n,
      l
    );
  }
  function fd(t, e, n, l, a) {
    n = n.render;
    var u = e.ref;
    if ("ref" in l) {
      var i = {};
      for (var c in l)
        c !== "ref" && (i[c] = l[c]);
    } else i = l;
    return hl(e), l = ac(
      t,
      e,
      n,
      i,
      u,
      a
    ), c = uc(), t !== null && !$t ? (ic(t, e, a), Cn(t, e, a)) : (dt && c && Fu(e), e.flags |= 1, It(t, e, l, a), e.child);
  }
  function dd(t, e, n, l, a) {
    if (t === null) {
      var u = n.type;
      return typeof u == "function" && !xs(u) && u.defaultProps === void 0 && n.compare === null ? (e.tag = 15, e.type = u, md(
        t,
        e,
        u,
        l,
        a
      )) : (t = Ju(
        n.type,
        null,
        l,
        e,
        e.mode,
        a
      ), t.ref = e.ref, t.return = e, e.child = t);
    }
    if (u = t.child, !Dc(t, a)) {
      var i = u.memoizedProps;
      if (n = n.compare, n = n !== null ? n : Ha, n(i, l) && t.ref === e.ref)
        return Cn(t, e, a);
    }
    return e.flags |= 1, t = Sn(u, l), t.ref = e.ref, t.return = e, e.child = t;
  }
  function md(t, e, n, l, a) {
    if (t !== null) {
      var u = t.memoizedProps;
      if (Ha(u, l) && t.ref === e.ref)
        if ($t = !1, e.pendingProps = l = u, Dc(t, a))
          (t.flags & 131072) !== 0 && ($t = !0);
        else
          return e.lanes = t.lanes, Cn(t, e, a);
    }
    return Oc(
      t,
      e,
      n,
      l,
      a
    );
  }
  function hd(t, e, n, l) {
    var a = l.children, u = t !== null ? t.memoizedState : null;
    if (t === null && e.stateNode === null && (e.stateNode = {
      _visibility: 1,
      _pendingMarkers: null,
      _retryCache: null,
      _transitions: null
    }), l.mode === "hidden") {
      if ((e.flags & 128) !== 0) {
        if (u = u !== null ? u.baseLanes | n : n, t !== null) {
          for (l = e.child = t.child, a = 0; l !== null; )
            a = a | l.lanes | l.childLanes, l = l.sibling;
          l = a & ~u;
        } else l = 0, e.child = null;
        return gd(
          t,
          e,
          u,
          n,
          l
        );
      }
      if ((n & 536870912) !== 0)
        e.memoizedState = { baseLanes: 0, cachePool: null }, t !== null && Pu(
          e,
          u !== null ? u.cachePool : null
        ), u !== null ? vf(e, u) : Ps(), pf(e);
      else
        return l = e.lanes = 536870912, gd(
          t,
          e,
          u !== null ? u.baseLanes | n : n,
          n,
          l
        );
    } else
      u !== null ? (Pu(e, u.cachePool), vf(e, u), kn(), e.memoizedState = null) : (t !== null && Pu(e, null), Ps(), kn());
    return It(t, e, a, n), e.child;
  }
  function Pa(t, e) {
    return t !== null && t.tag === 22 || e.stateNode !== null || (e.stateNode = {
      _visibility: 1,
      _pendingMarkers: null,
      _retryCache: null,
      _transitions: null
    }), e.sibling;
  }
  function gd(t, e, n, l, a) {
    var u = Ks();
    return u = u === null ? null : { parent: Kt._currentValue, pool: u }, e.memoizedState = {
      baseLanes: n,
      cachePool: u
    }, t !== null && Pu(e, null), Ps(), pf(e), t !== null && Kl(t, e, l, !0), e.childLanes = a, null;
  }
  function gi(t, e) {
    return e = yi(
      { mode: e.mode, children: e.children },
      t.mode
    ), e.ref = t.ref, t.child = e, e.return = t, e;
  }
  function yd(t, e, n) {
    return bl(e, t.child, null, n), t = gi(e, e.pendingProps), t.flags |= 2, Re(e), e.memoizedState = null, t;
  }
  function _y(t, e, n) {
    var l = e.pendingProps, a = (e.flags & 128) !== 0;
    if (e.flags &= -129, t === null) {
      if (dt) {
        if (l.mode === "hidden")
          return t = gi(e, l), e.lanes = 536870912, Pa(null, t);
        if (ec(e), (t = xt) ? (t = Ym(
          t,
          Ze
        ), t = t !== null && t.data === "&" ? t : null, t !== null && (e.memoizedState = {
          dehydrated: t,
          treeContext: jn !== null ? { id: ln, overflow: an } : null,
          retryLane: 536870912,
          hydrationErrors: null
        }, n = Wr(t), n.return = e, e.child = n, ue = e, xt = null)) : t = null, t === null) throw Hn(e);
        return e.lanes = 536870912, null;
      }
      return gi(e, l);
    }
    var u = t.memoizedState;
    if (u !== null) {
      var i = u.dehydrated;
      if (ec(e), a)
        if (e.flags & 256)
          e.flags &= -257, e = yd(
            t,
            e,
            n
          );
        else if (e.memoizedState !== null)
          e.child = t.child, e.flags |= 128, e = null;
        else throw Error(o(558));
      else if ($t || Kl(t, e, n, !1), a = (n & t.childLanes) !== 0, $t || a) {
        if (l = Dt, l !== null && (i = nr(l, n), i !== 0 && i !== u.retryLane))
          throw u.retryLane = i, rl(t, i), Ce(l, t, i), _c;
        Di(), e = yd(
          t,
          e,
          n
        );
      } else
        t = u.treeContext, xt = $e(i.nextSibling), ue = e, dt = !0, xn = null, Ze = !1, t !== null && tf(e, t), e = gi(e, l), e.flags |= 4096;
      return e;
    }
    return t = Sn(t.child, {
      mode: l.mode,
      children: l.children
    }), t.ref = e.ref, e.child = t, t.return = e, t;
  }
  function ea(t, e) {
    var n = e.ref;
    if (n === null)
      t !== null && t.ref !== null && (e.flags |= 4194816);
    else {
      if (typeof n != "function" && typeof n != "object")
        throw Error(o(284));
      (t === null || t.ref !== n) && (e.flags |= 4194816);
    }
  }
  function Oc(t, e, n, l, a) {
    return hl(e), n = ac(
      t,
      e,
      n,
      l,
      void 0,
      a
    ), l = uc(), t !== null && !$t ? (ic(t, e, a), Cn(t, e, a)) : (dt && l && Fu(e), e.flags |= 1, It(t, e, n, a), e.child);
  }
  function vd(t, e, n, l, a, u) {
    return hl(e), e.updateQueue = null, n = Sf(
      e,
      l,
      n,
      a
    ), bf(t), l = uc(), t !== null && !$t ? (ic(t, e, u), Cn(t, e, u)) : (dt && l && Fu(e), e.flags |= 1, It(t, e, n, u), e.child);
  }
  function pd(t, e, n, l, a) {
    if (hl(e), e.stateNode === null) {
      var u = Xl, i = n.contextType;
      typeof i == "object" && i !== null && (u = ie(i)), u = new n(l, u), e.memoizedState = u.state !== null && u.state !== void 0 ? u.state : null, u.updater = Ec, e.stateNode = u, u._reactInternals = e, u = e.stateNode, u.props = l, u.state = e.memoizedState, u.refs = {}, $s(e), i = n.contextType, u.context = typeof i == "object" && i !== null ? ie(i) : Xl, u.state = e.memoizedState, i = n.getDerivedStateFromProps, typeof i == "function" && (Sc(
        e,
        n,
        i,
        l
      ), u.state = e.memoizedState), typeof n.getDerivedStateFromProps == "function" || typeof u.getSnapshotBeforeUpdate == "function" || typeof u.UNSAFE_componentWillMount != "function" && typeof u.componentWillMount != "function" || (i = u.state, typeof u.componentWillMount == "function" && u.componentWillMount(), typeof u.UNSAFE_componentWillMount == "function" && u.UNSAFE_componentWillMount(), i !== u.state && Ec.enqueueReplaceState(u, u.state, null), Ka(e, l, u, a), Za(), u.state = e.memoizedState), typeof u.componentDidMount == "function" && (e.flags |= 4194308), l = !0;
    } else if (t === null) {
      u = e.stateNode;
      var c = e.memoizedProps, f = El(n, c);
      u.props = f;
      var v = u.context, _ = n.contextType;
      i = Xl, typeof _ == "object" && _ !== null && (i = ie(_));
      var M = n.getDerivedStateFromProps;
      _ = typeof M == "function" || typeof u.getSnapshotBeforeUpdate == "function", c = e.pendingProps !== c, _ || typeof u.UNSAFE_componentWillReceiveProps != "function" && typeof u.componentWillReceiveProps != "function" || (c || v !== i) && ad(
        e,
        u,
        l,
        i
      ), Yn = !1;
      var b = e.memoizedState;
      u.state = b, Ka(e, l, u, a), Za(), v = e.memoizedState, c || b !== v || Yn ? (typeof M == "function" && (Sc(
        e,
        n,
        M,
        l
      ), v = e.memoizedState), (f = Yn || ld(
        e,
        n,
        f,
        l,
        b,
        v,
        i
      )) ? (_ || typeof u.UNSAFE_componentWillMount != "function" && typeof u.componentWillMount != "function" || (typeof u.componentWillMount == "function" && u.componentWillMount(), typeof u.UNSAFE_componentWillMount == "function" && u.UNSAFE_componentWillMount()), typeof u.componentDidMount == "function" && (e.flags |= 4194308)) : (typeof u.componentDidMount == "function" && (e.flags |= 4194308), e.memoizedProps = l, e.memoizedState = v), u.props = l, u.state = v, u.context = i, l = f) : (typeof u.componentDidMount == "function" && (e.flags |= 4194308), l = !1);
    } else {
      u = e.stateNode, Fs(t, e), i = e.memoizedProps, _ = El(n, i), u.props = _, M = e.pendingProps, b = u.context, v = n.contextType, f = Xl, typeof v == "object" && v !== null && (f = ie(v)), c = n.getDerivedStateFromProps, (v = typeof c == "function" || typeof u.getSnapshotBeforeUpdate == "function") || typeof u.UNSAFE_componentWillReceiveProps != "function" && typeof u.componentWillReceiveProps != "function" || (i !== M || b !== f) && ad(
        e,
        u,
        l,
        f
      ), Yn = !1, b = e.memoizedState, u.state = b, Ka(e, l, u, a), Za();
      var S = e.memoizedState;
      i !== M || b !== S || Yn || t !== null && t.dependencies !== null && Wu(t.dependencies) ? (typeof c == "function" && (Sc(
        e,
        n,
        c,
        l
      ), S = e.memoizedState), (_ = Yn || ld(
        e,
        n,
        _,
        l,
        b,
        S,
        f
      ) || t !== null && t.dependencies !== null && Wu(t.dependencies)) ? (v || typeof u.UNSAFE_componentWillUpdate != "function" && typeof u.componentWillUpdate != "function" || (typeof u.componentWillUpdate == "function" && u.componentWillUpdate(l, S, f), typeof u.UNSAFE_componentWillUpdate == "function" && u.UNSAFE_componentWillUpdate(
        l,
        S,
        f
      )), typeof u.componentDidUpdate == "function" && (e.flags |= 4), typeof u.getSnapshotBeforeUpdate == "function" && (e.flags |= 1024)) : (typeof u.componentDidUpdate != "function" || i === t.memoizedProps && b === t.memoizedState || (e.flags |= 4), typeof u.getSnapshotBeforeUpdate != "function" || i === t.memoizedProps && b === t.memoizedState || (e.flags |= 1024), e.memoizedProps = l, e.memoizedState = S), u.props = l, u.state = S, u.context = f, l = _) : (typeof u.componentDidUpdate != "function" || i === t.memoizedProps && b === t.memoizedState || (e.flags |= 4), typeof u.getSnapshotBeforeUpdate != "function" || i === t.memoizedProps && b === t.memoizedState || (e.flags |= 1024), l = !1);
    }
    return u = l, ea(t, e), l = (e.flags & 128) !== 0, u || l ? (u = e.stateNode, n = l && typeof n.getDerivedStateFromError != "function" ? null : u.render(), e.flags |= 1, t !== null && l ? (e.child = bl(
      e,
      t.child,
      null,
      a
    ), e.child = bl(
      e,
      null,
      n,
      a
    )) : It(t, e, n, a), e.memoizedState = u.state, t = e.child) : t = Cn(
      t,
      e,
      a
    ), t;
  }
  function bd(t, e, n, l) {
    return dl(), e.flags |= 256, It(t, e, n, l), e.child;
  }
  var zc = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
  };
  function Cc(t) {
    return { baseLanes: t, cachePool: cf() };
  }
  function Mc(t, e, n) {
    return t = t !== null ? t.childLanes & ~n : 0, e && (t |= xe), t;
  }
  function Sd(t, e, n) {
    var l = e.pendingProps, a = !1, u = (e.flags & 128) !== 0, i;
    if ((i = u) || (i = t !== null && t.memoizedState === null ? !1 : (ce.current & 2) !== 0), i && (a = !0, e.flags &= -129), i = (e.flags & 32) !== 0, e.flags &= -33, t === null) {
      if (dt) {
        if (a ? Xn(e) : kn(), (t = xt) ? (t = Ym(
          t,
          Ze
        ), t = t !== null && t.data !== "&" ? t : null, t !== null && (e.memoizedState = {
          dehydrated: t,
          treeContext: jn !== null ? { id: ln, overflow: an } : null,
          retryLane: 536870912,
          hydrationErrors: null
        }, n = Wr(t), n.return = e, e.child = n, ue = e, xt = null)) : t = null, t === null) throw Hn(e);
        return Co(t) ? e.lanes = 32 : e.lanes = 536870912, null;
      }
      var c = l.children;
      return l = l.fallback, a ? (kn(), a = e.mode, c = yi(
        { mode: "hidden", children: c },
        a
      ), l = fl(
        l,
        a,
        n,
        null
      ), c.return = e, l.return = e, c.sibling = l, e.child = c, l = e.child, l.memoizedState = Cc(n), l.childLanes = Mc(
        t,
        i,
        n
      ), e.memoizedState = zc, Pa(null, l)) : (Xn(e), Ac(e, c));
    }
    var f = t.memoizedState;
    if (f !== null && (c = f.dehydrated, c !== null)) {
      if (u)
        e.flags & 256 ? (Xn(e), e.flags &= -257, e = wc(
          t,
          e,
          n
        )) : e.memoizedState !== null ? (kn(), e.child = t.child, e.flags |= 128, e = null) : (kn(), c = l.fallback, a = e.mode, l = yi(
          { mode: "visible", children: l.children },
          a
        ), c = fl(
          c,
          a,
          n,
          null
        ), c.flags |= 2, l.return = e, c.return = e, l.sibling = c, e.child = l, bl(
          e,
          t.child,
          null,
          n
        ), l = e.child, l.memoizedState = Cc(n), l.childLanes = Mc(
          t,
          i,
          n
        ), e.memoizedState = zc, e = Pa(null, l));
      else if (Xn(e), Co(c)) {
        if (i = c.nextSibling && c.nextSibling.dataset, i) var v = i.dgst;
        i = v, l = Error(o(419)), l.stack = "", l.digest = i, Ya({ value: l, source: null, stack: null }), e = wc(
          t,
          e,
          n
        );
      } else if ($t || Kl(t, e, n, !1), i = (n & t.childLanes) !== 0, $t || i) {
        if (i = Dt, i !== null && (l = nr(i, n), l !== 0 && l !== f.retryLane))
          throw f.retryLane = l, rl(t, l), Ce(i, t, l), _c;
        zo(c) || Di(), e = wc(
          t,
          e,
          n
        );
      } else
        zo(c) ? (e.flags |= 192, e.child = t.child, e = null) : (t = f.treeContext, xt = $e(
          c.nextSibling
        ), ue = e, dt = !0, xn = null, Ze = !1, t !== null && tf(e, t), e = Ac(
          e,
          l.children
        ), e.flags |= 4096);
      return e;
    }
    return a ? (kn(), c = l.fallback, a = e.mode, f = t.child, v = f.sibling, l = Sn(f, {
      mode: "hidden",
      children: l.children
    }), l.subtreeFlags = f.subtreeFlags & 132120576, v !== null ? c = Sn(
      v,
      c
    ) : (c = fl(
      c,
      a,
      n,
      null
    ), c.flags |= 2), c.return = e, l.return = e, l.sibling = c, e.child = l, Pa(null, l), l = e.child, c = t.child.memoizedState, c === null ? c = Cc(n) : (a = c.cachePool, a !== null ? (f = Kt._currentValue, a = a.parent !== f ? { parent: f, pool: f } : a) : a = cf(), c = {
      baseLanes: c.baseLanes | n,
      cachePool: a
    }), l.memoizedState = c, l.childLanes = Mc(
      t,
      i,
      n
    ), e.memoizedState = zc, Pa(t.child, l)) : (Xn(e), n = t.child, t = n.sibling, n = Sn(n, {
      mode: "visible",
      children: l.children
    }), n.return = e, n.sibling = null, t !== null && (i = e.deletions, i === null ? (e.deletions = [t], e.flags |= 16) : i.push(t)), e.child = n, e.memoizedState = null, n);
  }
  function Ac(t, e) {
    return e = yi(
      { mode: "visible", children: e },
      t.mode
    ), e.return = t, t.child = e;
  }
  function yi(t, e) {
    return t = _e(22, t, null, e), t.lanes = 0, t;
  }
  function wc(t, e, n) {
    return bl(e, t.child, null, n), t = Ac(
      e,
      e.pendingProps.children
    ), t.flags |= 2, e.memoizedState = null, t;
  }
  function Ed(t, e, n) {
    t.lanes |= e;
    var l = t.alternate;
    l !== null && (l.lanes |= e), Xs(t.return, e, n);
  }
  function Td(t) {
    for (var e = null; t !== null; ) {
      var n = t.alternate;
      n !== null && ui(n) === null && (e = t), t = t.sibling;
    }
    return e;
  }
  function vi(t, e, n, l, a, u) {
    var i = t.memoizedState;
    i === null ? t.memoizedState = {
      isBackwards: e,
      rendering: null,
      renderingStartTime: 0,
      last: l,
      tail: n,
      tailMode: a,
      treeForkCount: u
    } : (i.isBackwards = e, i.rendering = null, i.renderingStartTime = 0, i.last = l, i.tail = n, i.tailMode = a, i.treeForkCount = u);
  }
  function Nc(t) {
    var e = t.child;
    for (t.child = null; e !== null; ) {
      var n = e.sibling;
      e.sibling = t.child, t.child = e, e = n;
    }
  }
  function Uc(t, e, n) {
    var l = e.pendingProps, a = l.revealOrder, u = l.tail;
    l = l.children;
    var i = ce.current;
    if (e.flags & 128)
      return Ja(e, i), null;
    var c = (i & 2) !== 0;
    if (c ? (i = i & 1 | 2, e.flags |= 128) : i &= 1, Ja(e, i), a === "backwards" && t !== null ? (Nc(t), It(t, e, l, n), Nc(t)) : It(t, e, l, n), l = dt ? La : 0, !c && t !== null && (t.flags & 128) !== 0)
      t: for (t = e.child; t !== null; ) {
        if (t.tag === 13)
          t.memoizedState !== null && Ed(t, n, e);
        else if (t.tag === 19)
          Ed(t, n, e);
        else if (t.child !== null) {
          t.child.return = t, t = t.child;
          continue;
        }
        if (t === e) break t;
        for (; t.sibling === null; ) {
          if (t.return === null || t.return === e)
            break t;
          t = t.return;
        }
        t.sibling.return = t.return, t = t.sibling;
      }
    switch (a) {
      case "backwards":
        n = Td(e.child), n === null ? (a = e.child, e.child = null) : (a = n.sibling, n.sibling = null, Nc(e)), vi(
          e,
          !0,
          a,
          null,
          u,
          l
        );
        break;
      case "unstable_legacy-backwards":
        for (n = null, a = e.child, e.child = null; a !== null; ) {
          if (t = a.alternate, t !== null && ui(t) === null) {
            e.child = a;
            break;
          }
          t = a.sibling, a.sibling = n, n = a, a = t;
        }
        vi(
          e,
          !0,
          n,
          null,
          u,
          l
        );
        break;
      case "together":
        vi(
          e,
          !1,
          null,
          null,
          void 0,
          l
        );
        break;
      case "independent":
        e.memoizedState = null;
        break;
      default:
        n = Td(e.child), n === null ? (a = e.child, e.child = null) : (a = n.sibling, n.sibling = null), vi(
          e,
          !1,
          a,
          n,
          u,
          l
        );
    }
    return e.child;
  }
  function Cn(t, e, n) {
    if (t !== null && (e.dependencies = t.dependencies), Kn |= e.lanes, (n & e.childLanes) === 0)
      if (t !== null) {
        if (Kl(
          t,
          e,
          n,
          !1
        ), (n & e.childLanes) === 0)
          return null;
      } else return null;
    if (t !== null && e.child !== t.child)
      throw Error(o(153));
    if (e.child !== null) {
      for (t = e.child, n = Sn(t, t.pendingProps), e.child = n, n.return = e; t.sibling !== null; )
        t = t.sibling, n = n.sibling = Sn(t, t.pendingProps), n.return = e;
      n.sibling = null;
    }
    return e.child;
  }
  function Dc(t, e) {
    return (t.lanes & e) !== 0 ? !0 : (t = t.dependencies, !!(t !== null && Wu(t)));
  }
  function Oy(t, e, n) {
    switch (e.tag) {
      case 3:
        Al(e, e.stateNode.containerInfo), Bn(e, Kt, t.memoizedState.cache), dl();
        break;
      case 27:
      case 5:
        ba(e);
        break;
      case 4:
        Al(e, e.stateNode.containerInfo);
        break;
      case 10:
        Bn(
          e,
          e.type,
          e.memoizedProps.value
        );
        break;
      case 31:
        if (e.memoizedState !== null)
          return e.flags |= 128, ec(e), null;
        break;
      case 13:
        var l = e.memoizedState;
        if (l !== null)
          return l.dehydrated !== null ? (Xn(e), e.flags |= 128, null) : (n & e.child.childLanes) !== 0 ? Sd(t, e, n) : (Xn(e), t = Cn(
            t,
            e,
            n
          ), t !== null ? t.sibling : null);
        Xn(e);
        break;
      case 19:
        if (e.flags & 128)
          return Uc(
            t,
            e,
            n
          );
        var a = (t.flags & 128) !== 0;
        if (l = (n & e.childLanes) !== 0, l || (Kl(
          t,
          e,
          n,
          !1
        ), l = (n & e.childLanes) !== 0), a) {
          if (l)
            return Uc(
              t,
              e,
              n
            );
          e.flags |= 128;
        }
        if (a = e.memoizedState, a !== null && (a.rendering = null, a.tail = null, a.lastEffect = null), Ja(e, ce.current), l) break;
        return null;
      case 22:
        return e.lanes = 0, hd(
          t,
          e,
          n,
          e.pendingProps
        );
      case 24:
        Bn(e, Kt, t.memoizedState.cache);
    }
    return Cn(t, e, n);
  }
  function _d(t, e, n) {
    if (t !== null)
      if (t.memoizedProps !== e.pendingProps)
        $t = !0;
      else {
        if (!Dc(t, n) && (e.flags & 128) === 0)
          return $t = !1, Oy(
            t,
            e,
            n
          );
        $t = (t.flags & 131072) !== 0;
      }
    else
      $t = !1, dt && (e.flags & 1048576) !== 0 && Pr(e, La, e.index);
    switch (e.lanes = 0, e.tag) {
      case 16:
        t: {
          var l = e.pendingProps;
          if (t = vl(e.elementType), e.type = t, typeof t == "function")
            xs(t) ? (l = El(t, l), e.tag = 1, e = pd(
              null,
              e,
              t,
              l,
              n
            )) : (e.tag = 0, e = Oc(
              null,
              e,
              t,
              l,
              n
            ));
          else {
            if (t != null) {
              var a = t.$$typeof;
              if (a === Pt) {
                e.tag = 11, e = fd(
                  null,
                  e,
                  t,
                  l,
                  n
                );
                break t;
              } else if (a === tt) {
                e.tag = 14, e = dd(
                  null,
                  e,
                  t,
                  l,
                  n
                );
                break t;
              }
            }
            throw e = D(t) || t, Error(o(306, e, ""));
          }
        }
        return e;
      case 0:
        return Oc(
          t,
          e,
          e.type,
          e.pendingProps,
          n
        );
      case 1:
        return l = e.type, a = El(
          l,
          e.pendingProps
        ), pd(
          t,
          e,
          l,
          a,
          n
        );
      case 3:
        t: {
          if (Al(
            e,
            e.stateNode.containerInfo
          ), t === null) throw Error(o(387));
          l = e.pendingProps;
          var u = e.memoizedState;
          a = u.element, Fs(t, e), Ka(e, l, null, n);
          var i = e.memoizedState;
          if (l = i.cache, Bn(e, Kt, l), l !== u.cache && ks(
            e,
            [Kt],
            n,
            !0
          ), Za(), l = i.element, u.isDehydrated)
            if (u = {
              element: l,
              isDehydrated: !1,
              cache: i.cache
            }, e.updateQueue.baseState = u, e.memoizedState = u, e.flags & 256) {
              e = bd(
                t,
                e,
                l,
                n
              );
              break t;
            } else if (l !== a) {
              a = Xe(
                Error(o(424)),
                e
              ), Ya(a), e = bd(
                t,
                e,
                l,
                n
              );
              break t;
            } else {
              switch (t = e.stateNode.containerInfo, t.nodeType) {
                case 9:
                  t = t.body;
                  break;
                default:
                  t = t.nodeName === "HTML" ? t.ownerDocument.body : t;
              }
              for (xt = $e(t.firstChild), ue = e, dt = !0, xn = null, Ze = !0, n = hf(
                e,
                null,
                l,
                n
              ), e.child = n; n; )
                n.flags = n.flags & -3 | 4096, n = n.sibling;
            }
          else {
            if (dl(), l === a) {
              e = Cn(
                t,
                e,
                n
              );
              break t;
            }
            It(t, e, l, n);
          }
          e = e.child;
        }
        return e;
      case 26:
        return ea(t, e), t === null ? (n = Zm(
          e.type,
          null,
          e.pendingProps,
          null
        )) ? e.memoizedState = n : dt || (n = e.type, t = e.pendingProps, l = Bi(
          re.current
        ).createElement(n), l[ae] = e, l[Ee] = t, oe(l, n, t), te(l), e.stateNode = l) : e.memoizedState = Zm(
          e.type,
          t.memoizedProps,
          e.pendingProps,
          t.memoizedState
        ), null;
      case 27:
        return ba(e), t === null && dt && (l = e.stateNode = Xm(
          e.type,
          e.pendingProps,
          re.current
        ), ue = e, Ze = !0, a = xt, Wn(e.type) ? (Mo = a, xt = $e(l.firstChild)) : xt = a), It(
          t,
          e,
          e.pendingProps.children,
          n
        ), ea(t, e), t === null && (e.flags |= 4194304), e.child;
      case 5:
        return t === null && dt && ((a = l = xt) && (l = mv(
          l,
          e.type,
          e.pendingProps,
          Ze
        ), l !== null ? (e.stateNode = l, ue = e, xt = $e(l.firstChild), Ze = !1, a = !0) : a = !1), a || Hn(e)), ba(e), a = e.type, u = e.pendingProps, i = t !== null ? t.memoizedProps : null, l = u.children, So(a, u) ? l = null : i !== null && So(a, i) && (e.flags |= 32), e.memoizedState !== null && (a = ac(
          t,
          e,
          gy,
          null,
          null,
          n
        ), gu._currentValue = a), ea(t, e), It(t, e, l, n), e.child;
      case 6:
        return t === null && dt && ((t = n = xt) && (n = hv(
          n,
          e.pendingProps,
          Ze
        ), n !== null ? (e.stateNode = n, ue = e, xt = null, t = !0) : t = !1), t || Hn(e)), null;
      case 13:
        return Sd(t, e, n);
      case 4:
        return Al(
          e,
          e.stateNode.containerInfo
        ), l = e.pendingProps, t === null ? e.child = bl(
          e,
          null,
          l,
          n
        ) : It(t, e, l, n), e.child;
      case 11:
        return fd(
          t,
          e,
          e.type,
          e.pendingProps,
          n
        );
      case 7:
        return l = e.pendingProps, ea(t, e), It(t, e, l, n), e.child;
      case 8:
        return It(
          t,
          e,
          e.pendingProps.children,
          n
        ), e.child;
      case 12:
        return It(
          t,
          e,
          e.pendingProps.children,
          n
        ), e.child;
      case 10:
        return l = e.pendingProps, Bn(e, e.type, l.value), It(t, e, l.children, n), e.child;
      case 9:
        return a = e.type._context, l = e.pendingProps.children, hl(e), a = ie(a), l = l(a), e.flags |= 1, It(t, e, l, n), e.child;
      case 14:
        return dd(
          t,
          e,
          e.type,
          e.pendingProps,
          n
        );
      case 15:
        return md(
          t,
          e,
          e.type,
          e.pendingProps,
          n
        );
      case 19:
        return Uc(t, e, n);
      case 31:
        return _y(t, e, n);
      case 22:
        return hd(
          t,
          e,
          n,
          e.pendingProps
        );
      case 24:
        return hl(e), l = ie(Kt), t === null ? (a = Ks(), a === null && (a = Dt, u = Vs(), a.pooledCache = u, u.refCount++, u !== null && (a.pooledCacheLanes |= n), a = u), e.memoizedState = { parent: l, cache: a }, $s(e), Bn(e, Kt, a)) : ((t.lanes & n) !== 0 && (Fs(t, e), Ka(e, null, null, n), Za()), a = t.memoizedState, u = e.memoizedState, a.parent !== l ? (a = { parent: l, cache: l }, e.memoizedState = a, e.lanes === 0 && (e.memoizedState = e.updateQueue.baseState = a), Bn(e, Kt, l)) : (l = u.cache, Bn(e, Kt, l), l !== a.cache && ks(
          e,
          [Kt],
          n,
          !0
        ))), It(
          t,
          e,
          e.pendingProps.children,
          n
        ), e.child;
      case 30:
        return l = e.pendingProps, l.name != null && l.name !== "auto" ? e.flags |= t === null ? 18882560 : 18874368 : dt && Fu(e), t !== null && t.memoizedProps.name !== l.name ? e.flags |= 4194816 : ea(t, e), It(t, e, l.children, n), e.child;
      case 29:
        throw e.pendingProps;
    }
    throw Error(o(156, e.tag));
  }
  function Mn(t) {
    t.flags |= 4;
  }
  function Rc(t, e, n, l, a) {
    var u;
    if ((u = (t.mode & 32) !== 0) && (u = n === null ? Wm(e, l) : Wm(e, l) && (l.src !== n.src || l.srcSet !== n.srcSet)), u) {
      if (t.flags |= 16777216, (a & 335544128) === a)
        if (t.stateNode.complete) t.flags |= 8192;
        else if (um()) t.flags |= 8192;
        else
          throw pl = ei, Js;
    } else t.flags &= -16777217;
  }
  function Od(t, e) {
    if (e.type !== "stylesheet" || (e.state.loading & 4) !== 0)
      t.flags &= -16777217;
    else if (t.flags |= 16777216, !Im(e))
      if (um()) t.flags |= 8192;
      else
        throw pl = ei, Js;
  }
  function pi(t, e) {
    e !== null && (t.flags |= 4), t.flags & 16384 && (e = t.tag !== 22 ? Po() : 536870912, t.lanes |= e, ia |= e);
  }
  function tu(t, e) {
    if (!dt)
      switch (t.tailMode) {
        case "visible":
          break;
        case "collapsed":
          for (var n = t.tail, l = null; n !== null; )
            n.alternate !== null && (l = n), n = n.sibling;
          l === null ? e || t.tail === null ? t.tail = null : t.tail.sibling = null : l.sibling = null;
          break;
        default:
          for (e = t.tail, n = null; e !== null; )
            e.alternate !== null && (n = e), e = e.sibling;
          n === null ? t.tail = null : n.sibling = null;
      }
  }
  function qt(t) {
    var e = t.alternate !== null && t.alternate.child === t.child, n = 0, l = 0;
    if (e)
      for (var a = t.child; a !== null; )
        n |= a.lanes | a.childLanes, l |= a.subtreeFlags & 132120576, l |= a.flags & 132120576, a.return = t, a = a.sibling;
    else
      for (a = t.child; a !== null; )
        n |= a.lanes | a.childLanes, l |= a.subtreeFlags, l |= a.flags, a.return = t, a = a.sibling;
    return t.subtreeFlags |= l, t.childLanes = n, e;
  }
  function zy(t, e, n) {
    var l = e.pendingProps;
    switch (Ls(e), e.tag) {
      case 16:
      case 15:
      case 0:
      case 11:
      case 7:
      case 8:
      case 12:
      case 9:
      case 14:
        return qt(e), null;
      case 1:
        return qt(e), null;
      case 3:
        return n = e.stateNode, l = null, t !== null && (l = t.memoizedState.cache), e.memoizedState.cache !== l && (e.flags |= 2048), _n(Kt), Un(), n.pendingContext && (n.context = n.pendingContext, n.pendingContext = null), (t === null || t.child === null) && (Zl(e) ? Mn(e) : t === null || t.memoizedState.isDehydrated && (e.flags & 256) === 0 || (e.flags |= 1024, Gs())), qt(e), null;
      case 26:
        var a = e.type, u = e.memoizedState;
        return t === null ? (Mn(e), u !== null ? (qt(e), Od(e, u)) : (qt(e), Rc(
          e,
          a,
          null,
          l,
          n
        ))) : u ? u !== t.memoizedState ? (Mn(e), qt(e), Od(e, u)) : (qt(e), e.flags &= -16777217) : (t = t.memoizedProps, t !== l && Mn(e), qt(e), Rc(
          e,
          a,
          t,
          l,
          n
        )), null;
      case 27:
        if (ll(e), n = re.current, a = e.type, t !== null && e.stateNode != null)
          t.memoizedProps !== l && Mn(e);
        else {
          if (!l) {
            if (e.stateNode === null)
              throw Error(o(166));
            return qt(e), e.subtreeFlags &= -33554433, null;
          }
          t = Gt.current, Zl(e) ? ef(e) : (t = Xm(a, l, n), e.stateNode = t, Mn(e));
        }
        return qt(e), e.subtreeFlags &= -33554433, null;
      case 5:
        if (ll(e), a = e.type, t !== null && e.stateNode != null)
          t.memoizedProps !== l && Mn(e);
        else {
          if (!l) {
            if (e.stateNode === null)
              throw Error(o(166));
            return qt(e), e.subtreeFlags &= -33554433, null;
          }
          if (u = Gt.current, Zl(e))
            ef(e);
          else {
            var i = Bi(
              re.current
            );
            switch (u) {
              case 1:
                u = i.createElementNS(
                  "http://www.w3.org/2000/svg",
                  a
                );
                break;
              case 2:
                u = i.createElementNS(
                  "http://www.w3.org/1998/Math/MathML",
                  a
                );
                break;
              default:
                switch (a) {
                  case "svg":
                    u = i.createElementNS(
                      "http://www.w3.org/2000/svg",
                      a
                    );
                    break;
                  case "math":
                    u = i.createElementNS(
                      "http://www.w3.org/1998/Math/MathML",
                      a
                    );
                    break;
                  case "script":
                    u = i.createElement("div"), u.innerHTML = "<script><\/script>", u = u.removeChild(
                      u.firstChild
                    );
                    break;
                  case "select":
                    u = typeof l.is == "string" ? i.createElement("select", {
                      is: l.is
                    }) : i.createElement("select"), l.multiple ? u.multiple = !0 : l.size && (u.size = l.size);
                    break;
                  default:
                    u = typeof l.is == "string" ? i.createElement(a, { is: l.is }) : i.createElement(a);
                }
            }
            u[ae] = e, u[Ee] = l;
            t: for (i = e.child; i !== null; ) {
              if (i.tag === 5 || i.tag === 6)
                u.appendChild(i.stateNode);
              else if (i.tag !== 4 && i.tag !== 27 && i.child !== null) {
                i.child.return = i, i = i.child;
                continue;
              }
              if (i === e) break t;
              for (; i.sibling === null; ) {
                if (i.return === null || i.return === e)
                  break t;
                i = i.return;
              }
              i.sibling.return = i.return, i = i.sibling;
            }
            e.stateNode = u;
            t: switch (oe(u, a, l), a) {
              case "button":
              case "input":
              case "select":
              case "textarea":
                l = !!l.autoFocus;
                break t;
              case "img":
                l = !0;
                break t;
              default:
                l = !1;
            }
            l && Mn(e);
          }
        }
        return qt(e), e.subtreeFlags &= -33554433, Rc(
          e,
          e.type,
          t === null ? null : t.memoizedProps,
          e.pendingProps,
          n
        ), null;
      case 6:
        if (t && e.stateNode != null)
          t.memoizedProps !== l && Mn(e);
        else {
          if (typeof l != "string" && e.stateNode === null)
            throw Error(o(166));
          if (t = re.current, Zl(e)) {
            if (t = e.stateNode, n = e.memoizedProps, l = null, a = ue, a !== null)
              switch (a.tag) {
                case 27:
                case 5:
                  l = a.memoizedProps;
              }
            t[ae] = e, t = !!(t.nodeValue === n || l !== null && l.suppressHydrationWarning === !0 || zm(t.nodeValue, n)), t || Hn(e, !0);
          } else
            t = Bi(t).createTextNode(
              l
            ), t[ae] = e, e.stateNode = t;
        }
        return qt(e), null;
      case 31:
        if (n = e.memoizedState, t === null || t.memoizedState !== null) {
          if (l = Zl(e), n !== null) {
            if (t === null) {
              if (!l) throw Error(o(318));
              if (t = e.memoizedState, t = t !== null ? t.dehydrated : null, !t) throw Error(o(557));
              t[ae] = e;
            } else
              dl(), (e.flags & 128) === 0 && (e.memoizedState = null), e.flags |= 4;
            qt(e), t = !1;
          } else
            n = Gs(), t !== null && t.memoizedState !== null && (t.memoizedState.hydrationErrors = n), t = !0;
          if (!t)
            return e.flags & 256 ? (Re(e), e) : (Re(e), null);
          if ((e.flags & 128) !== 0)
            throw Error(o(558));
        }
        return qt(e), null;
      case 13:
        if (l = e.memoizedState, t === null || t.memoizedState !== null && t.memoizedState.dehydrated !== null) {
          if (a = Zl(e), l !== null && l.dehydrated !== null) {
            if (t === null) {
              if (!a) throw Error(o(318));
              if (a = e.memoizedState, a = a !== null ? a.dehydrated : null, !a) throw Error(o(317));
              a[ae] = e;
            } else
              dl(), (e.flags & 128) === 0 && (e.memoizedState = null), e.flags |= 4;
            qt(e), a = !1;
          } else
            a = Gs(), t !== null && t.memoizedState !== null && (t.memoizedState.hydrationErrors = a), a = !0;
          if (!a)
            return e.flags & 256 ? (Re(e), e) : (Re(e), null);
        }
        return Re(e), (e.flags & 128) !== 0 ? (e.lanes = n, e) : (n = l !== null, t = t !== null && t.memoizedState !== null, n && (l = e.child, a = null, l.alternate !== null && l.alternate.memoizedState !== null && l.alternate.memoizedState.cachePool !== null && (a = l.alternate.memoizedState.cachePool.pool), u = null, l.memoizedState !== null && l.memoizedState.cachePool !== null && (u = l.memoizedState.cachePool.pool), u !== a && (l.flags |= 2048)), n !== t && n && (e.child.flags |= 8192), pi(e, e.updateQueue), qt(e), null);
      case 4:
        return Un(), t === null && go(e.stateNode.containerInfo), e.flags |= 67108864, qt(e), null;
      case 10:
        return _n(e.type), qt(e), null;
      case 19:
        if (nc(e), l = e.memoizedState, l === null) return qt(e), null;
        if (a = (e.flags & 128) !== 0, u = l.rendering, u === null)
          if (a) tu(l, !1);
          else {
            if (kt !== 0 || t !== null && (t.flags & 128) !== 0)
              for (t = e.child; t !== null; ) {
                if (u = ui(t), u !== null) {
                  for (e.flags |= 128, tu(l, !1), t = u.updateQueue, e.updateQueue = t, pi(e, t), e.subtreeFlags = 0, t = n, n = e.child; n !== null; )
                    Fr(n, t), n = n.sibling;
                  return Ja(
                    e,
                    ce.current & 1 | 2
                  ), dt && En(e, l.treeForkCount), e.child;
                }
                t = t.sibling;
              }
            l.tail !== null && we() > wi && (e.flags |= 128, a = !0, tu(l, !1), e.lanes = 4194304);
          }
        else {
          if (!a)
            if (t = ui(u), t !== null) {
              if (e.flags |= 128, a = !0, t = t.updateQueue, e.updateQueue = t, pi(e, t), tu(l, !0), l.tail === null && l.tailMode !== "collapsed" && l.tailMode !== "visible" && !u.alternate && !dt)
                return qt(e), null;
            } else
              2 * we() - l.renderingStartTime > wi && n !== 536870912 && (e.flags |= 128, a = !0, tu(l, !1), e.lanes = 4194304);
          l.isBackwards ? (u.sibling = e.child, e.child = u) : (t = l.last, t !== null ? t.sibling = u : e.child = u, l.last = u);
        }
        if (l.tail !== null) {
          t = l.tail;
          t: {
            for (n = t; n !== null; ) {
              if (n.alternate !== null) {
                n = !1;
                break t;
              }
              n = n.sibling;
            }
            n = !0;
          }
          return l.rendering = t, l.tail = t.sibling, l.renderingStartTime = we(), t.sibling = null, u = ce.current, u = a ? u & 1 | 2 : u & 1, l.tailMode === "visible" || l.tailMode === "collapsed" || !n || dt ? Ja(e, u) : (n = u, rt(se, e), rt(ce, n), fe === null && (fe = e)), dt && En(e, l.treeForkCount), t;
        }
        return qt(e), null;
      case 22:
      case 23:
        return Re(e), tc(), l = e.memoizedState !== null, t !== null ? t.memoizedState !== null !== l && (e.flags |= 8192) : l && (e.flags |= 8192), l ? (n & 536870912) !== 0 && (e.flags & 128) === 0 && (qt(e), e.subtreeFlags & 6 && (e.flags |= 8192)) : qt(e), n = e.updateQueue, n !== null && pi(e, n.retryQueue), n = null, t !== null && t.memoizedState !== null && t.memoizedState.cachePool !== null && (n = t.memoizedState.cachePool.pool), l = null, e.memoizedState !== null && e.memoizedState.cachePool !== null && (l = e.memoizedState.cachePool.pool), l !== n && (e.flags |= 2048), t !== null && St(yl), null;
      case 24:
        return n = null, t !== null && (n = t.memoizedState.cache), e.memoizedState.cache !== n && (e.flags |= 2048), _n(Kt), qt(e), null;
      case 25:
        return null;
      case 30:
        return e.flags |= 33554432, qt(e), null;
    }
    throw Error(o(156, e.tag));
  }
  function Cy(t, e) {
    switch (Ls(e), e.tag) {
      case 1:
        return t = e.flags, t & 65536 ? (e.flags = t & -65537 | 128, e) : null;
      case 3:
        return _n(Kt), Un(), t = e.flags, (t & 65536) !== 0 && (t & 128) === 0 ? (e.flags = t & -65537 | 128, e) : null;
      case 26:
      case 27:
      case 5:
        return ll(e), null;
      case 31:
        if (e.memoizedState !== null) {
          if (Re(e), e.alternate === null)
            throw Error(o(340));
          dl();
        }
        return t = e.flags, t & 65536 ? (e.flags = t & -65537 | 128, e) : null;
      case 13:
        if (Re(e), t = e.memoizedState, t !== null && t.dehydrated !== null) {
          if (e.alternate === null)
            throw Error(o(340));
          dl();
        }
        return t = e.flags, t & 65536 ? (e.flags = t & -65537 | 128, e) : null;
      case 19:
        return nc(e), t = e.flags, t & 65536 ? (e.flags = t & -65537 | 128, t = e.memoizedState, t !== null && (t.rendering = null, t.tail = null), e.flags |= 4, e) : null;
      case 4:
        return Un(), null;
      case 10:
        return _n(e.type), null;
      case 22:
      case 23:
        return Re(e), tc(), t !== null && St(yl), t = e.flags, t & 65536 ? (e.flags = t & -65537 | 128, e) : null;
      case 24:
        return _n(Kt), null;
      case 25:
        return null;
      default:
        return null;
    }
  }
  function zd(t, e) {
    switch (Ls(e), e.tag) {
      case 3:
        _n(Kt), Un();
        break;
      case 26:
      case 27:
      case 5:
        ll(e);
        break;
      case 4:
        Un();
        break;
      case 31:
        e.memoizedState !== null && Re(e);
        break;
      case 13:
        Re(e);
        break;
      case 19:
        nc(e);
        break;
      case 10:
        _n(e.type);
        break;
      case 22:
      case 23:
        Re(e), tc(), t !== null && St(yl);
        break;
      case 24:
        _n(Kt);
    }
  }
  function eu(t, e) {
    try {
      var n = e.updateQueue, l = n !== null ? n.lastEffect : null;
      if (l !== null) {
        var a = l.next;
        n = a;
        do {
          if ((n.tag & t) === t) {
            l = void 0;
            var u = n.create, i = n.inst;
            l = u(), i.destroy = l;
          }
          n = n.next;
        } while (n !== a);
      }
    } catch (c) {
      Mt(e, e.return, c);
    }
  }
  function Vn(t, e, n) {
    try {
      var l = e.updateQueue, a = l !== null ? l.lastEffect : null;
      if (a !== null) {
        var u = a.next;
        l = u;
        do {
          if ((l.tag & t) === t) {
            var i = l.inst, c = i.destroy;
            if (c !== void 0) {
              i.destroy = void 0, a = e;
              var f = n, v = c;
              try {
                v();
              } catch (_) {
                Mt(
                  a,
                  f,
                  _
                );
              }
            }
          }
          l = l.next;
        } while (l !== u);
      }
    } catch (_) {
      Mt(e, e.return, _);
    }
  }
  function Cd(t) {
    var e = t.updateQueue;
    if (e !== null) {
      var n = t.stateNode;
      try {
        yf(e, n);
      } catch (l) {
        Mt(t, t.return, l);
      }
    }
  }
  function Md(t, e, n) {
    n.props = El(
      t.type,
      t.memoizedProps
    ), n.state = t.memoizedState;
    try {
      n.componentWillUnmount();
    } catch (l) {
      Mt(t, e, l);
    }
  }
  function An(t, e) {
    try {
      var n = t.ref;
      if (n !== null) {
        switch (t.tag) {
          case 26:
          case 27:
          case 5:
            var l = t.stateNode;
            break;
          case 30:
            var a = t.stateNode, u = pn(t.memoizedProps, a);
            (a.ref === null || a.ref.name !== u) && (a.ref = jm(u)), l = a.ref;
            break;
          case 7:
            t.stateNode === null && (t.stateNode = new Be(t)), l = t.stateNode;
            break;
          default:
            l = t.stateNode;
        }
        typeof n == "function" ? t.refCleanup = n(l) : n.current = l;
      }
    } catch (i) {
      Mt(t, e, i);
    }
  }
  function ye(t, e) {
    var n = t.ref, l = t.refCleanup;
    if (n !== null)
      if (typeof l == "function")
        try {
          l();
        } catch (a) {
          Mt(t, e, a);
        } finally {
          t.refCleanup = null, t = t.alternate, t != null && (t.refCleanup = null);
        }
      else if (typeof n == "function")
        try {
          n(null);
        } catch (a) {
          Mt(t, e, a);
        }
      else n.current = null;
  }
  function Ad(t) {
    var e = t.type, n = t.memoizedProps, l = t.stateNode;
    try {
      t: switch (e) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          n.autoFocus && l.focus();
          break t;
        case "img":
          n.src ? l.src = n.src : n.srcSet && (l.srcset = n.srcSet);
      }
    } catch (a) {
      Mt(t, t.return, a);
    }
  }
  function qc(t, e, n) {
    try {
      var l = t.stateNode;
      Fy(l, t.type, n, e), l[Ee] = e;
    } catch (a) {
      Mt(t, t.return, a);
    }
  }
  function wd(t, e) {
    if (t.tag === 5 && t.alternate === null && e !== null)
      for (var n = 0; n < e.length; n++)
        Lm(
          t.stateNode,
          e[n]
        );
  }
  function Nd(t) {
    for (var e = t.return; e !== null; ) {
      if (jc(e)) {
        var n = t.stateNode, l = e.stateNode._eventListeners;
        if (l !== null)
          for (var a = 0; a < l.length; a++) {
            var u = l[a];
            n.removeEventListener(
              u.type,
              u.listener,
              u.optionsOrUseCapture
            );
          }
      }
      if (bi(e)) break;
      e = e.return;
    }
  }
  function bi(t) {
    return t.tag === 5 || t.tag === 3 || t.tag === 26 || t.tag === 27 && Wn(t.type) || t.tag === 4;
  }
  function jc(t) {
    return t && t.tag === 7 && t.stateNode !== null;
  }
  function xc(t) {
    t: for (; ; ) {
      for (; t.sibling === null; ) {
        if (t.return === null || bi(t.return)) return null;
        t = t.return;
      }
      for (t.sibling.return = t.return, t = t.sibling; t.tag !== 5 && t.tag !== 6 && t.tag !== 18; ) {
        if (t.tag === 27 && Wn(t.type) || t.flags & 2 || t.child === null || t.tag === 4) continue t;
        t.child.return = t, t = t.child;
      }
      if (!(t.flags & 2)) return t.stateNode;
    }
  }
  function Hc(t, e, n, l) {
    var a = t.tag;
    if (a === 5 || a === 6)
      a = t.stateNode, e ? (n.nodeType === 9 ? n.body : n.nodeName === "HTML" ? n.ownerDocument.body : n).insertBefore(a, e) : (e = n.nodeType === 9 ? n.body : n.nodeName === "HTML" ? n.ownerDocument.body : n, e.appendChild(a), n = n._reactRootContainer, n != null || e.onclick !== null || (e.onclick = yn)), wd(t, l), Et = !0;
    else if (a !== 4 && (a === 27 && Wn(t.type) && (n = t.stateNode, e = null), t = t.child, t !== null))
      for (Hc(
        t,
        e,
        n,
        l
      ), t = t.sibling; t !== null; )
        Hc(
          t,
          e,
          n,
          l
        ), t = t.sibling;
  }
  function Si(t, e, n, l) {
    var a = t.tag;
    if (a === 5 || a === 6)
      a = t.stateNode, e ? n.insertBefore(a, e) : n.appendChild(a), wd(t, l), Et = !0;
    else if (a !== 4 && (a === 27 && Wn(t.type) && (n = t.stateNode), t = t.child, t !== null))
      for (Si(
        t,
        e,
        n,
        l
      ), t = t.sibling; t !== null; )
        Si(
          t,
          e,
          n,
          l
        ), t = t.sibling;
  }
  function Ud(t) {
    var e = t.stateNode, n = t.memoizedProps;
    try {
      for (var l = t.type, a = e.attributes; a.length; )
        e.removeAttributeNode(a[0]);
      oe(e, l, n), e[ae] = t, e[Ee] = n;
    } catch (u) {
      Mt(t, t.return, u);
    }
  }
  var Ei = !1, qe = null;
  function Dd(t) {
    (t.tag === 30 || (t.subtreeFlags & 33554432) !== 0) && (Ei = !0);
  }
  var un = null;
  function Rd() {
    var t = un;
    return un = null, t;
  }
  var Ke = 0;
  function na(t, e, n, l, a) {
    return Ke = 0, qd(
      t.child,
      e,
      n,
      l,
      a
    );
  }
  function qd(t, e, n, l, a) {
    for (var u = !1; t !== null; ) {
      if (t.tag === 5) {
        var i = t.stateNode;
        if (l !== null) {
          var c = To(i);
          l.push(c), c.view && (u = !0);
        } else
          u || To(i).view && (u = !0);
        Ei = !0, Rm(
          i,
          Ke === 0 ? e : e + "_" + Ke,
          n
        ), Ke++;
      } else (t.tag !== 22 || t.memoizedState === null) && (t.tag === 30 && a || qd(
        t.child,
        e,
        n,
        l,
        a
      ) && (u = !0));
      t = t.sibling;
    }
    return u;
  }
  function sn(t, e) {
    for (; t !== null; )
      t.tag === 5 ? qm(t.stateNode, t.memoizedProps) : (t.tag !== 22 || t.memoizedState === null) && (t.tag === 30 && e || sn(
        t.child,
        e
      )), t = t.sibling;
  }
  function Ti(t) {
    if ((t.subtreeFlags & 18874368) !== 0)
      for (t = t.child; t !== null; ) {
        if ((t.tag !== 22 || t.memoizedState === null) && (Ti(t), t.tag === 30 && (t.flags & 18874368) !== 0 && t.stateNode.paired)) {
          var e = t.memoizedProps;
          if (e.name == null || e.name === "auto")
            throw Error(o(544));
          var n = e.name;
          e = bn(e.default, e.share), e !== "none" && (na(
            t,
            n,
            e,
            null,
            !1
          ) || sn(t.child, !1));
        }
        t = t.sibling;
      }
  }
  function Bc(t, e) {
    if (t.tag === 30) {
      var n = t.stateNode, l = t.memoizedProps, a = pn(l, n), u = bn(
        l.default,
        n.paired ? l.share : l.enter
      );
      u !== "none" ? na(t, a, u, null, !1) ? (Ti(t), n.paired || e || oa(t, l.onEnter)) : sn(t.child, !1) : Ti(t);
    } else if ((t.subtreeFlags & 33554432) !== 0)
      for (t = t.child; t !== null; )
        Bc(t, e), t = t.sibling;
    else Ti(t);
  }
  function Lc(t) {
    if (qe !== null && qe.size !== 0) {
      var e = qe;
      if ((t.subtreeFlags & 18874368) !== 0)
        for (t = t.child; t !== null; ) {
          if (t.tag !== 22 || t.memoizedState === null) {
            if (t.tag === 30 && (t.flags & 18874368) !== 0) {
              var n = t.memoizedProps, l = n.name;
              if (l != null && l !== "auto") {
                var a = e.get(l);
                if (a !== void 0) {
                  var u = bn(
                    n.default,
                    n.share
                  );
                  if (u !== "none" && (na(
                    t,
                    l,
                    u,
                    null,
                    !1
                  ) ? (u = t.stateNode, a.paired = u, u.paired = a, oa(t, n.onShare)) : sn(t.child, !1)), e.delete(l), e.size === 0) break;
                }
              }
            }
            Lc(t);
          }
          t = t.sibling;
        }
    }
  }
  function Yc(t) {
    if (t.tag === 30) {
      var e = t.memoizedProps, n = pn(e, t.stateNode), l = qe !== null ? qe.get(n) : void 0, a = bn(
        e.default,
        l !== void 0 ? e.share : e.exit
      );
      a !== "none" && (na(t, n, a, null, !1) ? l !== void 0 ? (a = t.stateNode, l.paired = a, a.paired = l, qe.delete(n), oa(t, e.onShare)) : oa(t, e.onExit) : sn(t.child, !1)), qe !== null && Lc(t);
    } else if ((t.subtreeFlags & 33554432) !== 0)
      for (t = t.child; t !== null; )
        Yc(t), t = t.sibling;
    else
      qe !== null && Lc(t);
  }
  function jd(t) {
    for (t = t.child; t !== null; ) {
      if (t.tag === 30) {
        var e = t.memoizedProps, n = pn(e, t.stateNode);
        e = bn(e.default, e.update), t.flags &= -5, e !== "none" && na(
          t,
          n,
          e,
          t.memoizedState = [],
          !1
        );
      } else
        (t.subtreeFlags & 33554432) !== 0 && jd(t);
      t = t.sibling;
    }
  }
  function Gc(t) {
    if ((t.subtreeFlags & 18874368) !== 0)
      for (t = t.child; t !== null; ) {
        if (t.tag !== 22 || t.memoizedState === null) {
          if (t.tag === 30 && (t.flags & 18874368) !== 0) {
            var e = t.stateNode;
            e.paired !== null && (e.paired = null, sn(t.child, !1));
          }
          Gc(t);
        }
        t = t.sibling;
      }
  }
  function _i(t) {
    if (t.tag === 30)
      t.stateNode.paired = null, sn(t.child, !1), Gc(t);
    else if ((t.subtreeFlags & 33554432) !== 0)
      for (t = t.child; t !== null; )
        _i(t), t = t.sibling;
    else Gc(t);
  }
  function xd(t) {
    for (t = t.child; t !== null; )
      t.tag === 30 ? sn(t.child, !1) : (t.subtreeFlags & 33554432) !== 0 && xd(t), t = t.sibling;
  }
  function Qc(t, e, n, l, a, u, i) {
    for (var c = !1; e !== null; ) {
      if (e.tag === 5) {
        var f = e.stateNode;
        if (u !== null && Ke < u.length) {
          var v = u[Ke], _ = To(f);
          (v.view || _.view) && (c = !0);
          var M;
          if (M = (t.flags & 4) === 0)
            if (_.clip) M = !0;
            else {
              M = v.rect;
              var b = _.rect;
              M = M.y !== b.y || M.x !== b.x || M.height !== b.height || M.width !== b.width;
            }
          M && (t.flags |= 4), _.abs ? _ = !v.abs : (v = v.rect, _ = _.rect, _ = v.height !== _.height || v.width !== _.width), _ && (t.flags |= 32);
        } else t.flags |= 32;
        (t.flags & 4) !== 0 && Rm(
          f,
          Ke === 0 ? n : n + "_" + Ke,
          a
        ), c && (t.flags & 4) !== 0 || (un === null && (un = []), un.push(
          f,
          l,
          e.memoizedProps
        )), Ke++;
      } else (e.tag !== 22 || e.memoizedState === null) && (e.tag === 30 && i ? t.flags |= e.flags & 32 : Qc(
        t,
        e.child,
        n,
        l,
        a,
        u,
        i
      ) && (c = !0));
      e = e.sibling;
    }
    return c;
  }
  function Hd(t, e) {
    for (t = t.child; t !== null; ) {
      if (t.tag === 30) {
        var n = t.memoizedProps, l = t.stateNode, a = pn(n, l), u = bn(n.default, n.update), i;
        i = t.memoizedState, t.memoizedState = null, l = t;
        var c = t.child;
        Ke = 0, a = Qc(
          l,
          c,
          a,
          a,
          u,
          i,
          !1
        ), (t.flags & 4) !== 0 && a && oa(t, n.onUpdate);
      } else
        (t.subtreeFlags & 33554432) !== 0 && Hd(t);
      t = t.sibling;
    }
  }
  var cn = !1, Xt = !1, on = !1, Xc = !1, Bd = typeof WeakSet == "function" ? WeakSet : Set, ee = null, rn = !1, nu = !1, Oi = !1, kc = !1;
  function My(t, e, n) {
    if (t = t.containerInfo, po = Vi, t = Yr(t), ws(t)) {
      if ("selectionStart" in t)
        var l = {
          start: t.selectionStart,
          end: t.selectionEnd
        };
      else
        t: {
          l = (l = t.ownerDocument) && l.defaultView || window;
          var a = l.getSelection && l.getSelection();
          if (a && a.rangeCount !== 0) {
            l = a.anchorNode;
            var u = a.anchorOffset, i = a.focusNode;
            a = a.focusOffset;
            try {
              l.nodeType, i.nodeType;
            } catch {
              l = null;
              break t;
            }
            var c = 0, f = -1, v = -1, _ = 0, M = 0, b = t, S = null;
            e: for (; ; ) {
              for (var L; b !== l || u !== 0 && b.nodeType !== 3 || (f = c + u), b !== i || a !== 0 && b.nodeType !== 3 || (v = c + a), b.nodeType === 3 && (c += b.nodeValue.length), (L = b.firstChild) !== null; )
                S = b, b = L;
              for (; ; ) {
                if (b === t) break e;
                if (S === l && ++_ === u && (f = c), S === i && ++M === a && (v = c), (L = b.nextSibling) !== null) break;
                b = S, S = b.parentNode;
              }
              b = L;
            }
            l = f === -1 || v === -1 ? null : { start: f, end: v };
          } else l = null;
        }
      l = l || { start: 0, end: 0 };
    } else l = null;
    for (bo = { focusedElem: t, selectionRange: l }, Vi = !1, n = (n & 335544064) === n, ee = e, e = n ? 9270 : 1028; ee !== null; ) {
      if (t = ee, n && (l = t.deletions, l !== null))
        for (u = 0; u < l.length; u++)
          n && Yc(l[u]);
      if (t.alternate === null && (t.flags & 2) !== 0)
        n && Dd(t), zi(n);
      else {
        if (t.tag === 22) {
          if (l = t.alternate, t.memoizedState !== null) {
            l !== null && l.memoizedState === null && n && Yc(l), zi(n);
            continue;
          } else if (l !== null && l.memoizedState !== null) {
            n && Dd(t), zi(n);
            continue;
          }
        }
        l = t.child, (t.subtreeFlags & e) !== 0 && l !== null ? (l.return = t, ee = l) : (n && jd(t), zi(n));
      }
    }
    qe = null;
  }
  function zi(t) {
    for (; ee !== null; ) {
      var e = ee, n = t, l = e.alternate, a = e.flags;
      switch (e.tag) {
        case 0:
        case 11:
        case 15:
          if ((a & 4) !== 0 && (l = e.updateQueue, l = l !== null ? l.events : null, l !== null))
            for (n = 0; n < l.length; n++)
              a = l[n], a.ref.impl = a.nextImpl;
          break;
        case 1:
          if ((a & 1024) !== 0 && l !== null) {
            n = void 0, a = l.memoizedProps, l = l.memoizedState;
            var u = e.stateNode;
            try {
              var i = El(
                e.type,
                a
              );
              n = u.getSnapshotBeforeUpdate(
                i,
                l
              ), u.__reactInternalSnapshotBeforeUpdate = n;
            } catch (c) {
              Mt(e, e.return, c);
            }
          }
          break;
        case 3:
          if ((a & 1024) !== 0) {
            if (l = e.stateNode.containerInfo, n = l.nodeType, n === 9)
              Oo(l);
            else if (n === 1)
              switch (l.nodeName) {
                case "HEAD":
                case "HTML":
                case "BODY":
                  Oo(l);
                  break;
                default:
                  l.textContent = "";
              }
          }
          break;
        case 5:
        case 26:
        case 27:
        case 6:
        case 4:
        case 17:
          break;
        case 30:
          n && l !== null && (n = pn(
            l.memoizedProps,
            l.stateNode
          ), a = e.memoizedProps, a = bn(a.default, a.update), a !== "none" && na(
            l,
            n,
            a,
            l.memoizedState = [],
            !0
          ));
          break;
        default:
          if ((a & 1024) !== 0) throw Error(o(163));
      }
      if (l = e.sibling, l !== null) {
        l.return = e.return, ee = l;
        break;
      }
      ee = e.return;
    }
  }
  function Ld(t, e, n) {
    var l = n.flags;
    switch (n.tag) {
      case 0:
      case 11:
      case 15:
        fn(t, n), l & 4 && eu(5, n);
        break;
      case 1:
        if (fn(t, n), l & 4)
          if (t = n.stateNode, e === null)
            try {
              t.componentDidMount();
            } catch (i) {
              Mt(n, n.return, i);
            }
          else {
            var a = El(
              n.type,
              e.memoizedProps
            );
            e = e.memoizedState;
            try {
              t.componentDidUpdate(
                a,
                e,
                t.__reactInternalSnapshotBeforeUpdate
              );
            } catch (i) {
              Mt(
                n,
                n.return,
                i
              );
            }
          }
        l & 64 && Cd(n), l & 512 && An(n, n.return);
        break;
      case 3:
        if (fn(t, n), l & 64 && (t = n.updateQueue, t !== null)) {
          if (e = null, n.child !== null)
            switch (n.child.tag) {
              case 27:
              case 5:
                e = n.child.stateNode;
                break;
              case 1:
                e = n.child.stateNode;
            }
          try {
            yf(t, e);
          } catch (i) {
            Mt(n, n.return, i);
          }
        }
        break;
      case 27:
        e === null && l & 4 && Ud(n);
      case 26:
      case 5:
        fn(t, n), e === null && l & 4 && Ad(n), l & 512 && An(n, n.return);
        break;
      case 12:
        fn(t, n);
        break;
      case 31:
        fn(t, n), l & 4 && Xd(t, n);
        break;
      case 13:
        fn(t, n), l & 4 && kd(t, n), l & 64 && (t = n.memoizedState, t !== null && (t = t.dehydrated, t !== null && (n = By.bind(
          null,
          n
        ), gv(t, n))));
        break;
      case 22:
        if (l = n.memoizedState !== null || cn, !l) {
          e = e !== null && e.memoizedState !== null || Xt, a = cn;
          var u = Xt;
          cn = l, (Xt = e) && !u ? dn(
            t,
            n,
            (n.subtreeFlags & 8772) !== 0
          ) : fn(t, n), cn = a, Xt = u;
        }
        break;
      case 30:
        fn(t, n), l & 512 && An(n, n.return);
        break;
      case 7:
        l & 512 && An(n, n.return);
      default:
        fn(t, n);
    }
  }
  function Vc(t, e) {
    for (t = t.child; t !== null; )
      Yd(t, e), t = t.sibling;
  }
  function Yd(t, e) {
    switch (t.tag) {
      case 5:
      case 26:
        try {
          var n = t.stateNode;
          if (e) {
            var l = n.style;
            typeof l.setProperty == "function" ? l.setProperty("display", "none", "important") : l.display = "none";
          } else {
            var a = t.stateNode, u = t.memoizedProps.style, i = u != null && u.hasOwnProperty("display") ? u.display : null;
            a.style.display = i == null || typeof i == "boolean" ? "" : ("" + i).trim();
          }
        } catch (f) {
          Mt(t, t.return, f);
        }
        Zc(t, e);
        break;
      case 6:
        try {
          t.stateNode.nodeValue = e ? "" : t.memoizedProps, Et = !0;
        } catch (f) {
          Mt(t, t.return, f);
        }
        break;
      case 18:
        try {
          var c = t.stateNode;
          e ? Dm(c, !0) : Dm(t.stateNode, !1);
        } catch (f) {
          Mt(t, t.return, f);
        }
        break;
      case 22:
      case 23:
        t.memoizedState === null && Vc(t, e);
        break;
      default:
        Vc(t, e);
    }
  }
  function Zc(t, e) {
    if (t.subtreeFlags & 67108864)
      for (t = t.child; t !== null; ) {
        t: {
          var n = t, l = e;
          switch (n.tag) {
            case 4:
              Yd(n, l);
              break t;
            case 22:
              n.memoizedState === null && Zc(n, l);
              break t;
            default:
              Zc(n, l);
          }
        }
        t = t.sibling;
      }
  }
  function Gd(t) {
    var e = t.alternate;
    e !== null && (t.alternate = null, Gd(e)), t.child = null, t.deletions = null, t.sibling = null, t.tag === 5 && (e = t.stateNode, e !== null && ds(e)), t.stateNode = null, t.return = null, t.dependencies = null, t.memoizedProps = null, t.memoizedState = null, t.pendingProps = null, t.stateNode = null, t.updateQueue = null;
  }
  var Bt = null, Oe = !1;
  function Pe(t, e, n) {
    for (n = n.child; n !== null; )
      Qd(t, e, n), n = n.sibling;
  }
  function Qd(t, e, n) {
    if (Ne && typeof Ne.onCommitFiberUnmount == "function")
      try {
        Ne.onCommitFiberUnmount(za, n);
      } catch {
      }
    switch (n.tag) {
      case 26:
        Xt || ye(n, e), Pe(
          t,
          e,
          n
        ), n.memoizedState ? n.memoizedState.count-- : n.stateNode && (n = n.stateNode, n.parentNode.removeChild(n));
        break;
      case 27:
        Xt || ye(n, e);
        var l = Bt, a = Oe;
        Wn(n.type) && (Bt = n.stateNode, Oe = !1), Pe(
          t,
          e,
          n
        ), fu(n.stateNode), Bt = l, Oe = a;
        break;
      case 5:
        Xt || ye(n, e), n.tag === 5 && Nd(n);
      case 6:
        if (l = Bt, a = Oe, Bt = null, Pe(
          t,
          e,
          n
        ), Bt = l, Oe = a, Bt !== null)
          if (Oe)
            try {
              (Bt.nodeType === 9 ? Bt.body : Bt.nodeName === "HTML" ? Bt.ownerDocument.body : Bt).removeChild(n.stateNode), Et = !0;
            } catch (u) {
              Mt(
                n,
                e,
                u
              );
            }
          else
            try {
              Bt.removeChild(n.stateNode), Et = !0;
            } catch (u) {
              Mt(
                n,
                e,
                u
              );
            }
        break;
      case 18:
        Bt !== null && (Oe ? (t = Bt, Um(
          t.nodeType === 9 ? t.body : t.nodeName === "HTML" ? t.ownerDocument.body : t,
          n.stateNode
        ), va(t)) : Um(Bt, n.stateNode));
        break;
      case 4:
        l = Bt, a = Oe, Bt = n.stateNode.containerInfo, Oe = !0, Pe(
          t,
          e,
          n
        ), Bt = l, Oe = a;
        break;
      case 0:
      case 11:
      case 14:
      case 15:
        Vn(2, n, e), Xt || Vn(4, n, e), Pe(
          t,
          e,
          n
        );
        break;
      case 1:
        Xt || (ye(n, e), l = n.stateNode, typeof l.componentWillUnmount == "function" && Md(
          n,
          e,
          l
        )), Pe(
          t,
          e,
          n
        );
        break;
      case 21:
        Pe(
          t,
          e,
          n
        );
        break;
      case 22:
        Xt = (l = Xt) || n.memoizedState !== null, Pe(
          t,
          e,
          n
        ), Xt = l;
        break;
      case 30:
        ye(n, e), Pe(
          t,
          e,
          n
        );
        break;
      case 7:
        Xt || ye(n, e), Pe(
          t,
          e,
          n
        );
        break;
      default:
        Pe(
          t,
          e,
          n
        );
    }
  }
  function Xd(t, e) {
    if (e.memoizedState === null && (t = e.alternate, t !== null && (t = t.memoizedState, t !== null))) {
      t = t.dehydrated;
      try {
        va(t);
      } catch (n) {
        Mt(e, e.return, n);
      }
    }
  }
  function kd(t, e) {
    if (e.memoizedState === null && (t = e.alternate, t !== null && (t = t.memoizedState, t !== null && (t = t.dehydrated, t !== null))))
      try {
        va(t);
      } catch (n) {
        Mt(e, e.return, n);
      }
  }
  function Ay(t) {
    switch (t.tag) {
      case 31:
      case 13:
      case 19:
        var e = t.stateNode;
        return e === null && (e = t.stateNode = new Bd()), e;
      case 22:
        return t = t.stateNode, e = t._retryCache, e === null && (e = t._retryCache = new Bd()), e;
      default:
        throw Error(o(435, t.tag));
    }
  }
  function Ci(t, e) {
    var n = Ay(t);
    e.forEach(function(l) {
      if (!n.has(l)) {
        n.add(l);
        var a = Ly.bind(null, t, l);
        l.then(a, a);
      }
    });
  }
  function ve(t, e, n) {
    var l = e.deletions;
    if (l !== null)
      for (var a = 0; a < l.length; a++) {
        var u = l[a], i = t, c = e, f = c;
        t: for (; f !== null; ) {
          switch (f.tag) {
            case 27:
              if (Wn(f.type)) {
                Bt = f.stateNode, Oe = !1;
                break t;
              }
              break;
            case 5:
              Bt = f.stateNode, Oe = !1;
              break t;
            case 3:
            case 4:
              Bt = f.stateNode.containerInfo, Oe = !0;
              break t;
          }
          f = f.return;
        }
        if (Bt === null) throw Error(o(160));
        Qd(i, c, u), Bt = null, Oe = !1, i = u.alternate, i !== null && (i.return = null), u.return = null;
      }
    if (e.subtreeFlags & 13886)
      for (e = e.child; e !== null; )
        Vd(e, t, n), e = e.sibling;
  }
  var tn = null;
  function Vd(t, e, n) {
    var l = t.alternate, a = t.flags;
    switch (t.tag) {
      case 0:
      case 11:
      case 14:
      case 15:
        ve(e, t, n), pe(t), a & 4 && (Vn(3, t, t.return), eu(3, t), Vn(5, t, t.return));
        break;
      case 1:
        ve(e, t, n), pe(t), a & 512 && (Xt || l === null || ye(l, l.return)), a & 64 && cn && (t = t.updateQueue, t !== null && (l = t.callbacks, l !== null && (e = t.shared.hiddenCallbacks, t.shared.hiddenCallbacks = e === null ? l : e.concat(l))));
        break;
      case 26:
        var u = tn;
        if (ve(e, t, n), pe(t), a & 512 && (Xt || l === null || ye(l, l.return)), a & 4)
          if (n = l !== null ? l.memoizedState : null, e = t.memoizedState, l === null)
            if (e === null)
              if (t.stateNode === null) {
                t: {
                  l = t.type, e = t.memoizedProps, n = u.ownerDocument || u;
                  e: switch (l) {
                    case "title":
                      a = n.getElementsByTagName("title")[0], (!a || a[Aa] || a[ae] || a.namespaceURI === "http://www.w3.org/2000/svg" || a.hasAttribute("itemprop")) && (a = n.createElement(l), n.head.insertBefore(
                        a,
                        n.querySelector("head > title")
                      )), oe(a, l, e), a[ae] = t, te(a), l = a;
                      break t;
                    case "link":
                      if (u = $m(
                        "link",
                        "href",
                        n
                      ).get(l + (e.href || ""))) {
                        for (var i = 0; i < u.length; i++)
                          if (a = u[i], a.getAttribute("href") === (e.href == null || e.href === "" ? null : e.href) && a.getAttribute("rel") === (e.rel == null ? null : e.rel) && a.getAttribute("title") === (e.title == null ? null : e.title) && a.getAttribute("crossorigin") === (e.crossOrigin == null ? null : e.crossOrigin)) {
                            u.splice(i, 1);
                            break e;
                          }
                      }
                      a = n.createElement(l), oe(a, l, e), n.head.appendChild(a);
                      break;
                    case "meta":
                      if (u = $m(
                        "meta",
                        "content",
                        n
                      ).get(l + (e.content || ""))) {
                        for (i = 0; i < u.length; i++)
                          if (a = u[i], a.getAttribute("content") === (e.content == null ? null : "" + e.content) && a.getAttribute("name") === (e.name == null ? null : e.name) && a.getAttribute("property") === (e.property == null ? null : e.property) && a.getAttribute("http-equiv") === (e.httpEquiv == null ? null : e.httpEquiv) && a.getAttribute("charset") === (e.charSet == null ? null : e.charSet)) {
                            u.splice(i, 1);
                            break e;
                          }
                      }
                      a = n.createElement(l), oe(a, l, e), n.head.appendChild(a);
                      break;
                    default:
                      throw Error(o(468, l));
                  }
                  a[ae] = t, te(a), l = a;
                }
                t.stateNode = l;
              } else
                Fm(
                  u,
                  t.type,
                  t.stateNode
                );
            else
              t.stateNode = Jm(
                u,
                e,
                t.memoizedProps
              );
          else
            n !== e ? (n === null ? l.stateNode !== null && (l = l.stateNode, l.parentNode.removeChild(l)) : n.count--, e === null ? Fm(
              u,
              t.type,
              t.stateNode
            ) : Jm(
              u,
              e,
              t.memoizedProps
            )) : e === null && t.stateNode !== null && qc(
              t,
              t.memoizedProps,
              l.memoizedProps
            );
        break;
      case 27:
        ve(e, t, n), pe(t), a & 512 && (Xt || l === null || ye(l, l.return)), l !== null && a & 4 && qc(
          t,
          t.memoizedProps,
          l.memoizedProps
        );
        break;
      case 5:
        if (u = on, on = !1, ve(e, t, n), on = u, pe(t), a & 512 && (Xt || l === null || ye(l, l.return)), t.flags & 32) {
          e = t.stateNode;
          try {
            xl(e, ""), Et = !0;
          } catch (_) {
            Mt(t, t.return, _);
          }
        }
        a & 4 && t.stateNode != null && (e = t.memoizedProps, qc(
          t,
          e,
          l !== null ? l.memoizedProps : e
        )), a & 1024 && (Xc = !0);
        break;
      case 6:
        if (ve(e, t, n), pe(t), a & 4) {
          if (t.stateNode === null)
            throw Error(o(162));
          l = t.memoizedProps, e = t.stateNode;
          try {
            e.nodeValue = l, Et = !0;
          } catch (_) {
            Mt(t, t.return, _);
          }
        }
        break;
      case 3:
        if (Et = !1, Gi = null, u = tn, tn = Li(e.containerInfo), ve(e, t, n), tn = u, pe(t), a & 4 && l !== null && l.memoizedState.isDehydrated)
          try {
            va(e.containerInfo);
          } catch (_) {
            Mt(t, t.return, _);
          }
        Xc && (Xc = !1, Zd(t)), Et = !1;
        break;
      case 4:
        l = on, on = cn, a = rr(), u = tn, tn = Li(
          t.stateNode.containerInfo
        ), ve(e, t, n), pe(t), tn = u, Et && nu && (Oi = !0), Et = a, on = l;
        break;
      case 12:
        ve(e, t, n), pe(t);
        break;
      case 31:
        ve(e, t, n), pe(t), a & 4 && (l = t.updateQueue, l !== null && (t.updateQueue = null, Ci(t, l)));
        break;
      case 13:
        ve(e, t, n), pe(t), t.child.flags & 8192 && t.memoizedState !== null != (l !== null && l.memoizedState !== null) && (Ai = we()), a & 4 && (l = t.updateQueue, l !== null && (t.updateQueue = null, Ci(t, l)));
        break;
      case 22:
        u = t.memoizedState !== null, i = l !== null && l.memoizedState !== null;
        var c = cn, f = Xt, v = on;
        cn = c || u, on = v || u, Xt = f || i, ve(e, t, n), Xt = f, on = v, cn = c, pe(t), a & 8192 && (e = t.stateNode, e._visibility = u ? e._visibility & -2 : e._visibility | 1, u && (l === null || i || cn || Xt || Tl(t)), !u && on || Vc(t, u)), a & 4 && (l = t.updateQueue, l !== null && (e = l.retryQueue, e !== null && (l.retryQueue = null, Ci(t, e))));
        break;
      case 19:
        ve(e, t, n), pe(t), a & 4 && (l = t.updateQueue, l !== null && (t.updateQueue = null, Ci(t, l)));
        break;
      case 30:
        a & 512 && (Xt || l === null || ye(l, l.return)), a = rr(), u = nu, i = (n & 335544064) === n, c = t.memoizedProps, nu = i && bn(
          c.default,
          c.update
        ) !== "none", ve(e, t, n), pe(t), i && l !== null && Et && (t.flags |= 4), nu = u, Et = a;
        break;
      case 21:
        break;
      case 7:
        l && l.stateNode !== null && (l.stateNode._fragmentFiber = t);
      default:
        ve(e, t, n), pe(t);
    }
  }
  function pe(t) {
    var e = t.flags;
    if (e & 2) {
      try {
        for (var n, l = null, a = t.return; a !== null; ) {
          if (jc(a)) {
            var u = a.stateNode;
            l === null ? l = [u] : l.push(u);
          }
          if (bi(a)) {
            n = a;
            break;
          }
          a = a.return;
        }
        if (n == null) throw Error(o(160));
        switch (n.tag) {
          case 27:
            var i = n.stateNode, c = xc(t);
            Si(
              t,
              c,
              i,
              l
            );
            break;
          case 5:
            var f = n.stateNode;
            n.flags & 32 && (xl(f, ""), n.flags &= -33);
            var v = xc(t);
            Si(
              t,
              v,
              f,
              l
            );
            break;
          case 3:
          case 4:
            var _ = n.stateNode.containerInfo, M = xc(t);
            Hc(
              t,
              M,
              _,
              l
            );
            break;
          default:
            throw Error(o(161));
        }
      } catch (b) {
        Mt(t, t.return, b);
      }
      t.flags &= -3;
    }
    e & 4096 && (t.flags &= -4097);
  }
  function Zd(t) {
    if (t.subtreeFlags & 1024)
      for (t = t.child; t !== null; ) {
        var e = t;
        Zd(e), e.tag === 5 && e.flags & 1024 && e.stateNode.reset(), t = t.sibling;
      }
  }
  function la(t, e) {
    if (e.subtreeFlags & 9270)
      for (e = e.child; e !== null; )
        Kd(e, t), e = e.sibling;
    else Hd(e);
  }
  function Kd(t, e) {
    var n = t.alternate;
    if (n === null) Bc(t, !1);
    else
      switch (t.tag) {
        case 3:
          if (kc = rn = !1, Rd(), la(e, t), !rn && !Oi) {
            if (t = un, t !== null)
              for (var l = 0; l < t.length; l += 3) {
                n = t[l];
                var a = t[l + 1];
                qm(n, t[l + 2]), n = n.ownerDocument.documentElement, n !== null && n.animate(
                  { opacity: [0, 0], pointerEvents: ["none", "none"] },
                  {
                    duration: 0,
                    fill: "forwards",
                    pseudoElement: "::view-transition-group(" + a + ")"
                  }
                );
              }
            t = e.containerInfo, t = t.nodeType === 9 ? t.documentElement : t.ownerDocument.documentElement, t !== null && t.style.viewTransitionName === "" && (t.style.viewTransitionName = "none", t.animate(
              { opacity: [0, 0], pointerEvents: ["none", "none"] },
              {
                duration: 0,
                fill: "forwards",
                pseudoElement: "::view-transition-group(root)"
              }
            ), t.animate(
              { width: [0, 0], height: [0, 0] },
              {
                duration: 0,
                fill: "forwards",
                pseudoElement: "::view-transition"
              }
            )), kc = !0;
          }
          un = null;
          break;
        case 5:
          la(e, t);
          break;
        case 4:
          l = rn, rn = !1, la(e, t), rn && (Oi = !0), rn = l;
          break;
        case 22:
          t.memoizedState === null && (n.memoizedState !== null ? Bc(t, !1) : la(e, t));
          break;
        case 30:
          l = rn, a = Rd(), rn = !1, la(e, t), rn && (t.flags |= 4);
          var u = t.memoizedProps, i = t.stateNode;
          e = pn(u, i), i = pn(n.memoizedProps, i);
          var c = bn(u.default, u.update);
          c === "none" ? e = !1 : (u = n.memoizedState, n.memoizedState = null, n = t.child, Ke = 0, e = Qc(
            t,
            n,
            e,
            i,
            c,
            u,
            !0
          ), Ke !== (u === null ? 0 : u.length) && (t.flags |= 32)), (t.flags & 4) !== 0 && e ? (oa(
            t,
            t.memoizedProps.onUpdate
          ), un = a) : a !== null && (a.push.apply(a, un), un = a), rn = (t.flags & 32) !== 0 ? !0 : l;
          break;
        default:
          la(e, t);
      }
  }
  function fn(t, e) {
    if (e.subtreeFlags & 8772)
      for (e = e.child; e !== null; )
        Ld(t, e.alternate, e), e = e.sibling;
  }
  function Tl(t) {
    for (t = t.child; t !== null; ) {
      var e = t;
      switch (e.tag) {
        case 0:
        case 11:
        case 14:
        case 15:
          Vn(4, e, e.return), Tl(e);
          break;
        case 1:
          ye(e, e.return);
          var n = e.stateNode;
          typeof n.componentWillUnmount == "function" && Md(
            e,
            e.return,
            n
          ), Tl(e);
          break;
        case 27:
          fu(e.stateNode);
        case 26:
        case 5:
          ye(e, e.return), e.tag === 5 && Nd(e), Tl(e);
          break;
        case 22:
          e.memoizedState === null && Tl(e);
          break;
        case 30:
          ye(e, e.return), Tl(e);
          break;
        case 7:
          ye(e, e.return);
        default:
          Tl(e);
      }
      t = t.sibling;
    }
  }
  function dn(t, e, n) {
    for (n = n && (e.subtreeFlags & 8772) !== 0, e = e.child; e !== null; ) {
      var l = e.alternate, a = t, u = e, i = u.flags;
      switch (u.tag) {
        case 0:
        case 11:
        case 15:
          dn(
            a,
            u,
            n
          ), eu(4, u);
          break;
        case 1:
          if (dn(
            a,
            u,
            n
          ), l = u, a = l.stateNode, typeof a.componentDidMount == "function")
            try {
              a.componentDidMount();
            } catch (_) {
              Mt(l, l.return, _);
            }
          if (l = u, a = l.updateQueue, a !== null) {
            var c = l.stateNode;
            try {
              var f = a.shared.hiddenCallbacks;
              if (f !== null)
                for (a.shared.hiddenCallbacks = null, a = 0; a < f.length; a++)
                  gf(f[a], c);
            } catch (_) {
              Mt(l, l.return, _);
            }
          }
          n && i & 64 && Cd(u), An(u, u.return);
          break;
        case 27:
          Ud(u);
        case 26:
        case 5:
          if (u.tag === 5) {
            c = u;
            for (var v = c.return; v !== null && (jc(v) && Lm(
              c.stateNode,
              v.stateNode
            ), !bi(v)); )
              v = v.return;
          }
          dn(
            a,
            u,
            n
          ), n && l === null && i & 4 && Ad(u), An(u, u.return);
          break;
        case 12:
          dn(
            a,
            u,
            n
          );
          break;
        case 31:
          dn(
            a,
            u,
            n
          ), n && i & 4 && Xd(a, u);
          break;
        case 13:
          dn(
            a,
            u,
            n
          ), n && i & 4 && kd(a, u);
          break;
        case 22:
          u.memoizedState === null && dn(
            a,
            u,
            n
          ), An(u, u.return);
          break;
        case 30:
          dn(
            a,
            u,
            n
          ), An(u, u.return);
          break;
        case 7:
          An(u, u.return);
        default:
          dn(
            a,
            u,
            n
          );
      }
      e = e.sibling;
    }
  }
  function Kc(t, e) {
    var n = null;
    t !== null && t.memoizedState !== null && t.memoizedState.cachePool !== null && (n = t.memoizedState.cachePool.pool), t = null, e.memoizedState !== null && e.memoizedState.cachePool !== null && (t = e.memoizedState.cachePool.pool), t !== n && (t != null && t.refCount++, n != null && Ga(n));
  }
  function Jc(t, e) {
    t = null, e.alternate !== null && (t = e.alternate.memoizedState.cache), e = e.memoizedState.cache, e !== t && (e.refCount++, t != null && Ga(t));
  }
  function Je(t, e, n, l) {
    var a = (n & 335544064) === n;
    if (e.subtreeFlags & (a ? 10262 : 10256))
      for (e = e.child; e !== null; )
        Jd(
          t,
          e,
          n,
          l
        ), e = e.sibling;
    else a && xd(e);
  }
  function Jd(t, e, n, l) {
    var a = (n & 335544064) === n;
    a && e.alternate === null && e.return !== null && e.return.alternate !== null && _i(e);
    var u = e.flags;
    switch (e.tag) {
      case 0:
      case 11:
      case 15:
        Je(
          t,
          e,
          n,
          l
        ), u & 2048 && eu(9, e);
        break;
      case 1:
        Je(
          t,
          e,
          n,
          l
        );
        break;
      case 3:
        Je(
          t,
          e,
          n,
          l
        ), a && kc && (t = t.containerInfo, t = t.nodeType === 9 ? t.body : t.nodeName === "HTML" ? t.ownerDocument.body : t, t.style.viewTransitionName === "root" && (t.style.viewTransitionName = ""), t = t.ownerDocument.documentElement, t !== null && t.style.viewTransitionName === "none" && (t.style.viewTransitionName = "")), u & 2048 && (u = null, e.alternate !== null && (u = e.alternate.memoizedState.cache), e = e.memoizedState.cache, e !== u && (e.refCount++, u != null && Ga(u)));
        break;
      case 12:
        if (u & 2048) {
          Je(
            t,
            e,
            n,
            l
          ), u = e.stateNode;
          try {
            var i = e.memoizedProps, c = i.id, f = i.onPostCommit;
            typeof f == "function" && f(
              c,
              e.alternate === null ? "mount" : "update",
              u.passiveEffectDuration,
              -0
            );
          } catch (v) {
            Mt(e, e.return, v);
          }
        } else
          Je(
            t,
            e,
            n,
            l
          );
        break;
      case 31:
        Je(
          t,
          e,
          n,
          l
        );
        break;
      case 13:
        Je(
          t,
          e,
          n,
          l
        );
        break;
      case 23:
        break;
      case 22:
        i = e.stateNode, c = e.alternate, e.memoizedState !== null ? (a && c !== null && c.memoizedState === null && _i(c), i._visibility & 2 ? Je(
          t,
          e,
          n,
          l
        ) : lu(
          t,
          e
        )) : (a && c !== null && c.memoizedState !== null && _i(e), i._visibility & 2 ? Je(
          t,
          e,
          n,
          l
        ) : (i._visibility |= 2, aa(
          t,
          e,
          n,
          l,
          (e.subtreeFlags & 10256) !== 0 || !1
        ))), u & 2048 && Kc(c, e);
        break;
      case 24:
        Je(
          t,
          e,
          n,
          l
        ), u & 2048 && Jc(e.alternate, e);
        break;
      case 30:
        a && (u = e.alternate, u !== null && (sn(u.child, !0), sn(e.child, !0))), Je(
          t,
          e,
          n,
          l
        );
        break;
      default:
        Je(
          t,
          e,
          n,
          l
        );
    }
  }
  function aa(t, e, n, l, a) {
    for (a = a && ((e.subtreeFlags & 10256) !== 0 || !1), e = e.child; e !== null; ) {
      var u = t, i = e, c = n, f = l, v = i.flags;
      switch (i.tag) {
        case 0:
        case 11:
        case 15:
          aa(
            u,
            i,
            c,
            f,
            a
          ), eu(8, i);
          break;
        case 23:
          break;
        case 22:
          var _ = i.stateNode;
          i.memoizedState !== null ? _._visibility & 2 ? aa(
            u,
            i,
            c,
            f,
            a
          ) : lu(
            u,
            i
          ) : (_._visibility |= 2, aa(
            u,
            i,
            c,
            f,
            a
          )), a && v & 2048 && Kc(
            i.alternate,
            i
          );
          break;
        case 24:
          aa(
            u,
            i,
            c,
            f,
            a
          ), a && v & 2048 && Jc(i.alternate, i);
          break;
        default:
          aa(
            u,
            i,
            c,
            f,
            a
          );
      }
      e = e.sibling;
    }
  }
  function lu(t, e) {
    if (e.subtreeFlags & 10256)
      for (e = e.child; e !== null; ) {
        var n = t, l = e, a = l.flags;
        switch (l.tag) {
          case 22:
            lu(n, l), a & 2048 && Kc(
              l.alternate,
              l
            );
            break;
          case 24:
            lu(n, l), a & 2048 && Jc(l.alternate, l);
            break;
          default:
            lu(n, l);
        }
        e = e.sibling;
      }
  }
  var _l = 8192;
  function Ol(t, e, n) {
    if (t.subtreeFlags & _l)
      for (t = t.child; t !== null; )
        $d(
          t,
          e,
          n
        ), t = t.sibling;
  }
  function $d(t, e, n) {
    switch (t.tag) {
      case 26:
        Ol(
          t,
          e,
          n
        ), t.flags & _l && (t.memoizedState !== null ? Av(
          n,
          tn,
          t.memoizedState,
          t.memoizedProps
        ) : (t = t.stateNode, (e & 335544128) === e && th(n, t)));
        break;
      case 5:
        Ol(
          t,
          e,
          n
        ), t.flags & _l && (t = t.stateNode, (e & 335544128) === e && th(n, t));
        break;
      case 3:
      case 4:
        var l = tn;
        tn = Li(t.stateNode.containerInfo), Ol(
          t,
          e,
          n
        ), tn = l;
        break;
      case 22:
        t.memoizedState === null && (l = t.alternate, l !== null && l.memoizedState !== null ? (l = _l, _l = 16777216, Ol(
          t,
          e,
          n
        ), _l = l) : Ol(
          t,
          e,
          n
        ));
        break;
      case 30:
        if ((t.flags & _l) !== 0 && (l = t.memoizedProps.name, l != null && l !== "auto")) {
          var a = t.stateNode;
          a.paired = null, qe === null && (qe = /* @__PURE__ */ new Map()), qe.set(l, a);
        }
        Ol(
          t,
          e,
          n
        );
        break;
      default:
        Ol(
          t,
          e,
          n
        );
    }
  }
  function Fd(t) {
    var e = t.alternate;
    if (e !== null && (t = e.child, t !== null)) {
      e.child = null;
      do
        e = t.sibling, t.sibling = null, t = e;
      while (t !== null);
    }
  }
  function au(t) {
    var e = t.deletions;
    if ((t.flags & 16) !== 0) {
      if (e !== null)
        for (var n = 0; n < e.length; n++) {
          var l = e[n];
          ee = l, Id(
            l,
            t
          );
        }
      Fd(t);
    }
    if (t.subtreeFlags & 10256)
      for (t = t.child; t !== null; )
        Wd(t), t = t.sibling;
  }
  function Wd(t) {
    switch (t.tag) {
      case 0:
      case 11:
      case 15:
        au(t), t.flags & 2048 && Vn(9, t, t.return);
        break;
      case 3:
        au(t);
        break;
      case 12:
        au(t);
        break;
      case 22:
        var e = t.stateNode;
        t.memoizedState !== null && e._visibility & 2 && (t.return === null || t.return.tag !== 13) ? (e._visibility &= -3, Mi(t)) : au(t);
        break;
      default:
        au(t);
    }
  }
  function Mi(t) {
    var e = t.deletions;
    if ((t.flags & 16) !== 0) {
      if (e !== null)
        for (var n = 0; n < e.length; n++) {
          var l = e[n];
          ee = l, Id(
            l,
            t
          );
        }
      Fd(t);
    }
    for (t = t.child; t !== null; ) {
      switch (e = t, e.tag) {
        case 0:
        case 11:
        case 15:
          Vn(8, e, e.return), Mi(e);
          break;
        case 22:
          n = e.stateNode, n._visibility & 2 && (n._visibility &= -3, Mi(e));
          break;
        default:
          Mi(e);
      }
      t = t.sibling;
    }
  }
  function Id(t, e) {
    for (; ee !== null; ) {
      var n = ee;
      switch (n.tag) {
        case 0:
        case 11:
        case 15:
          Vn(8, n, e);
          break;
        case 23:
        case 22:
          if (n.memoizedState !== null && n.memoizedState.cachePool !== null) {
            var l = n.memoizedState.cachePool.pool;
            l != null && l.refCount++;
          }
          break;
        case 24:
          Ga(n.memoizedState.cache);
      }
      if (l = n.child, l !== null) l.return = n, ee = l;
      else
        t: for (n = t; ee !== null; ) {
          l = ee;
          var a = l.sibling, u = l.return;
          if (Gd(l), l === n) {
            ee = null;
            break t;
          }
          if (a !== null) {
            a.return = u, ee = a;
            break t;
          }
          ee = u;
        }
    }
  }
  var wy = {
    getCacheForType: function(t) {
      var e = ie(Kt), n = e.data.get(t);
      return n === void 0 && (n = t(), e.data.set(t, n)), n;
    },
    cacheSignal: function() {
      return ie(Kt).controller.signal;
    }
  }, Ny = typeof WeakMap == "function" ? WeakMap : Map, Ot = 0, Dt = null, mt = null, vt = 0, Ct = 0, je = null, Zn = !1, ua = !1, $c = !1, wn = 0, kt = 0, Kn = 0, zl = 0, Fc = 0, xe = 0, ia = 0, uu = null, ze = null, Wc = !1, Ai = 0, Pd = 0, wi = 1 / 0, Ni = null, Jn = null, Lt = 0, en = null, Cl = null, mn = 0, Ic = 0, Pc = null, tm = null, iu = null, sa = null, ca = null, su = 0, to = null;
  function He() {
    return (Ot & 2) !== 0 && vt !== 0 ? vt & -vt : U.T !== null ? ro() : lr();
  }
  function em() {
    if (xe === 0)
      if ((vt & 536870912) === 0 || dt) {
        var t = Uu;
        Uu <<= 1, (Uu & 3932160) === 0 && (Uu = 262144), xe = t;
      } else xe = 536870912;
    return t = se.current, t !== null && (t.flags |= 32), xe;
  }
  function oa(t, e) {
    if (e != null) {
      var n = t.stateNode, l = n.ref;
      l === null && (l = n.ref = jm(
        pn(t.memoizedProps, n)
      )), sa === null && (sa = []), sa.push(e.bind(null, l));
    }
  }
  function Ce(t, e, n) {
    (t === Dt && (Ct === 2 || Ct === 9) || t.cancelPendingCommit !== null) && (ra(t, 0), $n(
      t,
      vt,
      xe,
      !1
    )), Ma(t, n), ((Ot & 2) === 0 || t !== Dt) && (t === Dt && ((Ot & 2) === 0 && (zl |= n), kt === 4 && $n(
      t,
      vt,
      xe,
      !1
    )), hn(t));
  }
  function nm(t, e, n) {
    if ((Ot & 6) !== 0) throw Error(o(327));
    var l = !n && (e & 127) === 0 && (e & t.expiredLanes) === 0 || Ca(t, e), a = l ? Ry(t, e) : no(t, e, !0), u = l;
    do {
      if (a === 0) {
        ua && !l && $n(t, e, 0, !1);
        break;
      } else {
        if (n = t.current.alternate, u && !Uy(n)) {
          a = no(t, e, !1), u = !1;
          continue;
        }
        if (a === 2) {
          if (u = e, t.errorRecoveryDisabledLanes & u)
            var i = 0;
          else
            i = t.pendingLanes & -536870913, i = i !== 0 ? i : i & 536870912 ? 536870912 : 0;
          if (i !== 0) {
            e = i;
            t: {
              var c = t;
              a = uu;
              var f = c.current.memoizedState.isDehydrated;
              if (f && (ra(c, i).flags |= 256), i = no(
                c,
                i,
                !1
              ), i !== 2) {
                if ($c && !f) {
                  c.errorRecoveryDisabledLanes |= u, zl |= u, a = 4;
                  break t;
                }
                u = ze, ze = a, u !== null && (ze === null ? ze = u : ze.push.apply(
                  ze,
                  u
                ));
              }
              a = i;
            }
            if (u = !1, a !== 2) continue;
          }
        }
        if (a === 1) {
          ra(t, 0), $n(t, e, 0, !0);
          break;
        }
        t: {
          switch (l = t, u = a, u) {
            case 0:
            case 1:
              throw Error(o(345));
            case 4:
              if ((e & 4194048) !== e && (e & 62914560) !== e)
                break;
            case 6:
              $n(
                l,
                e,
                xe,
                !Zn
              );
              break t;
            case 2:
              ze = null;
              break;
            case 3:
            case 5:
              break;
            default:
              throw Error(o(329));
          }
          if ((e & 62914560) === e && (a = Ai + 300 - we(), 10 < a)) {
            if ($n(
              l,
              e,
              xe,
              !Zn
            ), Ru(l, 0, !0) !== 0) break t;
            mn = e, l.timeoutHandle = wm(
              lm.bind(
                null,
                l,
                n,
                ze,
                Ni,
                Wc,
                e,
                xe,
                zl,
                ia,
                Zn,
                u,
                "Throttled",
                -0,
                0
              ),
              a
            );
            break t;
          }
          lm(
            l,
            n,
            ze,
            Ni,
            Wc,
            e,
            xe,
            zl,
            ia,
            Zn,
            u,
            null,
            -0,
            0
          );
        }
      }
      break;
    } while (!0);
    hn(t);
  }
  function lm(t, e, n, l, a, u, i, c, f, v, _, M, b, S) {
    t.timeoutHandle = -1;
    var L = e.subtreeFlags, k = (u & 335544064) === u;
    if (M = null, (k || L & 8192 || (L & 16785408) === 16785408) && (M = {
      stylesheets: null,
      count: 0,
      imgCount: 0,
      imgBytes: 0,
      suspenseyImages: [],
      waitingForImages: !0,
      waitingForViewTransition: !1,
      unsuspend: yn
    }, qe = null, $d(
      e,
      u,
      M
    ), k && (L = M, k = t.containerInfo, k = (k.nodeType === 9 ? k : k.ownerDocument).__reactViewTransition, k != null && (L.count++, L.waitingForViewTransition = !0, L = hu.bind(L), k.finished.then(L, L))), L = (u & 62914560) === u ? Ai - we() : (u & 4194048) === u ? Pd - we() : 0, L = wv(
      M,
      L
    ), L !== null)) {
      mn = u, t.cancelPendingCommit = L(
        fm.bind(
          null,
          t,
          e,
          u,
          n,
          l,
          a,
          i,
          c,
          f,
          _,
          M,
          null,
          b,
          S
        )
      ), $n(t, u, i, !v);
      return;
    }
    fm(
      t,
      e,
      u,
      n,
      l,
      a,
      i,
      c,
      f,
      _,
      M
    );
  }
  function Uy(t) {
    for (var e = t; ; ) {
      var n = e.tag;
      if ((n === 0 || n === 11 || n === 15) && e.flags & 16384 && (n = e.updateQueue, n !== null && (n = n.stores, n !== null)))
        for (var l = 0; l < n.length; l++) {
          var a = n[l], u = a.getSnapshot;
          a = a.value;
          try {
            if (!De(u(), a)) return !1;
          } catch {
            return !1;
          }
        }
      if (n = e.child, e.subtreeFlags & 16384 && n !== null)
        n.return = e, e = n;
      else {
        if (e === t) break;
        for (; e.sibling === null; ) {
          if (e.return === null || e.return === t) return !0;
          e = e.return;
        }
        e.sibling.return = e.return, e = e.sibling;
      }
    }
    return !0;
  }
  function $n(t, e, n, l) {
    e &= ~Fc, e &= ~zl, t.suspendedLanes |= e, t.pingedLanes &= ~e, l && (t.warmLanes |= e), l = t.expirationTimes;
    for (var a = e; 0 < a; ) {
      var u = 31 - Ue(a), i = 1 << u;
      l[u] = -1, a &= ~i;
    }
    n !== 0 && tr(t, n, e);
  }
  function Ui() {
    return (Ot & 6) === 0 ? (cu(0), !1) : !0;
  }
  function eo() {
    if (mt !== null) {
      if (Ct === 0)
        var t = mt.return;
      else
        t = mt, Tn = ml = null, sc(t), Fl = null, ka = 0, t = mt;
      for (; t !== null; )
        zd(t.alternate, t), t = t.return;
      mt = null;
    }
  }
  function ra(t, e) {
    var n = t.timeoutHandle;
    n !== -1 && (t.timeoutHandle = -1, Py(n)), n = t.cancelPendingCommit, n !== null && (t.cancelPendingCommit = null, n()), mn = 0, eo(), Dt = t, mt = n = Sn(t.current, null), vt = e, Ct = 0, je = null, Zn = !1, ua = Ca(t, e), $c = !1, ia = xe = Fc = zl = Kn = kt = 0, ze = uu = null, Wc = !1, (e & 8) !== 0 && (e |= e & 32);
    var l = t.entangledLanes;
    if (l !== 0)
      for (t = t.entanglements, l &= e; 0 < l; ) {
        var a = 31 - Ue(l), u = 1 << a;
        e |= t[a], l &= ~u;
      }
    return wn = e, Vu(), n;
  }
  function am(t, e) {
    at = null, U.H = Ia, e === $l || e === ti ? (e = ff(), Ct = 3) : e === Js ? (e = ff(), Ct = 4) : Ct = e === _c ? 8 : e !== null && typeof e == "object" && typeof e.then == "function" ? 6 : 1, je = e, mt === null && (kt = 1, hi(
      t,
      Xe(e, t.current)
    ));
  }
  function um() {
    var t = se.current;
    return t === null ? !0 : (vt & 4194048) === vt ? fe === null : (vt & 62914560) === vt || (vt & 536870912) !== 0 ? t === fe : !1;
  }
  function im() {
    var t = U.H;
    return U.H = Ia, t === null ? Ia : t;
  }
  function sm() {
    var t = U.A;
    return U.A = wy, t;
  }
  function Di() {
    kt = 4, Zn || (vt & 4194048) !== vt && se.current !== null || (ua = !0), (Kn & 134217727) === 0 && (zl & 134217727) === 0 || Dt === null || $n(
      Dt,
      vt,
      xe,
      !1
    );
  }
  function no(t, e, n) {
    var l = Ot;
    Ot |= 2;
    var a = im(), u = sm();
    (Dt !== t || vt !== e) && (Ni = null, ra(t, e)), e = !1;
    var i = kt;
    t: do
      try {
        if (Ct !== 0 && mt !== null) {
          var c = mt, f = je;
          switch (Ct) {
            case 8:
              eo(), i = 6;
              break t;
            case 3:
            case 2:
            case 9:
            case 6:
              se.current === null && (e = !0);
              var v = Ct;
              if (Ct = 0, je = null, fa(t, c, f, v), n && ua) {
                i = 0;
                break t;
              }
              break;
            default:
              v = Ct, Ct = 0, je = null, fa(t, c, f, v);
          }
        }
        Dy(), i = kt;
        break;
      } catch (_) {
        am(t, _);
      }
    while (!0);
    return e && t.shellSuspendCounter++, Tn = ml = null, Ot = l, U.H = a, U.A = u, mt === null && (Dt = null, vt = 0, Vu()), i;
  }
  function Dy() {
    for (; mt !== null; ) cm(mt);
  }
  function Ry(t, e) {
    var n = Ot;
    Ot |= 2;
    var l = im(), a = sm();
    Dt !== t || vt !== e ? (Ni = null, wi = we() + 500, ra(t, e)) : ua = Ca(
      t,
      e
    );
    t: do
      try {
        if (Ct !== 0 && mt !== null) {
          e = mt;
          var u = je;
          e: switch (Ct) {
            case 1:
              Ct = 0, je = null, fa(t, e, u, 1);
              break;
            case 2:
            case 9:
              if (of(u)) {
                Ct = 0, je = null, om(e);
                break;
              }
              e = function() {
                Ct !== 2 && Ct !== 9 || Dt !== t || (Ct = 7), hn(t);
              }, u.then(e, e);
              break t;
            case 3:
              Ct = 7;
              break t;
            case 4:
              Ct = 5;
              break t;
            case 7:
              of(u) ? (Ct = 0, je = null, om(e)) : (Ct = 0, je = null, fa(t, e, u, 7));
              break;
            case 5:
              var i = null;
              switch (mt.tag) {
                case 26:
                  i = mt.memoizedState;
                case 5:
                case 27:
                  var c = mt;
                  if (i ? Im(i) : c.stateNode.complete) {
                    Ct = 0, je = null;
                    var f = c.sibling;
                    if (f !== null) mt = f;
                    else {
                      var v = c.return;
                      v !== null ? (mt = v, Ri(v)) : mt = null;
                    }
                    break e;
                  }
              }
              Ct = 0, je = null, fa(t, e, u, 5);
              break;
            case 6:
              Ct = 0, je = null, fa(t, e, u, 6);
              break;
            case 8:
              eo(), kt = 6;
              break t;
            default:
              throw Error(o(462));
          }
        }
        qy();
        break;
      } catch (_) {
        am(t, _);
      }
    while (!0);
    return Tn = ml = null, U.H = l, U.A = a, Ot = n, mt !== null ? 0 : (Dt = null, vt = 0, Vu(), kt);
  }
  function qy() {
    for (; mt !== null && !eg(); )
      cm(mt);
  }
  function cm(t) {
    var e = _d(t.alternate, t, wn);
    t.memoizedProps = t.pendingProps, e === null ? Ri(t) : mt = e;
  }
  function om(t) {
    var e = t, n = e.alternate;
    switch (e.tag) {
      case 15:
      case 0:
        e = vd(
          n,
          e,
          e.pendingProps,
          e.type,
          void 0,
          vt
        );
        break;
      case 11:
        e = vd(
          n,
          e,
          e.pendingProps,
          e.type.render,
          e.ref,
          vt
        );
        break;
      case 5:
        sc(e);
      default:
        zd(n, e), e = mt = Fr(e, wn), e = _d(n, e, wn);
    }
    t.memoizedProps = t.pendingProps, e === null ? Ri(t) : mt = e;
  }
  function fa(t, e, n, l) {
    Tn = ml = null, sc(e), Fl = null, ka = 0;
    var a = e.return;
    try {
      if (Ty(
        t,
        a,
        e,
        n,
        vt
      )) {
        kt = 1, hi(
          t,
          Xe(n, t.current)
        ), mt = null;
        return;
      }
    } catch (u) {
      if (a !== null) throw mt = a, u;
      kt = 1, hi(
        t,
        Xe(n, t.current)
      ), mt = null;
      return;
    }
    e.flags & 32768 ? (dt || l === 1 ? t = !0 : ua || (vt & 536870912) !== 0 ? t = !1 : (Zn = t = !0, (l === 2 || l === 9 || l === 3 || l === 6) && (l = se.current, l !== null && l.tag === 13 && (l.flags |= 16384))), rm(e, t)) : Ri(e);
  }
  function Ri(t) {
    var e = t;
    do {
      if ((e.flags & 32768) !== 0) {
        rm(
          e,
          Zn
        );
        return;
      }
      t = e.return;
      var n = zy(
        e.alternate,
        e,
        wn
      );
      if (n !== null) {
        mt = n;
        return;
      }
      if (e = e.sibling, e !== null) {
        mt = e;
        return;
      }
      mt = e = t;
    } while (e !== null);
    kt === 0 && (kt = 5);
  }
  function rm(t, e) {
    do {
      var n = Cy(t.alternate, t);
      if (n !== null) {
        n.flags &= 32767, mt = n;
        return;
      }
      if (n = t.return, n !== null && (n.flags |= 32768, n.subtreeFlags = 0, n.deletions = null), !e && (t = t.sibling, t !== null)) {
        mt = t;
        return;
      }
      mt = t = n;
    } while (t !== null);
    kt = 6, mt = null;
  }
  function fm(t, e, n, l, a, u, i, c, f, v, _) {
    t.cancelPendingCommit = null;
    do
      qi();
    while (Lt !== 0);
    if ((Ot & 6) !== 0) throw Error(o(327));
    if (e !== null) {
      if (e === t.current) throw Error(o(177));
      if (u = e.lanes | e.childLanes, u |= qs, fg(
        t,
        n,
        u,
        i,
        c,
        f
      ), t === Dt && (mt = Dt = null, vt = 0), Cl = e, en = t, mn = n, Ic = u, Pc = a, tm = l, sa = null, (n & 335544064) === n ? (ca = fy(t), l = 10262) : (ca = null, l = 10256), (e.subtreeFlags & l) !== 0 || (e.flags & l) !== 0 ? (t.callbackNode = null, t.callbackPriority = 0, Yy(wu, function() {
        return io(), null;
      })) : (t.callbackNode = null, t.callbackPriority = 0), Ei = !1, l = (e.flags & 13878) !== 0, (e.subtreeFlags & 13878) !== 0 || l) {
        l = U.T, U.T = null, a = x.p, x.p = 2, i = Ot, Ot |= 4;
        try {
          My(t, e, n);
        } finally {
          Ot = i, x.p = a, U.T = l;
        }
      }
      e = Ei, Lt = 1, e ? iu = uv(
        _,
        t.containerInfo,
        ca,
        lo,
        ao,
        xy,
        uo,
        io,
        jy
      ) : (lo(), ao(), uo());
    }
  }
  function jy(t) {
    if (Lt !== 0) {
      var e = en.onRecoverableError;
      e(t, { componentStack: null });
    }
  }
  function xy() {
    Lt === 3 && (Lt = 0, Kd(Cl, en), Lt = 4);
  }
  function lo() {
    if (Lt === 1) {
      Lt = 0;
      var t = en, e = Cl, n = mn, l = (e.flags & 13878) !== 0;
      if ((e.subtreeFlags & 13878) !== 0 || l) {
        l = U.T, U.T = null;
        var a = x.p;
        x.p = 2;
        var u = Ot;
        Ot |= 4;
        try {
          nu = Oi = !1, Vd(e, t, n), n = bo;
          var i = Yr(t.containerInfo), c = n.focusedElem, f = n.selectionRange;
          if (i !== c && c && c.ownerDocument && Lr(
            c.ownerDocument.documentElement,
            c
          )) {
            if (f !== null && ws(c)) {
              var v = f.start, _ = f.end;
              if (_ === void 0 && (_ = v), "selectionStart" in c)
                c.selectionStart = v, c.selectionEnd = Math.min(
                  _,
                  c.value.length
                );
              else {
                var M = c.ownerDocument || document, b = M && M.defaultView || window;
                if (b.getSelection) {
                  var S = b.getSelection(), L = c.textContent.length, k = Math.min(f.start, L), ut = f.end === void 0 ? k : Math.min(f.end, L);
                  !S.extend && k > ut && (i = ut, ut = k, k = i);
                  var p = Br(
                    c,
                    k
                  ), h = Br(
                    c,
                    ut
                  );
                  if (p && h && (S.rangeCount !== 1 || S.anchorNode !== p.node || S.anchorOffset !== p.offset || S.focusNode !== h.node || S.focusOffset !== h.offset)) {
                    var E = M.createRange();
                    E.setStart(p.node, p.offset), S.removeAllRanges(), k > ut ? (S.addRange(E), S.extend(h.node, h.offset)) : (E.setEnd(h.node, h.offset), S.addRange(E));
                  }
                }
              }
            }
            for (M = [], S = c; S = S.parentNode; )
              S.nodeType === 1 && M.push({
                element: S,
                left: S.scrollLeft,
                top: S.scrollTop
              });
            for (typeof c.focus == "function" && c.focus(), c = 0; c < M.length; c++) {
              var w = M[c];
              w.element.scrollLeft = w.left, w.element.scrollTop = w.top;
            }
          }
          Vi = !!po, bo = po = null;
        } finally {
          Ot = u, x.p = a, U.T = l;
        }
      }
      t.current = e, Lt = 2;
    }
  }
  function ao() {
    if (Lt === 2) {
      Lt = 0;
      var t = en, e = Cl, n = (e.flags & 8772) !== 0;
      if ((e.subtreeFlags & 8772) !== 0 || n) {
        n = U.T, U.T = null;
        var l = x.p;
        x.p = 2;
        var a = Ot;
        Ot |= 4;
        try {
          Ld(t, e.alternate, e);
        } finally {
          Ot = a, x.p = l, U.T = n;
        }
      }
      Lt = 3;
    }
  }
  function uo() {
    if (Lt === 4 || Lt === 3) {
      Lt = 0, iu = null, ng();
      var t = en, e = Cl, n = mn, l = tm, a = (n & 335544064) === n ? 10262 : 10256;
      if ((e.subtreeFlags & a) !== 0 || (e.flags & a) !== 0 ? Lt = 5 : (Lt = 0, Cl = en = null, dm(t, t.pendingLanes)), a = t.pendingLanes, a === 0 && (Jn = null), rs(n), e = e.stateNode, Ne && typeof Ne.onCommitFiberRoot == "function")
        try {
          Ne.onCommitFiberRoot(
            za,
            e,
            void 0,
            (e.current.flags & 128) === 128
          );
        } catch {
        }
      if (l !== null) {
        e = U.T, a = x.p, x.p = 2, U.T = null;
        try {
          for (var u = t.onRecoverableError, i = 0; i < l.length; i++) {
            var c = l[i];
            u(c.value, {
              componentStack: c.stack
            });
          }
        } finally {
          U.T = e, x.p = a;
        }
      }
      if (l = sa, u = ca, ca = null, l !== null)
        for (sa = null, u === null && (u = []), c = 0; c < l.length; c++)
          (0, l[c])(u);
      (mn & 3) !== 0 && qi(), hn(t), a = t.pendingLanes, (n & 261930) !== 0 && (a & 42) !== 0 ? t === to ? su++ : (su = 0, to = t) : su = 0, cu(0);
    }
  }
  function dm(t, e) {
    (t.pooledCacheLanes &= e) === 0 && (e = t.pooledCache, e != null && (t.pooledCache = null, Ga(e)));
  }
  function qi() {
    return iu !== null && (iu.skipTransition(), iu = null), lo(), ao(), uo(), io();
  }
  function io() {
    if (Lt !== 5) return !1;
    var t = en, e = Ic;
    Ic = 0;
    var n = rs(mn), l = U.T, a = x.p;
    try {
      x.p = 32 > n ? 32 : n, U.T = null, n = Pc, Pc = null;
      var u = en, i = mn;
      if (Lt = 0, Cl = en = null, mn = 0, (Ot & 6) !== 0) throw Error(o(331));
      var c = Ot;
      if (Ot |= 4, Wd(u.current), Jd(
        u,
        u.current,
        i,
        n
      ), Ot = c, cu(0, !1), Ne && typeof Ne.onPostCommitFiberRoot == "function")
        try {
          Ne.onPostCommitFiberRoot(za, u);
        } catch {
        }
      return !0;
    } finally {
      x.p = a, U.T = l, dm(t, e);
    }
  }
  function mm(t, e, n) {
    e = Xe(n, e), e = Tc(t.stateNode, e, 2), t = Qn(t, e, 2), t !== null && (Ma(t, 2), hn(t));
  }
  function Mt(t, e, n) {
    if (t.tag === 3)
      mm(t, t, n);
    else
      for (; e !== null; ) {
        if (e.tag === 3) {
          mm(
            e,
            t,
            n
          );
          break;
        } else if (e.tag === 1) {
          var l = e.stateNode;
          if (typeof e.type.getDerivedStateFromError == "function" || typeof l.componentDidCatch == "function" && (Jn === null || !Jn.has(l))) {
            t = Xe(n, t), n = od(2), l = Qn(e, n, 2), l !== null && (rd(
              n,
              l,
              e,
              t
            ), Ma(l, 2), hn(l));
            break;
          }
        }
        e = e.return;
      }
  }
  function so(t, e, n) {
    var l = t.pingCache;
    if (l === null) {
      l = t.pingCache = new Ny();
      var a = /* @__PURE__ */ new Set();
      l.set(e, a);
    } else
      a = l.get(e), a === void 0 && (a = /* @__PURE__ */ new Set(), l.set(e, a));
    a.has(n) || ($c = !0, a.add(n), t = Hy.bind(null, t, e, n), e.then(t, t));
  }
  function Hy(t, e, n) {
    var l = t.pingCache;
    l !== null && l.delete(e), t.pingedLanes |= t.suspendedLanes & n, t.warmLanes &= ~n, Dt === t && (vt & n) === n && (kt === 4 || kt === 3 && (vt & 62914560) === vt && 300 > we() - Ai ? (Ot & 2) === 0 && ra(t, 0) : Fc |= n, ia === vt && (ia = 0)), hn(t);
  }
  function hm(t, e) {
    e === 0 && (e = Po()), t = rl(t, e), t !== null && (Ma(t, e), hn(t));
  }
  function By(t) {
    var e = t.memoizedState, n = 0;
    e !== null && (n = e.retryLane), hm(t, n);
  }
  function Ly(t, e) {
    var n = 0;
    switch (t.tag) {
      case 31:
      case 13:
        var l = t.stateNode, a = t.memoizedState;
        a !== null && (n = a.retryLane);
        break;
      case 19:
        l = t.stateNode;
        break;
      case 22:
        l = t.stateNode._retryCache;
        break;
      default:
        throw Error(o(314));
    }
    l !== null && l.delete(e), hm(t, n);
  }
  function Yy(t, e) {
    return Oa(t, e);
  }
  var da = null, ma = null, co = !1, ji = !1, oo = !1, Fn = 0;
  function hn(t) {
    t !== ma && t.next === null && (ma === null ? da = ma = t : ma = ma.next = t), ji = !0, co || (co = !0, Qy());
  }
  function cu(t, e) {
    if (!oo && ji) {
      oo = !0;
      do
        for (var n = !1, l = da; l !== null; ) {
          if (t !== 0) {
            var a = l.pendingLanes;
            if (a === 0) var u = 0;
            else {
              var i = l.suspendedLanes, c = l.pingedLanes;
              u = (1 << 31 - Ue(42 | t) + 1) - 1, u &= a & ~(i & ~c), u = u & 201326741 ? u & 201326741 | 1 : u ? u | 2 : 0;
            }
            u !== 0 && (n = !0, pm(l, u));
          } else
            u = vt, u = Ru(
              l,
              l === Dt ? u : 0,
              l.cancelPendingCommit !== null || l.timeoutHandle !== -1
            ), (u & 3) === 0 || Ca(l, u) || (n = !0, pm(l, u));
          l = l.next;
        }
      while (n);
      oo = !1;
    }
  }
  function Gy() {
    gm();
  }
  function gm() {
    ji = co = !1;
    var t = 0;
    Fn !== 0 && Iy() && (t = Fn);
    for (var e = we(), n = null, l = da; l !== null; ) {
      var a = l.next, u = ym(l, e);
      u === 0 ? (l.next = null, n === null ? da = a : n.next = a, a === null && (ma = n)) : (n = l, (t !== 0 || (u & 3) !== 0) && (ji = !0)), l = a;
    }
    Lt !== 0 && Lt !== 5 || cu(t), Fn !== 0 && (Fn = 0);
  }
  function ym(t, e) {
    for (var n = t.suspendedLanes, l = t.pingedLanes, a = t.expirationTimes, u = t.pendingLanes & -62914561; 0 < u; ) {
      var i = 31 - Ue(u), c = 1 << i, f = a[i];
      f === -1 ? ((c & n) === 0 || (c & l) !== 0) && (a[i] = rg(c, e)) : f <= e && (t.expiredLanes |= c), u &= ~c;
    }
    if (e = Dt, n = vt, n = Ru(
      t,
      t === e ? n : 0,
      t.cancelPendingCommit !== null || t.timeoutHandle !== -1
    ), l = t.callbackNode, n === 0 || t === e && (Ct === 2 || Ct === 9) || t.cancelPendingCommit !== null)
      return l !== null && l !== null && ss(l), t.callbackNode = null, t.callbackPriority = 0;
    if ((n & 3) === 0 || Ca(t, n)) {
      if (e = n & -n, e === t.callbackPriority) return e;
      switch (l !== null && ss(l), rs(n)) {
        case 2:
        case 8:
          n = Wo;
          break;
        case 32:
          n = wu;
          break;
        case 268435456:
          n = Io;
          break;
        default:
          n = wu;
      }
      return l = vm.bind(null, t), n = Oa(n, l), t.callbackPriority = e, t.callbackNode = n, e;
    }
    return l !== null && l !== null && ss(l), t.callbackPriority = 2, t.callbackNode = null, 2;
  }
  function vm(t, e) {
    if (Lt !== 0 && Lt !== 5)
      return t.callbackNode = null, t.callbackPriority = 0, null;
    var n = t.callbackNode;
    if (qi() && t.callbackNode !== n)
      return null;
    var l = vt;
    return l = Ru(
      t,
      t === Dt ? l : 0,
      t.cancelPendingCommit !== null || t.timeoutHandle !== -1
    ), l === 0 ? null : (nm(t, l, e), ym(t, we()), t.callbackNode != null && t.callbackNode === n ? vm.bind(null, t) : null);
  }
  function pm(t, e) {
    if (qi()) return null;
    nm(t, e, !0);
  }
  function Qy() {
    tv(function() {
      (Ot & 6) !== 0 ? Oa(
        Fo,
        Gy
      ) : gm();
    });
  }
  function ro() {
    if (Fn === 0) {
      var t = gl;
      t === 0 && (t = Nu, Nu <<= 1, (Nu & 261888) === 0 && (Nu = 256)), Fn = t;
    }
    return Fn;
  }
  function bm(t) {
    return t == null || typeof t == "symbol" || typeof t == "boolean" ? null : typeof t == "function" ? t : Hu("" + t);
  }
  function Sm(t, e) {
    var n = e.ownerDocument.createElement("input");
    return n.name = e.name, n.value = e.value, t.id && n.setAttribute("form", t.id), e.parentNode.insertBefore(n, e), t = new FormData(t), n.parentNode.removeChild(n), t;
  }
  function Xy(t, e, n, l, a) {
    if (e === "submit" && n && n.stateNode === a) {
      var u = bm(
        (a[Ee] || null).action
      ), i = l.submitter;
      i && (e = (e = i[Ee] || null) ? bm(e.formAction) : i.getAttribute("formAction"), e !== null && (u = e, i = null));
      var c = new Gu(
        "action",
        "action",
        null,
        l,
        a
      );
      t.push({
        event: c,
        listeners: [
          {
            instance: null,
            listener: function() {
              if (l.defaultPrevented) {
                if (Fn !== 0) {
                  var f = i ? Sm(a, i) : new FormData(a);
                  yc(
                    n,
                    {
                      pending: !0,
                      data: f,
                      method: a.method,
                      action: u
                    },
                    null,
                    f
                  );
                }
              } else
                typeof u == "function" && (c.preventDefault(), f = i ? Sm(a, i) : new FormData(a), yc(
                  n,
                  {
                    pending: !0,
                    data: f,
                    method: a.method,
                    action: u
                  },
                  u,
                  f
                ));
            },
            currentTarget: a
          }
        ]
      });
    }
  }
  for (var fo = 0; fo < Rs.length; fo++) {
    var mo = Rs[fo], ky = mo.toLowerCase(), Vy = mo[0].toUpperCase() + mo.slice(1);
    Ie(
      ky,
      "on" + Vy
    );
  }
  Ie(Xr, "onAnimationEnd"), Ie(kr, "onAnimationIteration"), Ie(Vr, "onAnimationStart"), Ie("dblclick", "onDoubleClick"), Ie("focusin", "onFocus"), Ie("focusout", "onBlur"), Ie(ly, "onTransitionRun"), Ie(ay, "onTransitionStart"), Ie(uy, "onTransitionCancel"), Ie(Zr, "onTransitionEnd"), ql("onMouseEnter", ["mouseout", "mouseover"]), ql("onMouseLeave", ["mouseout", "mouseover"]), ql("onPointerEnter", ["pointerout", "pointerover"]), ql("onPointerLeave", ["pointerout", "pointerover"]), il(
    "onChange",
    "change click focusin focusout input keydown keyup selectionchange".split(" ")
  ), il(
    "onSelect",
    "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(
      " "
    )
  ), il("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
  ]), il(
    "onCompositionEnd",
    "compositionend focusout keydown keypress keyup mousedown".split(" ")
  ), il(
    "onCompositionStart",
    "compositionstart focusout keydown keypress keyup mousedown".split(" ")
  ), il(
    "onCompositionUpdate",
    "compositionupdate focusout keydown keypress keyup mousedown".split(" ")
  );
  var ou = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(
    " "
  ), Zy = new Set(
    "beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat(ou)
  );
  function Em(t, e) {
    e = (e & 4) !== 0;
    for (var n = 0; n < t.length; n++) {
      var l = t[n], a = l.event;
      l = l.listeners;
      t: {
        var u = void 0;
        if (e)
          for (var i = l.length - 1; 0 <= i; i--) {
            var c = l[i], f = c.instance, v = c.currentTarget;
            if (c = c.listener, f !== u && a.isPropagationStopped())
              break t;
            u = c, a.currentTarget = v;
            try {
              u(a);
            } catch (_) {
              ku(_);
            }
            a.currentTarget = null, u = f;
          }
        else
          for (i = 0; i < l.length; i++) {
            if (c = l[i], f = c.instance, v = c.currentTarget, c = c.listener, f !== u && a.isPropagationStopped())
              break t;
            u = c, a.currentTarget = v;
            try {
              u(a);
            } catch (_) {
              ku(_);
            }
            a.currentTarget = null, u = f;
          }
      }
    }
  }
  function ht(t, e) {
    var n = e[fs];
    n === void 0 && (n = e[fs] = /* @__PURE__ */ new Set());
    var l = t + "__bubble";
    n.has(l) || (Tm(e, t, 2, !1), n.add(l));
  }
  function ho(t, e, n) {
    var l = 0;
    e && (l |= 4), Tm(
      n,
      t,
      l,
      e
    );
  }
  var xi = "_reactListening" + Math.random().toString(36).slice(2);
  function go(t) {
    if (!t[xi]) {
      t[xi] = !0, ir.forEach(function(n) {
        n !== "selectionchange" && (Zy.has(n) || ho(n, !1, t), ho(n, !0, t));
      });
      var e = t.nodeType === 9 ? t : t.ownerDocument;
      e === null || e[xi] || (e[xi] = !0, ho("selectionchange", !1, e));
    }
  }
  function Tm(t, e, n, l) {
    switch (ch(e)) {
      case 2:
        var a = Rv;
        break;
      case 8:
        a = qv;
        break;
      default:
        a = Uo;
    }
    n = a.bind(
      null,
      e,
      n,
      t
    ), a = void 0, !Ss || e !== "touchstart" && e !== "touchmove" && e !== "wheel" || (a = !0), l ? a !== void 0 ? t.addEventListener(e, n, {
      capture: !0,
      passive: a
    }) : t.addEventListener(e, n, !0) : a !== void 0 ? t.addEventListener(e, n, {
      passive: a
    }) : t.addEventListener(e, n, !1);
  }
  function yo(t, e, n, l, a) {
    var u = l;
    if ((e & 1) === 0 && (e & 2) === 0 && l !== null)
      t: for (; ; ) {
        if (l === null) return;
        var i = l.tag;
        if (i === 3 || i === 4) {
          var c = l.stateNode.containerInfo;
          if (c === a) break;
          if (i === 4)
            for (i = l.return; i !== null; ) {
              var f = i.tag;
              if ((f === 3 || f === 4) && i.stateNode.containerInfo === a)
                return;
              i = i.return;
            }
          for (; c !== null; ) {
            if (i = ul(c), i === null) return;
            if (f = i.tag, f === 5 || f === 6 || f === 26 || f === 27) {
              l = u = i;
              continue t;
            }
            c = c.parentNode;
          }
        }
        l = l.return;
      }
    br(function() {
      var v = u, _ = ps(n), M = [];
      t: {
        var b = Kr.get(t);
        if (b !== void 0) {
          var S = Gu, L = t;
          switch (t) {
            case "keypress":
              if (Lu(n) === 0) break t;
            case "keydown":
            case "keyup":
              S = jg;
              break;
            case "focusin":
              L = "focus", S = Os;
              break;
            case "focusout":
              L = "blur", S = Os;
              break;
            case "beforeblur":
            case "afterblur":
              S = Os;
              break;
            case "click":
              if (n.button === 2) break t;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
              S = Tr;
              break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
              S = _g;
              break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
              S = Bg;
              break;
            case Xr:
            case kr:
            case Vr:
              S = Cg;
              break;
            case Zr:
              S = Yg;
              break;
            case "scroll":
            case "scrollend":
              S = Eg;
              break;
            case "wheel":
              S = Qg;
              break;
            case "copy":
            case "cut":
            case "paste":
              S = Ag;
              break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
              S = Or;
              break;
            case "toggle":
            case "beforetoggle":
              S = kg;
          }
          var k = (e & 4) !== 0, ut = !k && (t === "scroll" || t === "scrollend"), p = k ? b !== null ? b + "Capture" : null : b;
          k = [];
          for (var h = v, E; h !== null; ) {
            var w = h;
            if (E = w.stateNode, w = w.tag, w !== 5 && w !== 26 && w !== 27 || E === null || p === null || (w = Na(h, p), w != null && k.push(
              ru(h, w, E)
            )), ut) break;
            h = h.return;
          }
          0 < k.length && (b = new S(
            b,
            L,
            null,
            n,
            _
          ), M.push({ event: b, listeners: k }));
        }
      }
      if ((e & 7) === 0) {
        t: {
          if (S = t === "mouseover" || t === "pointerover", b = t === "mouseout" || t === "pointerout", S && n !== vs && (L = n.relatedTarget || n.fromElement) && (ul(L) || L[Ul]))
            break t;
          (b || S) && (L = _.window === _ ? _ : (S = _.ownerDocument) ? S.defaultView || S.parentWindow : window, b ? (S = n.relatedTarget || n.toElement, b = v, S = S ? ul(S) : null, S !== null && (ut = z(S), k = S.tag, S !== ut || k !== 5 && k !== 27 && k !== 6) && (S = null)) : (b = null, S = v), b !== S && (k = Tr, w = "onMouseLeave", p = "onMouseEnter", h = "mouse", (t === "pointerout" || t === "pointerover") && (k = Or, w = "onPointerLeave", p = "onPointerEnter", h = "pointer"), ut = b == null ? L : wa(b), E = S == null ? L : wa(S), L = new k(
            w,
            h + "leave",
            b,
            n,
            _
          ), L.target = ut, L.relatedTarget = E, w = null, ul(_) === v && (k = new k(
            p,
            h + "enter",
            S,
            n,
            _
          ), k.target = E, k.relatedTarget = ut, w = k), ut = w, k = b && S ? _t(
            b,
            S,
            Ky
          ) : null, b !== null && _m(
            M,
            L,
            b,
            k,
            !1
          ), S !== null && ut !== null && _m(
            M,
            ut,
            S,
            k,
            !0
          )));
        }
        t: {
          if (b = v ? wa(v) : window, S = b.nodeName && b.nodeName.toLowerCase(), S === "select" || S === "input" && b.type === "file")
            var Z = Dr;
          else if (Nr(b))
            if (Rr)
              Z = ty;
            else {
              Z = Ig;
              var pt = Wg;
            }
          else
            S = b.nodeName, !S || S.toLowerCase() !== "input" || b.type !== "checkbox" && b.type !== "radio" ? v && ys(v.elementType) && (Z = Dr) : Z = Pg;
          if (Z && (Z = Z(t, v))) {
            Ur(
              M,
              Z,
              n,
              _
            );
            break t;
          }
          pt && pt(t, b, v), t === "focusout" && v && b.type === "number" && v.memoizedProps.value != null && gs(b, "number", b.value);
        }
        switch (pt = v ? wa(v) : window, t) {
          case "focusin":
            (Nr(pt) || pt.contentEditable === "true") && (Yl = pt, Ns = v, Ba = null);
            break;
          case "focusout":
            Ba = Ns = Yl = null;
            break;
          case "mousedown":
            Us = !0;
            break;
          case "contextmenu":
          case "mouseup":
          case "dragend":
            Us = !1, Gr(M, n, _);
            break;
          case "selectionchange":
            if (ny) break;
          case "keydown":
          case "keyup":
            Gr(M, n, _);
        }
        var J;
        if (Cs)
          t: {
            switch (t) {
              case "compositionstart":
                var P = "onCompositionStart";
                break t;
              case "compositionend":
                P = "onCompositionEnd";
                break t;
              case "compositionupdate":
                P = "onCompositionUpdate";
                break t;
            }
            P = void 0;
          }
        else
          Ll ? Ar(t, n) && (P = "onCompositionEnd") : t === "keydown" && n.keyCode === 229 && (P = "onCompositionStart");
        P && (zr && n.locale !== "ko" && (Ll || P !== "onCompositionStart" ? P === "onCompositionEnd" && Ll && (J = Sr()) : (qn = _, Es = "value" in qn ? qn.value : qn.textContent, Ll = !0)), pt = Hi(v, P), 0 < pt.length && (P = new _r(
          P,
          t,
          null,
          n,
          _
        ), M.push({ event: P, listeners: pt }), J ? P.data = J : (J = wr(n), J !== null && (P.data = J)))), (J = Zg ? Kg(t, n) : Jg(t, n)) && (P = Hi(v, "onBeforeInput"), 0 < P.length && (pt = new _r(
          "onBeforeInput",
          "beforeinput",
          null,
          n,
          _
        ), M.push({
          event: pt,
          listeners: P
        }), pt.data = J)), Xy(
          M,
          t,
          v,
          n,
          _
        );
      }
      Em(M, e);
    });
  }
  function ru(t, e, n) {
    return {
      instance: t,
      listener: e,
      currentTarget: n
    };
  }
  function Hi(t, e) {
    for (var n = e + "Capture", l = []; t !== null; ) {
      var a = t, u = a.stateNode;
      if (a = a.tag, a !== 5 && a !== 26 && a !== 27 || u === null || (a = Na(t, n), a != null && l.unshift(
        ru(t, a, u)
      ), a = Na(t, e), a != null && l.push(
        ru(t, a, u)
      )), t.tag === 3) return l;
      t = t.return;
    }
    return [];
  }
  function Ky(t) {
    if (t === null) return null;
    do
      t = t.return;
    while (t && t.tag !== 5 && t.tag !== 27);
    return t || null;
  }
  function _m(t, e, n, l, a) {
    for (var u = e._reactName, i = []; n !== null && n !== l; ) {
      var c = n, f = c.alternate, v = c.stateNode;
      if (c = c.tag, f !== null && f === l) break;
      c !== 5 && c !== 26 && c !== 27 || v === null || (f = v, a ? (v = Na(n, u), v != null && i.unshift(
        ru(n, v, f)
      )) : a || (v = Na(n, u), v != null && i.push(
        ru(n, v, f)
      ))), n = n.return;
    }
    i.length !== 0 && t.push({ event: e, listeners: i });
  }
  var Jy = /\r\n?/g, $y = /\u0000|\uFFFD/g;
  function Om(t) {
    return (typeof t == "string" ? t : "" + t).replace(Jy, `
`).replace($y, "");
  }
  function zm(t, e) {
    return e = Om(e), Om(t) === e;
  }
  function Ut(t, e, n, l, a, u) {
    switch (n) {
      case "children":
        if (typeof l == "string")
          e === "body" || e === "textarea" && l === "" || xl(t, l);
        else if (typeof l == "number" || typeof l == "bigint")
          e !== "body" && xl(t, "" + l);
        else return;
        break;
      case "className":
        ju(t, "class", l);
        break;
      case "tabIndex":
        ju(t, "tabindex", l);
        break;
      case "dir":
      case "role":
      case "viewBox":
      case "width":
      case "height":
        ju(t, n, l);
        break;
      case "style":
        vr(t, l, u);
        return;
      case "data":
        if (e !== "object") {
          ju(t, "data", l);
          break;
        }
      case "src":
      case "href":
        if (l === "" && (e !== "a" || n !== "href")) {
          t.removeAttribute(n);
          break;
        }
        if (l == null || typeof l == "function" || typeof l == "symbol" || typeof l == "boolean") {
          t.removeAttribute(n);
          break;
        }
        l = Hu("" + l), t.setAttribute(n, l);
        break;
      case "action":
      case "formAction":
        if (typeof l == "function") {
          t.setAttribute(
            n,
            "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')"
          );
          break;
        } else
          typeof u == "function" && (n === "formAction" ? (e !== "input" && Ut(t, e, "name", a.name, a, null), Ut(
            t,
            e,
            "formEncType",
            a.formEncType,
            a,
            null
          ), Ut(
            t,
            e,
            "formMethod",
            a.formMethod,
            a,
            null
          ), Ut(
            t,
            e,
            "formTarget",
            a.formTarget,
            a,
            null
          )) : (Ut(t, e, "encType", a.encType, a, null), Ut(t, e, "method", a.method, a, null), Ut(t, e, "target", a.target, a, null)));
        if (l == null || typeof l == "symbol" || typeof l == "boolean") {
          t.removeAttribute(n);
          break;
        }
        l = Hu("" + l), t.setAttribute(n, l);
        break;
      case "onClick":
        l != null && (t.onclick = yn);
        return;
      case "onScroll":
        l != null && ht("scroll", t);
        return;
      case "onScrollEnd":
        l != null && ht("scrollend", t);
        return;
      case "dangerouslySetInnerHTML":
        if (l != null) {
          if (typeof l != "object" || !("__html" in l))
            throw Error(o(61));
          if (n = l.__html, n != null) {
            if (a.children != null) throw Error(o(60));
            t.innerHTML = n;
          }
        }
        break;
      case "multiple":
        t.multiple = l && typeof l != "function" && typeof l != "symbol";
        break;
      case "muted":
        t.muted = l && typeof l != "function" && typeof l != "symbol";
        break;
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
      case "defaultValue":
      case "defaultChecked":
      case "innerHTML":
      case "ref":
        break;
      case "autoFocus":
        break;
      case "xlinkHref":
        if (l == null || typeof l == "function" || typeof l == "boolean" || typeof l == "symbol") {
          t.removeAttribute("xlink:href");
          break;
        }
        n = Hu("" + l), t.setAttributeNS(
          "http://www.w3.org/1999/xlink",
          "xlink:href",
          n
        );
        break;
      case "contentEditable":
      case "spellCheck":
      case "draggable":
      case "value":
      case "autoReverse":
      case "externalResourcesRequired":
      case "focusable":
      case "preserveAlpha":
        l != null && typeof l != "function" && typeof l != "symbol" ? t.setAttribute(n, "" + l) : t.removeAttribute(n);
        break;
      case "inert":
      case "allowFullScreen":
      case "async":
      case "autoPlay":
      case "controls":
      case "default":
      case "defer":
      case "disabled":
      case "disablePictureInPicture":
      case "disableRemotePlayback":
      case "formNoValidate":
      case "hidden":
      case "loop":
      case "noModule":
      case "noValidate":
      case "open":
      case "playsInline":
      case "readOnly":
      case "required":
      case "reversed":
      case "scoped":
      case "seamless":
      case "itemScope":
        l && typeof l != "function" && typeof l != "symbol" ? t.setAttribute(n, "") : t.removeAttribute(n);
        break;
      case "capture":
      case "download":
        l === !0 ? t.setAttribute(n, "") : l !== !1 && l != null && typeof l != "function" && typeof l != "symbol" ? t.setAttribute(n, l) : t.removeAttribute(n);
        break;
      case "cols":
      case "rows":
      case "size":
      case "span":
        l != null && typeof l != "function" && typeof l != "symbol" && !isNaN(l) && 1 <= l ? t.setAttribute(n, l) : t.removeAttribute(n);
        break;
      case "rowSpan":
      case "start":
        l == null || typeof l == "function" || typeof l == "symbol" || isNaN(l) ? t.removeAttribute(n) : t.setAttribute(n, l);
        break;
      case "popover":
        ht("beforetoggle", t), ht("toggle", t), qu(t, "popover", l);
        break;
      case "xlinkActuate":
        gn(
          t,
          "http://www.w3.org/1999/xlink",
          "xlink:actuate",
          l
        );
        break;
      case "xlinkArcrole":
        gn(
          t,
          "http://www.w3.org/1999/xlink",
          "xlink:arcrole",
          l
        );
        break;
      case "xlinkRole":
        gn(
          t,
          "http://www.w3.org/1999/xlink",
          "xlink:role",
          l
        );
        break;
      case "xlinkShow":
        gn(
          t,
          "http://www.w3.org/1999/xlink",
          "xlink:show",
          l
        );
        break;
      case "xlinkTitle":
        gn(
          t,
          "http://www.w3.org/1999/xlink",
          "xlink:title",
          l
        );
        break;
      case "xlinkType":
        gn(
          t,
          "http://www.w3.org/1999/xlink",
          "xlink:type",
          l
        );
        break;
      case "xmlBase":
        gn(
          t,
          "http://www.w3.org/XML/1998/namespace",
          "xml:base",
          l
        );
        break;
      case "xmlLang":
        gn(
          t,
          "http://www.w3.org/XML/1998/namespace",
          "xml:lang",
          l
        );
        break;
      case "xmlSpace":
        gn(
          t,
          "http://www.w3.org/XML/1998/namespace",
          "xml:space",
          l
        );
        break;
      case "is":
        qu(t, "is", l);
        break;
      case "innerText":
      case "textContent":
        return;
      default:
        if (!(2 < n.length) || n[0] !== "o" && n[0] !== "O" || n[1] !== "n" && n[1] !== "N")
          n = bg.get(n) || n, qu(t, n, l);
        else return;
    }
    Et = !0;
  }
  function vo(t, e, n, l, a, u) {
    switch (n) {
      case "style":
        vr(t, l, u);
        return;
      case "dangerouslySetInnerHTML":
        if (l != null) {
          if (typeof l != "object" || !("__html" in l))
            throw Error(o(61));
          if (n = l.__html, n != null) {
            if (a.children != null) throw Error(o(60));
            t.innerHTML = n;
          }
        }
        break;
      case "children":
        if (typeof l == "string") xl(t, l);
        else if (typeof l == "number" || typeof l == "bigint")
          xl(t, "" + l);
        else return;
        break;
      case "onScroll":
        l != null && ht("scroll", t);
        return;
      case "onScrollEnd":
        l != null && ht("scrollend", t);
        return;
      case "onClick":
        l != null && (t.onclick = yn);
        return;
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
      case "innerHTML":
      case "ref":
        return;
      case "innerText":
      case "textContent":
        return;
      default:
        if (!sr.hasOwnProperty(n))
          t: {
            if (n[0] === "o" && n[1] === "n" && (a = n.endsWith("Capture"), e = n.slice(2, a ? n.length - 7 : void 0), u = t[Ee] || null, u = u != null ? u[n] : null, typeof u == "function" && t.removeEventListener(e, u, a), typeof l == "function")) {
              typeof u != "function" && u !== null && (n in t ? t[n] = null : t.hasAttribute(n) && t.removeAttribute(n)), t.addEventListener(e, l, a);
              break t;
            }
            Et = !0, n in t ? t[n] = l : l === !0 ? t.setAttribute(n, "") : qu(t, n, l);
          }
        return;
    }
    Et = !0;
  }
  function oe(t, e, n) {
    switch (e) {
      case "div":
      case "span":
      case "svg":
      case "path":
      case "a":
      case "g":
      case "p":
      case "li":
        break;
      case "img":
        ht("error", t), ht("load", t);
        var l = !1, a = !1, u;
        for (u in n)
          if (n.hasOwnProperty(u)) {
            var i = n[u];
            if (i != null)
              switch (u) {
                case "src":
                  l = !0;
                  break;
                case "srcSet":
                  a = !0;
                  break;
                case "children":
                case "dangerouslySetInnerHTML":
                  throw Error(o(137, e));
                default:
                  Ut(t, e, u, i, n, null);
              }
          }
        a && Ut(t, e, "srcSet", n.srcSet, n, null), l && Ut(t, e, "src", n.src, n, null);
        return;
      case "input":
        ht("invalid", t);
        var c = u = i = a = null, f = null, v = null;
        for (l in n)
          if (n.hasOwnProperty(l)) {
            var _ = n[l];
            if (_ != null)
              switch (l) {
                case "name":
                  a = _;
                  break;
                case "type":
                  i = _;
                  break;
                case "checked":
                  f = _;
                  break;
                case "defaultChecked":
                  v = _;
                  break;
                case "value":
                  u = _;
                  break;
                case "defaultValue":
                  c = _;
                  break;
                case "children":
                case "dangerouslySetInnerHTML":
                  if (_ != null)
                    throw Error(o(137, e));
                  break;
                default:
                  Ut(t, e, l, _, n, null);
              }
          }
        mr(
          t,
          u,
          c,
          f,
          v,
          i,
          a,
          !1
        );
        return;
      case "select":
        ht("invalid", t), l = i = u = null;
        for (a in n)
          if (n.hasOwnProperty(a) && (c = n[a], c != null))
            switch (a) {
              case "value":
                u = c;
                break;
              case "defaultValue":
                i = c;
                break;
              case "multiple":
                l = c;
              default:
                Ut(t, e, a, c, n, null);
            }
        e = u, n = i, t.multiple = !!l, e != null ? jl(t, !!l, e, !1) : n != null && jl(t, !!l, n, !0);
        return;
      case "textarea":
        ht("invalid", t), u = a = l = null;
        for (i in n)
          if (n.hasOwnProperty(i) && (c = n[i], c != null))
            switch (i) {
              case "value":
                l = c;
                break;
              case "defaultValue":
                a = c;
                break;
              case "children":
                u = c;
                break;
              case "dangerouslySetInnerHTML":
                if (c != null) throw Error(o(91));
                break;
              default:
                Ut(t, e, i, c, n, null);
            }
        gr(t, l, a, u);
        return;
      case "option":
        for (f in n)
          if (n.hasOwnProperty(f) && (l = n[f], l != null))
            switch (f) {
              case "selected":
                t.selected = l && typeof l != "function" && typeof l != "symbol";
                break;
              default:
                Ut(t, e, f, l, n, null);
            }
        return;
      case "dialog":
        ht("beforetoggle", t), ht("toggle", t), ht("cancel", t), ht("close", t);
        break;
      case "iframe":
      case "object":
        ht("load", t);
        break;
      case "video":
      case "audio":
        for (l = 0; l < ou.length; l++)
          ht(ou[l], t);
        break;
      case "image":
        ht("error", t), ht("load", t);
        break;
      case "details":
        ht("toggle", t);
        break;
      case "embed":
      case "source":
      case "link":
        ht("error", t), ht("load", t);
      case "area":
      case "base":
      case "br":
      case "col":
      case "hr":
      case "keygen":
      case "meta":
      case "param":
      case "track":
      case "wbr":
      case "menuitem":
        for (v in n)
          if (n.hasOwnProperty(v) && (l = n[v], l != null))
            switch (v) {
              case "children":
              case "dangerouslySetInnerHTML":
                throw Error(o(137, e));
              default:
                Ut(t, e, v, l, n, null);
            }
        return;
      default:
        if (ys(e)) {
          for (_ in n)
            n.hasOwnProperty(_) && (l = n[_], l !== void 0 && vo(
              t,
              e,
              _,
              l,
              n,
              void 0
            ));
          return;
        }
    }
    for (c in n)
      n.hasOwnProperty(c) && (l = n[c], l != null && Ut(t, e, c, l, n, null));
  }
  function Fy(t, e, n, l) {
    switch (e) {
      case "div":
      case "span":
      case "svg":
      case "path":
      case "a":
      case "g":
      case "p":
      case "li":
        break;
      case "input":
        var a = null, u = null, i = null, c = null, f = null, v = null, _ = null;
        for (S in n) {
          var M = n[S];
          if (n.hasOwnProperty(S) && M != null)
            switch (S) {
              case "checked":
                break;
              case "value":
                break;
              case "defaultValue":
                f = M;
              default:
                l.hasOwnProperty(S) || Ut(t, e, S, null, l, M);
            }
        }
        for (var b in l) {
          var S = l[b];
          if (M = n[b], l.hasOwnProperty(b) && (S != null || M != null))
            switch (b) {
              case "type":
                S !== M && (Et = !0), u = S;
                break;
              case "name":
                S !== M && (Et = !0), a = S;
                break;
              case "checked":
                S !== M && (Et = !0), v = S;
                break;
              case "defaultChecked":
                S !== M && (Et = !0), _ = S;
                break;
              case "value":
                S !== M && (Et = !0), i = S;
                break;
              case "defaultValue":
                S !== M && (Et = !0), c = S;
                break;
              case "children":
              case "dangerouslySetInnerHTML":
                if (S != null)
                  throw Error(o(137, e));
                break;
              default:
                S !== M && Ut(
                  t,
                  e,
                  b,
                  S,
                  l,
                  M
                );
            }
        }
        hs(
          t,
          i,
          c,
          f,
          v,
          _,
          u,
          a
        );
        return;
      case "select":
        S = i = c = b = null;
        for (u in n)
          if (f = n[u], n.hasOwnProperty(u) && f != null)
            switch (u) {
              case "value":
                break;
              case "multiple":
                S = f;
              default:
                l.hasOwnProperty(u) || Ut(
                  t,
                  e,
                  u,
                  null,
                  l,
                  f
                );
            }
        for (a in l)
          if (u = l[a], f = n[a], l.hasOwnProperty(a) && (u != null || f != null))
            switch (a) {
              case "value":
                u !== f && (Et = !0), b = u;
                break;
              case "defaultValue":
                u !== f && (Et = !0), c = u;
                break;
              case "multiple":
                u !== f && (Et = !0), i = u;
              default:
                u !== f && Ut(
                  t,
                  e,
                  a,
                  u,
                  l,
                  f
                );
            }
        e = c, n = i, l = S, b != null ? jl(t, !!n, b, !1) : !!l != !!n && (e != null ? jl(t, !!n, e, !0) : jl(t, !!n, n ? [] : "", !1));
        return;
      case "textarea":
        S = b = null;
        for (c in n)
          if (a = n[c], n.hasOwnProperty(c) && a != null && !l.hasOwnProperty(c))
            switch (c) {
              case "value":
                break;
              case "children":
                break;
              default:
                Ut(t, e, c, null, l, a);
            }
        for (i in l)
          if (a = l[i], u = n[i], l.hasOwnProperty(i) && (a != null || u != null))
            switch (i) {
              case "value":
                a !== u && (Et = !0), b = a;
                break;
              case "defaultValue":
                a !== u && (Et = !0), S = a;
                break;
              case "children":
                break;
              case "dangerouslySetInnerHTML":
                if (a != null) throw Error(o(91));
                break;
              default:
                a !== u && Ut(t, e, i, a, l, u);
            }
        hr(t, b, S);
        return;
      case "option":
        for (var L in n)
          if (b = n[L], n.hasOwnProperty(L) && b != null && !l.hasOwnProperty(L))
            switch (L) {
              case "selected":
                t.selected = !1;
                break;
              default:
                Ut(
                  t,
                  e,
                  L,
                  null,
                  l,
                  b
                );
            }
        for (f in l)
          if (b = l[f], S = n[f], l.hasOwnProperty(f) && b !== S && (b != null || S != null))
            switch (f) {
              case "selected":
                b !== S && (Et = !0), t.selected = b && typeof b != "function" && typeof b != "symbol";
                break;
              default:
                Ut(
                  t,
                  e,
                  f,
                  b,
                  l,
                  S
                );
            }
        return;
      case "img":
      case "link":
      case "area":
      case "base":
      case "br":
      case "col":
      case "embed":
      case "hr":
      case "keygen":
      case "meta":
      case "param":
      case "source":
      case "track":
      case "wbr":
      case "menuitem":
        for (var k in n)
          b = n[k], n.hasOwnProperty(k) && b != null && !l.hasOwnProperty(k) && Ut(t, e, k, null, l, b);
        for (v in l)
          if (b = l[v], S = n[v], l.hasOwnProperty(v) && b !== S && (b != null || S != null))
            switch (v) {
              case "children":
              case "dangerouslySetInnerHTML":
                if (b != null)
                  throw Error(o(137, e));
                break;
              default:
                Ut(
                  t,
                  e,
                  v,
                  b,
                  l,
                  S
                );
            }
        return;
      default:
        if (ys(e)) {
          for (var ut in n)
            b = n[ut], n.hasOwnProperty(ut) && b !== void 0 && !l.hasOwnProperty(ut) && vo(
              t,
              e,
              ut,
              void 0,
              l,
              b
            );
          for (_ in l)
            b = l[_], S = n[_], !l.hasOwnProperty(_) || b === S || b === void 0 && S === void 0 || vo(
              t,
              e,
              _,
              b,
              l,
              S
            );
          return;
        }
    }
    for (var p in n)
      b = n[p], n.hasOwnProperty(p) && b != null && !l.hasOwnProperty(p) && Ut(t, e, p, null, l, b);
    for (M in l)
      b = l[M], S = n[M], !l.hasOwnProperty(M) || b === S || b == null && S == null || Ut(t, e, M, b, l, S);
  }
  function Cm(t) {
    switch (t) {
      case "css":
      case "script":
      case "font":
      case "img":
      case "image":
      case "input":
      case "link":
        return !0;
      default:
        return !1;
    }
  }
  function Wy() {
    if (typeof performance.getEntriesByType == "function") {
      for (var t = 0, e = 0, n = performance.getEntriesByType("resource"), l = 0; l < n.length; l++) {
        var a = n[l], u = a.transferSize, i = a.initiatorType, c = a.duration;
        if (u && c && Cm(i)) {
          for (i = 0, c = a.responseEnd, l += 1; l < n.length; l++) {
            var f = n[l], v = f.startTime;
            if (v > c) break;
            var _ = f.transferSize, M = f.initiatorType;
            _ && Cm(M) && (f = f.responseEnd, i += _ * (f < c ? 1 : (c - v) / (f - v)));
          }
          if (--l, e += 8 * (u + i) / (a.duration / 1e3), t++, 10 < t) break;
        }
      }
      if (0 < t) return e / t / 1e6;
    }
    return navigator.connection && (t = navigator.connection.downlink, typeof t == "number") ? t : 5;
  }
  var po = null, bo = null;
  function Bi(t) {
    return t.nodeType === 9 ? t : t.ownerDocument;
  }
  function Mm(t) {
    switch (t) {
      case "http://www.w3.org/2000/svg":
        return 1;
      case "http://www.w3.org/1998/Math/MathML":
        return 2;
      default:
        return 0;
    }
  }
  function Am(t, e) {
    if (t === 0)
      switch (e) {
        case "svg":
          return 1;
        case "math":
          return 2;
        default:
          return 0;
      }
    return t === 1 && e === "foreignObject" ? 0 : t;
  }
  function So(t, e) {
    return t === "textarea" || t === "noscript" || typeof e.children == "string" || typeof e.children == "number" || typeof e.children == "bigint" || typeof e.dangerouslySetInnerHTML == "object" && e.dangerouslySetInnerHTML !== null && e.dangerouslySetInnerHTML.__html != null;
  }
  var Eo = null;
  function Iy() {
    var t = window.event;
    return t && t.type === "popstate" ? t === Eo ? !1 : (Eo = t, !0) : (Eo = null, !1);
  }
  var wm = typeof setTimeout == "function" ? setTimeout : void 0, Py = typeof clearTimeout == "function" ? clearTimeout : void 0, Nm = typeof Promise == "function" ? Promise : void 0, tv = typeof queueMicrotask == "function" ? queueMicrotask : typeof Nm < "u" ? function(t) {
    return Nm.resolve(null).then(t).catch(ev);
  } : wm;
  function ev(t) {
    setTimeout(function() {
      throw t;
    });
  }
  function Wn(t) {
    return t === "head";
  }
  function Um(t, e) {
    var n = e, l = 0;
    do {
      var a = n.nextSibling;
      if (t.removeChild(n), a && a.nodeType === 8)
        if (n = a.data, n === "/$" || n === "/&") {
          if (l === 0) {
            t.removeChild(a), va(e);
            return;
          }
          l--;
        } else if (n === "$" || n === "$?" || n === "$~" || n === "$!" || n === "&")
          l++;
        else if (n === "html")
          fu(t.ownerDocument.documentElement);
        else if (n === "head") {
          n = t.ownerDocument.head, fu(n);
          for (var u = n.firstChild; u; ) {
            var i = u.nextSibling, c = u.nodeName;
            u[Aa] || c === "SCRIPT" || c === "STYLE" || c === "LINK" && u.rel.toLowerCase() === "stylesheet" || n.removeChild(u), u = i;
          }
        } else
          n === "body" && fu(t.ownerDocument.body);
      n = a;
    } while (n);
    va(e);
  }
  function Dm(t, e) {
    var n = t;
    t = 0;
    do {
      var l = n.nextSibling;
      if (n.nodeType === 1 ? e ? (n._stashedDisplay = n.style.display, n.style.display = "none") : (n.style.display = n._stashedDisplay || "", n.getAttribute("style") === "" && n.removeAttribute("style")) : n.nodeType === 3 && (e ? (n._stashedText = n.nodeValue, n.nodeValue = "") : n.nodeValue = n._stashedText || ""), l && l.nodeType === 8)
        if (n = l.data, n === "/$") {
          if (t === 0) break;
          t--;
        } else
          n !== "$" && n !== "$?" && n !== "$~" && n !== "$!" || t++;
      n = l;
    } while (n);
  }
  function Rm(t, e, n) {
    if (e = CSS.escape(e) !== e ? "r-" + btoa(e).replace(/=/g, "") : e, t.style.viewTransitionName = e, n != null && (t.style.viewTransitionClass = n), n = getComputedStyle(t), n.display === "inline") {
      if (e = t.getClientRects(), e.length === 1) var l = 1;
      else
        for (var a = l = 0; a < e.length; a++) {
          var u = e[a];
          0 < u.width && 0 < u.height && l++;
        }
      l === 1 && (t = t.style, t.display = e.length === 1 ? "inline-block" : "block", t.marginTop = "-" + n.paddingTop, t.marginBottom = "-" + n.paddingBottom);
    }
  }
  function qm(t, e) {
    t = t.style, e = e.style;
    var n = e != null ? e.hasOwnProperty("viewTransitionName") ? e.viewTransitionName : e.hasOwnProperty("view-transition-name") ? e["view-transition-name"] : null : null;
    t.viewTransitionName = n == null || typeof n == "boolean" ? "" : ("" + n).trim(), n = e != null ? e.hasOwnProperty("viewTransitionClass") ? e.viewTransitionClass : e.hasOwnProperty("view-transition-class") ? e["view-transition-class"] : null : null, t.viewTransitionClass = n == null || typeof n == "boolean" ? "" : ("" + n).trim(), t.display === "inline-block" && (e == null ? t.display = t.margin = "" : (n = e.display, t.display = n == null || typeof n == "boolean" ? "" : n, n = e.margin, n != null ? t.margin = n : (n = e.hasOwnProperty("marginTop") ? e.marginTop : e["margin-top"], t.marginTop = n == null || typeof n == "boolean" ? "" : n, e = e.hasOwnProperty("marginBottom") ? e.marginBottom : e["margin-bottom"], t.marginBottom = e == null || typeof e == "boolean" ? "" : e)));
  }
  function nv(t, e, n) {
    return n = n.ownerDocument.defaultView, {
      rect: t,
      abs: e.position === "absolute" || e.position === "fixed",
      clip: e.clipPath !== "none" || e.overflow !== "visible" || e.filter !== "none" || e.mask !== "none" || e.mask !== "none" || e.borderRadius !== "0px",
      view: 0 <= t.bottom && 0 <= t.right && t.top <= n.innerHeight && t.left <= n.innerWidth
    };
  }
  function To(t) {
    var e = t.getBoundingClientRect(), n = getComputedStyle(t);
    return nv(e, n, t);
  }
  function lv(t) {
    return t.documentElement.clientHeight;
  }
  function av(t) {
    this.addEventListener("load", t), this.addEventListener("error", t);
  }
  function uv(t, e, n, l, a, u, i, c, f) {
    var v = e.nodeType === 9 ? e : e.ownerDocument;
    try {
      var _ = v.startViewTransition({
        update: function() {
          var M = v.defaultView, b = M.navigation && M.navigation.transition, S = v.fonts.status;
          l();
          var L = [];
          if (S === "loaded" && (lv(v), v.fonts.status === "loading" && L.push(v.fonts.ready)), S = L.length, t !== null)
            for (var k = t.suspenseyImages, ut = 0, p = 0; p < k.length; p++) {
              var h = k[p];
              if (!h.complete) {
                var E = h.getBoundingClientRect();
                if (0 < E.bottom && 0 < E.right && E.top < M.innerHeight && E.left < M.innerWidth) {
                  if (ut += Pm(h), ut > Qi) {
                    L.length = S;
                    break;
                  }
                  h = new Promise(
                    av.bind(h)
                  ), L.push(h);
                }
              }
            }
          if (0 < L.length)
            return M = Promise.race([
              Promise.all(L),
              new Promise(function(w) {
                return setTimeout(w, 500);
              })
            ]).then(a, a), (b ? Promise.allSettled([b.finished, M]) : M).then(u, u);
          if (a(), b)
            return b.finished.then(
              u,
              u
            );
          u();
        },
        types: n
      });
      return v.__reactViewTransition = _, _.ready.then(
        function() {
          for (var M = v.documentElement.getAnimations({
            subtree: !0
          }), b = 0; b < M.length; b++) {
            var S = M[b].effect, L = S.pseudoElement;
            if (L != null && L.startsWith("::view-transition")) {
              L = S.getKeyframes();
              for (var k = void 0, ut = void 0, p = !0, h = 0; h < L.length; h++) {
                var E = L[h], w = E.width;
                if (k === void 0) k = w;
                else if (k !== w) {
                  p = !1;
                  break;
                }
                if (w = E.height, ut === void 0) ut = w;
                else if (ut !== w) {
                  p = !1;
                  break;
                }
                delete E.width, delete E.height, E.transform === "none" && delete E.transform;
              }
              p && k !== void 0 && ut !== void 0 && (S.setKeyframes(L), p = getComputedStyle(
                S.target,
                S.pseudoElement
              ), p.width !== k || p.height !== ut) && (p = L[0], p.width = k, p.height = ut, p = L[L.length - 1], p.width = k, p.height = ut, S.setKeyframes(L));
            }
          }
          i();
        },
        function(M) {
          v.__reactViewTransition === _ && (v.__reactViewTransition = null);
          try {
            if (typeof M == "object" && M !== null)
              switch (M.name) {
                case "InvalidStateError":
                  (M.message === "View transition was skipped because document visibility state is hidden." || M.message === "Skipping view transition because document visibility state has become hidden." || M.message === "Skipping view transition because viewport size changed." || M.message === "Transition was aborted because of invalid state") && (M = null);
              }
            M !== null && f(M);
          } finally {
            l(), a(), i();
          }
        }
      ), _.finished.finally(function() {
        for (var M = v.documentElement, b = M.getAnimations({ subtree: !0 }), S = 0; S < b.length; S++) {
          var L = b[S], k = L.effect, ut = k.pseudoElement;
          ut != null && ut.startsWith("::view-transition") && k.target === M && L.cancel();
        }
        v.__reactViewTransition === _ && (v.__reactViewTransition = null), c();
      }), _;
    } catch {
      return l(), a(), i(), null;
    }
  }
  function Ml(t, e) {
    this._scope = document.documentElement, this._selector = "::view-transition-" + t + "(" + e + ")";
  }
  Ml.prototype.animate = function(t, e) {
    return e = typeof e == "number" ? { duration: e } : W({}, e), e.pseudoElement = this._selector, this._scope.animate(t, e);
  }, Ml.prototype.getAnimations = function() {
    for (var t = this._scope, e = this._selector, n = t.getAnimations({ subtree: !0 }), l = [], a = 0; a < n.length; a++) {
      var u = n[a].effect;
      u !== null && u.target === t && u.pseudoElement === e && l.push(n[a]);
    }
    return l;
  }, Ml.prototype.getComputedStyle = function() {
    return getComputedStyle(this._scope, this._selector);
  };
  function jm(t) {
    return {
      name: t,
      group: new Ml("group", t),
      imagePair: new Ml("image-pair", t),
      old: new Ml("old", t),
      new: new Ml("new", t)
    };
  }
  function Be(t) {
    this._fragmentFiber = t, this._observers = this._eventListeners = null;
  }
  Be.prototype.addEventListener = function(t, e, n) {
    this._eventListeners === null && (this._eventListeners = []);
    var l = this._eventListeners;
    Hm(l, t, e, n) === -1 && (l.push({
      type: t,
      listener: e,
      optionsOrUseCapture: n
    }), j(
      this._fragmentFiber.child,
      !1,
      iv,
      t,
      e,
      n
    )), this._eventListeners = l;
  };
  function iv(t, e, n, l) {
    return gt(t).addEventListener(
      e,
      n,
      l
    ), !1;
  }
  Be.prototype.removeEventListener = function(t, e, n) {
    var l = this._eventListeners;
    l !== null && typeof l < "u" && 0 < l.length && (j(
      this._fragmentFiber.child,
      !1,
      sv,
      t,
      e,
      n
    ), t = Hm(
      l,
      t,
      e,
      n
    ), this._eventListeners !== null && this._eventListeners.splice(t, 1));
  };
  function sv(t, e, n, l) {
    return gt(t).removeEventListener(
      e,
      n,
      l
    ), !1;
  }
  function xm(t) {
    return t == null ? "0" : typeof t == "boolean" ? "c=" + (t ? "1" : "0") : "c=" + (t.capture ? "1" : "0") + "&o=" + (t.once ? "1" : "0") + "&p=" + (t.passive ? "1" : "0");
  }
  function Hm(t, e, n, l) {
    for (var a = 0; a < t.length; a++) {
      var u = t[a];
      if (u.type === e && u.listener === n && xm(u.optionsOrUseCapture) === xm(l))
        return a;
    }
    return -1;
  }
  Be.prototype.dispatchEvent = function(t) {
    var e = $(this._fragmentFiber);
    if (e === null) return !0;
    e = gt(e);
    var n = this._eventListeners;
    if (n !== null && 0 < n.length || !t.bubbles) {
      var l = document.createTextNode("");
      if (n)
        for (var a = 0; a < n.length; a++) {
          var u = n[a];
          l.addEventListener(
            u.type,
            u.listener,
            u.optionsOrUseCapture
          );
        }
      if (e.appendChild(l), t = l.dispatchEvent(t), n)
        for (a = 0; a < n.length; a++)
          u = n[a], l.removeEventListener(
            u.type,
            u.listener,
            u.optionsOrUseCapture
          );
      return e.removeChild(l), t;
    }
    return e.dispatchEvent(t);
  }, Be.prototype.focus = function(t) {
    j(
      this._fragmentFiber.child,
      !0,
      Bm,
      t,
      void 0,
      void 0
    );
  };
  function Bm(t, e) {
    return t = gt(t), yv(t, e);
  }
  Be.prototype.focusLast = function(t) {
    var e = [];
    j(
      this._fragmentFiber.child,
      !0,
      _o,
      e,
      void 0,
      void 0
    );
    for (var n = e.length - 1; 0 <= n && !Bm(e[n], t); n--) ;
  };
  function _o(t, e) {
    return e.push(t), !1;
  }
  Be.prototype.blur = function() {
    j(
      this._fragmentFiber.child,
      !1,
      cv,
      void 0,
      void 0,
      void 0
    );
  };
  function cv(t) {
    return t = gt(t), t === t.ownerDocument.activeElement ? (t.blur(), !0) : !1;
  }
  Be.prototype.observeUsing = function(t) {
    this._observers === null && (this._observers = /* @__PURE__ */ new Set()), this._observers.add(t), j(
      this._fragmentFiber.child,
      !1,
      ov,
      t,
      void 0,
      void 0
    );
  };
  function ov(t, e) {
    return t = gt(t), e.observe(t), !1;
  }
  Be.prototype.unobserveUsing = function(t) {
    var e = this._observers;
    e !== null && e.has(t) && (e.delete(t), j(
      this._fragmentFiber.child,
      !1,
      rv,
      t,
      void 0,
      void 0
    ));
  };
  function rv(t, e) {
    return t = gt(t), e.unobserve(t), !1;
  }
  Be.prototype.getClientRects = function() {
    var t = [];
    return j(
      this._fragmentFiber.child,
      !1,
      fv,
      t,
      void 0,
      void 0
    ), t;
  };
  function fv(t, e) {
    return t = gt(t), e.push.apply(e, t.getClientRects()), !1;
  }
  Be.prototype.getRootNode = function(t) {
    var e = $(this._fragmentFiber);
    return e === null ? this : gt(e).getRootNode(t);
  }, Be.prototype.compareDocumentPosition = function(t) {
    var e = $(this._fragmentFiber);
    if (e === null) return Node.DOCUMENT_POSITION_DISCONNECTED;
    var n = [];
    j(
      this._fragmentFiber.child,
      !1,
      _o,
      n,
      void 0,
      void 0
    );
    var l = gt(e);
    if (n.length === 0) {
      n = this._fragmentFiber;
      var a = l.compareDocumentPosition(t);
      return e = a, l === t ? e = Node.DOCUMENT_POSITION_CONTAINS : a & Node.DOCUMENT_POSITION_CONTAINED_BY && (j(n.sibling, !1, wt), n = ct, ct = null, n === null ? e = Node.DOCUMENT_POSITION_PRECEDING : (t = gt(n).compareDocumentPosition(
        t
      ), e = t === 0 || t & Node.DOCUMENT_POSITION_FOLLOWING ? Node.DOCUMENT_POSITION_FOLLOWING : Node.DOCUMENT_POSITION_PRECEDING)), e |= Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC;
    }
    e = gt(n[0]), a = gt(n[n.length - 1]);
    for (var u = gt(n[0]), i = !1, c = this._fragmentFiber.return; c !== null && (c.tag === 4 && (i = !0), !(c.tag === 3 || c.tag === 5)); )
      c = c.return;
    if (u = i ? u.parentElement : l, u == null) return Node.DOCUMENT_POSITION_DISCONNECTED;
    l = u.compareDocumentPosition(e) & Node.DOCUMENT_POSITION_CONTAINED_BY, u = u.compareDocumentPosition(a) & Node.DOCUMENT_POSITION_CONTAINED_BY, i = e.compareDocumentPosition(t);
    var f = a.compareDocumentPosition(t);
    return c = i & Node.DOCUMENT_POSITION_CONTAINED_BY || f & Node.DOCUMENT_POSITION_CONTAINED_BY, f = l && u && i & Node.DOCUMENT_POSITION_FOLLOWING && f & Node.DOCUMENT_POSITION_PRECEDING, e = l && e === t || u && a === t || c || f ? Node.DOCUMENT_POSITION_CONTAINED_BY : !l && e === t || !u && a === t ? Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC : i, e & Node.DOCUMENT_POSITION_DISCONNECTED || e & Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC || dv(
      e,
      this._fragmentFiber,
      n[0],
      n[n.length - 1],
      t
    ) ? e : Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC;
  };
  function dv(t, e, n, l, a) {
    var u = ul(a);
    if (t & Node.DOCUMENT_POSITION_CONTAINED_BY) {
      if (n = !!u)
        t: {
          for (; u !== null; ) {
            if (u.tag === 7 && (u === e || u.alternate === e)) {
              n = !0;
              break t;
            }
            u = u.return;
          }
          n = !1;
        }
      return n;
    }
    if (t & Node.DOCUMENT_POSITION_CONTAINS) {
      if (u === null)
        return u = a.ownerDocument, a === u || a === u.body;
      t: {
        for (u = e, e = $(e); u !== null; ) {
          if (!(u.tag !== 5 && u.tag !== 3 || u !== e && u.alternate !== e)) {
            u = !0;
            break t;
          }
          u = u.return;
        }
        u = !1;
      }
      return u;
    }
    return t & Node.DOCUMENT_POSITION_PRECEDING ? ((e = !!u) && !(e = u === n) && (e = _t(
      n,
      u,
      it
    ), e === null ? e = !1 : (j(
      e,
      !0,
      yt,
      u,
      n
    ), u = ct, ct = null, e = u !== null)), e) : t & Node.DOCUMENT_POSITION_FOLLOWING ? ((e = !!u) && !(e = u === l) && (e = _t(
      l,
      u,
      it
    ), e === null ? e = !1 : (j(
      e,
      !0,
      X,
      u,
      l
    ), u = ct, G = ct = null, e = u !== null)), e) : !1;
  }
  Be.prototype.scrollIntoView = function(t) {
    if (typeof t == "object") throw Error(o(566));
    var e = [];
    j(
      this._fragmentFiber.child,
      !1,
      _o,
      e,
      void 0,
      void 0
    );
    var n = t !== !1;
    if (e.length === 0) {
      e = this._fragmentFiber;
      var l = [null, null], a = $(e);
      a !== null && ft(l, e, a.child), n = n ? l[1] || l[0] || $(this._fragmentFiber) : l[0] || l[1], n !== null && gt(n).scrollIntoView(t);
    } else
      for (l = n ? e.length - 1 : 0; l !== (n ? -1 : e.length); )
        gt(e[l]).scrollIntoView(t), l += n ? -1 : 1;
  };
  function Lm(t, e) {
    var n = e._eventListeners;
    if (n !== null)
      for (var l = 0; l < n.length; l++) {
        var a = n[l];
        t.addEventListener(
          a.type,
          a.listener,
          a.optionsOrUseCapture
        );
      }
    e._observers !== null && e._observers.forEach(function(u) {
      u.observe(t);
    });
  }
  function Oo(t) {
    var e = t.firstChild;
    for (e && e.nodeType === 10 && (e = e.nextSibling); e; ) {
      var n = e;
      switch (e = e.nextSibling, n.nodeName) {
        case "HTML":
        case "HEAD":
        case "BODY":
          Oo(n), ds(n);
          continue;
        case "SCRIPT":
        case "STYLE":
          continue;
        case "LINK":
          if (n.rel.toLowerCase() === "stylesheet") continue;
      }
      t.removeChild(n);
    }
  }
  function mv(t, e, n, l) {
    for (; t.nodeType === 1; ) {
      var a = n;
      if (t.nodeName.toLowerCase() !== e.toLowerCase()) {
        if (!l && (t.nodeName !== "INPUT" || t.type !== "hidden"))
          break;
      } else if (l) {
        if (!t[Aa])
          switch (e) {
            case "meta":
              if (!t.hasAttribute("itemprop")) break;
              return t;
            case "link":
              if (u = t.getAttribute("rel"), u === "stylesheet" && t.hasAttribute("data-precedence"))
                break;
              if (u !== a.rel || t.getAttribute("href") !== (a.href == null || a.href === "" ? null : a.href) || t.getAttribute("crossorigin") !== (a.crossOrigin == null ? null : a.crossOrigin) || t.getAttribute("title") !== (a.title == null ? null : a.title))
                break;
              return t;
            case "style":
              if (t.hasAttribute("data-precedence")) break;
              return t;
            case "script":
              if (u = t.getAttribute("src"), (u !== (a.src == null ? null : a.src) || t.getAttribute("type") !== (a.type == null ? null : a.type) || t.getAttribute("crossorigin") !== (a.crossOrigin == null ? null : a.crossOrigin)) && u && t.hasAttribute("async") && !t.hasAttribute("itemprop"))
                break;
              return t;
            default:
              return t;
          }
      } else if (e === "input" && t.type === "hidden") {
        var u = a.name == null ? null : "" + a.name;
        if (a.type === "hidden" && t.getAttribute("name") === u)
          return t;
      } else return t;
      if (t = $e(t.nextSibling), t === null) break;
    }
    return null;
  }
  function hv(t, e, n) {
    if (e === "") return null;
    for (; t.nodeType !== 3; )
      if ((t.nodeType !== 1 || t.nodeName !== "INPUT" || t.type !== "hidden") && !n || (t = $e(t.nextSibling), t === null)) return null;
    return t;
  }
  function Ym(t, e) {
    for (; t.nodeType !== 8; )
      if ((t.nodeType !== 1 || t.nodeName !== "INPUT" || t.type !== "hidden") && !e || (t = $e(t.nextSibling), t === null)) return null;
    return t;
  }
  function zo(t) {
    return t.data === "$?" || t.data === "$~";
  }
  function Co(t) {
    return t.data === "$!" || t.data === "$?" && t.ownerDocument.readyState !== "loading";
  }
  function gv(t, e) {
    var n = t.ownerDocument;
    if (t.data === "$~") t._reactRetry = e;
    else if (t.data !== "$?" || n.readyState !== "loading")
      e();
    else {
      var l = function() {
        e(), n.removeEventListener("DOMContentLoaded", l);
      };
      n.addEventListener("DOMContentLoaded", l), t._reactRetry = l;
    }
  }
  function $e(t) {
    for (; t != null; t = t.nextSibling) {
      var e = t.nodeType;
      if (e === 1 || e === 3) break;
      if (e === 8) {
        if (e = t.data, e === "$" || e === "$!" || e === "$?" || e === "$~" || e === "&" || e === "F!" || e === "F")
          break;
        if (e === "/$" || e === "/&") return null;
      }
    }
    return t;
  }
  var Mo = null;
  function Gm(t) {
    t = t.nextSibling;
    for (var e = 0; t; ) {
      if (t.nodeType === 8) {
        var n = t.data;
        if (n === "/$" || n === "/&") {
          if (e === 0)
            return $e(t.nextSibling);
          e--;
        } else
          n !== "$" && n !== "$!" && n !== "$?" && n !== "$~" && n !== "&" || e++;
      }
      t = t.nextSibling;
    }
    return null;
  }
  function Qm(t) {
    t = t.previousSibling;
    for (var e = 0; t; ) {
      if (t.nodeType === 8) {
        var n = t.data;
        if (n === "$" || n === "$!" || n === "$?" || n === "$~" || n === "&") {
          if (e === 0) return t;
          e--;
        } else n !== "/$" && n !== "/&" || e++;
      }
      t = t.previousSibling;
    }
    return null;
  }
  function yv(t, e) {
    function n() {
      l = !0;
    }
    var l = !1;
    try {
      t.addEventListener("focus", n), (t.focus || HTMLElement.prototype.focus).call(t, e);
    } finally {
      t.removeEventListener("focus", n);
    }
    return l;
  }
  function Xm(t, e, n) {
    switch (e = Bi(n), t) {
      case "html":
        if (t = e.documentElement, !t) throw Error(o(452));
        return t;
      case "head":
        if (t = e.head, !t) throw Error(o(453));
        return t;
      case "body":
        if (t = e.body, !t) throw Error(o(454));
        return t;
      default:
        throw Error(o(451));
    }
  }
  function fu(t) {
    for (var e = t.attributes; e.length; )
      t.removeAttributeNode(e[0]);
    ds(t);
  }
  var Fe = /* @__PURE__ */ new Map(), km = /* @__PURE__ */ new Set();
  function Li(t) {
    return typeof t.getRootNode == "function" ? t.getRootNode() : t.nodeType === 9 ? t : t.ownerDocument;
  }
  var Nn = x.d;
  x.d = {
    f: vv,
    r: pv,
    D: bv,
    C: Sv,
    L: Ev,
    m: Tv,
    X: Ov,
    S: _v,
    M: zv
  };
  function vv() {
    var t = Nn.f(), e = Ui();
    return t || e;
  }
  function pv(t) {
    var e = Dl(t);
    e !== null && e.tag === 5 && e.type === "form" ? $f(e) : Nn.r(t);
  }
  var ha = typeof document > "u" ? null : document;
  function Vm(t, e, n) {
    var l = ha;
    if (l && typeof e == "string" && e) {
      var a = Ge(e);
      a = 'link[rel="' + t + '"][href="' + a + '"]', typeof n == "string" && (a += '[crossorigin="' + n + '"]'), km.has(a) || (km.add(a), t = { rel: t, crossOrigin: n, href: e }, l.querySelector(a) === null && (e = l.createElement("link"), oe(e, "link", t), te(e), l.head.appendChild(e)));
    }
  }
  function bv(t) {
    Nn.D(t), Vm("dns-prefetch", t, null);
  }
  function Sv(t, e) {
    Nn.C(t, e), Vm("preconnect", t, e);
  }
  function Ev(t, e, n) {
    Nn.L(t, e, n);
    var l = ha;
    if (l && t && e) {
      var a = 'link[rel="preload"][as="' + Ge(e) + '"]';
      e === "image" && n && n.imageSrcSet ? (a += '[imagesrcset="' + Ge(
        n.imageSrcSet
      ) + '"]', typeof n.imageSizes == "string" && (a += '[imagesizes="' + Ge(
        n.imageSizes
      ) + '"]')) : a += '[href="' + Ge(t) + '"]';
      var u = a;
      switch (e) {
        case "style":
          u = ga(t);
          break;
        case "script":
          u = ya(t);
      }
      Fe.has(u) || (t = W(
        {
          rel: "preload",
          href: e === "image" && n && n.imageSrcSet ? void 0 : t,
          as: e
        },
        n
      ), Fe.set(u, t), l.querySelector(a) !== null || e === "style" && l.querySelector(du(u)) || e === "script" && l.querySelector(mu(u)) || (e = l.createElement("link"), oe(e, "link", t), te(e), l.head.appendChild(e)));
    }
  }
  function Tv(t, e) {
    Nn.m(t, e);
    var n = ha;
    if (n && t) {
      var l = e && typeof e.as == "string" ? e.as : "script", a = 'link[rel="modulepreload"][as="' + Ge(l) + '"][href="' + Ge(t) + '"]', u = a;
      switch (l) {
        case "audioworklet":
        case "paintworklet":
        case "serviceworker":
        case "sharedworker":
        case "worker":
        case "script":
          u = ya(t);
      }
      if (!Fe.has(u) && (t = W({ rel: "modulepreload", href: t }, e), Fe.set(u, t), n.querySelector(a) === null)) {
        switch (l) {
          case "audioworklet":
          case "paintworklet":
          case "serviceworker":
          case "sharedworker":
          case "worker":
          case "script":
            if (n.querySelector(mu(u)))
              return;
        }
        l = n.createElement("link"), oe(l, "link", t), te(l), n.head.appendChild(l);
      }
    }
  }
  function _v(t, e, n) {
    Nn.S(t, e, n);
    var l = ha;
    if (l && t) {
      var a = Rl(l).hoistableStyles, u = ga(t);
      e = e || "default";
      var i = a.get(u);
      if (!i) {
        var c = { loading: 0, preload: null };
        if (i = l.querySelector(
          du(u)
        ))
          c.loading = 5;
        else {
          t = W(
            { rel: "stylesheet", href: t, "data-precedence": e },
            n
          ), (n = Fe.get(u)) && Ao(t, n);
          var f = i = l.createElement("link");
          te(f), oe(f, "link", t), f._p = new Promise(function(v, _) {
            f.onload = v, f.onerror = _;
          }), f.addEventListener("load", function() {
            c.loading |= 1;
          }), f.addEventListener("error", function() {
            c.loading |= 2;
          }), c.loading |= 4, Yi(i, e, l);
        }
        i = {
          type: "stylesheet",
          instance: i,
          count: 1,
          state: c
        }, a.set(u, i);
      }
    }
  }
  function Ov(t, e) {
    Nn.X(t, e);
    var n = ha;
    if (n && t) {
      var l = Rl(n).hoistableScripts, a = ya(t), u = l.get(a);
      u || (u = n.querySelector(mu(a)), u || (t = W({ src: t, async: !0 }, e), (e = Fe.get(a)) && wo(t, e), u = n.createElement("script"), te(u), oe(u, "link", t), n.head.appendChild(u)), u = {
        type: "script",
        instance: u,
        count: 1,
        state: null
      }, l.set(a, u));
    }
  }
  function zv(t, e) {
    Nn.M(t, e);
    var n = ha;
    if (n && t) {
      var l = Rl(n).hoistableScripts, a = ya(t), u = l.get(a);
      u || (u = n.querySelector(mu(a)), u || (t = W({ src: t, async: !0, type: "module" }, e), (e = Fe.get(a)) && wo(t, e), u = n.createElement("script"), te(u), oe(u, "link", t), n.head.appendChild(u)), u = {
        type: "script",
        instance: u,
        count: 1,
        state: null
      }, l.set(a, u));
    }
  }
  function Zm(t, e, n, l) {
    var a = (a = re.current) ? Li(a) : null;
    if (!a) throw Error(o(446));
    switch (t) {
      case "meta":
      case "title":
        return null;
      case "style":
        return typeof n.precedence == "string" && typeof n.href == "string" ? (e = ga(n.href), n = Rl(
          a
        ).hoistableStyles, l = n.get(e), l || (l = {
          type: "style",
          instance: null,
          count: 0,
          state: null
        }, n.set(e, l)), l) : { type: "void", instance: null, count: 0, state: null };
      case "link":
        if (n.rel === "stylesheet" && typeof n.href == "string" && typeof n.precedence == "string") {
          t = ga(n.href);
          var u = Rl(
            a
          ).hoistableStyles, i = u.get(t);
          if (i || (a = a.ownerDocument || a, i = {
            type: "stylesheet",
            instance: null,
            count: 0,
            state: { loading: 0, preload: null }
          }, u.set(t, i), (u = a.querySelector(
            du(t)
          )) && !u._p && (i.instance = u, i.state.loading = 5), Fe.has(t) || (n = {
            rel: "preload",
            as: "style",
            href: n.href,
            crossOrigin: n.crossOrigin,
            integrity: n.integrity,
            media: n.media,
            hrefLang: n.hrefLang,
            referrerPolicy: n.referrerPolicy
          }, Fe.set(t, n), u || Cv(
            a,
            t,
            n,
            i.state
          ))), e && l === null)
            throw Error(o(528, ""));
          return i;
        }
        if (e && l !== null)
          throw Error(o(529, ""));
        return null;
      case "script":
        return e = n.async, n = n.src, typeof n == "string" && e && typeof e != "function" && typeof e != "symbol" ? (e = ya(n), n = Rl(
          a
        ).hoistableScripts, l = n.get(e), l || (l = {
          type: "script",
          instance: null,
          count: 0,
          state: null
        }, n.set(e, l)), l) : { type: "void", instance: null, count: 0, state: null };
      default:
        throw Error(o(444, t));
    }
  }
  function ga(t) {
    return 'href="' + Ge(t) + '"';
  }
  function du(t) {
    return 'link[rel="stylesheet"][' + t + "]";
  }
  function Km(t) {
    return W({}, t, {
      "data-precedence": t.precedence,
      precedence: null
    });
  }
  function Cv(t, e, n, l) {
    t.querySelector('link[rel="preload"][as="style"][' + e + "]") ? l.loading = 1 : (e = t.createElement("link"), l.preload = e, e.addEventListener("load", function() {
      return l.loading |= 1;
    }), e.addEventListener("error", function() {
      return l.loading |= 2;
    }), oe(e, "link", n), te(e), t.head.appendChild(e));
  }
  function ya(t) {
    return '[src="' + Ge(t) + '"]';
  }
  function mu(t) {
    return "script[async]" + t;
  }
  function Jm(t, e, n) {
    if (e.count++, e.instance === null)
      switch (e.type) {
        case "style":
          var l = t.querySelector(
            'style[data-href~="' + Ge(n.href) + '"]'
          );
          if (l)
            return e.instance = l, te(l), l;
          var a = W({}, n, {
            "data-href": n.href,
            "data-precedence": n.precedence,
            href: null,
            precedence: null
          });
          return l = (t.ownerDocument || t).createElement(
            "style"
          ), te(l), oe(l, "style", a), Yi(l, n.precedence, t), e.instance = l;
        case "stylesheet":
          a = ga(n.href);
          var u = t.querySelector(
            du(a)
          );
          if (u)
            return e.state.loading |= 4, e.instance = u, te(u), u;
          l = Km(n), (a = Fe.get(a)) && Ao(l, a), u = (t.ownerDocument || t).createElement("link"), te(u);
          var i = u;
          return i._p = new Promise(function(c, f) {
            i.onload = c, i.onerror = f;
          }), oe(u, "link", l), e.state.loading |= 4, Yi(u, n.precedence, t), e.instance = u;
        case "script":
          return u = ya(n.src), (a = t.querySelector(
            mu(u)
          )) ? (e.instance = a, te(a), a) : (l = n, (a = Fe.get(u)) && (l = W({}, n), wo(l, a)), t = t.ownerDocument || t, a = t.createElement("script"), te(a), oe(a, "link", l), t.head.appendChild(a), e.instance = a);
        case "void":
          return null;
        default:
          throw Error(o(443, e.type));
      }
    else
      e.type === "stylesheet" && (e.state.loading & 4) === 0 && (l = e.instance, e.state.loading |= 4, Yi(l, n.precedence, t));
    return e.instance;
  }
  function Yi(t, e, n) {
    for (var l = n.querySelectorAll(
      'link[rel="stylesheet"][data-precedence],style[data-precedence]'
    ), a = l.length ? l[l.length - 1] : null, u = a, i = 0; i < l.length; i++) {
      var c = l[i];
      if (c.dataset.precedence === e) u = c;
      else if (u !== a) break;
    }
    u ? u.parentNode.insertBefore(t, u.nextSibling) : (e = n.nodeType === 9 ? n.head : n, e.insertBefore(t, e.firstChild));
  }
  function Ao(t, e) {
    t.crossOrigin == null && (t.crossOrigin = e.crossOrigin), t.referrerPolicy == null && (t.referrerPolicy = e.referrerPolicy), t.title == null && (t.title = e.title);
  }
  function wo(t, e) {
    t.crossOrigin == null && (t.crossOrigin = e.crossOrigin), t.referrerPolicy == null && (t.referrerPolicy = e.referrerPolicy), t.integrity == null && (t.integrity = e.integrity);
  }
  var Gi = null;
  function $m(t, e, n) {
    if (Gi === null) {
      var l = /* @__PURE__ */ new Map(), a = Gi = /* @__PURE__ */ new Map();
      a.set(n, l);
    } else
      a = Gi, l = a.get(n), l || (l = /* @__PURE__ */ new Map(), a.set(n, l));
    if (l.has(t)) return l;
    for (l.set(t, null), n = n.getElementsByTagName(t), a = 0; a < n.length; a++) {
      var u = n[a];
      if (!(u[Aa] || u[ae] || t === "link" && u.getAttribute("rel") === "stylesheet") && u.namespaceURI !== "http://www.w3.org/2000/svg") {
        var i = u.getAttribute(e) || "";
        i = t + i;
        var c = l.get(i);
        c ? c.push(u) : l.set(i, [u]);
      }
    }
    return l;
  }
  function Fm(t, e, n) {
    t = t.ownerDocument || t, t.head.insertBefore(
      n,
      e === "title" ? t.querySelector("head > title") : null
    );
  }
  function Mv(t, e, n) {
    if (n === 1 || e.itemProp != null) return !1;
    switch (t) {
      case "meta":
      case "title":
        return !0;
      case "style":
        if (typeof e.precedence != "string" || typeof e.href != "string" || e.href === "")
          break;
        return !0;
      case "link":
        if (typeof e.rel != "string" || typeof e.href != "string" || e.href === "" || e.onLoad || e.onError)
          break;
        switch (e.rel) {
          case "stylesheet":
            return t = e.disabled, typeof e.precedence == "string" && t == null;
          default:
            return !0;
        }
      case "script":
        if (e.async && typeof e.async != "function" && typeof e.async != "symbol" && !e.onLoad && !e.onError && e.src && typeof e.src == "string")
          return !0;
    }
    return !1;
  }
  function Wm(t, e) {
    return t === "img" && e.src != null && e.src !== "" && e.onLoad == null && e.loading !== "lazy";
  }
  function Im(t) {
    return !(t.type === "stylesheet" && (t.state.loading & 3) === 0);
  }
  function Pm(t) {
    return (t.width || 100) * (t.height || 100) * (typeof devicePixelRatio == "number" ? devicePixelRatio : 1) * 0.25;
  }
  function th(t, e) {
    typeof e.decode == "function" && (t.imgCount++, e.complete || (t.imgBytes += Pm(e), t.suspenseyImages.push(e)), t = Nv.bind(t), e.decode().then(t, t));
  }
  function Av(t, e, n, l) {
    if (n.type === "stylesheet" && (typeof l.media != "string" || matchMedia(l.media).matches !== !1) && (n.state.loading & 4) === 0) {
      if (n.instance === null) {
        var a = ga(l.href), u = e.querySelector(
          du(a)
        );
        if (u) {
          e = u._p, e !== null && typeof e == "object" && typeof e.then == "function" && (t.count++, t = hu.bind(t), e.then(t, t)), n.state.loading |= 4, n.instance = u, te(u);
          return;
        }
        u = e.ownerDocument || e, l = Km(l), (a = Fe.get(a)) && Ao(l, a), u = u.createElement("link"), te(u);
        var i = u;
        i._p = new Promise(function(c, f) {
          i.onload = c, i.onerror = f;
        }), oe(u, "link", l), n.instance = u;
      }
      t.stylesheets === null && (t.stylesheets = /* @__PURE__ */ new Map()), t.stylesheets.set(n, e), (e = n.state.preload) && (n.state.loading & 3) === 0 && (t.count++, n = hu.bind(t), e.addEventListener("load", n), e.addEventListener("error", n));
    }
  }
  var Qi = 0;
  function wv(t, e) {
    return t.stylesheets && t.count === 0 && ki(t, t.stylesheets), 0 < t.count || 0 < t.imgCount ? function(n) {
      var l = setTimeout(function() {
        if (t.stylesheets && ki(t, t.stylesheets), t.unsuspend) {
          var u = t.unsuspend;
          t.unsuspend = null, u();
        }
      }, 6e4 + e);
      0 < t.imgBytes && Qi === 0 && (Qi = 62500 * Wy());
      var a = setTimeout(
        function() {
          if (t.waitingForImages = !1, t.count === 0 && (t.stylesheets && ki(t, t.stylesheets), t.unsuspend)) {
            var u = t.unsuspend;
            t.unsuspend = null, u();
          }
        },
        (t.imgBytes > Qi ? 50 : 800) + e
      );
      return t.unsuspend = n, function() {
        t.unsuspend = null, clearTimeout(l), clearTimeout(a);
      };
    } : null;
  }
  function eh(t) {
    if (t.count === 0 && (t.imgCount === 0 || !t.waitingForImages)) {
      if (t.stylesheets) ki(t, t.stylesheets);
      else if (t.unsuspend) {
        var e = t.unsuspend;
        t.unsuspend = null, e();
      }
    }
  }
  function hu() {
    this.count--, eh(this);
  }
  function Nv() {
    this.imgCount--, eh(this);
  }
  var Xi = null;
  function ki(t, e) {
    t.stylesheets = null, t.unsuspend !== null && (t.count++, Xi = /* @__PURE__ */ new Map(), e.forEach(Uv, t), Xi = null, hu.call(t));
  }
  function Uv(t, e) {
    if (!(e.state.loading & 4)) {
      var n = Xi.get(t);
      if (n) var l = n.get(null);
      else {
        n = /* @__PURE__ */ new Map(), Xi.set(t, n);
        for (var a = t.querySelectorAll(
          "link[data-precedence],style[data-precedence]"
        ), u = 0; u < a.length; u++) {
          var i = a[u];
          (i.nodeName === "LINK" || i.getAttribute("media") !== "not all") && (n.set(i.dataset.precedence, i), l = i);
        }
        l && n.set(null, l);
      }
      a = e.instance, i = a.getAttribute("data-precedence"), u = n.get(i) || l, u === l && n.set(null, a), n.set(i, a), this.count++, l = hu.bind(this), a.addEventListener("load", l), a.addEventListener("error", l), u ? u.parentNode.insertBefore(a, u.nextSibling) : (t = t.nodeType === 9 ? t.head : t, t.insertBefore(a, t.firstChild)), e.state.loading |= 4;
    }
  }
  var gu = {
    $$typeof: Wt,
    Provider: null,
    Consumer: null,
    _currentValue: nt,
    _currentValue2: nt,
    _threadCount: 0
  };
  function Dv(t, e, n, l, a, u, i, c, f) {
    this.tag = 1, this.containerInfo = t, this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = -1, this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null, this.callbackPriority = 0, this.expirationTimes = cs(-1), this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = cs(0), this.hiddenUpdates = cs(null), this.identifierPrefix = l, this.onUncaughtError = a, this.onCaughtError = u, this.onRecoverableError = i, this.pooledCache = null, this.pooledCacheLanes = 0, this.formState = f, this.transitionTypes = null, this.incompleteTransitions = /* @__PURE__ */ new Map();
  }
  function nh(t, e, n, l, a, u, i, c, f, v, _, M) {
    return t = new Dv(
      t,
      e,
      n,
      i,
      f,
      v,
      _,
      M,
      c
    ), e = 1, u === !0 && (e |= 24), u = _e(3, null, null, e), t.current = u, u.stateNode = t, e = Vs(), e.refCount++, t.pooledCache = e, e.refCount++, u.memoizedState = {
      element: l,
      isDehydrated: n,
      cache: e
    }, $s(u), t;
  }
  function lh(t) {
    return t ? (t = Xl, t) : Xl;
  }
  function ah(t, e, n, l, a, u) {
    a = lh(a), l.context === null ? l.context = a : l.pendingContext = a, l = Gn(e), l.payload = { element: n }, u = u === void 0 ? null : u, u !== null && (l.callback = u), n = Qn(t, l, e), n !== null && (Ce(n, t, e), Va(n, t, e));
  }
  function uh(t, e) {
    if (t = t.memoizedState, t !== null && t.dehydrated !== null) {
      var n = t.retryLane;
      t.retryLane = n !== 0 && n < e ? n : e;
    }
  }
  function No(t, e) {
    uh(t, e), (t = t.alternate) && uh(t, e);
  }
  function ih(t) {
    if (t.tag === 13 || t.tag === 31) {
      var e = rl(t, 67108864);
      e !== null && Ce(e, t, 67108864), No(t, 67108864);
    }
  }
  function sh(t) {
    if (t.tag === 13 || t.tag === 31) {
      var e = He();
      e = os(e);
      var n = rl(t, e);
      n !== null && Ce(n, t, e), No(t, e);
    }
  }
  var Vi = !0;
  function Rv(t, e, n, l) {
    var a = U.T;
    U.T = null;
    var u = x.p;
    try {
      x.p = 2, Uo(t, e, n, l);
    } finally {
      x.p = u, U.T = a;
    }
  }
  function qv(t, e, n, l) {
    var a = U.T;
    U.T = null;
    var u = x.p;
    try {
      x.p = 8, Uo(t, e, n, l);
    } finally {
      x.p = u, U.T = a;
    }
  }
  function Uo(t, e, n, l) {
    if (Vi) {
      var a = Do(l);
      if (a === null)
        yo(
          t,
          e,
          l,
          Zi,
          n
        ), oh(t, l);
      else if (xv(
        a,
        t,
        e,
        n,
        l
      ))
        l.stopPropagation();
      else if (oh(t, l), e & 4 && -1 < jv.indexOf(t)) {
        for (; a !== null; ) {
          var u = Dl(a);
          if (u !== null)
            switch (u.tag) {
              case 3:
                if (u = u.stateNode, u.current.memoizedState.isDehydrated) {
                  var i = al(u.pendingLanes);
                  if (i !== 0) {
                    var c = u;
                    for (c.pendingLanes |= 2, c.entangledLanes |= 2; i; ) {
                      var f = 1 << 31 - Ue(i);
                      c.entanglements[1] |= f, i &= ~f;
                    }
                    hn(u), (Ot & 6) === 0 && (wi = we() + 500, cu(0));
                  }
                }
                break;
              case 31:
              case 13:
                c = rl(u, 2), c !== null && Ce(c, u, 2), Ui(), No(u, 2);
            }
          if (u = Do(l), u === null && yo(
            t,
            e,
            l,
            Zi,
            n
          ), u === a) break;
          a = u;
        }
        a !== null && l.stopPropagation();
      } else
        yo(
          t,
          e,
          l,
          null,
          n
        );
    }
  }
  function Do(t) {
    return t = ps(t), Ro(t);
  }
  var Zi = null;
  function Ro(t) {
    if (Zi = null, t = ul(t), t !== null) {
      var e = z(t);
      if (e === null) t = null;
      else {
        var n = e.tag;
        if (n === 13) {
          if (t = R(e), t !== null) return t;
          t = null;
        } else if (n === 31) {
          if (t = H(e), t !== null) return t;
          t = null;
        } else if (n === 3) {
          if (e.stateNode.current.memoizedState.isDehydrated)
            return e.tag === 3 ? e.stateNode.containerInfo : null;
          t = null;
        } else e !== t && (t = null);
      }
    }
    return Zi = t, null;
  }
  function ch(t) {
    switch (t) {
      case "beforetoggle":
      case "cancel":
      case "click":
      case "close":
      case "contextmenu":
      case "copy":
      case "cut":
      case "auxclick":
      case "dblclick":
      case "dragend":
      case "dragstart":
      case "drop":
      case "focusin":
      case "focusout":
      case "input":
      case "invalid":
      case "keydown":
      case "keypress":
      case "keyup":
      case "mousedown":
      case "mouseup":
      case "paste":
      case "pause":
      case "play":
      case "pointercancel":
      case "pointerdown":
      case "pointerup":
      case "ratechange":
      case "reset":
      case "seeked":
      case "submit":
      case "toggle":
      case "touchcancel":
      case "touchend":
      case "touchstart":
      case "volumechange":
      case "change":
      case "selectionchange":
      case "textInput":
      case "compositionstart":
      case "compositionend":
      case "compositionupdate":
      case "beforeblur":
      case "afterblur":
      case "beforeinput":
      case "blur":
      case "fullscreenchange":
      case "focus":
      case "hashchange":
      case "popstate":
      case "select":
      case "selectstart":
        return 2;
      case "drag":
      case "dragenter":
      case "dragexit":
      case "dragleave":
      case "dragover":
      case "mousemove":
      case "mouseout":
      case "mouseover":
      case "pointermove":
      case "pointerout":
      case "pointerover":
      case "resize":
      case "scroll":
      case "touchmove":
      case "wheel":
      case "mouseenter":
      case "mouseleave":
      case "pointerenter":
      case "pointerleave":
        return 8;
      case "message":
        switch (lg()) {
          case Fo:
            return 2;
          case Wo:
            return 8;
          case wu:
          case ag:
            return 32;
          case Io:
            return 268435456;
          default:
            return 32;
        }
      default:
        return 32;
    }
  }
  var qo = !1, In = null, Pn = null, tl = null, yu = /* @__PURE__ */ new Map(), vu = /* @__PURE__ */ new Map(), el = [], jv = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(
    " "
  );
  function oh(t, e) {
    switch (t) {
      case "focusin":
      case "focusout":
        In = null;
        break;
      case "dragenter":
      case "dragleave":
        Pn = null;
        break;
      case "mouseover":
      case "mouseout":
        tl = null;
        break;
      case "pointerover":
      case "pointerout":
        yu.delete(e.pointerId);
        break;
      case "gotpointercapture":
      case "lostpointercapture":
        vu.delete(e.pointerId);
    }
  }
  function pu(t, e, n, l, a, u) {
    return t === null || t.nativeEvent !== u ? (t = {
      blockedOn: e,
      domEventName: n,
      eventSystemFlags: l,
      nativeEvent: u,
      targetContainers: [a]
    }, e !== null && (e = Dl(e), e !== null && ih(e)), t) : (t.eventSystemFlags |= l, e = t.targetContainers, a !== null && e.indexOf(a) === -1 && e.push(a), t);
  }
  function xv(t, e, n, l, a) {
    switch (e) {
      case "focusin":
        return In = pu(
          In,
          t,
          e,
          n,
          l,
          a
        ), !0;
      case "dragenter":
        return Pn = pu(
          Pn,
          t,
          e,
          n,
          l,
          a
        ), !0;
      case "mouseover":
        return tl = pu(
          tl,
          t,
          e,
          n,
          l,
          a
        ), !0;
      case "pointerover":
        var u = a.pointerId;
        return yu.set(
          u,
          pu(
            yu.get(u) || null,
            t,
            e,
            n,
            l,
            a
          )
        ), !0;
      case "gotpointercapture":
        return u = a.pointerId, vu.set(
          u,
          pu(
            vu.get(u) || null,
            t,
            e,
            n,
            l,
            a
          )
        ), !0;
    }
    return !1;
  }
  function rh(t) {
    var e = ul(t.target);
    if (e !== null) {
      var n = z(e);
      if (n !== null) {
        if (e = n.tag, e === 13) {
          if (e = R(n), e !== null) {
            t.blockedOn = e, ar(t.priority, function() {
              sh(n);
            });
            return;
          }
        } else if (e === 31) {
          if (e = H(n), e !== null) {
            t.blockedOn = e, ar(t.priority, function() {
              sh(n);
            });
            return;
          }
        } else if (e === 3 && n.stateNode.current.memoizedState.isDehydrated) {
          t.blockedOn = n.tag === 3 ? n.stateNode.containerInfo : null;
          return;
        }
      }
    }
    t.blockedOn = null;
  }
  function Ki(t) {
    if (t.blockedOn !== null) return !1;
    for (var e = t.targetContainers; 0 < e.length; ) {
      var n = Do(t.nativeEvent);
      if (n === null) {
        n = t.nativeEvent;
        var l = new n.constructor(
          n.type,
          n
        );
        vs = l, n.target.dispatchEvent(l), vs = null;
      } else
        return e = Dl(n), e !== null && ih(e), t.blockedOn = n, !1;
      e.shift();
    }
    return !0;
  }
  function fh(t, e, n) {
    Ki(t) && n.delete(e);
  }
  function Hv() {
    qo = !1, In !== null && Ki(In) && (In = null), Pn !== null && Ki(Pn) && (Pn = null), tl !== null && Ki(tl) && (tl = null), yu.forEach(fh), vu.forEach(fh);
  }
  function Ji(t, e) {
    t.blockedOn === e && (t.blockedOn = null, qo || (qo = !0, s.unstable_scheduleCallback(
      s.unstable_NormalPriority,
      Hv
    )));
  }
  var $i = null;
  function dh(t) {
    $i !== t && ($i = t, s.unstable_scheduleCallback(
      s.unstable_NormalPriority,
      function() {
        $i === t && ($i = null);
        for (var e = 0; e < t.length; e += 3) {
          var n = t[e], l = t[e + 1], a = t[e + 2];
          if (typeof l != "function") {
            if (Ro(l || n) === null)
              continue;
            break;
          }
          var u = Dl(n);
          u !== null && (t.splice(e, 3), e -= 3, yc(
            u,
            {
              pending: !0,
              data: a,
              method: n.method,
              action: l
            },
            l,
            a
          ));
        }
      }
    ));
  }
  function va(t) {
    function e(f) {
      return Ji(f, t);
    }
    In !== null && Ji(In, t), Pn !== null && Ji(Pn, t), tl !== null && Ji(tl, t), yu.forEach(e), vu.forEach(e);
    for (var n = 0; n < el.length; n++) {
      var l = el[n];
      l.blockedOn === t && (l.blockedOn = null);
    }
    for (; 0 < el.length && (n = el[0], n.blockedOn === null); )
      rh(n), n.blockedOn === null && el.shift();
    if (n = (t.ownerDocument || t).$$reactFormReplay, n != null)
      for (l = 0; l < n.length; l += 3) {
        var a = n[l], u = n[l + 1], i = a[Ee] || null;
        if (typeof u == "function")
          i || dh(n);
        else if (i) {
          var c = null;
          if (u && u.hasAttribute("formAction")) {
            if (a = u, i = u[Ee] || null)
              c = i.formAction;
            else if (Ro(a) !== null) continue;
          } else c = i.action;
          typeof c == "function" ? n[l + 1] = c : (n.splice(l, 3), l -= 3), dh(n);
        }
      }
  }
  function mh() {
    function t(u) {
      u.canIntercept && u.info === "react-transition" && u.intercept({
        handler: function() {
          return new Promise(function(i) {
            return a = i;
          });
        },
        focusReset: "manual",
        scroll: "manual"
      });
    }
    function e() {
      a !== null && (a(), a = null), l || setTimeout(n, 20);
    }
    function n() {
      if (!l && !navigation.transition) {
        var u = navigation.currentEntry;
        u && u.url != null && navigation.navigate(u.url, {
          state: u.getState(),
          info: "react-transition",
          history: "replace"
        });
      }
    }
    if (typeof navigation == "object") {
      var l = !1, a = null;
      return navigation.addEventListener("navigate", t), navigation.addEventListener("navigatesuccess", e), navigation.addEventListener("navigateerror", e), setTimeout(n, 100), function() {
        l = !0, navigation.removeEventListener("navigate", t), navigation.removeEventListener("navigatesuccess", e), navigation.removeEventListener("navigateerror", e), a !== null && (a(), a = null);
      };
    }
  }
  function jo(t) {
    this._internalRoot = t;
  }
  Fi.prototype.render = jo.prototype.render = function(t) {
    var e = this._internalRoot;
    if (e === null) throw Error(o(409));
    var n = e.current, l = He();
    ah(n, l, t, e, null, null);
  }, Fi.prototype.unmount = jo.prototype.unmount = function() {
    var t = this._internalRoot;
    if (t !== null) {
      this._internalRoot = null;
      var e = t.containerInfo;
      ah(t.current, 2, null, t, null, null), Ui(), e[Ul] = null;
    }
  };
  function Fi(t) {
    this._internalRoot = t;
  }
  Fi.prototype.unstable_scheduleHydration = function(t) {
    if (t) {
      var e = lr();
      t = { blockedOn: null, target: t, priority: e };
      for (var n = 0; n < el.length && e !== 0 && e < el[n].priority; n++) ;
      el.splice(n, 0, t), n === 0 && rh(t);
    }
  };
  var hh = r.version;
  if (hh !== "19.3.0-canary-fb2177c1-20251114")
    throw Error(
      o(
        527,
        hh,
        "19.3.0-canary-fb2177c1-20251114"
      )
    );
  x.findDOMNode = function(t) {
    var e = t._reactInternals;
    if (e === void 0)
      throw typeof t.render == "function" ? Error(o(188)) : (t = Object.keys(t).join(","), Error(o(268, t)));
    return t = O(e), t = t !== null ? Q(t) : null, t = t === null ? null : t.stateNode, t;
  };
  var Bv = {
    bundleType: 0,
    version: "19.3.0-canary-fb2177c1-20251114",
    rendererPackageName: "react-dom",
    currentDispatcherRef: U,
    reconcilerVersion: "19.3.0-canary-fb2177c1-20251114"
  };
  if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u") {
    var Wi = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!Wi.isDisabled && Wi.supportsFiber)
      try {
        za = Wi.inject(
          Bv
        ), Ne = Wi;
      } catch {
      }
  }
  return Su.createRoot = function(t, e) {
    if (!g(t)) throw Error(o(299));
    var n = !1, l = "", a = ud, u = id, i = sd;
    return e != null && (e.unstable_strictMode === !0 && (n = !0), e.identifierPrefix !== void 0 && (l = e.identifierPrefix), e.onUncaughtError !== void 0 && (a = e.onUncaughtError), e.onCaughtError !== void 0 && (u = e.onCaughtError), e.onRecoverableError !== void 0 && (i = e.onRecoverableError)), e = nh(
      t,
      1,
      !1,
      null,
      null,
      n,
      l,
      null,
      a,
      u,
      i,
      mh
    ), t[Ul] = e.current, go(t), new jo(e);
  }, Su.hydrateRoot = function(t, e, n) {
    if (!g(t)) throw Error(o(299));
    var l = !1, a = "", u = ud, i = id, c = sd, f = null;
    return n != null && (n.unstable_strictMode === !0 && (l = !0), n.identifierPrefix !== void 0 && (a = n.identifierPrefix), n.onUncaughtError !== void 0 && (u = n.onUncaughtError), n.onCaughtError !== void 0 && (i = n.onCaughtError), n.onRecoverableError !== void 0 && (c = n.onRecoverableError), n.formState !== void 0 && (f = n.formState)), e = nh(
      t,
      1,
      !0,
      e,
      n ?? null,
      l,
      a,
      f,
      u,
      i,
      c,
      mh
    ), e.context = lh(null), n = e.current, l = He(), l = os(l), a = Gn(l), a.callback = null, Qn(n, a, l), n = l, e.current.lanes = n, Ma(e, n), hn(e), t[Ul] = e.current, go(t), new Fi(e);
  }, Su.version = "19.3.0-canary-fb2177c1-20251114", Su;
}
var Hh;
function xp() {
  if (Hh) return ko.exports;
  Hh = 1;
  function s() {
    if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ > "u" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function"))
      try {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(s);
      } catch (r) {
        console.error(r);
      }
  }
  return s(), ko.exports = jp(), ko.exports;
}
var Ih = xp();
const Hp = /* @__PURE__ */ es(Ih), Bp = /* @__PURE__ */ ts({
  __proto__: null,
  default: Hp
}, [Ih]);
typeof window < "u" && !window.global && (window.global = typeof global > "u" ? window : global);
if (globalThis.__clerkSharedModules) {
  const s = globalThis.__clerkSharedModules.react?.version;
  s && s !== At.version && console.warn(`[@clerk/ui/register] React version mismatch detected. Already registered: ${s}, current import: ${At.version}. This may cause issues with the shared @clerk/ui variant.`);
} else globalThis.__clerkSharedModules = {
  react: Vv,
  "react-dom": ep,
  "react-dom/client": Bp,
  "react/jsx-runtime": Xv
};
zt(({ clerk: s, children: r, ...m }) => {
  const { appearance: o, getContainer: g, component: z, ...R } = m;
  r = Ou(r, "Invite members");
  const H = _u(r)("InviteMembersButton"), N = () => s.openInviteMembers({
    appearance: o,
    getContainer: g
  }), Q = {
    ...R,
    onClick: async (j) => (H && typeof H == "object" && "props" in H && await zu(H.props.onClick)(j), N())
  };
  return A.cloneElement(H, Q);
}, {
  component: "InviteMembersButton",
  renderWhileLoading: !0
});
zt(({ clerk: s, children: r, ...m }) => {
  const { appearance: o, getContainer: g, component: z, signUpFallbackRedirectUrl: R, forceRedirectUrl: H, fallbackRedirectUrl: N, signUpForceRedirectUrl: O, mode: Q, initialValues: j, withSignUp: $, oauthFlow: ft, ...gt } = m;
  r = Ou(r, "Sign in");
  const ct = _u(r)("SignInButton"), G = () => {
    const X = {
      forceRedirectUrl: H,
      fallbackRedirectUrl: N,
      signUpFallbackRedirectUrl: R,
      signUpForceRedirectUrl: O,
      initialValues: j,
      withSignUp: $,
      oauthFlow: ft
    };
    return Q === "modal" ? s.openSignIn({
      ...X,
      appearance: o,
      getContainer: g
    }) : s.redirectToSignIn({
      ...X,
      signInFallbackRedirectUrl: N,
      signInForceRedirectUrl: H
    });
  }, yt = {
    ...gt,
    onClick: async (X) => (ct && typeof ct == "object" && "props" in ct && await zu(ct.props.onClick)(X), G())
  };
  return A.cloneElement(ct, yt);
}, {
  component: "SignInButton",
  renderWhileLoading: !0
});
zt(({ clerk: s, children: r, ...m }) => {
  const { redirectUrl: o, getContainer: g, component: z, ...R } = m;
  r = Ou(r, "Sign in with Metamask");
  const H = _u(r)("SignInWithMetamaskButton"), N = async () => {
    async function j() {
      await s.authenticateWithMetamask({ redirectUrl: o || void 0 });
    }
    j();
  }, Q = {
    ...R,
    onClick: async (j) => (await zu(H.props.onClick)(j), N())
  };
  return A.cloneElement(H, Q);
}, {
  component: "SignInWithMetamask",
  renderWhileLoading: !0
});
zt(({ clerk: s, children: r, ...m }) => {
  const { redirectUrl: o = "/", sessionId: g, signOutOptions: z, getContainer: R, component: H, ...N } = m;
  z && is("SignOutButton `signOutOptions`", "Use the `redirectUrl` and `sessionId` props directly instead."), r = Ou(r, "Sign out");
  const O = _u(r)("SignOutButton"), Q = () => s.signOut({
    redirectUrl: o,
    ...g !== void 0 && { sessionId: g },
    ...z
  }), $ = {
    ...N,
    onClick: async (ft) => (await zu(O.props.onClick)(ft), Q())
  };
  return A.cloneElement(O, $);
}, {
  component: "SignOutButton",
  renderWhileLoading: !0
});
zt(({ clerk: s, children: r, ...m }) => {
  const { appearance: o, unsafeMetadata: g, getContainer: z, component: R, fallbackRedirectUrl: H, forceRedirectUrl: N, signInFallbackRedirectUrl: O, signInForceRedirectUrl: Q, mode: j, initialValues: $, oauthFlow: ft, ...gt } = m;
  r = Ou(r, "Sign up");
  const ct = _u(r)("SignUpButton"), G = () => {
    const X = {
      fallbackRedirectUrl: H,
      forceRedirectUrl: N,
      signInFallbackRedirectUrl: O,
      signInForceRedirectUrl: Q,
      initialValues: $,
      oauthFlow: ft
    };
    return j === "modal" ? s.openSignUp({
      ...X,
      appearance: o,
      unsafeMetadata: g,
      getContainer: z
    }) : s.redirectToSignUp({
      ...X,
      signUpFallbackRedirectUrl: H,
      signUpForceRedirectUrl: N
    });
  }, yt = {
    ...gt,
    onClick: async (X) => (ct && typeof ct == "object" && "props" in ct && await zu(ct.props.onClick)(X), G())
  };
  return A.cloneElement(ct, yt);
}, {
  component: "SignUpButton",
  renderWhileLoading: !0
});
F0({ packageName: "@clerk/react" });
Ap("@clerk/react");
var Ph = {};
(function s(r, m, o, g) {
  var z = !!(r.Worker && r.Blob && r.Promise && r.OffscreenCanvas && r.OffscreenCanvasRenderingContext2D && r.HTMLCanvasElement && r.HTMLCanvasElement.prototype.transferControlToOffscreen && r.URL && r.URL.createObjectURL), R = typeof Path2D == "function" && typeof DOMMatrix == "function", H = (function() {
    if (!r.OffscreenCanvas)
      return !1;
    try {
      var T = new OffscreenCanvas(1, 1), y = T.getContext("2d");
      y.fillRect(0, 0, 1, 1);
      var V = T.transferToImageBitmap();
      y.createPattern(V, "no-repeat");
    } catch {
      return !1;
    }
    return !0;
  })();
  function N() {
  }
  function O(T) {
    var y = m.exports.Promise, V = y !== void 0 ? y : r.Promise;
    return typeof V == "function" ? new V(T) : (T(N, N), null);
  }
  var Q = /* @__PURE__ */ (function(T, y) {
    return {
      transform: function(V) {
        if (T)
          return V;
        if (y.has(V))
          return y.get(V);
        var F = new OffscreenCanvas(V.width, V.height), d = F.getContext("2d");
        return d.drawImage(V, 0, 0), y.set(V, F), F;
      },
      clear: function() {
        y.clear();
      }
    };
  })(H, /* @__PURE__ */ new Map()), j = (function() {
    var T = Math.floor(16.666666666666668), y, V, F = {}, d = 0;
    return typeof requestAnimationFrame == "function" && typeof cancelAnimationFrame == "function" ? (y = function(C) {
      var q = Math.random();
      return F[q] = requestAnimationFrame(function D(Y) {
        d === Y || d + T - 1 < Y ? (d = Y, delete F[q], C()) : F[q] = requestAnimationFrame(D);
      }), q;
    }, V = function(C) {
      F[C] && cancelAnimationFrame(F[C]);
    }) : (y = function(C) {
      return setTimeout(C, T);
    }, V = function(C) {
      return clearTimeout(C);
    }), { frame: y, cancel: V };
  })(), $ = /* @__PURE__ */ (function() {
    var T, y, V = {};
    function F(d) {
      function C(q, D) {
        d.postMessage({ options: q || {}, callback: D });
      }
      d.init = function(D) {
        var Y = D.transferControlToOffscreen();
        d.postMessage({ canvas: Y }, [Y]);
      }, d.fire = function(D, Y, U) {
        if (y)
          return C(D, null), y;
        var x = Math.random().toString(36).slice(2);
        return y = O(function(nt) {
          function st(Rt) {
            Rt.data.callback === x && (delete V[x], d.removeEventListener("message", st), y = null, Q.clear(), U(), nt());
          }
          d.addEventListener("message", st), C(D, x), V[x] = st.bind(null, { data: { callback: x } });
        }), y;
      }, d.reset = function() {
        d.postMessage({ reset: !0 });
        for (var D in V)
          V[D](), delete V[D];
      };
    }
    return function() {
      if (T)
        return T;
      if (!o && z) {
        var d = [
          "var CONFETTI, SIZE = {}, module = {};",
          "(" + s.toString() + ")(this, module, true, SIZE);",
          "onmessage = function(msg) {",
          "  if (msg.data.options) {",
          "    CONFETTI(msg.data.options).then(function () {",
          "      if (msg.data.callback) {",
          "        postMessage({ callback: msg.data.callback });",
          "      }",
          "    });",
          "  } else if (msg.data.reset) {",
          "    CONFETTI && CONFETTI.reset();",
          "  } else if (msg.data.resize) {",
          "    SIZE.width = msg.data.resize.width;",
          "    SIZE.height = msg.data.resize.height;",
          "  } else if (msg.data.canvas) {",
          "    SIZE.width = msg.data.canvas.width;",
          "    SIZE.height = msg.data.canvas.height;",
          "    CONFETTI = module.exports.create(msg.data.canvas);",
          "  }",
          "}"
        ].join(`
`);
        try {
          T = new Worker(URL.createObjectURL(new Blob([d])));
        } catch (C) {
          return typeof console < "u" && typeof console.warn == "function" && console.warn("🎊 Could not load worker", C), null;
        }
        F(T);
      }
      return T;
    };
  })(), ft = {
    particleCount: 50,
    angle: 90,
    spread: 45,
    startVelocity: 45,
    decay: 0.9,
    gravity: 1,
    drift: 0,
    ticks: 200,
    x: 0.5,
    y: 0.5,
    shapes: ["square", "circle"],
    zIndex: 100,
    colors: [
      "#26ccff",
      "#a25afd",
      "#ff5e7e",
      "#88ff5a",
      "#fcff42",
      "#ffa62d",
      "#ff36ff"
    ],
    // probably should be true, but back-compat
    disableForReducedMotion: !1,
    scalar: 1
  };
  function gt(T, y) {
    return y ? y(T) : T;
  }
  function ct(T) {
    return T != null;
  }
  function G(T, y, V) {
    return gt(
      T && ct(T[y]) ? T[y] : ft[y],
      V
    );
  }
  function wt(T) {
    return T < 0 ? 0 : Math.floor(T);
  }
  function yt(T, y) {
    return Math.floor(Math.random() * (y - T)) + T;
  }
  function X(T) {
    return parseInt(T, 16);
  }
  function it(T) {
    return T.map(_t);
  }
  function _t(T) {
    var y = String(T).replace(/[^0-9a-f]/gi, "");
    return y.length < 6 && (y = y[0] + y[0] + y[1] + y[1] + y[2] + y[2]), {
      r: X(y.substring(0, 2)),
      g: X(y.substring(2, 4)),
      b: X(y.substring(4, 6))
    };
  }
  function W(T) {
    var y = G(T, "origin", Object);
    return y.x = G(y, "x", Number), y.y = G(y, "y", Number), y;
  }
  function jt(T) {
    T.width = document.documentElement.clientWidth, T.height = document.documentElement.clientHeight;
  }
  function I(T) {
    var y = T.getBoundingClientRect();
    T.width = y.width, T.height = y.height;
  }
  function ot(T) {
    var y = document.createElement("canvas");
    return y.style.position = "fixed", y.style.top = "0px", y.style.left = "0px", y.style.pointerEvents = "none", y.style.zIndex = T, y;
  }
  function Yt(T, y, V, F, d, C, q, D, Y) {
    T.save(), T.translate(y, V), T.rotate(C), T.scale(F, d), T.arc(0, 0, 1, q, D, Y), T.restore();
  }
  function Ht(T) {
    var y = T.angle * (Math.PI / 180), V = T.spread * (Math.PI / 180);
    return {
      x: T.x,
      y: T.y,
      wobble: Math.random() * 10,
      wobbleSpeed: Math.min(0.11, Math.random() * 0.1 + 0.05),
      velocity: T.startVelocity * 0.5 + Math.random() * T.startVelocity,
      angle2D: -y + (0.5 * V - Math.random() * V),
      tiltAngle: (Math.random() * (0.75 - 0.25) + 0.25) * Math.PI,
      color: T.color,
      shape: T.shape,
      tick: 0,
      totalTicks: T.ticks,
      decay: T.decay,
      drift: T.drift,
      random: Math.random() + 2,
      tiltSin: 0,
      tiltCos: 0,
      wobbleX: 0,
      wobbleY: 0,
      gravity: T.gravity * 3,
      ovalScalar: 0.6,
      scalar: T.scalar,
      flat: T.flat
    };
  }
  function Zt(T, y) {
    y.x += Math.cos(y.angle2D) * y.velocity + y.drift, y.y += Math.sin(y.angle2D) * y.velocity + y.gravity, y.velocity *= y.decay, y.flat ? (y.wobble = 0, y.wobbleX = y.x + 10 * y.scalar, y.wobbleY = y.y + 10 * y.scalar, y.tiltSin = 0, y.tiltCos = 0, y.random = 1) : (y.wobble += y.wobbleSpeed, y.wobbleX = y.x + 10 * y.scalar * Math.cos(y.wobble), y.wobbleY = y.y + 10 * y.scalar * Math.sin(y.wobble), y.tiltAngle += 0.1, y.tiltSin = Math.sin(y.tiltAngle), y.tiltCos = Math.cos(y.tiltAngle), y.random = Math.random() + 2);
    var V = y.tick++ / y.totalTicks, F = y.x + y.random * y.tiltCos, d = y.y + y.random * y.tiltSin, C = y.wobbleX + y.random * y.tiltCos, q = y.wobbleY + y.random * y.tiltSin;
    if (T.fillStyle = "rgba(" + y.color.r + ", " + y.color.g + ", " + y.color.b + ", " + (1 - V) + ")", T.beginPath(), R && y.shape.type === "path" && typeof y.shape.path == "string" && Array.isArray(y.shape.matrix))
      T.fill(K(
        y.shape.path,
        y.shape.matrix,
        y.x,
        y.y,
        Math.abs(C - F) * 0.1,
        Math.abs(q - d) * 0.1,
        Math.PI / 10 * y.wobble
      ));
    else if (y.shape.type === "bitmap") {
      var D = Math.PI / 10 * y.wobble, Y = Math.abs(C - F) * 0.1, U = Math.abs(q - d) * 0.1, x = y.shape.bitmap.width * y.scalar, nt = y.shape.bitmap.height * y.scalar, st = new DOMMatrix([
        Math.cos(D) * Y,
        Math.sin(D) * Y,
        -Math.sin(D) * U,
        Math.cos(D) * U,
        y.x,
        y.y
      ]);
      st.multiplySelf(new DOMMatrix(y.shape.matrix));
      var Rt = T.createPattern(Q.transform(y.shape.bitmap), "no-repeat");
      Rt.setTransform(st), T.globalAlpha = 1 - V, T.fillStyle = Rt, T.fillRect(
        y.x - x / 2,
        y.y - nt / 2,
        x,
        nt
      ), T.globalAlpha = 1;
    } else if (y.shape === "circle")
      T.ellipse ? T.ellipse(y.x, y.y, Math.abs(C - F) * y.ovalScalar, Math.abs(q - d) * y.ovalScalar, Math.PI / 10 * y.wobble, 0, 2 * Math.PI) : Yt(T, y.x, y.y, Math.abs(C - F) * y.ovalScalar, Math.abs(q - d) * y.ovalScalar, Math.PI / 10 * y.wobble, 0, 2 * Math.PI);
    else if (y.shape === "star")
      for (var lt = Math.PI / 2 * 3, St = 4 * y.scalar, rt = 8 * y.scalar, Gt = y.x, me = y.y, re = 5, he = Math.PI / re; re--; )
        Gt = y.x + Math.cos(lt) * rt, me = y.y + Math.sin(lt) * rt, T.lineTo(Gt, me), lt += he, Gt = y.x + Math.cos(lt) * St, me = y.y + Math.sin(lt) * St, T.lineTo(Gt, me), lt += he;
    else
      T.moveTo(Math.floor(y.x), Math.floor(y.y)), T.lineTo(Math.floor(y.wobbleX), Math.floor(d)), T.lineTo(Math.floor(C), Math.floor(q)), T.lineTo(Math.floor(F), Math.floor(y.wobbleY));
    return T.closePath(), T.fill(), y.tick < y.totalTicks;
  }
  function Ae(T, y, V, F, d) {
    var C = y.slice(), q = T.getContext("2d"), D, Y, U = O(function(x) {
      function nt() {
        D = Y = null, q.clearRect(0, 0, F.width, F.height), Q.clear(), d(), x();
      }
      function st() {
        o && !(F.width === g.width && F.height === g.height) && (F.width = T.width = g.width, F.height = T.height = g.height), !F.width && !F.height && (V(T), F.width = T.width, F.height = T.height), q.clearRect(0, 0, F.width, F.height), C = C.filter(function(Rt) {
          return Zt(q, Rt);
        }), C.length ? D = j.frame(st) : nt();
      }
      D = j.frame(st), Y = nt;
    });
    return {
      addFettis: function(x) {
        return C = C.concat(x), U;
      },
      canvas: T,
      promise: U,
      reset: function() {
        D && j.cancel(D), Y && Y();
      }
    };
  }
  function Wt(T, y) {
    var V = !T, F = !!G(y || {}, "resize"), d = !1, C = G(y, "disableForReducedMotion", Boolean), q = z && !!G(y || {}, "useWorker"), D = q ? $() : null, Y = V ? jt : I, U = T && D ? !!T.__confetti_initialized : !1, x = typeof matchMedia == "function" && matchMedia("(prefers-reduced-motion)").matches, nt;
    function st(lt, St, rt) {
      for (var Gt = G(lt, "particleCount", wt), me = G(lt, "angle", Number), re = G(lt, "spread", Number), he = G(lt, "startVelocity", Number), Al = G(lt, "decay", Number), Un = G(lt, "gravity", Number), ba = G(lt, "drift", Number), ll = G(lt, "colors", it), Sa = G(lt, "ticks", Number), Ea = G(lt, "shapes"), nn = G(lt, "scalar"), Ta = !!G(lt, "flat"), wl = W(lt), Au = Gt, Nl = [], _a = T.width * wl.x, Oa = T.height * wl.y; Au--; )
        Nl.push(
          Ht({
            x: _a,
            y: Oa,
            angle: me,
            spread: re,
            startVelocity: he,
            color: ll[Au % ll.length],
            shape: Ea[yt(0, Ea.length)],
            ticks: Sa,
            decay: Al,
            gravity: Un,
            drift: ba,
            scalar: nn,
            flat: Ta
          })
        );
      return nt ? nt.addFettis(Nl) : (nt = Ae(T, Nl, Y, St, rt), nt.promise);
    }
    function Rt(lt) {
      var St = C || G(lt, "disableForReducedMotion", Boolean), rt = G(lt, "zIndex", Number);
      if (St && x)
        return O(function(he) {
          he();
        });
      V && nt ? T = nt.canvas : V && !T && (T = ot(rt), document.body.appendChild(T)), F && !U && Y(T);
      var Gt = {
        width: T.width,
        height: T.height
      };
      D && !U && D.init(T), U = !0, D && (T.__confetti_initialized = !0);
      function me() {
        if (D) {
          var he = {
            getBoundingClientRect: function() {
              if (!V)
                return T.getBoundingClientRect();
            }
          };
          Y(he), D.postMessage({
            resize: {
              width: he.width,
              height: he.height
            }
          });
          return;
        }
        Gt.width = Gt.height = null;
      }
      function re() {
        nt = null, F && (d = !1, r.removeEventListener("resize", me)), V && T && (document.body.contains(T) && document.body.removeChild(T), T = null, U = !1);
      }
      return F && !d && (d = !0, r.addEventListener("resize", me, !1)), D ? D.fire(lt, Gt, re) : st(lt, Gt, re);
    }
    return Rt.reset = function() {
      D && D.reset(), nt && nt.reset();
    }, Rt;
  }
  var Pt;
  function B() {
    return Pt || (Pt = Wt(null, { useWorker: !0, resize: !0 })), Pt;
  }
  function K(T, y, V, F, d, C, q) {
    var D = new Path2D(T), Y = new Path2D();
    Y.addPath(D, new DOMMatrix(y));
    var U = new Path2D();
    return U.addPath(Y, new DOMMatrix([
      Math.cos(q) * d,
      Math.sin(q) * d,
      -Math.sin(q) * C,
      Math.cos(q) * C,
      V,
      F
    ])), U;
  }
  function tt(T) {
    if (!R)
      throw new Error("path confetti are not supported in this browser");
    var y, V;
    typeof T == "string" ? y = T : (y = T.path, V = T.matrix);
    var F = new Path2D(y), d = document.createElement("canvas"), C = d.getContext("2d");
    if (!V) {
      for (var q = 1e3, D = q, Y = q, U = 0, x = 0, nt, st, Rt = 0; Rt < q; Rt += 2)
        for (var lt = 0; lt < q; lt += 2)
          C.isPointInPath(F, Rt, lt, "nonzero") && (D = Math.min(D, Rt), Y = Math.min(Y, lt), U = Math.max(U, Rt), x = Math.max(x, lt));
      nt = U - D, st = x - Y;
      var St = 10, rt = Math.min(St / nt, St / st);
      V = [
        rt,
        0,
        0,
        rt,
        -Math.round(nt / 2 + D) * rt,
        -Math.round(st / 2 + Y) * rt
      ];
    }
    return {
      type: "path",
      path: y,
      matrix: V
    };
  }
  function bt(T) {
    var y, V = 1, F = "#000000", d = '"Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji", "EmojiOne Color", "Android Emoji", "Twemoji Mozilla", "system emoji", sans-serif';
    typeof T == "string" ? y = T : (y = T.text, V = "scalar" in T ? T.scalar : V, d = "fontFamily" in T ? T.fontFamily : d, F = "color" in T ? T.color : F);
    var C = 10 * V, q = "" + C + "px " + d, D = new OffscreenCanvas(C, C), Y = D.getContext("2d");
    Y.font = q;
    var U = Y.measureText(y), x = Math.ceil(U.actualBoundingBoxRight + U.actualBoundingBoxLeft), nt = Math.ceil(U.actualBoundingBoxAscent + U.actualBoundingBoxDescent), st = 2, Rt = U.actualBoundingBoxLeft + st, lt = U.actualBoundingBoxAscent + st;
    x += st + st, nt += st + st, D = new OffscreenCanvas(x, nt), Y = D.getContext("2d"), Y.font = q, Y.fillStyle = F, Y.fillText(y, Rt, lt);
    var St = 1 / V;
    return {
      type: "bitmap",
      // TODO these probably need to be transfered for workers
      bitmap: D.transferToImageBitmap(),
      matrix: [St, 0, 0, St, -x * St / 2, -nt * St / 2]
    };
  }
  m.exports = function() {
    return B().apply(this, arguments);
  }, m.exports.reset = function() {
    B().reset();
  }, m.exports.create = Wt, m.exports.shapeFromPath = tt, m.exports.shapeFromText = bt;
})(/* @__PURE__ */ (function() {
  return typeof window < "u" ? window : typeof self < "u" ? self : this || {};
})(), Ph, !1);
Ph.exports.create;
At.createContext(null);
const Lp = Object.assign({
  type: "lesson",
  title: "Linear Search",
  subtitle: "Understanding the baseline before binary search"
}, {
  entry: "courses/binary-search-ii/lessons/linear-search",
  slug: "linear-search",
  href: "/courses/binary-search-ii/lessons/linear-search",
  script: "/static/courses/binary-search-ii/lessons/linear-search.js",
  import: "#courses/binary-search-ii/lessons/linear-search",
  filename: "courses/binary-search-ii/lessons/linear-search.mdx"
}), Yp = Object.assign({
  type: "lesson",
  title: "Introduction to Binary Search",
  subtitle: "Finding target values in sorted arrays"
}, {
  entry: "courses/binary-search-ii/lessons/intro-binary-search",
  slug: "intro-binary-search",
  href: "/courses/binary-search-ii/lessons/intro-binary-search",
  script: "/static/courses/binary-search-ii/lessons/intro-binary-search.js",
  import: "#courses/binary-search-ii/lessons/intro-binary-search",
  filename: "courses/binary-search-ii/lessons/intro-binary-search.mdx"
}), Gp = Object.assign({
  type: "lesson",
  title: "Binary Search Analysis",
  subtitle: "Complexity analysis and real-world applications"
}, {
  entry: "courses/binary-search-ii/lessons/binary-search-edge-cases",
  slug: "binary-search-edge-cases",
  href: "/courses/binary-search-ii/lessons/binary-search-edge-cases",
  script: "/static/courses/binary-search-ii/lessons/binary-search-edge-cases.js",
  import: "#courses/binary-search-ii/lessons/binary-search-edge-cases",
  filename: "courses/binary-search-ii/lessons/binary-search-edge-cases.mdx"
}), Qp = Object.assign({
  type: "lesson",
  title: "Transition Point Basics",
  subtitle: "Introduction to the transition point recipe"
}, {
  entry: "courses/binary-search-ii/lessons/transition-point-basics",
  slug: "transition-point-basics",
  href: "/courses/binary-search-ii/lessons/transition-point-basics",
  script: "/static/courses/binary-search-ii/lessons/transition-point-basics.js",
  import: "#courses/binary-search-ii/lessons/transition-point-basics",
  filename: "courses/binary-search-ii/lessons/transition-point-basics.mdx"
}), Xp = Object.assign({
  type: "lesson",
  title: "Transition Point Advanced",
  subtitle: "Handling edge cases and varied return values"
}, {
  entry: "courses/binary-search-ii/lessons/transition-point-advanced",
  slug: "transition-point-advanced",
  href: "/courses/binary-search-ii/lessons/transition-point-advanced",
  script: "/static/courses/binary-search-ii/lessons/transition-point-advanced.js",
  import: "#courses/binary-search-ii/lessons/transition-point-advanced",
  filename: "courses/binary-search-ii/lessons/transition-point-advanced.mdx"
}), kp = Object.assign({
  type: "lesson",
  title: "Sorting to Enable Binary Search",
  subtitle: "When preprocessing unlocks efficient searching"
}, {
  entry: "courses/binary-search-ii/lessons/sorting-for-binary-search",
  slug: "sorting-for-binary-search",
  href: "/courses/binary-search-ii/lessons/sorting-for-binary-search",
  script: "/static/courses/binary-search-ii/lessons/sorting-for-binary-search.js",
  import: "#courses/binary-search-ii/lessons/sorting-for-binary-search",
  filename: "courses/binary-search-ii/lessons/sorting-for-binary-search.mdx"
}), Vp = Object.assign({
  type: "lesson",
  title: "Binary Search on Implicit Data",
  subtitle: "Searching rotated arrays, nearly sorted arrays, and peak/valley structures"
}, {
  entry: "courses/binary-search-ii/lessons/implicit-data",
  slug: "implicit-data",
  href: "/courses/binary-search-ii/lessons/implicit-data",
  script: "/static/courses/binary-search-ii/lessons/implicit-data.js",
  import: "#courses/binary-search-ii/lessons/implicit-data",
  filename: "courses/binary-search-ii/lessons/implicit-data.mdx"
}), Zp = Object.assign({
  type: "lesson",
  title: "Guess-and-Check with Binary Search",
  subtitle: "Solving optimization problems by searching the answer space"
}, {
  entry: "courses/binary-search-ii/lessons/guess-and-check",
  slug: "guess-and-check",
  href: "/courses/binary-search-ii/lessons/guess-and-check",
  script: "/static/courses/binary-search-ii/lessons/guess-and-check.js",
  import: "#courses/binary-search-ii/lessons/guess-and-check",
  filename: "courses/binary-search-ii/lessons/guess-and-check.mdx"
}), Kp = Object.assign({
  type: "lesson",
  title: "Binary Search on Non-Array Structures",
  subtitle: "Searching trees, grids, matrices, and custom data structures"
}, {
  entry: "courses/binary-search-ii/lessons/non-array-structures",
  slug: "non-array-structures",
  href: "/courses/binary-search-ii/lessons/non-array-structures",
  script: "/static/courses/binary-search-ii/lessons/non-array-structures.js",
  import: "#courses/binary-search-ii/lessons/non-array-structures",
  filename: "courses/binary-search-ii/lessons/non-array-structures.mdx"
}), Jp = Object.assign({
  type: "unit",
  title: "Binary Search Lessons",
  subtitle: "Comprehensive coverage of binary search concepts and techniques",
  children: [Lp, Yp, Gp, Qp, Xp, kp, Vp, Zp, Kp]
}, {
  entry: "courses/binary-search-ii/lessons",
  slug: "lessons",
  href: "/courses/binary-search-ii/lessons",
  script: "/static/courses/binary-search-ii/lessons.js",
  import: "#courses/binary-search-ii/lessons",
  filename: "courses/binary-search-ii/lessons/_lessons.mdx"
}), $p = Object.assign({
  type: "course",
  title: "Binary Search II",
  subtitle: "Advanced binary search techniques and applications",
  icon: Me.jsx(h0, {
    className: "h-8 w-8 text-indigo-800"
  }),
  children: [Jp],
  image: "images/example-hero.jpg"
}, {
  entry: "courses/binary-search-ii",
  slug: "binary-search-ii",
  href: "/courses/binary-search-ii",
  script: "/static/courses/binary-search-ii.js",
  import: "#courses/binary-search-ii",
  filename: "courses/binary-search-ii/_binary-search-ii.mdx"
}), Fp = Object.assign({
  type: "lesson",
  title: "Stack Basics",
  subtitle: "Understanding the stack data structure"
}, {
  entry: "courses/stacks-and-queues/stacks/stack-basics",
  slug: "stack-basics",
  href: "/courses/stacks-and-queues/stacks/stack-basics",
  script: "/static/courses/stacks-and-queues/stacks/stack-basics.js",
  import: "#courses/stacks-and-queues/stacks/stack-basics",
  filename: "courses/stacks-and-queues/stacks/stack-basics.mdx"
}), Wp = Object.assign({
  type: "lesson",
  title: "Common Stack Operations",
  subtitle: "Patterns and techniques with stacks"
}, {
  entry: "courses/stacks-and-queues/stacks/stack-operations",
  slug: "stack-operations",
  href: "/courses/stacks-and-queues/stacks/stack-operations",
  script: "/static/courses/stacks-and-queues/stacks/stack-operations.js",
  import: "#courses/stacks-and-queues/stacks/stack-operations",
  filename: "courses/stacks-and-queues/stacks/stack-operations.mdx"
}), Ip = Object.assign({
  type: "lesson",
  title: "Classic Stack Problems",
  subtitle: "Essential problems that use stacks"
}, {
  entry: "courses/stacks-and-queues/stacks/stack-problems",
  slug: "stack-problems",
  href: "/courses/stacks-and-queues/stacks/stack-problems",
  script: "/static/courses/stacks-and-queues/stacks/stack-problems.js",
  import: "#courses/stacks-and-queues/stacks/stack-problems",
  filename: "courses/stacks-and-queues/stacks/stack-problems.mdx"
}), Pp = Object.assign({
  type: "unit",
  title: "Stacks",
  subtitle: "Last-In-First-Out (LIFO) data structure",
  children: [Fp, Wp, Ip]
}, {
  entry: "courses/stacks-and-queues/stacks",
  slug: "stacks",
  href: "/courses/stacks-and-queues/stacks",
  script: "/static/courses/stacks-and-queues/stacks.js",
  import: "#courses/stacks-and-queues/stacks",
  filename: "courses/stacks-and-queues/stacks/_stacks.mdx"
}), tb = Object.assign({
  type: "lesson",
  title: "Queue Basics",
  subtitle: "Understanding the queue data structure"
}, {
  entry: "courses/stacks-and-queues/queues/queue-basics",
  slug: "queue-basics",
  href: "/courses/stacks-and-queues/queues/queue-basics",
  script: "/static/courses/stacks-and-queues/queues/queue-basics.js",
  import: "#courses/stacks-and-queues/queues/queue-basics",
  filename: "courses/stacks-and-queues/queues/queue-basics.mdx"
}), eb = Object.assign({
  type: "lesson",
  title: "Queue Variations",
  subtitle: "Deques, priority queues, and circular queues"
}, {
  entry: "courses/stacks-and-queues/queues/queue-variations",
  slug: "queue-variations",
  href: "/courses/stacks-and-queues/queues/queue-variations",
  script: "/static/courses/stacks-and-queues/queues/queue-variations.js",
  import: "#courses/stacks-and-queues/queues/queue-variations",
  filename: "courses/stacks-and-queues/queues/queue-variations.mdx"
}), nb = Object.assign({
  type: "lesson",
  title: "Classic Queue Problems",
  subtitle: "Essential problems using queues"
}, {
  entry: "courses/stacks-and-queues/queues/queue-problems",
  slug: "queue-problems",
  href: "/courses/stacks-and-queues/queues/queue-problems",
  script: "/static/courses/stacks-and-queues/queues/queue-problems.js",
  import: "#courses/stacks-and-queues/queues/queue-problems",
  filename: "courses/stacks-and-queues/queues/queue-problems.mdx"
}), lb = Object.assign({
  type: "unit",
  title: "Queues",
  subtitle: "First-In-First-Out (FIFO) data structure",
  children: [tb, eb, nb]
}, {
  entry: "courses/stacks-and-queues/queues",
  slug: "queues",
  href: "/courses/stacks-and-queues/queues",
  script: "/static/courses/stacks-and-queues/queues.js",
  import: "#courses/stacks-and-queues/queues",
  filename: "courses/stacks-and-queues/queues/_queues.mdx"
}), ab = Object.assign({
  type: "course",
  title: "Stacks & Queues",
  subtitle: "Master LIFO and FIFO data structures for efficient problem solving",
  icon: Me.jsx(a0, {
    className: "h-8 w-8 text-purple-700"
  }),
  children: [Pp, lb]
}, {
  entry: "courses/stacks-and-queues",
  slug: "stacks-and-queues",
  href: "/courses/stacks-and-queues",
  script: "/static/courses/stacks-and-queues.js",
  import: "#courses/stacks-and-queues",
  filename: "courses/stacks-and-queues/_stacks-and-queues.mdx"
}), ub = Object.assign({
  type: "lesson",
  title: "Set Basics",
  subtitle: "Understanding hash sets"
}, {
  entry: "courses/sets-and-maps/hash-sets/set-basics",
  slug: "set-basics",
  href: "/courses/sets-and-maps/hash-sets/set-basics",
  script: "/static/courses/sets-and-maps/hash-sets/set-basics.js",
  import: "#courses/sets-and-maps/hash-sets/set-basics",
  filename: "courses/sets-and-maps/hash-sets/set-basics.mdx"
}), ib = Object.assign({
  type: "lesson",
  title: "Set Operations",
  subtitle: "Union, intersection, difference, and more"
}, {
  entry: "courses/sets-and-maps/hash-sets/set-operations",
  slug: "set-operations",
  href: "/courses/sets-and-maps/hash-sets/set-operations",
  script: "/static/courses/sets-and-maps/hash-sets/set-operations.js",
  import: "#courses/sets-and-maps/hash-sets/set-operations",
  filename: "courses/sets-and-maps/hash-sets/set-operations.mdx"
}), sb = Object.assign({
  type: "lesson",
  title: "Classic Set Problems",
  subtitle: "Essential problems using hash sets"
}, {
  entry: "courses/sets-and-maps/hash-sets/set-problems",
  slug: "set-problems",
  href: "/courses/sets-and-maps/hash-sets/set-problems",
  script: "/static/courses/sets-and-maps/hash-sets/set-problems.js",
  import: "#courses/sets-and-maps/hash-sets/set-problems",
  filename: "courses/sets-and-maps/hash-sets/set-problems.mdx"
}), cb = Object.assign({
  type: "unit",
  title: "Hash Sets",
  subtitle: "Fast lookups and uniqueness constraints",
  children: [ub, ib, sb]
}, {
  entry: "courses/sets-and-maps/hash-sets",
  slug: "hash-sets",
  href: "/courses/sets-and-maps/hash-sets",
  script: "/static/courses/sets-and-maps/hash-sets.js",
  import: "#courses/sets-and-maps/hash-sets",
  filename: "courses/sets-and-maps/hash-sets/_hash-sets.mdx"
}), ob = Object.assign({
  type: "lesson",
  title: "Map Basics",
  subtitle: "Understanding hash maps and dictionaries"
}, {
  entry: "courses/sets-and-maps/hash-maps/map-basics",
  slug: "map-basics",
  href: "/courses/sets-and-maps/hash-maps/map-basics",
  script: "/static/courses/sets-and-maps/hash-maps/map-basics.js",
  import: "#courses/sets-and-maps/hash-maps/map-basics",
  filename: "courses/sets-and-maps/hash-maps/map-basics.mdx"
}), rb = Object.assign({
  type: "lesson",
  title: "Common Map Patterns",
  subtitle: "Frequency counting, indexing, and more"
}, {
  entry: "courses/sets-and-maps/hash-maps/map-patterns",
  slug: "map-patterns",
  href: "/courses/sets-and-maps/hash-maps/map-patterns",
  script: "/static/courses/sets-and-maps/hash-maps/map-patterns.js",
  import: "#courses/sets-and-maps/hash-maps/map-patterns",
  filename: "courses/sets-and-maps/hash-maps/map-patterns.mdx"
}), fb = Object.assign({
  type: "lesson",
  title: "Classic Map Problems",
  subtitle: "Essential problems using hash maps"
}, {
  entry: "courses/sets-and-maps/hash-maps/map-problems",
  slug: "map-problems",
  href: "/courses/sets-and-maps/hash-maps/map-problems",
  script: "/static/courses/sets-and-maps/hash-maps/map-problems.js",
  import: "#courses/sets-and-maps/hash-maps/map-problems",
  filename: "courses/sets-and-maps/hash-maps/map-problems.mdx"
}), db = Object.assign({
  type: "unit",
  title: "Hash Maps",
  subtitle: "Key-value storage with fast access",
  children: [ob, rb, fb]
}, {
  entry: "courses/sets-and-maps/hash-maps",
  slug: "hash-maps",
  href: "/courses/sets-and-maps/hash-maps",
  script: "/static/courses/sets-and-maps/hash-maps.js",
  import: "#courses/sets-and-maps/hash-maps",
  filename: "courses/sets-and-maps/hash-maps/_hash-maps.mdx"
}), mb = Object.assign({
  type: "course",
  title: "Sets & Maps",
  subtitle: "Harness hash-based data structures for fast lookups and uniqueness",
  icon: Me.jsx(n0, {
    className: "h-8 w-8 text-teal-700"
  }),
  children: [cb, db]
}, {
  entry: "courses/sets-and-maps",
  slug: "sets-and-maps",
  href: "/courses/sets-and-maps",
  script: "/static/courses/sets-and-maps.js",
  import: "#courses/sets-and-maps",
  filename: "courses/sets-and-maps/_sets-and-maps.mdx"
}), hb = Object.assign({
  type: "collection",
  title: "Tier 1",
  subtitle: "The fundamentals",
  children: [$p, ab, mb]
}, {
  entry: "courses/tier-1",
  slug: "tier-1",
  href: "/courses/tier-1",
  script: "/static/courses/tier-1.js",
  import: "#courses/tier-1",
  filename: "courses/tier-1.mdx"
}), gb = Object.assign({
  type: "lesson",
  title: "Introduction to Sliding Window",
  subtitle: "Understanding the sliding window technique"
}, {
  entry: "courses/sliding-windows/introduction-to-sliding-window",
  slug: "introduction-to-sliding-window",
  href: "/courses/sliding-windows/introduction-to-sliding-window",
  script: "/static/courses/sliding-windows/introduction-to-sliding-window.js",
  import: "#courses/sliding-windows/introduction-to-sliding-window",
  filename: "courses/sliding-windows/introduction-to-sliding-window.mdx"
}), yb = Object.assign({
  type: "lesson",
  title: "Fixed-Size Window Problems",
  subtitle: "Problems with constant window size"
}, {
  entry: "courses/sliding-windows/fixed-size-window",
  slug: "fixed-size-window",
  href: "/courses/sliding-windows/fixed-size-window",
  script: "/static/courses/sliding-windows/fixed-size-window.js",
  import: "#courses/sliding-windows/fixed-size-window",
  filename: "courses/sliding-windows/fixed-size-window.mdx"
}), vb = Object.assign({
  type: "lesson",
  title: "Variable-Size Window Problems",
  subtitle: "Problems with dynamic window size"
}, {
  entry: "courses/sliding-windows/variable-size-window",
  slug: "variable-size-window",
  href: "/courses/sliding-windows/variable-size-window",
  script: "/static/courses/sliding-windows/variable-size-window.js",
  import: "#courses/sliding-windows/variable-size-window",
  filename: "courses/sliding-windows/variable-size-window.mdx"
}), pb = Object.assign({
  type: "lesson",
  title: "Advanced Sliding Window Techniques",
  subtitle: "Monotonic deques and complex patterns"
}, {
  entry: "courses/sliding-windows/advanced-sliding-window",
  slug: "advanced-sliding-window",
  href: "/courses/sliding-windows/advanced-sliding-window",
  script: "/static/courses/sliding-windows/advanced-sliding-window.js",
  import: "#courses/sliding-windows/advanced-sliding-window",
  filename: "courses/sliding-windows/advanced-sliding-window.mdx"
}), bb = Object.assign({
  type: "course",
  title: "Sliding Windows",
  subtitle: "Efficiently solve subarray and substring problems",
  icon: Me.jsx(i0, {
    className: "h-8 w-8 text-cyan-700"
  }),
  children: [gb, yb, vb, pb]
}, {
  entry: "courses/sliding-windows",
  slug: "sliding-windows",
  href: "/courses/sliding-windows",
  script: "/static/courses/sliding-windows.js",
  import: "#courses/sliding-windows",
  filename: "courses/sliding-windows/_sliding-windows.mdx"
}), Sb = Object.assign({
  type: "lesson",
  title: "Introduction to Backtracking",
  subtitle: "What is backtracking and when to use it"
}, {
  entry: "courses/backtracking/fundamentals/introduction-to-backtracking",
  slug: "introduction-to-backtracking",
  href: "/courses/backtracking/fundamentals/introduction-to-backtracking",
  script: "/static/courses/backtracking/fundamentals/introduction-to-backtracking.js",
  import: "#courses/backtracking/fundamentals/introduction-to-backtracking",
  filename: "courses/backtracking/fundamentals/introduction-to-backtracking.mdx"
}), Eb = Object.assign({
  type: "lesson",
  title: "The Backtracking Template",
  subtitle: "A universal pattern for backtracking problems"
}, {
  entry: "courses/backtracking/fundamentals/the-backtracking-template",
  slug: "the-backtracking-template",
  href: "/courses/backtracking/fundamentals/the-backtracking-template",
  script: "/static/courses/backtracking/fundamentals/the-backtracking-template.js",
  import: "#courses/backtracking/fundamentals/the-backtracking-template",
  filename: "courses/backtracking/fundamentals/the-backtracking-template.mdx"
}), Tb = Object.assign({
  type: "unit",
  title: "Backtracking Fundamentals",
  subtitle: "Core concepts and the recursive pattern",
  children: [Sb, Eb]
}, {
  entry: "courses/backtracking/fundamentals",
  slug: "fundamentals",
  href: "/courses/backtracking/fundamentals",
  script: "/static/courses/backtracking/fundamentals.js",
  import: "#courses/backtracking/fundamentals",
  filename: "courses/backtracking/fundamentals/_fundamentals.mdx"
}), _b = Object.assign({
  type: "lesson",
  title: "Combinations and Subsets",
  subtitle: "Problems involving selecting elements"
}, {
  entry: "courses/backtracking/classic-problems/combinations-and-subsets",
  slug: "combinations-and-subsets",
  href: "/courses/backtracking/classic-problems/combinations-and-subsets",
  script: "/static/courses/backtracking/classic-problems/combinations-and-subsets.js",
  import: "#courses/backtracking/classic-problems/combinations-and-subsets",
  filename: "courses/backtracking/classic-problems/combinations-and-subsets.mdx"
}), Ob = Object.assign({
  type: "lesson",
  title: "Backtracking with Constraints",
  subtitle: "Board problems, grids, and complex constraints"
}, {
  entry: "courses/backtracking/classic-problems/backtracking-with-constraints",
  slug: "backtracking-with-constraints",
  href: "/courses/backtracking/classic-problems/backtracking-with-constraints",
  script: "/static/courses/backtracking/classic-problems/backtracking-with-constraints.js",
  import: "#courses/backtracking/classic-problems/backtracking-with-constraints",
  filename: "courses/backtracking/classic-problems/backtracking-with-constraints.mdx"
}), zb = Object.assign({
  type: "unit",
  title: "Classic Backtracking Problems",
  subtitle: "Essential problems and patterns",
  children: [_b, Ob]
}, {
  entry: "courses/backtracking/classic-problems",
  slug: "classic-problems",
  href: "/courses/backtracking/classic-problems",
  script: "/static/courses/backtracking/classic-problems.js",
  import: "#courses/backtracking/classic-problems",
  filename: "courses/backtracking/classic-problems/_classic-problems.mdx"
}), Cb = Object.assign({
  type: "course",
  title: "Backtracking",
  subtitle: "Explore all possibilities with recursive search strategies",
  icon: Me.jsx(t0, {
    className: "h-8 w-8 text-orange-700"
  }),
  children: [Tb, zb]
}, {
  entry: "courses/backtracking",
  slug: "backtracking",
  href: "/courses/backtracking",
  script: "/static/courses/backtracking.js",
  import: "#courses/backtracking",
  filename: "courses/backtracking/_backtracking.mdx"
}), Mb = Object.assign({
  type: "lesson",
  title: "Introduction to Dynamic Programming",
  subtitle: "What is DP and when to use it"
}, {
  entry: "courses/dynamic-programming/fundamentals/introduction-to-dp",
  slug: "introduction-to-dp",
  href: "/courses/dynamic-programming/fundamentals/introduction-to-dp",
  script: "/static/courses/dynamic-programming/fundamentals/introduction-to-dp.js",
  import: "#courses/dynamic-programming/fundamentals/introduction-to-dp",
  filename: "courses/dynamic-programming/fundamentals/introduction-to-dp.mdx"
}), Ab = Object.assign({
  type: "lesson",
  title: "Common DP Patterns",
  subtitle: "Recognizing and solving standard DP problems"
}, {
  entry: "courses/dynamic-programming/fundamentals/common-dp-patterns",
  slug: "common-dp-patterns",
  href: "/courses/dynamic-programming/fundamentals/common-dp-patterns",
  script: "/static/courses/dynamic-programming/fundamentals/common-dp-patterns.js",
  import: "#courses/dynamic-programming/fundamentals/common-dp-patterns",
  filename: "courses/dynamic-programming/fundamentals/common-dp-patterns.mdx"
}), wb = Object.assign({
  type: "unit",
  title: "DP Fundamentals",
  subtitle: "Core concepts and problem-solving approach",
  children: [Mb, Ab]
}, {
  entry: "courses/dynamic-programming/fundamentals",
  slug: "fundamentals",
  href: "/courses/dynamic-programming/fundamentals",
  script: "/static/courses/dynamic-programming/fundamentals.js",
  import: "#courses/dynamic-programming/fundamentals",
  filename: "courses/dynamic-programming/fundamentals/_fundamentals.mdx"
}), Nb = Object.assign({
  type: "lesson",
  title: "Classic DP Problems",
  subtitle: "Essential problems every engineer should know"
}, {
  entry: "courses/dynamic-programming/classic-problems",
  slug: "classic-problems",
  href: "/courses/dynamic-programming/classic-problems",
  script: "/static/courses/dynamic-programming/classic-problems.js",
  import: "#courses/dynamic-programming/classic-problems",
  filename: "courses/dynamic-programming/classic-problems.mdx"
}), Ub = Object.assign({
  type: "course",
  title: "Dynamic Programming",
  subtitle: "Solve complex problems by breaking them into subproblems",
  icon: Me.jsx(p0, {
    className: "h-8 w-8 text-pink-700"
  }),
  children: [wb, Nb]
}, {
  entry: "courses/dynamic-programming",
  slug: "dynamic-programming",
  href: "/courses/dynamic-programming",
  script: "/static/courses/dynamic-programming.js",
  import: "#courses/dynamic-programming",
  filename: "courses/dynamic-programming/_dynamic-programming.mdx"
}), Db = Object.assign({
  type: "collection",
  title: "Tier 2",
  subtitle: "Common patterns and techniques",
  children: [bb, Cb, Ub]
}, {
  entry: "courses/tier-2",
  slug: "tier-2",
  href: "/courses/tier-2",
  script: "/static/courses/tier-2.js",
  import: "#courses/tier-2",
  filename: "courses/tier-2.mdx"
}), Rb = Object.assign({
  type: "lesson",
  title: "Introduction to Monotonic Structures",
  subtitle: "Understanding monotonic stacks and deques"
}, {
  entry: "courses/monotonic-stacks-and-queues/introduction",
  slug: "introduction",
  href: "/courses/monotonic-stacks-and-queues/introduction",
  script: "/static/courses/monotonic-stacks-and-queues/introduction.js",
  import: "#courses/monotonic-stacks-and-queues/introduction",
  filename: "courses/monotonic-stacks-and-queues/introduction.mdx"
}), qb = Object.assign({
  type: "lesson",
  title: "Classic Problems",
  subtitle: "Essential monotonic stack/deque problems"
}, {
  entry: "courses/monotonic-stacks-and-queues/classic-problems",
  slug: "classic-problems",
  href: "/courses/monotonic-stacks-and-queues/classic-problems",
  script: "/static/courses/monotonic-stacks-and-queues/classic-problems.js",
  import: "#courses/monotonic-stacks-and-queues/classic-problems",
  filename: "courses/monotonic-stacks-and-queues/classic-problems.mdx"
}), jb = Object.assign({
  type: "course",
  title: "Monotonic Stacks & Queues",
  subtitle: "Advanced techniques for maintaining order in data structures",
  icon: Me.jsx(y0, {
    className: "h-8 w-8 text-indigo-700"
  }),
  children: [Rb, qb]
}, {
  entry: "courses/monotonic-stacks-and-queues",
  slug: "monotonic-stacks-and-queues",
  href: "/courses/monotonic-stacks-and-queues",
  script: "/static/courses/monotonic-stacks-and-queues.js",
  import: "#courses/monotonic-stacks-and-queues",
  filename: "courses/monotonic-stacks-and-queues/_monotonic-stacks-and-queues.mdx"
}), xb = Object.assign({
  type: "lesson",
  title: "Multidimensional DP",
  subtitle: "Beyond 1D and 2D dynamic programming"
}, {
  entry: "courses/advanced-dynamic-programming/multidimensional-dp",
  slug: "multidimensional-dp",
  href: "/courses/advanced-dynamic-programming/multidimensional-dp",
  script: "/static/courses/advanced-dynamic-programming/multidimensional-dp.js",
  import: "#courses/advanced-dynamic-programming/multidimensional-dp",
  filename: "courses/advanced-dynamic-programming/multidimensional-dp.mdx"
}), Hb = Object.assign({
  type: "lesson",
  title: "DP Optimization Techniques",
  subtitle: "Space and time optimization strategies"
}, {
  entry: "courses/advanced-dynamic-programming/optimization-techniques",
  slug: "optimization-techniques",
  href: "/courses/advanced-dynamic-programming/optimization-techniques",
  script: "/static/courses/advanced-dynamic-programming/optimization-techniques.js",
  import: "#courses/advanced-dynamic-programming/optimization-techniques",
  filename: "courses/advanced-dynamic-programming/optimization-techniques.mdx"
}), Bb = Object.assign({
  type: "course",
  title: "Advanced Dynamic Programming",
  subtitle: "Tackle complex optimization with advanced DP techniques",
  icon: Me.jsx(S0, {
    className: "h-8 w-8 text-amber-700"
  }),
  children: [xb, Hb]
}, {
  entry: "courses/advanced-dynamic-programming",
  slug: "advanced-dynamic-programming",
  href: "/courses/advanced-dynamic-programming",
  script: "/static/courses/advanced-dynamic-programming.js",
  import: "#courses/advanced-dynamic-programming",
  filename: "courses/advanced-dynamic-programming/_advanced-dynamic-programming.mdx"
}), Lb = Object.assign({
  type: "lesson",
  title: "Introduction to Union-Find",
  subtitle: "The disjoint set union data structure"
}, {
  entry: "courses/union-find/introduction",
  slug: "introduction",
  href: "/courses/union-find/introduction",
  script: "/static/courses/union-find/introduction.js",
  import: "#courses/union-find/introduction",
  filename: "courses/union-find/introduction.mdx"
}), Yb = Object.assign({
  type: "lesson",
  title: "Classic Union-Find Problems",
  subtitle: "Essential problems using disjoint sets"
}, {
  entry: "courses/union-find/classic-problems",
  slug: "classic-problems",
  href: "/courses/union-find/classic-problems",
  script: "/static/courses/union-find/classic-problems.js",
  import: "#courses/union-find/classic-problems",
  filename: "courses/union-find/classic-problems.mdx"
}), Gb = Object.assign({
  type: "course",
  title: "Union-Find",
  subtitle: "Efficiently manage disjoint sets and connectivity problems",
  icon: Me.jsx(d0, {
    className: "h-8 w-8 text-emerald-700"
  }),
  children: [Lb, Yb]
}, {
  entry: "courses/union-find",
  slug: "union-find",
  href: "/courses/union-find",
  script: "/static/courses/union-find.js",
  import: "#courses/union-find",
  filename: "courses/union-find/_union-find.mdx"
}), Qb = Object.assign({
  type: "collection",
  title: "Tier 3",
  subtitle: "Niche but powerful techniques",
  children: [jb, Bb, Gb]
}, {
  entry: "courses/tier-3",
  slug: "tier-3",
  href: "/courses/tier-3",
  script: "/static/courses/tier-3.js",
  import: "#courses/tier-3",
  filename: "courses/tier-3.mdx"
}), Xb = Object.assign({
  type: "collection",
  title: "Technical Topics",
  subtitle: "Courses for data structures, algorithms, and problem-solving patterns",
  children: [hb, Db, Qb]
}, {
  entry: "courses/technical-topics",
  slug: "technical-topics",
  href: "/courses/technical-topics",
  script: "/static/courses/technical-topics.js",
  import: "#courses/technical-topics",
  filename: "courses/technical-topics.mdx"
}), kb = Object.assign({
  type: "collection",
  title: "Course Catalog",
  children: [R0, Xb]
}, {
  entry: "courses",
  slug: "courses",
  href: "/courses",
  script: "/static/courses.js",
  import: "#courses",
  filename: "courses/_courses.mdx"
}), Bh = /* @__PURE__ */ new Map();
function tg(s) {
  if (!Bh.has(s.href) && (Bh.set(s.href, s), !!s.children))
    for (const r of s.children)
      r.parent = s, tg(r);
}
tg(kb);
export {
  Bh as registry
};
//# sourceMappingURL=beyond-ctci.js.map
